
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire49d7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire49d7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("6Pb6R", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b3cfa183fa168ea8c7cf286e27765b6f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4f801fa1dc3951b4$var$_react = $4f801fa1dc3951b4$var$_interopRequireDefault((parcelRequire("fsvuC")));

var $4f801fa1dc3951b4$var$_iconNew = $4f801fa1dc3951b4$var$_interopRequireDefault((parcelRequire("6SPX3")));
function $4f801fa1dc3951b4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusError".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/status-error
 * Usage guidance:
 * Reserved for error statuses and messaging.
 * Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4f801fa1dc3951b4$var$StatusErrorIcon = (props)=>/*#__PURE__*/ $4f801fa1dc3951b4$var$_react.default.createElement($4f801fa1dc3951b4$var$_iconNew.default, Object.assign({
        name: "StatusErrorIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.586.603a2 2 0 0 1 2.828 0l5.983 5.983a2 2 0 0 1 0 2.828l-5.983 5.982a2 2 0 0 1-2.828 0L.604 9.414a2 2 0 0 1 0-2.828zM8 10.25a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-.75-6.5V9h1.5V3.75z" clip-rule="evenodd"/>`
    }, props));
$4f801fa1dc3951b4$var$StatusErrorIcon.displayName = 'StatusErrorIcon';
var $4f801fa1dc3951b4$var$_default = module.exports.default = $4f801fa1dc3951b4$var$StatusErrorIcon;

});
parcelRegister("6SPX3", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "Icon", () => $5c7fdad8b2c3035b$export$f04a61298a47a40f);
$parcel$export(module.exports, "default", () => $5c7fdad8b2c3035b$export$2e2bcd8739ae039);
/* icon-new.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $gJ6nT = parcelRequire("gJ6nT");
const $5c7fdad8b2c3035b$var$svgStyles = null;
const $5c7fdad8b2c3035b$var$iconStyles = null;
const $5c7fdad8b2c3035b$var$smallIconStyles = null;
const $5c7fdad8b2c3035b$var$scaleStyles = null;
/**
 * For windows high contrast mode
 */ const $5c7fdad8b2c3035b$var$baseHcmStyles = null;
const $5c7fdad8b2c3035b$var$scaleSize = null;
const $5c7fdad8b2c3035b$var$coreSizeMedium = {
    none: "_39xV025zaO _0jFU0V5zaO",
    compact: "_39xV02NHnM _0jFU0VNHnM",
    spacious: "_39xV02NHnM _0jFU0VNHnM"
};
const $5c7fdad8b2c3035b$var$coreSizeSmall = {
    none: "_39xV028HPE _0jFU0V8HPE",
    compact: "_39xV025zaO _0jFU0V5zaO",
    spacious: "_39xV02NHnM _0jFU0VNHnM"
};
const $5c7fdad8b2c3035b$var$paddingMap = {
    medium: {
        none: 0,
        compact: 4,
        spacious: 4
    },
    small: {
        none: 0,
        compact: 2.66,
        spacious: 8
    }
};
const $5c7fdad8b2c3035b$export$f04a61298a47a40f = /*#__PURE__*/ (0, $fsvuC.memo)(function Icon(props) {
    const { color: color = 'currentColor', testId: testId, label: label, dangerouslySetGlyph: // Used to set icon dimensions/behaviour in codegen
    // Used to set icon glyphs in codegen
    dangerouslySetGlyph, shouldScale: // Used with iconTile to scale icon up and down
    shouldScale, spacing: spacing = 'none', name: name } = props;
    const dangerouslySetInnerHTML = dangerouslySetGlyph ? {
        __html: dangerouslySetGlyph
    } : undefined;
    let size = 'medium';
    if ('size' in props && props.size !== undefined) {
        if (typeof props.size === 'string') size = props.size === 'small' || props.size === 'medium' ? props.size : size;
        else if (name) {
            const newSize = props.size(name);
            size = newSize === 'small' || newSize === 'medium' ? newSize : size;
        }
    }
    const baseSize = 16;
    const viewBoxPadding = $5c7fdad8b2c3035b$var$paddingMap[size][spacing];
    const viewBoxSize = baseSize + 2 * viewBoxPadding;
    return /*#__PURE__*/ (0, $5chsV.jsx)("span", {
        "data-testid": testId,
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            color: color
        },
        className: (0, $gJ6nT.default)([
            "_3iDTPbvbI6 _24h04i2Njc _3YEZNOdnbC _26BoRw7dHp _03SyCPU7Rg _0LQT5ECyim",
            "_2z3AMPyL8i _1hdADdMFyn",
            shouldScale && "_39xV02OLYo _0jFU0VOLYo",
            size === 'small' && "_26BoRw8HPE"
        ]),
        children: /*#__PURE__*/ (0, $5chsV.jsx)("svg", {
            fill: "none",
            // Adjusting the viewBox allows the icon padding to scale with the contents of the SVG, which
            // we want for Icon Tile
            viewBox: `${0 - viewBoxPadding} ${0 - viewBoxPadding} ${viewBoxSize} ${viewBoxSize}`,
            role: "presentation",
            dangerouslySetInnerHTML: dangerouslySetInnerHTML,
            className: (0, $gJ6nT.default)([
                "_4bt5LAnQyn _2WAcuGnQyn _1UtDYz98eZ _1pp6NdYbGa _1RrJLiUWqv _24fbFs98eZ",
                shouldScale ? "_39xV02OLYo _0jFU0VOLYo" : size === 'small' ? $5c7fdad8b2c3035b$var$coreSizeSmall[spacing] : $5c7fdad8b2c3035b$var$coreSizeMedium[spacing]
            ])
        })
    });
});
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$5c7fdad8b2c3035b$export$2e2bcd8739ae039 = $5c7fdad8b2c3035b$export$f04a61298a47a40f;

});


parcelRegister("cqpe5", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $b002449545f464e7$export$2e2bcd8739ae039);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $4rs9h = parcelRequire("4rs9h");

var $f85qz = parcelRequire("f85qz");
/**
 * __Loading button__
 *
 * @deprecated Legacy loading buttons are deprecated and will be removed from `atlaskit/button` in an upcoming major release. Please use `Button` from `@atlaskit/button/default/button` with the `isLoading` prop.
 *
 * Please refer to the [migration guide](https://atlassian.design/components/button/button-legacy/migration-guide) for further details.
 *
 * A small wrapper around Button that allows you to show an @atlaskit/spinner as an overlay on the button when you set an isLoading prop to true.
 *
 * - [Examples](https://atlassian.design/components/button/examples#loading-button)
 */ const $b002449545f464e7$var$LoadingButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).forwardRef(function LoadingButton({ appearance: appearance, isDisabled: isDisabled, isSelected: isSelected, isLoading: isLoading = false, spacing: spacing, ...rest }, ref) {
    // Button already has React.memo, so just leaning on that
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $4rs9h.default), {
        ...rest,
        ref: ref,
        appearance: appearance,
        // No need to render aria-disabled when it is false
        "aria-disabled": isLoading || undefined,
        isDisabled: isDisabled,
        isSelected: isSelected,
        overlay: isLoading ? /*#__PURE__*/ (0, $5chsV.jsx)((0, $f85qz.default), {
            spacing: spacing,
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected
        }) : null,
        spacing: spacing
    });
});
// Tools including enzyme rely on components having a display name
$b002449545f464e7$var$LoadingButton.displayName = 'LoadingButton';
var $b002449545f464e7$export$2e2bcd8739ae039 = $b002449545f464e7$var$LoadingButton;

});
parcelRegister("4rs9h", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $84a1ecfc25a1e4ef$export$2e2bcd8739ae039);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $9Tkwf = parcelRequire("9Tkwf");

var $b6cDn = parcelRequire("b6cDn");

var $8lKCF = parcelRequire("8lKCF");

var $9VW4N = parcelRequire("9VW4N");
const $84a1ecfc25a1e4ef$var$isFirefox = typeof navigator !== 'undefined' && navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
/**
 * __Button__
 *
 * @deprecated Legacy buttons are deprecated and will be removed from `atlaskit/button` in an upcoming major release. Please use `Button` from `@atlaskit/button/default/button`.
 *
 * Please refer to the [migration guide](https://atlassian.design/components/button/button-legacy/migration-guide) for further details.
 *
 * A button triggers an event or action. They let users know what will happen next.
 *
 * - [Examples](https://atlassian.design/components/button/button-legacy/examples)
 * - [Code](https://atlassian.design/components/button/button-legacy/code)
 * - [Usage](https://atlassian.design/components/button/button-legacy/usage)
 */ const $84a1ecfc25a1e4ef$var$Button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).forwardRef(function Button({ appearance: appearance = 'default', children: children, iconBefore: iconBefore, iconAfter: iconAfter, isSelected: isSelected = false, onMouseDown: providedOnMouseDown = (0, $9Tkwf.default), onMouseUp: providedOnMouseUp = (0, $9Tkwf.default), shouldFitContainer: shouldFitContainer = false, spacing: spacing = 'default', ...rest }, ref) {
    const isOnlySingleIcon = (0, $9VW4N.default)({
        children: children,
        iconBefore: iconBefore,
        iconAfter: iconAfter
    });
    const [isActive, setIsActive] = (0, $fsvuC.useState)(false);
    // Wrap onMouseDown / onMouseUp to manually trigger active state
    // in Firefox
    const onMouseDown = (0, $fsvuC.useCallback)((event)=>{
        providedOnMouseDown(event);
        if ($84a1ecfc25a1e4ef$var$isFirefox) setIsActive(true);
    }, [
        providedOnMouseDown,
        setIsActive
    ]);
    const onMouseUp = (0, $fsvuC.useCallback)((event)=>{
        providedOnMouseUp(event);
        if ($84a1ecfc25a1e4ef$var$isFirefox) setIsActive(false);
    }, [
        providedOnMouseUp,
        setIsActive
    ]);
    const buttonCss = (0, $fsvuC.useMemo)(()=>(0, $8lKCF.getCss)({
            appearance: appearance,
            spacing: spacing,
            isSelected: isSelected,
            shouldFitContainer: shouldFitContainer,
            isOnlySingleIcon: isOnlySingleIcon
        }), [
        appearance,
        spacing,
        isSelected,
        shouldFitContainer,
        isOnlySingleIcon
    ]);
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $b6cDn.default), {
        ...rest,
        ref: ref,
        appearance: appearance,
        buttonCss: buttonCss,
        children: children,
        // Due to how click events are set, we need to set active styles
        // manually in Firefox and wrap onMouseDown/onMouseUp
        "data-firefox-is-active": isActive ? true : undefined,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        isSelected: isSelected,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        spacing: spacing
    });
}));
// Tools including enzyme rely on components having a display name
$84a1ecfc25a1e4ef$var$Button.displayName = 'Button';
var $84a1ecfc25a1e4ef$export$2e2bcd8739ae039 = $84a1ecfc25a1e4ef$var$Button;

});
parcelRegister("9Tkwf", function(module, exports) {
$parcel$export(module.exports, "default", () => $b3ab295088f596df$export$2e2bcd8739ae039);
/**
 * An empty function which does nothing.
 */ function $b3ab295088f596df$export$2e2bcd8739ae039() {}

});

parcelRegister("b6cDn", function(module, exports) {
$parcel$export(module.exports, "default", () => $9b38fb96958ab46b$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/design-system/no-deprecated-imports, @atlaskit/platform/no-direct-document-usage -- Preserve old-button behavior while focus-ring usage is reviewed separately. */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $fsvuC = parcelRequire("fsvuC");

var $h2YWL = parcelRequire("h2YWL");

var $d5Gwv = parcelRequire("d5Gwv");

var $9Tkwf = parcelRequire("9Tkwf");

var $cO4y2 = parcelRequire("cO4y2");

var $6PcvU = parcelRequire("6PcvU");

var $lNjwN = parcelRequire("lNjwN");

var $25CKw = parcelRequire("25CKw");

var $jtjyQ = parcelRequire("jtjyQ");

var $3mveh = parcelRequire("3mveh");

var $j02Ka = parcelRequire("j02Ka");

var $7Pp4Q = parcelRequire("7Pp4Q");

var $d8yn6 = parcelRequire("d8yn6");
function $9b38fb96958ab46b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// Disabled buttons will still publish events for nested elements in webkit.
// We are disabling pointer events on child elements so that
// the button will always be the target of events
// Note: firefox does not have this behaviour for child elements
const $9b38fb96958ab46b$var$noPointerEventsOnChildrenCss = {
    '> *': {
        pointerEvents: 'none'
    }
};
/**
 * These CSS variables consumed by the new icons, to allow them to have appropriate
 * padding inside Button while also maintaining spacing for the existing icons.
 *
 * These styles can be removed once the new icons are fully rolled out
 * and we bump Button to set padding based on the new icons.
 */ const $9b38fb96958ab46b$var$iconBeforeSpacingFixStyle = {
    name: "s584p2",
    styles: "--ds--button--new-icon-padding-end:var(--ds-space-025, 2px);--ds--button--new-icon-padding-start:var(--ds-space-050, 4px);margin-inline-start:var(--ds-space-negative-025, -2px)"
};
const $9b38fb96958ab46b$var$iconAfterSpacingFixStyle = {
    name: "150qmyr",
    styles: "--ds--button--new-icon-padding-end:var(--ds-space-050, 4px);--ds--button--new-icon-padding-start:var(--ds-space-025, 2px);margin-inline-end:var(--ds-space-negative-025, -2px)"
};
const $9b38fb96958ab46b$var$getSpacingFix = (children, spacingStyles)=>{
    if (!children || (0, $7Pp4Q.getIfVisuallyHiddenChildren)(children)) return null;
    return spacingStyles;
};
const $9b38fb96958ab46b$var$getChildren = (children, childrenStyles)=>{
    if ((0, $7Pp4Q.getIfVisuallyHiddenChildren)(children)) return children;
    return children ? /*#__PURE__*/ (0, $h2YWL.jsx)("span", {
        css: childrenStyles
    }, children) : null;
};
const $9b38fb96958ab46b$var$ButtonBase = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).forwardRef(function ButtonBase(props, ref) {
    const { analyticsContext: // I don't think analytics should be in button, but for now it is
    analyticsContext, appearance: appearance = 'default', autoFocus: autoFocus = false, buttonCss: buttonCss, children: children, className: className, href: href, // use the provided component prop,
    // else default to anchor if there is a href, and button if there is no href
    component: Component = href ? 'a' : 'button', iconAfter: iconAfter, iconBefore: iconBefore, interactionName: interactionName, isDisabled: isDisabled = false, isSelected: isSelected = false, onBlur: onBlur, onClick: providedOnClick = (0, $9Tkwf.default), onFocus: onFocus, onMouseDown: providedOnMouseDown = (0, $9Tkwf.default), overlay: overlay, shouldFitContainer: // Pulling out so it doesn't spread on rendered component
    shouldFitContainer, spacing: spacing = 'default', tabIndex: tabIndex = 0, type: type = !href ? 'button' : undefined, testId: testId, ...rest } = props;
    const ourRef = (0, $fsvuC.useRef)();
    const setRef = (0, $fsvuC.useCallback)((node)=>{
        ourRef.current = node;
        if (ref == null) return;
        if (typeof ref === 'function') {
            ref(node);
            return;
        }
        // We can write to ref's `current` property, but Typescript does not like it.
        // @ts-ignore
        ref.current = node;
    }, [
        ourRef,
        ref
    ]);
    // Cross browser auto focusing is pretty broken, so we are doing it ourselves
    (0, $cO4y2.default)(ourRef, autoFocus);
    const interactionContext = (0, $fsvuC.useContext)((0, $lNjwN.default));
    const handleClick = (0, $fsvuC.useCallback)((e, analyticsEvent)=>{
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    const onClick = (0, $d5Gwv.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: 'clicked',
        componentName: 'button',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local",
        analyticsData: analyticsContext
    });
    // Button currently calls preventDefault, which is not standard button behaviour
    const onMouseDown = (0, $fsvuC.useCallback)((event)=>{
        event.preventDefault();
        providedOnMouseDown(event);
    }, [
        providedOnMouseDown
    ]);
    // Lose focus when becoming disabled (standard button behaviour)
    (0, $fsvuC.useEffect)(()=>{
        const el = ourRef.current;
        if (isDisabled && el && el === document.activeElement) el.blur();
    }, [
        isDisabled
    ]);
    // we are 'disabling' input with a button when there is an overlay
    const hasOverlay = Boolean(overlay);
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    const fadeStyles = /*#__PURE__*/ (0, $h2YWL.css)((0, $3mveh.getFadingCss)({
        hasOverlay: hasOverlay
    }));
    const isInteractive = !isDisabled && !hasOverlay;
    /**
   * HACK: Spinner needs to have different colours in the "new" tokens design compared to the old design.
   * For now, while we support both, these styles reach into Spinner when a theme is set, applies the right color.
   * Ticket to remove: https://product-fabric.atlassian.net/browse/DSP-2067.
   */ var spinnerHackCss = {};
    if (isSelected || isDisabled || appearance === 'warning') spinnerHackCss = {
        '[data-theme] & circle': {
            stroke: `${isSelected || isDisabled ? "var(--ds-icon-subtle, #505258)" : "var(--ds-icon-warning-inverse, #292A2E)"} !important`
        }
    };
    return /*#__PURE__*/ (0, $h2YWL.jsx)((0, $6PcvU.default), null, /*#__PURE__*/ (0, $h2YWL.jsx)(Component, {
        ...rest,
        ref: setRef,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        css: [
            buttonCss,
            isInteractive ? null : $9b38fb96958ab46b$var$noPointerEventsOnChildrenCss
        ],
        // using undefined so that the property doesn't exist when false
        "data-has-overlay": hasOverlay ? true : undefined,
        "data-testid": testId,
        disabled: isDisabled,
        href: isInteractive ? href : undefined,
        onBlur: onBlur,
        onClick: onClick,
        onFocus: onFocus,
        onMouseDown: onMouseDown,
        // Adding a tab index so element is always focusable, even when not a <button> or <a>
        // Disabling focus via keyboard navigation when disabled
        // as this is standard button behaviour
        tabIndex: isDisabled ? -1 : tabIndex,
        type: type,
        ...(0, $25CKw.default)({
            isInteractive: isInteractive
        })
    }, iconBefore ? /*#__PURE__*/ (0, $h2YWL.jsx)("span", {
        css: [
            fadeStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $j02Ka.getIconStyle)({
                spacing: spacing
            }),
            $9b38fb96958ab46b$var$getSpacingFix(children, $9b38fb96958ab46b$var$iconBeforeSpacingFixStyle)
        ]
    }, iconBefore) : null, $9b38fb96958ab46b$var$getChildren(children, [
        fadeStyles,
        (0, $jtjyQ.getContentStyle)({
            spacing: spacing
        })
    ]), iconAfter ? /*#__PURE__*/ (0, $h2YWL.jsx)("span", {
        css: [
            fadeStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $j02Ka.getIconStyle)({
                spacing: spacing
            }),
            $9b38fb96958ab46b$var$getSpacingFix(children, $9b38fb96958ab46b$var$iconAfterSpacingFixStyle)
        ]
    }, iconAfter) : null, overlay ? /*#__PURE__*/ (0, $h2YWL.jsx)("span", {
        css: [
            (0, $d8yn6.overlayCss),
            spinnerHackCss
        ]
    }, overlay) : null));
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$9b38fb96958ab46b$export$2e2bcd8739ae039 = $9b38fb96958ab46b$var$ButtonBase;

});
parcelRegister("d5Gwv", function(module, exports) {
$parcel$export(module.exports, "usePlatformLeafEventHandler", () => $de832ad483a11e67$export$a4687b0234b40e28);

var $fsvuC = parcelRequire("fsvuC");

var $mhEfz = parcelRequire("mhEfz");

var $g5SRF = parcelRequire("g5SRF");
function $de832ad483a11e67$export$a4687b0234b40e28({ fn: fn, action: action, componentName: componentName, actionSubject: actionSubject, packageName: packageName, packageVersion: packageVersion, analyticsData: analyticsData }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $mhEfz.useAnalyticsEvents)();
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    const dataRef = (0, $g5SRF.useTrackedRef)(analyticsData);
    const fnRef = (0, $g5SRF.useTrackedRef)(fn);
    const handler = (0, $fsvuC.useCallback)((value)=>{
        const analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject || componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        const context = {
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion,
            ...dataRef.current
        };
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        const clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        fnRef.current(value, analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        actionSubject,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}

});
parcelRegister("mhEfz", function(module, exports) {
$parcel$export(module.exports, "useAnalyticsEvents", () => $7029defbc1a954f8$export$5bf35293e545f20c);

var $euMuM = parcelRequire("euMuM");

var $5jOIJ = parcelRequire("5jOIJ");

var $iGFF1 = parcelRequire("iGFF1");
function $7029defbc1a954f8$export$5bf35293e545f20c() {
    const analyticsContext = (0, $iGFF1.useAnalyticsContext)();
    const createAnalyticsEvent = (0, $euMuM.useCallbackOne)((payload)=>{
        return new (0, $5jOIJ.default)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}

});
parcelRegister("5jOIJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $32d81acb314d71fb$export$2e2bcd8739ae039);
/// <reference types="node" />

var $c77jK = parcelRequire("c77jK");
class $32d81acb314d71fb$export$2e2bcd8739ae039 extends (0, $c77jK.default) {
    constructor(props){
        super(props), this._isUIAnalyticsEvent = true, this.clone = ()=>{
            if (this.hasFired) return null;
            const context = [
                ...this.context
            ];
            const handlers = [
                ...this.handlers
            ];
            const payload = $32d81acb314d71fb$var$clonePayload(this.payload);
            return new $32d81acb314d71fb$export$2e2bcd8739ae039({
                context: context,
                handlers: handlers,
                payload: payload
            });
        }, this.fire = (channel)=>{
            if (this.hasFired) return;
            this.handlers.forEach((handler)=>{
                try {
                    handler(this, channel);
                } catch (e) {}
            });
            this.hasFired = true;
        };
        this.context = props.context || [];
        this.handlers = props.handlers || [];
        this.hasFired = false;
    }
    update(updater) {
        if (this.hasFired) return this;
        return super.update(updater);
    }
}
const $32d81acb314d71fb$var$clonePayload = (payload)=>{
    try {
        return JSON.parse(JSON.stringify(payload));
    } catch (e) {
        // Shallow clone keeps the event usable without crashing the UI.
        return {
            ...payload
        };
    }
};

});
parcelRegister("c77jK", function(module, exports) {
$parcel$export(module.exports, "default", () => $d6859decac73e0db$export$2e2bcd8739ae039);
class $d6859decac73e0db$export$2e2bcd8739ae039 {
    constructor(props){
        this._isAnalyticsEvent = true;
        this.clone = ()=>{
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            const payload = {
                ...this.payload
            };
            return new $d6859decac73e0db$export$2e2bcd8739ae039({
                payload: payload
            });
        };
        this.payload = props.payload;
    }
    update(updater) {
        if (typeof updater === 'function') this.payload = updater(this.payload);
        if (typeof updater === 'object') this.payload = {
            ...this.payload,
            ...updater
        };
        return this;
    }
}

});


parcelRegister("iGFF1", function(module, exports) {
$parcel$export(module.exports, "useAnalyticsContext", () => $c8a6431c5dfb9b4c$export$d1f587f82ad51c4);

var $fsvuC = parcelRequire("fsvuC");

var $d9mL9 = parcelRequire("d9mL9");
const $c8a6431c5dfb9b4c$export$d1f587f82ad51c4 = ()=>{
    return (0, $fsvuC.useContext)((0, $d9mL9.default));
};

});
parcelRegister("d9mL9", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $992dc52b0933cbbd$export$2e2bcd8739ae039);

var $gPXG4 = parcelRequire("gPXG4");
var $992dc52b0933cbbd$export$2e2bcd8739ae039 = (0, $gPXG4.default);

});
parcelRegister("gPXG4", function(module, exports) {
$parcel$export(module.exports, "default", () => $0329cd37b9ebd509$export$2e2bcd8739ae039);

var $fsvuC = parcelRequire("fsvuC");
var $0329cd37b9ebd509$var$AnalyticsNextContext = (0, $fsvuC.createContext)({
    getAtlaskitAnalyticsContext: function() {
        return [];
    },
    getAtlaskitAnalyticsEventHandlers: function() {
        return [];
    }
});
var $0329cd37b9ebd509$export$2e2bcd8739ae039 = $0329cd37b9ebd509$var$AnalyticsNextContext;

});




parcelRegister("g5SRF", function(module, exports) {
$parcel$export(module.exports, "useTrackedRef", () => $74e022e7f2a7a5ca$export$1d27a74659855e44);

var $fsvuC = parcelRequire("fsvuC");
const $74e022e7f2a7a5ca$export$1d27a74659855e44 = (value)=>{
    const ref = (0, $fsvuC.useRef)(value);
    ref.current = value;
    return ref;
};

});


parcelRegister("cO4y2", function(module, exports) {
$parcel$export(module.exports, "default", () => $e0fe1331dcafe132$export$2e2bcd8739ae039);

var $fsvuC = parcelRequire("fsvuC");
function $e0fe1331dcafe132$export$2e2bcd8739ae039(ref, autoFocus) {
    const initialMount = (0, $fsvuC.useRef)(true);
    (0, $fsvuC.useEffect)(()=>{
        if (ref && initialMount.current && autoFocus && ref.current) ref.current.focus();
        initialMount.current = false;
    }, [
        autoFocus,
        ref
    ]);
}

});

parcelRegister("6PcvU", function(module, exports) {
$parcel$export(module.exports, "default", () => $298a1ab94aecd1a2$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ /* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- LENS1-245 tracks @atlaskit/focus-ring deprecation. */ 
var $fsvuC = parcelRequire("fsvuC");

var $h2YWL = parcelRequire("h2YWL");
const $298a1ab94aecd1a2$var$BORDER_WIDTH = 2;
const $298a1ab94aecd1a2$var$baseFocusOutsideStyles = /*#__PURE__*/ (0, $h2YWL.css)({
    outline: `${"var(--ds-border-width-focused, 2px)"} solid ${"var(--ds-border-focused, #4688EC)"}`,
    outlineOffset: $298a1ab94aecd1a2$var$BORDER_WIDTH
});
const $298a1ab94aecd1a2$var$baseInsetStyles = /*#__PURE__*/ (0, $h2YWL.css)({
    outlineColor: "var(--ds-border-focused, #4688EC)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    outlineOffset: -$298a1ab94aecd1a2$var$BORDER_WIDTH,
    outlineStyle: 'solid',
    outlineWidth: "var(--ds-border-width-focused, 2px)"
});
const $298a1ab94aecd1a2$var$focusRingStyles = /*#__PURE__*/ (0, $h2YWL.css)({
    // Focus styles used when :focus-visible isn't supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus': $298a1ab94aecd1a2$var$baseFocusOutsideStyles,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus-visible': $298a1ab94aecd1a2$var$baseFocusOutsideStyles,
    // Remove default focus styles for mouse interactions if :focus-visible is supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:focus:not(:focus-visible)': {
        outline: 'none'
    },
    '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
        '&:focus-visible': {
            outline: `${"var(--ds-border-width, 1px)"} solid`
        }
    }
});
const $298a1ab94aecd1a2$var$insetFocusRingStyles = /*#__PURE__*/ (0, $h2YWL.css)({
    // Focus styles used when :focus-visible isn't supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus': $298a1ab94aecd1a2$var$baseInsetStyles,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus-visible': $298a1ab94aecd1a2$var$baseInsetStyles,
    // Remove default focus styles for mouse interactions if :focus-visible is supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:focus:not(:focus-visible)': {
        outline: 'none'
    },
    '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
        '&:focus-visible': {
            outline: `${"var(--ds-border-width, 1px)"} solid`,
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            outlineOffset: '-1px'
        }
    }
});
/**
 * __Focus ring__
 *
 * A focus ring visually indicates the currently focused item.
 *
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/focus-ring)
 *
 * @example
 * ```jsx
 * import FocusRing from '@atlaskit/focus-ring';
 *
 * const InteractiveComponent = () => (
 *   <FocusRing>
 *     <button type="button">Hello</button>
 *   </FocusRing>
 * )
 * ```
 *
 * @deprecated FocusRing is deprecated. Use Focusable from @atlaskit/primitives/compiled/focusable instead.
 */ const $298a1ab94aecd1a2$var$FocusRing = /*#__PURE__*/ (0, $fsvuC.memo)(({ children: children, isInset: isInset, focus: focus })=>{
    const controlledStyles = isInset ? $298a1ab94aecd1a2$var$baseInsetStyles : $298a1ab94aecd1a2$var$baseFocusOutsideStyles;
    const uncontrolledStyles = isInset ? $298a1ab94aecd1a2$var$insetFocusRingStyles : $298a1ab94aecd1a2$var$focusRingStyles;
    const focusCls = typeof focus === 'undefined' ? uncontrolledStyles : focus === 'on' && controlledStyles;
    return /*#__PURE__*/ (0, $h2YWL.jsx)((0, $h2YWL.ClassNames), null, ({ css: css, cx: cx })=>(0, $fsvuC.Children).only(// This may look unwieldy but means we skip applying styles / cloning if no className is applicable
        focusCls ? // eslint-disable-next-line @repo/internal/react/no-clone-element
        /*#__PURE__*/ (0, $fsvuC.cloneElement)(children, {
            className: cx([
                css(focusCls),
                children.props.className
            ])
        }) : children));
});
$298a1ab94aecd1a2$var$FocusRing.displayName = 'FocusRing';
var $298a1ab94aecd1a2$export$2e2bcd8739ae039 = $298a1ab94aecd1a2$var$FocusRing;

});

parcelRegister("25CKw", function(module, exports) {
$parcel$export(module.exports, "default", () => $c0a136071077e331$export$2e2bcd8739ae039);
function $c0a136071077e331$var$abort(event) {
    event.preventDefault();
    event.stopPropagation();
}
const $c0a136071077e331$var$tabKeyCode = 9;
function $c0a136071077e331$var$onKey(event) {
    // Allowing tab so that a user can move focus away
    if (event.keyCode === $c0a136071077e331$var$tabKeyCode) return;
    $c0a136071077e331$var$abort(event);
}
const $c0a136071077e331$var$block = {
    onMouseDownCapture: $c0a136071077e331$var$abort,
    onMouseUpCapture: $c0a136071077e331$var$abort,
    // because we have tabIndex = -1 when disabled,
    // keyboard events can only occur when there is an overlay
    onKeyDownCapture: $c0a136071077e331$var$onKey,
    onKeyUpCapture: $c0a136071077e331$var$onKey,
    onTouchStartCapture: $c0a136071077e331$var$abort,
    onTouchEndCapture: $c0a136071077e331$var$abort,
    onPointerDownCapture: $c0a136071077e331$var$abort,
    onPointerUpCapture: $c0a136071077e331$var$abort,
    onClickCapture: $c0a136071077e331$var$abort,
    // Just smashing the existing onClick for good measure
    onClick: $c0a136071077e331$var$abort
};
const $c0a136071077e331$var$doNotBlock = {};
function $c0a136071077e331$export$2e2bcd8739ae039({ isInteractive: isInteractive }) {
    return isInteractive ? $c0a136071077e331$var$doNotBlock : $c0a136071077e331$var$block;
}

});

parcelRegister("jtjyQ", function(module, exports) {
$parcel$export(module.exports, "getContentStyle", () => $0ed59ea53182efe9$export$7ad0316cc0dd65a);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $h2YWL = parcelRequire("h2YWL");
function $0ed59ea53182efe9$export$7ad0316cc0dd65a({ spacing: spacing }) {
    return /*#__PURE__*/ (0, $h2YWL.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: spacing === 'none' ? 0 : '0 2px',
        // content can grow and shrink
        flexGrow: 1,
        flexShrink: 1,
        // ellipsis for overflow text
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    });
}

});

parcelRegister("3mveh", function(module, exports) {
$parcel$export(module.exports, "getFadingCss", () => $710b720b56f26563$export$1b5827d324e945b1);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $h2YWL = parcelRequire("h2YWL");
function $710b720b56f26563$export$1b5827d324e945b1({ hasOverlay: hasOverlay }) {
    return /*#__PURE__*/ (0, $h2YWL.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        opacity: hasOverlay ? 0 : 1,
        transition: 'opacity 0.3s'
    });
}

});

parcelRegister("j02Ka", function(module, exports) {
$parcel$export(module.exports, "getIconStyle", () => $672f5092e045549e$export$864eea3f4ec3368f);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $h2YWL = parcelRequire("h2YWL");
function $672f5092e045549e$export$864eea3f4ec3368f({ spacing: spacing }) {
    return /*#__PURE__*/ (0, $h2YWL.css)({
        display: 'flex',
        // icon size cannot grow and shrink
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: spacing === 'none' ? 0 : `0 2px`,
        flexGrow: 0,
        flexShrink: 0,
        alignSelf: 'center',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: 0,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: 0,
        userSelect: 'none'
    });
}

});

parcelRegister("7Pp4Q", function(module, exports) {
$parcel$export(module.exports, "getIfVisuallyHiddenChildren", () => $a823b786cc6ea491$export$20bbd2efb0d734c4);

var $fsvuC = parcelRequire("fsvuC");

var $8e1dR = parcelRequire("8e1dR");
const $a823b786cc6ea491$export$20bbd2efb0d734c4 = (children)=>{
    return children && /*#__PURE__*/ (0, $fsvuC.isValidElement)(children) && children.type === (0, $8e1dR.default);
};

});
parcelRegister("8e1dR", function(module, exports) {
$parcel$export(module.exports, "default", () => $c80b95f51f550c2d$export$2e2bcd8739ae039);
/* visually-hidden.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");
parcelRequire("fsvuC");

var $gJ6nT = parcelRequire("gJ6nT");
const $c80b95f51f550c2d$var$visuallyHiddenStyles = null;
/**
 * __Visually hidden__
 *
 * A composable element to apply a visually hidden effect to children.
 * Useful for accessibility compliance.
 *
 * @example
 * ```jsx
 * import VisuallyHidden from '@atlaskit/visually-hidden';
 *
 * export default () => (
 *   <div style={{ border: '1px solid black' }}>
 *      There is text hidden between the brackets [
 *      <VisuallyHidden>Can't see me!</VisuallyHidden>]
 *   </div>
 * );
 * ```
 */ const $c80b95f51f550c2d$var$VisuallyHidden = ({ children: children, testId: testId, role: role, id: id })=>{
    return /*#__PURE__*/ (0, $5chsV.jsx)("span", {
        id: id,
        "data-testid": testId,
        role: role,
        className: (0, $gJ6nT.default)([
            "_0Of8r2dnbC _1ZnuxbdnbC _1wydGWdnbC _2Zuz6QdnbC _30huDKdnbC _4bt5LAnQyn _2WAcuGnQyn _39xV02HZdu _0jFU0VHZdu _1mT5xdWVPG _1C7BHPdEFh _20VacPYbGa _1ANEUSLRg7"
        ]),
        children: children
    });
};
$c80b95f51f550c2d$var$VisuallyHidden.displayName = "VisuallyHidden";
$c80b95f51f550c2d$var$VisuallyHidden.displayName = 'VisuallyHidden';
var $c80b95f51f550c2d$export$2e2bcd8739ae039 = $c80b95f51f550c2d$var$VisuallyHidden;

});


parcelRegister("d8yn6", function(module, exports) {
$parcel$export(module.exports, "overlayCss", () => $15cc5e9c5105f769$export$1a9fe1b84c876bb5);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
const $15cc5e9c5105f769$export$1a9fe1b84c876bb5 = {
    // stretching to full width / height of button
    // this is important as we need it to still block
    // event if clicking in the button's own padding
    position: 'absolute',
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    // Putting all children in the center
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
};

});


parcelRegister("8lKCF", function(module, exports) {
$parcel$export(module.exports, "getCss", () => $61b6e75f67a3f302$export$955358618f994a11);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $llCao = parcelRequire("llCao");
const $61b6e75f67a3f302$var$gridSize = 8;
const $61b6e75f67a3f302$var$HAS_DISABLED_BACKGROUND = [
    'default',
    'primary',
    'danger',
    'warning'
];
const $61b6e75f67a3f302$var$heights = {
    default: `${32 / 14}em`,
    // 32px
    compact: `${24 / 14}em`,
    none: 'auto'
};
const $61b6e75f67a3f302$var$lineHeights = {
    default: $61b6e75f67a3f302$var$heights.default,
    compact: $61b6e75f67a3f302$var$heights.compact,
    none: 'inherit'
};
const $61b6e75f67a3f302$var$padding = {
    // 10px gutter
    default: `0 ${$61b6e75f67a3f302$var$gridSize + $61b6e75f67a3f302$var$gridSize / 4}px`,
    compact: `0 ${$61b6e75f67a3f302$var$gridSize + $61b6e75f67a3f302$var$gridSize / 4}px`,
    none: '0'
};
const $61b6e75f67a3f302$var$singleIconPadding = {
    // 2px gutter
    compact: `0 ${$61b6e75f67a3f302$var$gridSize / 4}px`,
    default: `0 ${$61b6e75f67a3f302$var$gridSize / 4}px`,
    none: '0'
};
const $61b6e75f67a3f302$var$verticalAlign = {
    default: 'middle',
    compact: 'middle',
    none: 'baseline'
};
const $61b6e75f67a3f302$var$defaultAfterStyles = {
    borderRadius: 'inherit',
    inset: "var(--ds-space-0, 0px)",
    borderStyle: 'solid',
    borderWidth: "var(--ds-border-width, 1px)",
    pointerEvents: 'none',
    position: 'absolute'
};
const $61b6e75f67a3f302$var$defaultStyles = {
    background: "var(--ds-background-neutral-subtle, #00000000)",
    color: "var(--ds-text, #292A2E)",
    '&::after': {
        ...$61b6e75f67a3f302$var$defaultAfterStyles,
        content: '""',
        borderColor: "var(--ds-border, #0B120E24)"
    },
    '&:hover': {
        background: "var(--ds-background-neutral-hovered, #0B120E24)",
        color: "var(--ds-text, #292A2E)",
        textDecoration: 'none'
    },
    '&:active': {
        background: "var(--ds-background-neutral-pressed, #080F214A)",
        color: "var(--ds-text, #292A2E)",
        textDecoration: 'none'
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-neutral-subtle, #00000000)"
    },
    '&:disabled[disabled]': {
        background: "var(--ds-background-neutral-subtle, #00000000)"
    },
    '&:disabled[disabled]:hover': {
        background: "var(--ds-background-neutral-subtle, #00000000)"
    },
    '&:disabled[disabled]:active': {
        background: "var(--ds-background-neutral-subtle, #00000000)"
    },
    textDecoration: 'none'
};
const $61b6e75f67a3f302$var$primaryStyles = {
    background: "var(--ds-background-brand-bold, #1868DB)",
    color: "var(--ds-text-inverse, #FFFFFF)",
    '&:hover': {
        background: "var(--ds-background-brand-bold-hovered, #1558BC)",
        color: "var(--ds-text-inverse, #FFFFFF)",
        textDecoration: 'none'
    },
    '&:active': {
        background: "var(--ds-background-brand-bold-pressed, #144794)",
        color: "var(--ds-text-inverse, #FFFFFF)",
        textDecoration: 'none'
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-brand-bold, #1868DB)"
    },
    textDecoration: 'none'
};
const $61b6e75f67a3f302$var$linkStyles = {
    background: 'transparent',
    color: "var(--ds-link, #1868DB)",
    '&:hover': {
        color: "var(--ds-link, #1868DB)",
        textDecoration: 'underline'
    },
    '&:active': {
        color: "var(--ds-link-pressed, #1558BC)",
        textDecoration: 'underline'
    },
    textDecoration: 'none'
};
const $61b6e75f67a3f302$var$subtleStyles = {
    background: 'transparent',
    color: "var(--ds-text-subtle, #505258)",
    '&:hover': {
        background: "var(--ds-background-neutral-subtle-hovered, #0515240F)",
        color: "var(--ds-text-subtle, #505258)",
        textDecoration: 'none'
    },
    '&:active': {
        background: "var(--ds-background-neutral-subtle-pressed, #0B120E24)",
        color: "var(--ds-text-subtle, #505258)",
        textDecoration: 'none'
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: 'transparent'
    },
    textDecoration: 'none'
};
const $61b6e75f67a3f302$var$subtleLinkStyles = {
    background: 'transparent',
    color: "var(--ds-text-subtle, #505258)",
    '&:hover': {
        background: 'transparent',
        color: "var(--ds-text-subtle, #505258)",
        textDecoration: 'underline'
    },
    '&:active': {
        background: 'transparent',
        color: "var(--ds-text, #292A2E)",
        textDecoration: 'underline'
    },
    textDecoration: 'none'
};
const $61b6e75f67a3f302$var$warningStyles = {
    background: "var(--ds-background-warning-bold, #FBC828)",
    color: "var(--ds-text-warning-inverse, #292A2E)",
    '&:hover': {
        background: "var(--ds-background-warning-bold-hovered, #FCA700)",
        color: "var(--ds-text-warning-inverse, #292A2E)",
        textDecoration: 'none'
    },
    '&:active': {
        background: "var(--ds-background-warning-bold-pressed, #F68909)",
        color: "var(--ds-text-warning-inverse, #292A2E)",
        textDecoration: 'none'
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-warning-bold, #FBC828)"
    },
    textDecoration: 'none'
};
const $61b6e75f67a3f302$var$dangerStyles = {
    background: "var(--ds-background-danger-bold, #C9372C)",
    color: "var(--ds-text-inverse, #FFFFFF)",
    '&:hover': {
        background: "var(--ds-background-danger-bold-hovered, #AE2E24)",
        color: "var(--ds-text-inverse, #FFFFFF)",
        textDecoration: 'none'
    },
    '&:active': {
        background: "var(--ds-background-danger-bold-pressed, #872821)",
        color: "var(--ds-text-inverse, #FFFFFF)",
        textDecoration: 'none'
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-danger-bold, #C9372C)"
    },
    textDecoration: 'none'
};
const $61b6e75f67a3f302$var$selectedStyles = {
    background: "var(--ds-background-selected, #E9F2FE)",
    color: "var(--ds-text-selected, #1868DB)",
    '&:not([disabled])::after': {
        ...$61b6e75f67a3f302$var$defaultAfterStyles,
        content: '""',
        borderColor: "var(--ds-border-selected, #1868DB)"
    }
};
const $61b6e75f67a3f302$var$hasOverlayStyles = {
    '&[data-has-overlay="true"]': {
        cursor: 'default',
        textDecoration: 'none'
    }
};
function $61b6e75f67a3f302$export$955358618f994a11({ appearance: appearance, spacing: spacing, isSelected: isSelected, shouldFitContainer: shouldFitContainer, isOnlySingleIcon: isOnlySingleIcon }) {
    const baseAppearanceStyles = {
        ...appearance === 'default' && $61b6e75f67a3f302$var$defaultStyles,
        ...appearance === 'primary' && $61b6e75f67a3f302$var$primaryStyles,
        ...appearance === 'link' && $61b6e75f67a3f302$var$linkStyles,
        ...appearance === 'subtle' && $61b6e75f67a3f302$var$subtleStyles,
        ...appearance === 'subtle-link' && $61b6e75f67a3f302$var$subtleLinkStyles,
        ...appearance === 'warning' && $61b6e75f67a3f302$var$warningStyles,
        ...appearance === 'danger' && $61b6e75f67a3f302$var$dangerStyles
    };
    const appearanceStyles = appearance === 'default' && (0, $llCao.fg)('platform-dst-tokens-finesse') ? {
        ...baseAppearanceStyles,
        '&:hover': {
            ...baseAppearanceStyles['&:hover'],
            background: "var(--ds-background-neutral-subtle-hovered, #0515240F)"
        },
        '&:active': {
            ...baseAppearanceStyles['&:active'],
            background: "var(--ds-background-neutral-subtle-pressed, #0B120E24)"
        }
    } : baseAppearanceStyles;
    const activeStyles = appearanceStyles['&:active'];
    return {
        // 0px margin added to css-reset
        alignItems: 'baseline',
        borderWidth: 0,
        borderRadius: "var(--ds-radius-medium, 6px)",
        boxSizing: 'border-box',
        display: 'inline-flex',
        fontSize: 'inherit',
        fontStyle: 'normal',
        // Chrome recently changed button so that they use 'arial' as the font family
        fontFamily: 'inherit',
        fontWeight: "var(--ds-font-weight-medium, 500)",
        // margin for button has been applied to css reset
        maxWidth: '100%',
        // Needed to position overlay
        position: 'relative',
        textAlign: 'center',
        textDecoration: 'none',
        transition: `${"var(--ds-button-hovered, background-color border-color 150ms cubic-bezier(0.4, 1, 0.6, 1))"}, box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38)`,
        whiteSpace: 'nowrap',
        cursor: 'pointer',
        height: $61b6e75f67a3f302$var$heights[spacing],
        lineHeight: $61b6e75f67a3f302$var$lineHeights[spacing],
        padding: isOnlySingleIcon ? $61b6e75f67a3f302$var$singleIconPadding[spacing] : $61b6e75f67a3f302$var$padding[spacing],
        verticalAlign: $61b6e75f67a3f302$var$verticalAlign[spacing],
        width: shouldFitContainer ? '100%' : 'auto',
        // justifyContent required for shouldFitContainer buttons with an icon inside
        justifyContent: 'center',
        ...isSelected ? $61b6e75f67a3f302$var$selectedStyles : {
            ...appearanceStyles,
            ...activeStyles && {
                '&:active': {
                    ...activeStyles,
                    transition: "var(--ds-button-pressed, background-color border-color 150ms cubic-bezier(0.4, 1, 0.6, 1))"
                }
            },
            '&[disabled]': {
                color: "var(--ds-text-disabled, #080F214A)",
                backgroundColor: $61b6e75f67a3f302$var$HAS_DISABLED_BACKGROUND.includes(appearance) ? "var(--ds-background-disabled, #0515240F)" : 'transparent',
                cursor: 'not-allowed',
                textDecoration: 'none',
                '&:hovered': {
                    backgroundColor: $61b6e75f67a3f302$var$HAS_DISABLED_BACKGROUND.includes(appearance) ? "var(--ds-background-disabled, #0515240F)" : 'transparent'
                },
                '&:active': {
                    backgroundColor: $61b6e75f67a3f302$var$HAS_DISABLED_BACKGROUND.includes(appearance) ? "var(--ds-background-disabled, #0515240F)" : 'transparent'
                }
            },
            ...$61b6e75f67a3f302$var$hasOverlayStyles
        },
        '&::-moz-focus-inner': {
            border: 0,
            margin: 0,
            padding: 0
        }
    };
}

});

parcelRegister("9VW4N", function(module, exports) {
$parcel$export(module.exports, "default", () => $1364bcc6b49558f0$export$2e2bcd8739ae039);

var $7Pp4Q = parcelRequire("7Pp4Q");
function $1364bcc6b49558f0$export$2e2bcd8739ae039({ children: children, iconBefore: iconBefore, iconAfter: iconAfter }) {
    if ((0, $7Pp4Q.getIfVisuallyHiddenChildren)(children)) return true;
    if (children) return false;
    if (iconBefore && !iconAfter) return true;
    if (!iconBefore && iconAfter) return true;
    return false;
}

});


parcelRegister("f85qz", function(module, exports) {
$parcel$export(module.exports, "default", () => $754f559441128013$export$2e2bcd8739ae039);

var $5chsV = parcelRequire("5chsV");
parcelRequire("fsvuC");

var $9cT91 = parcelRequire("9cT91");
function $754f559441128013$var$getSpinnerAppearance({ appearance: appearance, isDisabled: isDisabled, isSelected: isSelected }) {
    if (isDisabled) return 'inherit';
    if (isSelected) return 'invert';
    if (appearance === 'primary' || appearance === 'danger') return 'invert';
    return 'inherit';
}
function $754f559441128013$export$2e2bcd8739ae039({ appearance: appearance, isDisabled: isDisabled, isSelected: isSelected, spacing: spacing = 'default' }) {
    const size = spacing === 'default' ? 'medium' : 'small';
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $9cT91.default), {
        size: size,
        label: ", Loading",
        appearance: $754f559441128013$var$getSpinnerAppearance({
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected
        })
    });
}
$754f559441128013$export$2e2bcd8739ae039.displayName = "LoadingSpinner";

});
parcelRegister("9cT91", function(module, exports) {
$parcel$export(module.exports, "default", () => $62d3db9976307470$export$2e2bcd8739ae039);
/* spinner.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $gJ6nT = parcelRequire("gJ6nT");

var $fsvuC = parcelRequire("fsvuC");

var $lNjwN = parcelRequire("lNjwN");

var $gYTIx = parcelRequire("gYTIx");
/**
 * Returns the appropriate circle stroke color.
 */ function $62d3db9976307470$var$getStrokeColor(appearance) {
    return appearance === 'inherit' ? "var(--ds-icon-subtle, #505258)" : "var(--ds-icon-inverse, #FFFFFF)";
}
const $62d3db9976307470$var$rotate = null;
/**
 * There are three parts to the load in animation:
 * 1. Accelerated spin
 * 2. Stretch the spinner line
 */ const $62d3db9976307470$var$loadIn = null;
const $62d3db9976307470$var$styles = {
    rotateStyles: "_1gBibyjjpW _0nFVCGSNCR _03m2nySHWH _43vdfTehmh _0yKXXaDIqT",
    loadInStyles: "_1gBiby2DOz _0nFVCGipXj _43vdfTN8t6 _3Y6bKpZSoF",
    wrapperStyles: "_3iDTPbccYA _1RrJLit2nV",
    circleStyles: "_1rdFvhYbGa _0v5RGkwyF1 _4gxJYwdIGx _1hdADdtuo3 _4kdxYBTxK4"
};
/**
 * `useLayoutEffect` is being used in SSR safe form. On the server, this work doesn’t need to run.
 * `useEffect` is used in-place, because `useEffect` is not run on the server and it matches types
 * which makes things simpler than doing an `isServer` check or a `null` check.
 *
 * @see https://hello.atlassian.net/wiki/spaces/DST/pages/2081696628/DSTDACI-010+-+Interaction+Tracing+hooks+in+DS+components
 */ const $62d3db9976307470$var$useLayoutEffect = typeof window === 'undefined' ? (0, $fsvuC.useEffect) : (0, $fsvuC.useLayoutEffect);
/**
 * __Spinner__
 *
 * A spinner is an animated spinning icon that lets users know content is being loaded.
 *
 * - [Examples](https://atlassian.design/components/spinner/examples)
 * - [Code](https://atlassian.design/components/spinner/code)
 * - [Usage](https://atlassian.design/components/spinner/usage)
 */ const $62d3db9976307470$var$Spinner = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).forwardRef(function Spinner({ appearance: appearance = 'inherit', delay: delay = 0, interactionName: interactionName, label: label, size: providedSize = 'medium', testId: testId }, ref) {
    const size = typeof providedSize === 'number' ? providedSize : (0, $gYTIx.presetSizes)[providedSize];
    const animationDelay = `${delay}ms`;
    const stroke = $62d3db9976307470$var$getStrokeColor(appearance);
    const context = (0, $fsvuC.useContext)((0, $lNjwN.default));
    $62d3db9976307470$var$useLayoutEffect(()=>{
        if (context != null) return context.hold(interactionName);
    }, [
        context,
        interactionName
    ]);
    /**
   * The Spinner animation uses a combination of two
   * css animations on two separate elements.
   */ return /*#__PURE__*/ (0, $5chsV.jsx)("span", {
        /**
   * This span exists to off-load animations from the circle element,
   * which were causing performance issues (style recalculations)
   * on Safari and older versions of Chrome.
   *
   * This can be removed and styles placed back on the circle element once
   * Safari fixes this bug and off-loads rendering to the GPU from the CPU.
   */ "data-testid": testId ? `${testId}-wrapper` : 'spinner-wrapper',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            animationDelay: animationDelay,
            width: size,
            height: size
        },
        className: (0, $gJ6nT.default)([
            $62d3db9976307470$var$styles.wrapperStyles,
            $62d3db9976307470$var$styles.rotateStyles
        ]),
        children: /*#__PURE__*/ (0, $5chsV.jsx)("svg", {
            height: size,
            width: size,
            viewBox: "0 0 16 16",
            xmlns: "http://www.w3.org/2000/svg",
            "data-testid": testId,
            ref: ref,
            "aria-label": label || undefined,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: {
                animationDelay: animationDelay
            },
            role: label ? 'img' : 'none',
            className: (0, $gJ6nT.default)([
                $62d3db9976307470$var$styles.loadInStyles
            ]),
            children: /*#__PURE__*/ (0, $5chsV.jsx)("circle", {
                cx: "8",
                cy: "8",
                r: "7",
                style: {
                    stroke: stroke
                },
                className: (0, $gJ6nT.default)([
                    $62d3db9976307470$var$styles.circleStyles
                ])
            })
        })
    });
}));
var $62d3db9976307470$export$2e2bcd8739ae039 = $62d3db9976307470$var$Spinner;

});
parcelRegister("gYTIx", function(module, exports) {
$parcel$export(module.exports, "presetSizes", () => $73f6b7f0a630bb23$export$4e9f1640bbe7a1a8);
const $73f6b7f0a630bb23$export$4e9f1640bbe7a1a8 = {
    xsmall: 12,
    small: 16,
    medium: 24,
    large: 48,
    xlarge: 96
};

});




parcelRegister("cBvQ0", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fec260a5beb0e93db2111df1ab9a2e97>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $92d1a309e663d7bb$var$_react = $92d1a309e663d7bb$var$_interopRequireDefault((parcelRequire("fsvuC")));

var $92d1a309e663d7bb$var$_iconNew = $92d1a309e663d7bb$var$_interopRequireDefault((parcelRequire("6SPX3")));
function $92d1a309e663d7bb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusSuccess".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/status-success
 * Usage guidance:
 * Reserved for success statuses and messaging. Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $92d1a309e663d7bb$var$StatusSuccessIcon = (props)=>/*#__PURE__*/ $92d1a309e663d7bb$var$_react.default.createElement($92d1a309e663d7bb$var$_iconNew.default, Object.assign({
        name: "StatusSuccessIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0M6.75 9.828 4.826 7.52l-1.152.96 2.5 3a.75.75 0 0 0 1.152 0l5-6-1.152-.96z" clip-rule="evenodd"/>`
    }, props));
$92d1a309e663d7bb$var$StatusSuccessIcon.displayName = 'StatusSuccessIcon';
var $92d1a309e663d7bb$var$_default = module.exports.default = $92d1a309e663d7bb$var$StatusSuccessIcon;

});

parcelRegister("9cVKi", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3ceff5ba2cd41cd6899d33441cb75c99>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6b420724ac359c45$var$_react = $6b420724ac359c45$var$_interopRequireDefault((parcelRequire("fsvuC")));

var $6b420724ac359c45$var$_iconNew = $6b420724ac359c45$var$_interopRequireDefault((parcelRequire("6SPX3")));
function $6b420724ac359c45$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronDown".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/chevron-down
 * Usage guidance:
 * Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
 * Known uses: Open dropdown menu, expanded tree item, collapse tree item
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6b420724ac359c45$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $6b420724ac359c45$var$_react.default.createElement($6b420724ac359c45$var$_iconNew.default, Object.assign({
        name: "ChevronDownIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m14.53 6.03-6 6a.75.75 0 0 1-1.004.052l-.056-.052-6-6 1.06-1.06L8 10.44l5.47-5.47z"/>`
    }, props));
$6b420724ac359c45$var$ChevronDownIcon.displayName = 'ChevronDownIcon';
var $6b420724ac359c45$var$_default = module.exports.default = $6b420724ac359c45$var$ChevronDownIcon;

});

parcelRegister("dfYNc", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fd264112f4a6872d04b33e03dd95c892>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9a6bd52f06d94368$var$_react = $9a6bd52f06d94368$var$_interopRequireDefault((parcelRequire("fsvuC")));

var $9a6bd52f06d94368$var$_iconNew = $9a6bd52f06d94368$var$_interopRequireDefault((parcelRequire("6SPX3")));
function $9a6bd52f06d94368$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronUp".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/chevron-up
 * Usage guidance:
 * Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
 * Known uses: Close dropdown menu
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9a6bd52f06d94368$var$ChevronUpIcon = (props)=>/*#__PURE__*/ $9a6bd52f06d94368$var$_react.default.createElement($9a6bd52f06d94368$var$_iconNew.default, Object.assign({
        name: "ChevronUpIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m14.53 9.97-6-6a.75.75 0 0 0-1.004-.052l-.056.052-6 6 1.06 1.06L8 5.56l5.47 5.47z"/>`
    }, props));
$9a6bd52f06d94368$var$ChevronUpIcon.displayName = 'ChevronUpIcon';
var $9a6bd52f06d94368$var$_default = module.exports.default = $9a6bd52f06d94368$var$ChevronUpIcon;

});

parcelRegister("irYrv", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fe87206c037b1ad46cb54a88ca95fa3b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d6e9a246437bf3dd$var$_react = $d6e9a246437bf3dd$var$_interopRequireDefault((parcelRequire("fsvuC")));

var $d6e9a246437bf3dd$var$_iconNew = $d6e9a246437bf3dd$var$_interopRequireDefault((parcelRequire("6SPX3")));
function $d6e9a246437bf3dd$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Cross".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/cross
 * Usage guidance:
 * Known uses: closing modals, panels, and transient views; removing tags
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d6e9a246437bf3dd$var$CrossIcon = (props)=>/*#__PURE__*/ $d6e9a246437bf3dd$var$_react.default.createElement($d6e9a246437bf3dd$var$_iconNew.default, Object.assign({
        name: "CrossIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M13.53 3.53 9.06 8l4.47 4.47-1.06 1.06L8 9.06l-4.47 4.47-1.06-1.06L6.94 8 2.47 3.53l1.06-1.06L8 6.94l4.47-4.47z"/>`
    }, props));
$d6e9a246437bf3dd$var$CrossIcon.displayName = 'CrossIcon';
var $d6e9a246437bf3dd$var$_default = module.exports.default = $d6e9a246437bf3dd$var$CrossIcon;

});

parcelRegister("cBqdE", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::341f1a6f1df1c6bee81376e850857e59>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $92cd47566ee52bc8$var$_react = $92cd47566ee52bc8$var$_interopRequireDefault((parcelRequire("fsvuC")));

var $92cd47566ee52bc8$var$_iconNew = $92cd47566ee52bc8$var$_interopRequireDefault((parcelRequire("6SPX3")));
function $92cd47566ee52bc8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusInformation".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/status-information
 * Usage guidance:
 * Reserved for information statuses and messaging.
 * Filled status icons provide higher visual contrast to draw attention to important information.
 * For information tooltips, use the unfilled 'information circle' icon.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $92cd47566ee52bc8$var$StatusInformationIcon = (props)=>/*#__PURE__*/ $92cd47566ee52bc8$var$_react.default.createElement($92cd47566ee52bc8$var$_iconNew.default, Object.assign({
        name: "StatusInformationIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0M6.5 6.75v1.5h.75v4.25h1.5v-5A.75.75 0 0 0 8 6.75zM8 3.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2" clip-rule="evenodd"/>`
    }, props));
$92cd47566ee52bc8$var$StatusInformationIcon.displayName = 'StatusInformationIcon';
var $92cd47566ee52bc8$var$_default = module.exports.default = $92cd47566ee52bc8$var$StatusInformationIcon;

});

parcelRegister("gD3tC", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cd90c08a28534c92e68f27855e77fa64>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c1b2fc45fa3238ac$var$_react = $c1b2fc45fa3238ac$var$_interopRequireDefault((parcelRequire("fsvuC")));

var $c1b2fc45fa3238ac$var$_iconNew = $c1b2fc45fa3238ac$var$_interopRequireDefault((parcelRequire("6SPX3")));
function $c1b2fc45fa3238ac$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusWarning".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/status-warning
 * Usage guidance:
 * Reserved for warning statuses.
 * Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c1b2fc45fa3238ac$var$StatusWarningIcon = (props)=>/*#__PURE__*/ $c1b2fc45fa3238ac$var$_react.default.createElement($c1b2fc45fa3238ac$var$_iconNew.default, Object.assign({
        name: "StatusWarningIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.242 1.168c.756-1.395 2.76-1.395 3.516 0l5.9 10.878c.723 1.333-.242 2.953-1.758 2.953H2.1C.584 15-.38 13.38.342 12.046zM8 10.75a1 1 0 1 0 0 2.001 1 1 0 0 0 0-2M7.25 4.5v5h1.5v-5z" clip-rule="evenodd"/>`
    }, props));
$c1b2fc45fa3238ac$var$StatusWarningIcon.displayName = 'StatusWarningIcon';
var $c1b2fc45fa3238ac$var$_default = module.exports.default = $c1b2fc45fa3238ac$var$StatusWarningIcon;

});

parcelRegister("iVedp", function(module, exports) {

var $1RI93 = parcelRequire("1RI93");

var $c5gj6 = parcelRequire("c5gj6");

var $12sEq = parcelRequire("12sEq");


var $jHROS = parcelRequire("jHROS");

var $iwItQ = parcelRequire("iwItQ");

var $iP7DD = parcelRequire("iP7DD");

var $kdyFp = parcelRequire("kdyFp");

var $aQ7Tk = parcelRequire("aQ7Tk");

var $fWdGl = parcelRequire("fWdGl");

var $5c1Bf = parcelRequire("5c1Bf");

var $fx4XM = parcelRequire("fx4XM");

var $2ata7 = parcelRequire("2ata7");

var $5lcoU = parcelRequire("5lcoU");

var $7aLHw = parcelRequire("7aLHw");

var $hL5td = parcelRequire("hL5td");

});
parcelRegister("1RI93", function(module, exports) {
$parcel$export(module.exports, "ELEMENTS_CONTEXT", () => $eb57d7648d90e6b5$export$80450e0a84a5ede9);
$parcel$export(module.exports, "FabricElementsAnalyticsContext", () => $eb57d7648d90e6b5$export$3fe25500478a635c);

var $ejiCT = parcelRequire("ejiCT");
const $eb57d7648d90e6b5$export$80450e0a84a5ede9 = 'fabricElementsCtx';
const $eb57d7648d90e6b5$export$3fe25500478a635c = (0, $ejiCT.default)($eb57d7648d90e6b5$export$80450e0a84a5ede9, 'FabricElementsAnalyticsContext');

});
parcelRegister("ejiCT", function(module, exports) {
$parcel$export(module.exports, "default", () => $c44b6dcdd25ecb93$export$2e2bcd8739ae039);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $9sl8X = parcelRequire("9sl8X");
const $c44b6dcdd25ecb93$var$createNamespaceContext = (namespace, displayName = 'NamespacedContext')=>{
    const Component = (props)=>{
        const newData = {
            [namespace]: props.data
        };
        return /*#__PURE__*/ (0, $5chsV.jsx)((0, $9sl8X.default), {
            data: newData,
            children: (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).Children.only(props.children)
        });
    };
    Component.displayName = displayName;
    return Component;
};
var $c44b6dcdd25ecb93$export$2e2bcd8739ae039 = $c44b6dcdd25ecb93$var$createNamespaceContext;

});
parcelRegister("9sl8X", function(module, exports) {
$parcel$export(module.exports, "default", () => $11d3f5cb7e3c3805$export$2e2bcd8739ae039);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $llCao = parcelRequire("llCao");

var $kkKaC = parcelRequire("kkKaC");

var $ez83N = parcelRequire("ez83N");

var $5LVve = parcelRequire("5LVve");
const $11d3f5cb7e3c3805$var$AnalyticsContext = (props)=>{
    // Resolved once at mount, never re-read: Modern and Legacy are different component types, so
    // switching on a later render would unmount the whole subtree beneath this provider.
    const [isModernContext] = (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).useState(()=>(0, $kkKaC.default) || (0, $llCao.fg)('analytics-next-use-legacy-context') === false || (0, $llCao.fg)('adminhub-analytics-next-use-modern-context') || (0, $llCao.fg)('bitbucket-analytics-next-use-modern-context'));
    return isModernContext ? /*#__PURE__*/ (0, $5chsV.jsx)((0, $5LVve.default), {
        ...props
    }) : /*#__PURE__*/ (0, $5chsV.jsx)((0, $ez83N.default), {
        ...props
    });
};
$11d3f5cb7e3c3805$var$AnalyticsContext.displayName = "AnalyticsContext";
var $11d3f5cb7e3c3805$export$2e2bcd8739ae039 = $11d3f5cb7e3c3805$var$AnalyticsContext;

});
parcelRegister("kkKaC", function(module, exports) {
$parcel$export(module.exports, "default", () => $adbeb12e0d99daa5$export$2e2bcd8739ae039);
/// <reference types="node" />

var $hoalA = parcelRequire("hoalA");
const $adbeb12e0d99daa5$var$_default_1 = typeof $hoalA !== 'undefined' && $hoalA !== null && $hoalA.env?.['ANALYTICS_NEXT_MODERN_CONTEXT'];
var $adbeb12e0d99daa5$export$2e2bcd8739ae039 = $adbeb12e0d99daa5$var$_default_1;

});

parcelRegister("ez83N", function(module, exports) {
$parcel$export(module.exports, "default", () => $f6ae4046a4bbdafb$export$2e2bcd8739ae039);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $jf0Un = parcelRequire("jf0Un");

var $d9mL9 = parcelRequire("d9mL9");
const $f6ae4046a4bbdafb$var$ContextTypes = {
    getAtlaskitAnalyticsContext: (0, (/*@__PURE__*/$parcel$interopDefault($jf0Un))).func,
    getAtlaskitAnalyticsEventHandlers: (0, (/*@__PURE__*/$parcel$interopDefault($jf0Un))).func
};
const $f6ae4046a4bbdafb$var$noop = ()=>[];
// eslint-disable-next-line @repo/internal/react/no-class-components
class $f6ae4046a4bbdafb$var$AnalyticsContext extends (0, $fsvuC.Component) {
    static{
        this.contextTypes = $f6ae4046a4bbdafb$var$ContextTypes;
    }
    static{
        this.childContextTypes = $f6ae4046a4bbdafb$var$ContextTypes;
    }
    constructor(props){
        super(props), this.getChildContext = ()=>({
                getAtlaskitAnalyticsContext: this.getAnalyticsContext
            }), this.getAnalyticsContext = ()=>{
            const { data: data } = this.props;
            const { getAtlaskitAnalyticsContext: getAtlaskitAnalyticsContext = $f6ae4046a4bbdafb$var$noop } = this.context;
            return [
                ...getAtlaskitAnalyticsContext(),
                data
            ];
        }, this.getAnalyticsEventHandlers = ()=>{
            const { getAtlaskitAnalyticsEventHandlers: getAtlaskitAnalyticsEventHandlers = $f6ae4046a4bbdafb$var$noop } = this.context;
            return getAtlaskitAnalyticsEventHandlers();
        };
        this.contextValue = {
            getAtlaskitAnalyticsContext: this.getAnalyticsContext,
            getAtlaskitAnalyticsEventHandlers: this.getAnalyticsEventHandlers
        };
    }
    render() {
        const { children: children } = this.props;
        return /*#__PURE__*/ (0, $5chsV.jsx)((0, $d9mL9.default).Provider, {
            value: this.contextValue,
            children: children
        });
    }
}
$f6ae4046a4bbdafb$var$AnalyticsContext.displayName = "AnalyticsContext";
var $f6ae4046a4bbdafb$export$2e2bcd8739ae039 = $f6ae4046a4bbdafb$var$AnalyticsContext;

});

parcelRegister("5LVve", function(module, exports) {
$parcel$export(module.exports, "default", () => $caf72e89ee790361$export$2e2bcd8739ae039);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $d9mL9 = parcelRequire("d9mL9");

var $iGFF1 = parcelRequire("iGFF1");

var $g5SRF = parcelRequire("g5SRF");
const $caf72e89ee790361$var$AnalyticsContext = ({ data: data, children: children })=>{
    const dataRef = (0, $g5SRF.useTrackedRef)(data);
    const { getAtlaskitAnalyticsEventHandlers: getAtlaskitAnalyticsEventHandlers, getAtlaskitAnalyticsContext: getOriginalAnalyticsContext } = (0, $iGFF1.useAnalyticsContext)();
    const getAtlaskitAnalyticsContext = (0, $fsvuC.useCallback)(()=>{
        return [
            ...getOriginalAnalyticsContext(),
            dataRef.current
        ];
    }, [
        getOriginalAnalyticsContext,
        dataRef
    ]);
    const value = (0, $fsvuC.useMemo)(()=>({
            getAtlaskitAnalyticsContext: getAtlaskitAnalyticsContext,
            getAtlaskitAnalyticsEventHandlers: getAtlaskitAnalyticsEventHandlers
        }), [
        getAtlaskitAnalyticsContext,
        getAtlaskitAnalyticsEventHandlers
    ]);
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $d9mL9.default).Provider, {
        value: value,
        children: children
    });
};
$caf72e89ee790361$var$AnalyticsContext.displayName = "AnalyticsContext";
var $caf72e89ee790361$export$2e2bcd8739ae039 = $caf72e89ee790361$var$AnalyticsContext;

});




parcelRegister("c5gj6", function(module, exports) {
$parcel$export(module.exports, "NAVIGATION_CONTEXT", () => $08ea24e27c84a897$export$1fd3aad76a7c6788);
$parcel$export(module.exports, "NavigationAnalyticsContext", () => $08ea24e27c84a897$export$d0a82da1a0b94929);

var $ejiCT = parcelRequire("ejiCT");
const $08ea24e27c84a897$export$1fd3aad76a7c6788 = 'navigationCtx';
const $08ea24e27c84a897$export$d0a82da1a0b94929 = (0, $ejiCT.default)($08ea24e27c84a897$export$1fd3aad76a7c6788, 'NavigationAnalyticsContext');

});

parcelRegister("12sEq", function(module, exports) {
$parcel$export(module.exports, "EDITOR_CONTEXT", () => $26fc46ea3a5b4166$export$8c8f6d8f1fa796f0);
$parcel$export(module.exports, "EDITOR_APPEARANCE_CONTEXT", () => $26fc46ea3a5b4166$export$9eb2b47430ed3f7c);
$parcel$export(module.exports, "FabricEditorAnalyticsContext", () => $26fc46ea3a5b4166$export$629cada6c5e621e1);

var $ejiCT = parcelRequire("ejiCT");
const $26fc46ea3a5b4166$export$8c8f6d8f1fa796f0 = 'fabricEditorCtx';
var $26fc46ea3a5b4166$export$9eb2b47430ed3f7c = /*#__PURE__*/ function(EDITOR_APPEARANCE_CONTEXT) {
    EDITOR_APPEARANCE_CONTEXT["FIXED_WIDTH"] = "fixedWidth";
    EDITOR_APPEARANCE_CONTEXT["FULL_WIDTH"] = "fullWidth";
    EDITOR_APPEARANCE_CONTEXT["COMMENT"] = "comment";
    EDITOR_APPEARANCE_CONTEXT["CHROMELESS"] = "chromeless";
    EDITOR_APPEARANCE_CONTEXT["MOBILE"] = "mobile";
    EDITOR_APPEARANCE_CONTEXT["MAX"] = "max";
    return EDITOR_APPEARANCE_CONTEXT;
}({});
const $26fc46ea3a5b4166$export$629cada6c5e621e1 = (0, $ejiCT.default)($26fc46ea3a5b4166$export$8c8f6d8f1fa796f0, 'FabricEditorAnalyticsContext');

});

// Media uses a namespaced analytics context under the following key MEDIA_CONTEXT.
const $3a071bccf8601cb8$export$70df29c238ba7306 = 'mediaCtx'; // However we don't export any JSX component to create that namespaced analytics context.
 // In media components, analytics context is being created by this component:
 // @see packages/media/media-common/src/analytics/withMediaAnalyticsContext.tsx

parcelRegister("jHROS", function(module, exports) {
$parcel$export(module.exports, "PEOPLE_TEAMS_CONTEXT", () => $b75b1e840f42535f$export$b326383bee6cb993);
$parcel$export(module.exports, "PeopleTeamsAnalyticsContext", () => $b75b1e840f42535f$export$4119ddb38ccbfb87);

var $ejiCT = parcelRequire("ejiCT");
const $b75b1e840f42535f$export$b326383bee6cb993 = 'peopleTeamsCtx';
const $b75b1e840f42535f$export$4119ddb38ccbfb87 = (0, $ejiCT.default)($b75b1e840f42535f$export$b326383bee6cb993, 'PeopleTeamsAnalyticsContext');

});

parcelRegister("iwItQ", function(module, exports) {
$parcel$export(module.exports, "NOTIFICATIONS_CONTEXT", () => $c0a46efe5555767e$export$da1befb791e93c7e);
$parcel$export(module.exports, "NotificationsAnalyticsContext", () => $c0a46efe5555767e$export$6f8e7ff1e3feafd7);

var $ejiCT = parcelRequire("ejiCT");
const $c0a46efe5555767e$export$da1befb791e93c7e = 'NotificationsCtx';
const $c0a46efe5555767e$export$6f8e7ff1e3feafd7 = (0, $ejiCT.default)($c0a46efe5555767e$export$da1befb791e93c7e, 'NotificationsAnalyticsContext');

});

parcelRegister("iP7DD", function(module, exports) {
$parcel$export(module.exports, "RECENT_WORK_CONTEXT", () => $af2dfe89ce15f706$export$fc7a65795610cb71);

var $ejiCT = parcelRequire("ejiCT");
const $af2dfe89ce15f706$export$fc7a65795610cb71 = 'RecentWorkCtx';
const $af2dfe89ce15f706$export$745926731087ebe2 = (0, $ejiCT.default)($af2dfe89ce15f706$export$fc7a65795610cb71, 'RecentWorkAnalyticsContext');

});

parcelRegister("kdyFp", function(module, exports) {
$parcel$export(module.exports, "ATLAS_CONTEXT", () => $34af5209014e9503$export$4906017439f33fc0);

var $ejiCT = parcelRequire("ejiCT");
const $34af5209014e9503$export$4906017439f33fc0 = 'atlasCtx';
const $34af5209014e9503$export$43ebbe41370d4543 = (0, $ejiCT.default)($34af5209014e9503$export$4906017439f33fc0, 'AtlasAnalyticsContext');

});

parcelRegister("aQ7Tk", function(module, exports) {
$parcel$export(module.exports, "TOWNSQUARE_HOME_CONTEXT", () => $eaf1fb15340e7009$export$aa18ab4fff926c9e);

var $ejiCT = parcelRequire("ejiCT");
const $eaf1fb15340e7009$export$aa18ab4fff926c9e = 'townsquareHomeCtx';
const $eaf1fb15340e7009$export$d283110f5d85c8f2 = (0, $ejiCT.default)($eaf1fb15340e7009$export$aa18ab4fff926c9e, 'TownsquareHomeAnalyticsContext');

});

parcelRegister("fWdGl", function(module, exports) {
$parcel$export(module.exports, "LINKING_PLATFORM_CONTEXT", () => $b04562caf950b1a5$export$3240443bf2b83834);

var $ejiCT = parcelRequire("ejiCT");
const $b04562caf950b1a5$export$3240443bf2b83834 = 'linkingPlatformCtx';
const $b04562caf950b1a5$export$6d568da622ce0a08 = (0, $ejiCT.default)($b04562caf950b1a5$export$3240443bf2b83834, 'LinkingPlatformAnalyticsContext');

});

parcelRegister("5c1Bf", function(module, exports) {
$parcel$export(module.exports, "POST_OFFICE_CONTEXT", () => $1d8c0a93bc0cc2af$export$ef0c05448f0f8f9);
$parcel$export(module.exports, "PostOfficeAnalyticsContext", () => $1d8c0a93bc0cc2af$export$dcd232f3be312f94);

var $ejiCT = parcelRequire("ejiCT");
const $1d8c0a93bc0cc2af$export$ef0c05448f0f8f9 = 'postOfficeCtx';
const $1d8c0a93bc0cc2af$export$dcd232f3be312f94 = (0, $ejiCT.default)($1d8c0a93bc0cc2af$export$ef0c05448f0f8f9, 'PostOfficeAnalyticsContext');

});

parcelRegister("fx4XM", function(module, exports) {
$parcel$export(module.exports, "AI_MATE_CONTEXT", () => $703792249fcc19f1$export$5c3a6fd8b96e8b66);
$parcel$export(module.exports, "AIMateAnalyticsContext", () => $703792249fcc19f1$export$de3826c30468da26);

var $ejiCT = parcelRequire("ejiCT");
const $703792249fcc19f1$export$5c3a6fd8b96e8b66 = 'aiMateCtx';
const $703792249fcc19f1$export$de3826c30468da26 = (0, $ejiCT.default)($703792249fcc19f1$export$5c3a6fd8b96e8b66, 'AIMateAnalyticsContext');

});

parcelRegister("2ata7", function(module, exports) {
$parcel$export(module.exports, "AVP_CONTEXT", () => $7b328529b50eedc7$export$c2a811a4e42f4af5);

var $ejiCT = parcelRequire("ejiCT");
const $7b328529b50eedc7$export$c2a811a4e42f4af5 = 'avpCtx';
const $7b328529b50eedc7$export$da383e8879a25b03 = (0, $ejiCT.default)($7b328529b50eedc7$export$c2a811a4e42f4af5, 'AVPAnalyticsContext');

});

parcelRegister("5lcoU", function(module, exports) {
$parcel$export(module.exports, "GROWTH_CONTEXT", () => $9d0671a65eaab4b8$export$82023f2f4bfb06c1);
$parcel$export(module.exports, "GrowthAnalyticsContext", () => $9d0671a65eaab4b8$export$84980182680018f);

var $ejiCT = parcelRequire("ejiCT");
const $9d0671a65eaab4b8$export$82023f2f4bfb06c1 = 'editionAwarenessCtx';
const $9d0671a65eaab4b8$export$84980182680018f = (0, $ejiCT.default)($9d0671a65eaab4b8$export$82023f2f4bfb06c1, 'GrowthAnalyticsContext');

});

parcelRegister("7aLHw", function(module, exports) {
$parcel$export(module.exports, "OMNI_CHANNEL_CONTEXT", () => $21ac0ede11cdbc2e$export$6d3c48fd1b3e4f3b);

var $ejiCT = parcelRequire("ejiCT");
const $21ac0ede11cdbc2e$export$6d3c48fd1b3e4f3b = 'omniChannelCtx';
const $21ac0ede11cdbc2e$export$e4e6df99270bbbb1 = (0, $ejiCT.default)($21ac0ede11cdbc2e$export$6d3c48fd1b3e4f3b, 'OmniChannelAnalyticsContext');

});

parcelRegister("hL5td", function(module, exports) {
$parcel$export(module.exports, "ROVO_EXTENSION_CONTEXT", () => $244736bca725bb21$export$fae437eb1dd9520c);

var $ejiCT = parcelRequire("ejiCT");
const $244736bca725bb21$export$fae437eb1dd9520c = 'rovoExtensionCtx';
const $244736bca725bb21$export$7fcecc25ee38fbef = (0, $ejiCT.default)($244736bca725bb21$export$fae437eb1dd9520c, 'RovoExtensionAnalyticsContext');

});


parcelRegister("1GeZO", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => (parcelRequire("4chGK")).default);
$parcel$export(module.exports, "LOG_LEVEL", () => (parcelRequire("gek4D")).LOG_LEVEL);
$parcel$export(module.exports, "FabricChannel", () => (parcelRequire("9fEYx")).FabricChannel);

var $4chGK = parcelRequire("4chGK");

var $gek4D = parcelRequire("gek4D");

var $9fEYx = parcelRequire("9fEYx");

});
parcelRegister("4chGK", function(module, exports) {
$parcel$export(module.exports, "default", () => $8e5e5306b1a47679$export$2e2bcd8739ae039);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $XASv5 = parcelRequire("XASv5");

var $lpbj6 = parcelRequire("lpbj6");

var $6pCox = parcelRequire("6pCox");

var $ldCbq = parcelRequire("ldCbq");

var $3Cp6f = parcelRequire("3Cp6f");

var $9x36Q = parcelRequire("9x36Q");

var $c5lmG = parcelRequire("c5lmG");

var $bMl9b = parcelRequire("bMl9b");

var $jqPlK = parcelRequire("jqPlK");

var $gek4D = parcelRequire("gek4D");

var $iVFTh = parcelRequire("iVFTh");

var $66gpK = parcelRequire("66gpK");

var $fBMeC = parcelRequire("fBMeC");

var $9EV4Y = parcelRequire("9EV4Y");

var $gFJcK = parcelRequire("gFJcK");

var $NnN2v = parcelRequire("NnN2v");

var $k8C09 = parcelRequire("k8C09");

var $9eBeR = parcelRequire("9eBeR");

var $i4JDX = parcelRequire("i4JDX");

var $efWAr = parcelRequire("efWAr");

var $iIEYe = parcelRequire("iIEYe");

var $9fEYx = parcelRequire("9fEYx");
const $8e5e5306b1a47679$var$listenerMap = {
    [(0, $9fEYx.FabricChannel).a2ui]: (0, $XASv5.default),
    [(0, $9fEYx.FabricChannel).elements]: (0, $bMl9b.default),
    [(0, $9fEYx.FabricChannel).editor]: (0, $c5lmG.default),
    [(0, $9fEYx.FabricChannel).atlaskit]: (0, $ldCbq.default),
    [(0, $9fEYx.FabricChannel).navigation]: (0, $fBMeC.default),
    [(0, $9fEYx.FabricChannel).media]: (0, $66gpK.default),
    [(0, $9fEYx.FabricChannel).peopleTeams]: (0, $NnN2v.default),
    [(0, $9fEYx.FabricChannel).notifications]: (0, $9EV4Y.default),
    [(0, $9fEYx.FabricChannel).recentWork]: (0, $9eBeR.default),
    [(0, $9fEYx.FabricChannel).atlas]: (0, $6pCox.default),
    [(0, $9fEYx.FabricChannel).crossFlow]: (0, $9x36Q.default),
    [(0, $9fEYx.FabricChannel).linkingPlatform]: (0, $iVFTh.default),
    [(0, $9fEYx.FabricChannel).postOffice]: (0, $k8C09.default),
    [(0, $9fEYx.FabricChannel).aiMate]: (0, $lpbj6.default),
    [(0, $9fEYx.FabricChannel).avp]: (0, $3Cp6f.default),
    [(0, $9fEYx.FabricChannel).growth]: (0, $jqPlK.default),
    [(0, $9fEYx.FabricChannel).omniChannel]: (0, $gFJcK.default),
    [(0, $9fEYx.FabricChannel).townsquareHome]: (0, $iIEYe.default),
    [(0, $9fEYx.FabricChannel).rovoExtension]: (0, $i4JDX.default),
    [(0, $9fEYx.FabricChannel).teamworkGraph]: (0, $efWAr.default)
};
class $8e5e5306b1a47679$var$FabricAnalyticsListeners extends (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).Component {
    constructor(props){
        super(props);
        this.logger = new (0, $gek4D.default)({
            logLevel: props.logLevel
        });
    }
    render() {
        const { client: client, children: children, logLevel: logLevel, excludedChannels: excludedChannels } = this.props;
        if (typeof logLevel === 'number') this.logger.setLogLevel(logLevel);
        const listeners = Object.keys($8e5e5306b1a47679$var$listenerMap).filter((channel)=>!excludedChannels || excludedChannels.indexOf(channel) < 0).map((channel)=>$8e5e5306b1a47679$var$listenerMap[channel]).reduce((prev, Listener)=>/*#__PURE__*/ (0, $5chsV.jsx)(Listener, {
                client: client,
                logger: this.logger,
                children: prev
            }), children);
        return listeners;
    }
}
$8e5e5306b1a47679$var$FabricAnalyticsListeners.displayName = "FabricAnalyticsListeners";
var $8e5e5306b1a47679$export$2e2bcd8739ae039 = $8e5e5306b1a47679$var$FabricAnalyticsListeners;

});
parcelRegister("XASv5", function(module, exports) {
$parcel$export(module.exports, "default", () => $75c2fa7e311a50ff$export$2e2bcd8739ae039);

var $5chsV = parcelRequire("5chsV");
parcelRequire("fsvuC");

var $242fy = parcelRequire("242fy");

var $9fEYx = parcelRequire("9fEYx");

var $hTFJs = parcelRequire("hTFJs");
function $75c2fa7e311a50ff$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $242fy.default), {
        ...props,
        channel: (0, $9fEYx.FabricChannel).a2ui,
        processEvent: (0, $hTFJs.default)
    });
}
$75c2fa7e311a50ff$export$2e2bcd8739ae039.displayName = "A2UIAnalyticsListener";

});
parcelRegister("242fy", function(module, exports) {
$parcel$export(module.exports, "default", () => $a26c4ecd0ba0f6ef$export$2e2bcd8739ae039);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $bjvoZ = parcelRequire("bjvoZ");

var $kVyKT = parcelRequire("kVyKT");
class $a26c4ecd0ba0f6ef$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).Component {
    render() {
        return /*#__PURE__*/ (0, $5chsV.jsx)((0, $bjvoZ.default), {
            onEvent: this.listenerHandler,
            channel: this.props.channel,
            children: this.props.children
        });
    }
    constructor(...args){
        super(...args), this.listenerHandler = (event)=>{
            const { client: client, logger: logger, channel: channel, processEvent: processEvent } = this.props;
            if (!event.payload) return;
            logger.debug(`Received ${channel} event`, event);
            const payload = processEvent(event, logger);
            logger.debug(`Processed ${channel} event`, payload);
            if (payload) (0, $kVyKT.sendEvent)(logger, client)(payload);
        };
    }
}
$a26c4ecd0ba0f6ef$export$2e2bcd8739ae039.displayName = "GenericAnalyticsListener";

});
parcelRegister("bjvoZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $d87c06d55d9de74e$export$2e2bcd8739ae039);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $llCao = parcelRequire("llCao");

var $kkKaC = parcelRequire("kkKaC");

var $1AweU = parcelRequire("1AweU");

var $bunKQ = parcelRequire("bunKQ");
const $d87c06d55d9de74e$var$AnalyticsListener = (props)=>{
    // Resolved once at mount, never re-read: Modern and Legacy are different component types, so
    // switching on a later render would unmount the whole subtree beneath this listener.
    const [isModernContext] = (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).useState(()=>(0, $kkKaC.default) || (0, $llCao.fg)('analytics-next-use-legacy-context') === false || (0, $llCao.fg)('adminhub-analytics-next-use-modern-context') || (0, $llCao.fg)('bitbucket-analytics-next-use-modern-context'));
    return isModernContext ? /*#__PURE__*/ (0, $5chsV.jsx)((0, $bunKQ.default), {
        ...props
    }) : /*#__PURE__*/ (0, $5chsV.jsx)((0, $1AweU.default), {
        ...props
    });
};
$d87c06d55d9de74e$var$AnalyticsListener.displayName = "AnalyticsListener";
var $d87c06d55d9de74e$export$2e2bcd8739ae039 = $d87c06d55d9de74e$var$AnalyticsListener;

});
parcelRegister("1AweU", function(module, exports) {
$parcel$export(module.exports, "default", () => $c0351e07e74951dc$export$2e2bcd8739ae039);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $jf0Un = parcelRequire("jf0Un");

var $d9mL9 = parcelRequire("d9mL9");
const $c0351e07e74951dc$var$ContextTypes = {
    getAtlaskitAnalyticsEventHandlers: (0, (/*@__PURE__*/$parcel$interopDefault($jf0Un))).func,
    getAtlaskitAnalyticsContext: (0, (/*@__PURE__*/$parcel$interopDefault($jf0Un))).func
};
const $c0351e07e74951dc$var$noop = ()=>[];
// eslint-disable-next-line @repo/internal/react/no-class-components
class $c0351e07e74951dc$var$AnalyticsListener extends (0, $fsvuC.Component) {
    static{
        this.contextTypes = $c0351e07e74951dc$var$ContextTypes;
    }
    static{
        this.childContextTypes = $c0351e07e74951dc$var$ContextTypes;
    }
    constructor(props){
        super(props), this.getChildContext = ()=>({
                getAtlaskitAnalyticsEventHandlers: this.getAnalyticsEventHandlers,
                getAtlaskitAnalyticsContext: this.getAtlaskitAnalyticsContext
            }), this.getAnalyticsEventHandlers = ()=>{
            const { channel: channel, onEvent: onEvent } = this.props;
            const { getAtlaskitAnalyticsEventHandlers: getAtlaskitAnalyticsEventHandlers = $c0351e07e74951dc$var$noop } = this.context;
            const handler = (event, eventChannel)=>{
                if (channel === '*' || channel === eventChannel) onEvent(event, eventChannel);
            };
            return [
                handler,
                ...getAtlaskitAnalyticsEventHandlers()
            ];
        }, this.getAtlaskitAnalyticsContext = ()=>{
            const { getAtlaskitAnalyticsContext: getAtlaskitAnalyticsContext = $c0351e07e74951dc$var$noop } = this.context;
            return getAtlaskitAnalyticsContext();
        };
        this.contextValue = {
            getAtlaskitAnalyticsContext: this.getAtlaskitAnalyticsContext,
            getAtlaskitAnalyticsEventHandlers: this.getAnalyticsEventHandlers
        };
    }
    render() {
        const { children: children } = this.props;
        return /*#__PURE__*/ (0, $5chsV.jsx)((0, $d9mL9.default).Provider, {
            value: this.contextValue,
            children: children
        });
    }
}
$c0351e07e74951dc$var$AnalyticsListener.displayName = "AnalyticsListener";
var $c0351e07e74951dc$export$2e2bcd8739ae039 = $c0351e07e74951dc$var$AnalyticsListener;

});

parcelRegister("bunKQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $c4c1705ccd5d4b85$export$2e2bcd8739ae039);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $d9mL9 = parcelRequire("d9mL9");

var $iGFF1 = parcelRequire("iGFF1");

var $g5SRF = parcelRequire("g5SRF");
const $c4c1705ccd5d4b85$var$AnalyticsListener = ({ children: children, channel: channel, onEvent: onEvent })=>{
    const { getAtlaskitAnalyticsEventHandlers: getAtlaskitAnalyticsEventHandlers = ()=>[], getAtlaskitAnalyticsContext: getAtlaskitAnalyticsContext } = (0, $iGFF1.useAnalyticsContext)();
    const onEventRef = (0, $g5SRF.useTrackedRef)(onEvent);
    const channelRef = (0, $g5SRF.useTrackedRef)(channel);
    const getAnalyticsEventHandlers = (0, $fsvuC.useCallback)(()=>{
        const thisHandler = (event, eventChannel)=>{
            if (channelRef.current === '*' || channelRef.current === eventChannel) onEventRef.current(event, eventChannel);
        };
        return [
            thisHandler,
            ...getAtlaskitAnalyticsEventHandlers()
        ];
    }, [
        channelRef,
        onEventRef,
        getAtlaskitAnalyticsEventHandlers
    ]);
    const value = (0, $fsvuC.useMemo)(()=>({
            getAtlaskitAnalyticsContext: getAtlaskitAnalyticsContext,
            getAtlaskitAnalyticsEventHandlers: getAnalyticsEventHandlers
        }), [
        getAtlaskitAnalyticsContext,
        getAnalyticsEventHandlers
    ]);
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $d9mL9.default).Provider, {
        value: value,
        children: children
    });
};
$c4c1705ccd5d4b85$var$AnalyticsListener.displayName = "AnalyticsListener";
var $c4c1705ccd5d4b85$export$2e2bcd8739ae039 = $c4c1705ccd5d4b85$var$AnalyticsListener;

});


parcelRegister("kVyKT", function(module, exports) {
$parcel$export(module.exports, "sendEvent", () => $79a792ac6df67eaa$export$7329bcdc3edcd90e);
const $79a792ac6df67eaa$var$isPromise = (c)=>{
    return typeof c.then === 'function';
};
const $79a792ac6df67eaa$export$7329bcdc3edcd90e = (logger, client)=>(event)=>{
        if (client) {
            const { eventType: eventType, ...gasEvent } = event;
            const withClient = (cb)=>{
                if ($79a792ac6df67eaa$var$isPromise(client)) client.then(cb).catch((e)=>logger.warn('There was an error sending the event', e));
                else try {
                    cb(client);
                } catch (e) {
                    logger.warn('There was an error sending the event', e);
                }
            };
            switch(event.eventType){
                case 'ui':
                    logger.debug('Sending UI Event via analytics client', gasEvent);
                    withClient((client)=>client.sendUIEvent(gasEvent));
                    break;
                case 'operational':
                    logger.debug('Sending Operational Event via analytics client', gasEvent);
                    withClient((client)=>client.sendOperationalEvent(gasEvent));
                    break;
                case 'track':
                    logger.debug('Sending Track Event via analytics client', gasEvent);
                    withClient((client)=>client.sendTrackEvent(gasEvent));
                    break;
                case 'screen':
                    logger.debug('Sending Screen Event via analytics client', gasEvent);
                    withClient((client)=>client.sendScreenEvent(gasEvent));
                    break;
                default:
                    logger.error(`cannot map eventType ${event.eventType} to an analytics-web-client function`);
            }
        } else logger.warn('AnalyticsWebClient instance is not provided');
    };

});


parcelRegister("9fEYx", function(module, exports) {
$parcel$export(module.exports, "FabricChannel", () => $b1bae648f9fad09a$export$8faa0b115ef0268b);
var $b1bae648f9fad09a$export$8faa0b115ef0268b = /*#__PURE__*/ function(FabricChannel) {
    FabricChannel["a2ui"] = "a2ui";
    FabricChannel["atlaskit"] = "atlaskit";
    FabricChannel["elements"] = "fabric-elements";
    FabricChannel["navigation"] = "navigation";
    FabricChannel["editor"] = "editor";
    FabricChannel["media"] = "media";
    FabricChannel["peopleTeams"] = "peopleTeams";
    FabricChannel["notifications"] = "notifications";
    FabricChannel["recentWork"] = "recentWork";
    FabricChannel["atlas"] = "atlas";
    FabricChannel["crossFlow"] = "crossFlow";
    FabricChannel["linkingPlatform"] = "linkingPlatform";
    FabricChannel["postOffice"] = "postOffice";
    FabricChannel["aiMate"] = "aiMate";
    FabricChannel["avp"] = "avp";
    FabricChannel["growth"] = "growth";
    FabricChannel["omniChannel"] = "omniChannel";
    FabricChannel["townsquareHome"] = "townsquareHome";
    FabricChannel["rovoExtension"] = "rovoExtension";
    FabricChannel["teamworkGraph"] = "teamworkGraph";
    return FabricChannel;
}({});

});

parcelRegister("hTFJs", function(module, exports) {
$parcel$export(module.exports, "default", () => $343ff7a762364ce1$export$2e2bcd8739ae039);
/**
 * Inspired by analytics-web-react
 */ 
var $52ohX = parcelRequire("52ohX");

var $jo5KC = parcelRequire("jo5KC");


var $2cDzW = parcelRequire("2cDzW");

var $jY52b = parcelRequire("jY52b");

var $lyDmE = parcelRequire("lyDmE");

var $k5Yej = parcelRequire("k5Yej");
const $343ff7a762364ce1$var$A2UI_CONTEXT = 'a2ui';
const $343ff7a762364ce1$var$A2UI_TAG = 'a2ui';
const $343ff7a762364ce1$var$listenerVersion = "0.0.0-use.local";
var /**
 * This util exists to convert A2UI analytics-next events into the analytics platform format.
 */ $343ff7a762364ce1$export$2e2bcd8739ae039 = (event, logger)=>{
    const sources = (0, $k5Yej.getSources)(event, $343ff7a762364ce1$var$A2UI_CONTEXT);
    const source = (0, (/*@__PURE__*/$parcel$interopDefault($52ohX)))(sources) || (0, $ddd31af8f515fa50$export$b055de0e665cb20c);
    const extraAttributes = (0, $jY52b.getExtraAttributes)(event, $343ff7a762364ce1$var$A2UI_CONTEXT);
    const components = (0, $2cDzW.getComponents)(event, $343ff7a762364ce1$var$A2UI_CONTEXT);
    const packages = (0, $lyDmE.getPackageInfo)(event, $343ff7a762364ce1$var$A2UI_CONTEXT);
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($52ohX)))(packages) ?? {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const { eventType: eventType = (0, $ddd31af8f515fa50$export$a1562d08625f5d7e), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: payloadAttributes, containerId: containerId, containerType: containerType, name: name, objectId: objectId, objectType: objectType, path: path, url: url } = event.payload;
    const attributes = {
        listenerVersion: $343ff7a762364ce1$var$listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined,
        packageName: packageName,
        packageVersion: packageVersion,
        ...(0, (/*@__PURE__*/$parcel$interopDefault($jo5KC)))(extraAttributes, payloadAttributes)
    };
    const tags = new Set(event.payload.tags || []);
    tags.add($343ff7a762364ce1$var$A2UI_TAG);
    switch(eventType){
        case 0, $ddd31af8f515fa50$export$a1562d08625f5d7e:
        case 0, $ddd31af8f515fa50$export$12346a674644c156:
        case 0, $ddd31af8f515fa50$export$947dac6c72b26f81:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags),
                ...objectId && {
                    objectId: objectId
                },
                ...objectType && {
                    objectType: objectType
                },
                ...containerType && {
                    containerType: containerType
                },
                ...containerId && {
                    containerId: containerId
                }
            };
        case 0, $ddd31af8f515fa50$export$f1d537d508d2945a:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags),
                ...path && {
                    path: path
                },
                ...url && {
                    url: url
                }
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

});
// same types defined in analytics-web-client but avoid creating dependency with that
const $ddd31af8f515fa50$export$a1562d08625f5d7e = 'ui';
const $ddd31af8f515fa50$export$947dac6c72b26f81 = 'track';
const $ddd31af8f515fa50$export$f1d537d508d2945a = 'screen';
const $ddd31af8f515fa50$export$12346a674644c156 = 'operational';
const $ddd31af8f515fa50$export$b055de0e665cb20c = 'unknown';

parcelRegister("2cDzW", function(module, exports) {
$parcel$export(module.exports, "getComponents", () => $609b67d6f3149d59$export$4e811121b221213b);
/**
 * Largely taken from analytics-web-react
 */ 
var $iD8px = parcelRequire("iD8px");
const $609b67d6f3149d59$export$4e811121b221213b = (event, contextName)=>(0, $iD8px.extractFromEventContext)([
        'component',
        'componentName'
    ], event, false, contextName);

});
parcelRegister("iD8px", function(module, exports) {
$parcel$export(module.exports, "extractFromEventContext", () => $bd57f5710c1ba171$export$9b947b4502cd2705);
/**
 * Largely taken from analytics-web-react
 */ const $bd57f5710c1ba171$export$9b947b4502cd2705 = (propertyNames, event, namespacedContextOnly = true, contextName)=>event.context.reduce((acc, contextItem)=>{
        propertyNames.forEach((propertyName)=>{
            const navContext = contextItem[contextName];
            const navContextProp = navContext ? navContext[propertyName] : null;
            const value = namespacedContextOnly ? navContextProp : navContextProp || contextItem[propertyName];
            if (value) acc.push(value);
        });
        return acc;
    }, []);

});


parcelRegister("jY52b", function(module, exports) {
$parcel$export(module.exports, "getExtraAttributes", () => $b3781dd9aeafdddc$export$67c3590839ebecdd);
/**
 * Largely taken from analytics-web-react
 */ 
var $jo5KC = parcelRequire("jo5KC");

var $iD8px = parcelRequire("iD8px");
const $b3781dd9aeafdddc$export$67c3590839ebecdd = (event, contextName)=>(0, $iD8px.extractFromEventContext)([
        'attributes'
    ], event, true, contextName).reduce((result, extraAttributes)=>(0, (/*@__PURE__*/$parcel$interopDefault($jo5KC)))(result, extraAttributes), {});

});

parcelRegister("lyDmE", function(module, exports) {
$parcel$export(module.exports, "getPackageInfo", () => $4db94ea21573bd6b$export$cd17d76da7967240);
/**
 * Largely taken from analytics-web-react
 */ const $4db94ea21573bd6b$export$cd17d76da7967240 = (event, contextName)=>event.context.map((contextItem)=>{
        const navContext = contextItem[contextName];
        const item = navContext ? navContext : contextItem;
        return {
            packageName: item.packageName,
            packageVersion: item.packageVersion
        };
    }).filter((p)=>p.packageName);

});

parcelRegister("k5Yej", function(module, exports) {
$parcel$export(module.exports, "getSources", () => $59124f000b07d224$export$5f9bc633b116660f);
/**
 * Largely taken from analytics-web-react
 */ 
var $iD8px = parcelRequire("iD8px");
const $59124f000b07d224$export$5f9bc633b116660f = (event, contextName)=>(0, $iD8px.extractFromEventContext)([
        'source'
    ], event, false, contextName);

});



parcelRegister("lpbj6", function(module, exports) {
$parcel$export(module.exports, "default", () => $b3f67e7ffc2a6fe4$export$2e2bcd8739ae039);

var $5chsV = parcelRequire("5chsV");
parcelRequire("fsvuC");

var $242fy = parcelRequire("242fy");

var $9fEYx = parcelRequire("9fEYx");

var $dQ38H = parcelRequire("dQ38H");
function $b3f67e7ffc2a6fe4$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $242fy.default), {
        ...props,
        channel: (0, $9fEYx.FabricChannel).aiMate,
        processEvent: (0, $dQ38H.default)
    });
}
$b3f67e7ffc2a6fe4$export$2e2bcd8739ae039.displayName = "AIMateAnalyticsListener";

});
parcelRegister("dQ38H", function(module, exports) {
$parcel$export(module.exports, "default", () => $ea9b65ada9b5028b$export$2e2bcd8739ae039);
/**
 * Inspired by analytics-web-react
 */ 
var $52ohX = parcelRequire("52ohX");

var $jo5KC = parcelRequire("jo5KC");


var $fx4XM = parcelRequire("fx4XM");

var $2cDzW = parcelRequire("2cDzW");

var $jY52b = parcelRequire("jY52b");

var $lyDmE = parcelRequire("lyDmE");

var $k5Yej = parcelRequire("k5Yej");
const $ea9b65ada9b5028b$var$AI_MATE_TAG = 'aiMate';
const $ea9b65ada9b5028b$var$listenerVersion = "0.0.0-use.local";
var /**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * Analytics-next event format:
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Analytics platform event format:
 *  event {
 *      type: @atlaskit/analytics-gas-types.EventType
 *      payload {
 *          ...mandatoryAttributesBasedOnEventType
 *          attributes: {
 *              ...arbitraryAttributes
 *          }
 *      }
 *  }
 */ $ea9b65ada9b5028b$export$2e2bcd8739ae039 = (event, logger)=>{
    const sources = (0, $k5Yej.getSources)(event, (0, $fx4XM.AI_MATE_CONTEXT));
    const source = (0, (/*@__PURE__*/$parcel$interopDefault($52ohX)))(sources) || (0, $ddd31af8f515fa50$export$b055de0e665cb20c);
    const extraAttributes = (0, $jY52b.getExtraAttributes)(event, (0, $fx4XM.AI_MATE_CONTEXT));
    const components = (0, $2cDzW.getComponents)(event, (0, $fx4XM.AI_MATE_CONTEXT));
    const packages = (0, $lyDmE.getPackageInfo)(event, (0, $fx4XM.AI_MATE_CONTEXT));
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($52ohX)))((0, $lyDmE.getPackageInfo)(event, (0, $fx4XM.AI_MATE_CONTEXT))) || {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const { eventType: eventType = (0, $ddd31af8f515fa50$export$a1562d08625f5d7e), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: payloadAttributes, name: name, objectId: objectId, objectType: objectType, containerType: containerType, containerId: containerId, path: path, url: url } = event.payload;
    const attributes = {
        listenerVersion: $ea9b65ada9b5028b$var$listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined,
        packageName: packageName,
        packageVersion: packageVersion,
        ...(0, (/*@__PURE__*/$parcel$interopDefault($jo5KC)))(extraAttributes, payloadAttributes)
    };
    // Ensure navigation tag is not duplicated by using Set
    const tags = new Set(event.payload.tags || []);
    tags.add($ea9b65ada9b5028b$var$AI_MATE_TAG);
    if (event.payload) switch(eventType){
        case 0, $ddd31af8f515fa50$export$a1562d08625f5d7e:
        case 0, $ddd31af8f515fa50$export$12346a674644c156:
        case 0, $ddd31af8f515fa50$export$947dac6c72b26f81:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags),
                ...objectId && {
                    objectId: objectId
                },
                ...objectType && {
                    objectType: objectType
                },
                ...containerType && {
                    containerType: containerType
                },
                ...containerId && {
                    containerId: containerId
                }
            };
        case 0, $ddd31af8f515fa50$export$f1d537d508d2945a:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags),
                ...path && {
                    path: path
                },
                ...url && {
                    url: url
                }
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

});


parcelRegister("6pCox", function(module, exports) {
$parcel$export(module.exports, "default", () => $63aa33e1f7a43a8a$export$2e2bcd8739ae039);

var $5chsV = parcelRequire("5chsV");
parcelRequire("fsvuC");

var $242fy = parcelRequire("242fy");

var $9fEYx = parcelRequire("9fEYx");

var $cqTIz = parcelRequire("cqTIz");
function $63aa33e1f7a43a8a$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $242fy.default), {
        ...props,
        channel: (0, $9fEYx.FabricChannel).atlas,
        processEvent: (0, $cqTIz.default)
    });
}
$63aa33e1f7a43a8a$export$2e2bcd8739ae039.displayName = "AtlasAnalyticsListener";

});
parcelRegister("cqTIz", function(module, exports) {
$parcel$export(module.exports, "default", () => $6408f395a1a00190$export$2e2bcd8739ae039);
/**
 * Inspired by analytics-web-react
 */ 
var $52ohX = parcelRequire("52ohX");

var $jo5KC = parcelRequire("jo5KC");


var $kdyFp = parcelRequire("kdyFp");

var $2cDzW = parcelRequire("2cDzW");

var $jY52b = parcelRequire("jY52b");

var $lyDmE = parcelRequire("lyDmE");

var $k5Yej = parcelRequire("k5Yej");
const $6408f395a1a00190$var$ATLAS_TAG = 'atlas';
const $6408f395a1a00190$var$listenerVersion = "0.0.0-use.local";
var /**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * Analytics-next event format:
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Analytics platform event format:
 *  event {
 *      type: @atlaskit/analytics-gas-types.EventType
 *      payload {
 *          ...mandatoryAttributesBasedOnEventType
 *          attributes: {
 *              ...arbitraryAttributes
 *          }
 *      }
 *  }
 */ $6408f395a1a00190$export$2e2bcd8739ae039 = (event, logger)=>{
    const sources = (0, $k5Yej.getSources)(event, (0, $kdyFp.ATLAS_CONTEXT));
    const source = (0, (/*@__PURE__*/$parcel$interopDefault($52ohX)))(sources) || (0, $ddd31af8f515fa50$export$b055de0e665cb20c);
    const extraAttributes = (0, $jY52b.getExtraAttributes)(event, (0, $kdyFp.ATLAS_CONTEXT));
    const components = (0, $2cDzW.getComponents)(event, (0, $kdyFp.ATLAS_CONTEXT));
    const packages = (0, $lyDmE.getPackageInfo)(event, (0, $kdyFp.ATLAS_CONTEXT));
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($52ohX)))((0, $lyDmE.getPackageInfo)(event, (0, $kdyFp.ATLAS_CONTEXT))) || {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const { eventType: eventType = (0, $ddd31af8f515fa50$export$a1562d08625f5d7e), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: payloadAttributes, name: name } = event.payload;
    const attributes = {
        listenerVersion: $6408f395a1a00190$var$listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined,
        packageName: packageName,
        packageVersion: packageVersion,
        ...(0, (/*@__PURE__*/$parcel$interopDefault($jo5KC)))(extraAttributes, payloadAttributes)
    };
    // Ensure navigation tag is not duplicated by using Set
    const tags = new Set(event.payload.tags || []);
    tags.add($6408f395a1a00190$var$ATLAS_TAG);
    if (event.payload) switch(eventType){
        case 0, $ddd31af8f515fa50$export$a1562d08625f5d7e:
        case 0, $ddd31af8f515fa50$export$12346a674644c156:
        case 0, $ddd31af8f515fa50$export$947dac6c72b26f81:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $ddd31af8f515fa50$export$f1d537d508d2945a:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

});


parcelRegister("ldCbq", function(module, exports) {
$parcel$export(module.exports, "default", () => $26fdf6fa9c2f6984$export$2e2bcd8739ae039);

var $5chsV = parcelRequire("5chsV");
parcelRequire("fsvuC");

var $242fy = parcelRequire("242fy");

var $9fEYx = parcelRequire("9fEYx");

var $6eTM3 = parcelRequire("6eTM3");
function $26fdf6fa9c2f6984$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $242fy.default), {
        ...props,
        channel: (0, $9fEYx.FabricChannel).atlaskit,
        processEvent: (0, $6eTM3.default)
    });
}
$26fdf6fa9c2f6984$export$2e2bcd8739ae039.displayName = "AtlaskitListener";

});
parcelRegister("6eTM3", function(module, exports) {
$parcel$export(module.exports, "default", () => $7af8763c888fa282$export$2e2bcd8739ae039);
/**
 * Inspired by analytics-web-react
 */ 
var $52ohX = parcelRequire("52ohX");

var $jo5KC = parcelRequire("jo5KC");


var $7lWZz = parcelRequire("7lWZz");

var $hgDAZ = parcelRequire("hgDAZ");

var $gxGlQ = parcelRequire("gxGlQ");

var $gfTAg = parcelRequire("gfTAg");

var $4Qoom = parcelRequire("4Qoom");

var $FYZNf = parcelRequire("FYZNf");
const $7af8763c888fa282$var$ATLASKIT_TAG = 'atlaskit';
const $7af8763c888fa282$var$listenerVersion = "0.0.0-use.local";
var /**
 * This util exists to convert the Atlaskit event format into the analytics platform format.
 *
 * Atlaskit event format:
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Analytics platform event format:
 *  event {
 *      type: @atlaskit/analytics-gas-types.EventType
 *      payload {
 *          ...mandatoryAttributesBasedOnEventType
 *          attributes: {
 *              ...arbitraryAttributes
 *          }
 *      }
 *  }
 */ $7af8763c888fa282$export$2e2bcd8739ae039 = (event, logger)=>{
    const sources = (0, $FYZNf.getSources)(event);
    const source = (0, (/*@__PURE__*/$parcel$interopDefault($52ohX)))(sources) || (0, $ddd31af8f515fa50$export$b055de0e665cb20c);
    const extraAttributes = (0, $gxGlQ.getExtraAttributes)(event);
    const components = (0, $hgDAZ.getComponents)(event);
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($52ohX)))((0, $4Qoom.getPackageInfo)(event)) || {};
    const { eventType: eventType = (0, $ddd31af8f515fa50$export$a1562d08625f5d7e), action: action, actionSubjectId: actionSubjectId, attributes: payloadAttributes, containerId: containerId } = event.payload;
    const attributes = {
        listenerVersion: $7af8763c888fa282$var$listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: (0, $gfTAg.getPackageHierarchy)(event) || undefined,
        packageName: packageName,
        packageVersion: packageVersion,
        ...(0, (/*@__PURE__*/$parcel$interopDefault($jo5KC)))(extraAttributes, payloadAttributes)
    };
    // Ensure atlaskit tag is not duplicated by using Set
    const tags = new Set(event.payload.tags || []);
    tags.add($7af8763c888fa282$var$ATLASKIT_TAG);
    if (event.payload) {
        if (eventType === (0, $ddd31af8f515fa50$export$a1562d08625f5d7e)) return {
            eventType: eventType,
            source: source,
            actionSubject: (0, $7lWZz.getActionSubject)(event),
            action: action,
            actionSubjectId: actionSubjectId,
            attributes: attributes,
            containerId: containerId,
            tags: Array.from(tags)
        };
        if (eventType === (0, $ddd31af8f515fa50$export$947dac6c72b26f81) || eventType === (0, $ddd31af8f515fa50$export$12346a674644c156) || eventType === (0, $ddd31af8f515fa50$export$f1d537d508d2945a)) logger.error('Track, screen and operational events are currently not supported for atlaskit events');
        else logger.error('Invalid event type', eventType);
    }
    return null;
};

});
parcelRegister("7lWZz", function(module, exports) {
$parcel$export(module.exports, "getActionSubject", () => $fab9336aabe8d426$export$6f40cdf6d42c018d);
/**
 * Largely taken from analytics-web-react
 */ 
var $ftzJJ = parcelRequire("ftzJJ");
const $fab9336aabe8d426$export$6f40cdf6d42c018d = (event)=>{
    const overrides = (0, $ftzJJ.extractFromEventContext)('actionSubjectOverride', event);
    const closestContext = event.context.length > 0 ? event.context[event.context.length - 1] : {};
    const actionSubject = event.payload.actionSubject || closestContext.component;
    return overrides.length > 0 ? overrides[0] : actionSubject;
};

});
parcelRegister("ftzJJ", function(module, exports) {
$parcel$export(module.exports, "extractFromEventContext", () => $cb15cf46c54fb107$export$9b947b4502cd2705);
/**
 * Largely taken from analytics-web-react
 */ const $cb15cf46c54fb107$export$9b947b4502cd2705 = (propertyName, event)=>event.context.map((contextItem)=>contextItem[propertyName]).filter(Boolean);

});


parcelRegister("hgDAZ", function(module, exports) {
$parcel$export(module.exports, "getComponents", () => $5b2453a181969459$export$4e811121b221213b);
/**
 * Largely taken from analytics-web-react
 */ 
var $ftzJJ = parcelRequire("ftzJJ");
const $5b2453a181969459$export$4e811121b221213b = (event)=>(0, $ftzJJ.extractFromEventContext)('component', event);

});

parcelRegister("gxGlQ", function(module, exports) {
$parcel$export(module.exports, "getExtraAttributes", () => $2789cdd5031e59b6$export$67c3590839ebecdd);
/**
 * Largely taken from analytics-web-react
 */ 
var $jo5KC = parcelRequire("jo5KC");

var $ftzJJ = parcelRequire("ftzJJ");
const $2789cdd5031e59b6$export$67c3590839ebecdd = (event)=>(0, $ftzJJ.extractFromEventContext)('attributes', event).reduce((result, extraAttributes)=>(0, (/*@__PURE__*/$parcel$interopDefault($jo5KC)))(result, extraAttributes), {});

});

parcelRegister("gfTAg", function(module, exports) {
$parcel$export(module.exports, "getPackageHierarchy", () => $3b4c97b87d82166c$export$4e0b83da1896ebc7);
/**
 * Largely taken from analytics-web-react
 */ 
var $4Qoom = parcelRequire("4Qoom");
function $3b4c97b87d82166c$export$4e0b83da1896ebc7(event) {
    const packages = (0, $4Qoom.getPackageInfo)(event) || [];
    return packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName).join(',') || undefined;
}

});
parcelRegister("4Qoom", function(module, exports) {
$parcel$export(module.exports, "getPackageInfo", () => $789e543a72f48727$export$cd17d76da7967240);
/**
 * Largely taken from analytics-web-react
 */ const $789e543a72f48727$export$cd17d76da7967240 = (event)=>event.context.map((contextItem)=>({
            packageName: contextItem.packageName,
            packageVersion: contextItem.packageVersion
        })).filter((p)=>p.packageName);

});


parcelRegister("FYZNf", function(module, exports) {
$parcel$export(module.exports, "getSources", () => $715e4d94579a5d62$export$5f9bc633b116660f);
/**
 * Largely taken from analytics-web-react
 */ 
var $ftzJJ = parcelRequire("ftzJJ");
const $715e4d94579a5d62$export$5f9bc633b116660f = (event)=>(0, $ftzJJ.extractFromEventContext)('source', event);

});



parcelRegister("3Cp6f", function(module, exports) {
$parcel$export(module.exports, "default", () => $f0b166d78857393f$export$2e2bcd8739ae039);

var $5chsV = parcelRequire("5chsV");
parcelRequire("fsvuC");

var $242fy = parcelRequire("242fy");

var $9fEYx = parcelRequire("9fEYx");

var $5JUfq = parcelRequire("5JUfq");
function $f0b166d78857393f$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $242fy.default), {
        ...props,
        channel: (0, $9fEYx.FabricChannel).avp,
        processEvent: (0, $5JUfq.default)
    });
}
$f0b166d78857393f$export$2e2bcd8739ae039.displayName = "AVPAnalyticsListener";

});
parcelRegister("5JUfq", function(module, exports) {
$parcel$export(module.exports, "default", () => $5e7706a1078fcd70$export$2e2bcd8739ae039);
/**
 * Inspired by analytics-web-react
 */ 
var $52ohX = parcelRequire("52ohX");

var $jo5KC = parcelRequire("jo5KC");


var $2ata7 = parcelRequire("2ata7");

var $2cDzW = parcelRequire("2cDzW");

var $jY52b = parcelRequire("jY52b");

var $lyDmE = parcelRequire("lyDmE");

var $k5Yej = parcelRequire("k5Yej");
const $5e7706a1078fcd70$var$AVP_TAG = 'avp';
const $5e7706a1078fcd70$var$AVP_PLATFORM_TAG = 'analyticsVisualizationPlatform';
const $5e7706a1078fcd70$var$listenerVersion = "0.0.0-use.local";
var /**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * Analytics-next event format:
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Analytics platform event format:
 *  event {
 *      type: @atlaskit/analytics-gas-types.EventType
 *      payload {
 *          ...mandatoryAttributesBasedOnEventType
 *          attributes: {
 *              ...arbitraryAttributes
 *          }
 *      }
 *  }
 */ $5e7706a1078fcd70$export$2e2bcd8739ae039 = (event, logger)=>{
    const sources = (0, $k5Yej.getSources)(event, (0, $2ata7.AVP_CONTEXT));
    const source = (0, (/*@__PURE__*/$parcel$interopDefault($52ohX)))(sources) || (0, $ddd31af8f515fa50$export$b055de0e665cb20c);
    const extraAttributes = (0, $jY52b.getExtraAttributes)(event, (0, $2ata7.AVP_CONTEXT));
    const components = (0, $2cDzW.getComponents)(event, (0, $2ata7.AVP_CONTEXT));
    const packages = (0, $lyDmE.getPackageInfo)(event, (0, $2ata7.AVP_CONTEXT));
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($52ohX)))((0, $lyDmE.getPackageInfo)(event, (0, $2ata7.AVP_CONTEXT))) || {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const { eventType: eventType = (0, $ddd31af8f515fa50$export$a1562d08625f5d7e), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: payloadAttributes, name: name } = event.payload;
    const attributes = {
        listenerVersion: $5e7706a1078fcd70$var$listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined,
        packageName: packageName,
        packageVersion: packageVersion,
        ...(0, (/*@__PURE__*/$parcel$interopDefault($jo5KC)))(extraAttributes, payloadAttributes),
        ...(0, (/*@__PURE__*/$parcel$interopDefault($jo5KC)))({}, ...event.context)
    };
    // Put the registered platform tag first for product attribution, retaining the legacy tag.
    const tags = new Set([
        $5e7706a1078fcd70$var$AVP_PLATFORM_TAG,
        $5e7706a1078fcd70$var$AVP_TAG,
        ...event.payload.tags || []
    ]);
    if (event.payload) switch(eventType){
        case 0, $ddd31af8f515fa50$export$a1562d08625f5d7e:
        case 0, $ddd31af8f515fa50$export$12346a674644c156:
        case 0, $ddd31af8f515fa50$export$947dac6c72b26f81:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $ddd31af8f515fa50$export$f1d537d508d2945a:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

});


parcelRegister("9x36Q", function(module, exports) {
$parcel$export(module.exports, "default", () => $a349fea34694c9df$export$2e2bcd8739ae039);

var $5chsV = parcelRequire("5chsV");
parcelRequire("fsvuC");

var $242fy = parcelRequire("242fy");

var $9fEYx = parcelRequire("9fEYx");

var $2OSVr = parcelRequire("2OSVr");
function $a349fea34694c9df$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $242fy.default), {
        ...props,
        channel: (0, $9fEYx.FabricChannel).crossFlow,
        processEvent: (0, $2OSVr.default)
    });
}
$a349fea34694c9df$export$2e2bcd8739ae039.displayName = "CrossFlowAnalyticsListener";

});
parcelRegister("2OSVr", function(module, exports) {
$parcel$export(module.exports, "default", () => $3a28b2236392603c$export$2e2bcd8739ae039);
/**
 * Inspired by analytics-web-react
 */ 
var $52ohX = parcelRequire("52ohX");


var $c5gj6 = parcelRequire("c5gj6");

var $gxGlQ = parcelRequire("gxGlQ");

var $FYZNf = parcelRequire("FYZNf");

var $jY52b = parcelRequire("jY52b");
const $3a28b2236392603c$var$CROSS_FLOW_TAG = 'crossFlow';
var $3a28b2236392603c$export$2e2bcd8739ae039 = (event, logger)=>{
    const { eventType: eventType = (0, $ddd31af8f515fa50$export$a1562d08625f5d7e), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, name: name } = event.payload;
    let sources = (0, $FYZNf.getSources)(event);
    const lastSourceFromContext = (0, (/*@__PURE__*/$parcel$interopDefault($52ohX)))(sources);
    const source = event.payload.source ?? lastSourceFromContext;
    if (lastSourceFromContext !== source) sources.push(source);
    const attributes = {
        // To get extra attributes from AnalyticsContext from other products/platforms, e.g. Jira-frontend
        ...(0, $gxGlQ.getExtraAttributes)(event),
        // To inherit the extra attributes from the navigation (Atlassian Switcher) context into the crossFlow events,
        // because the events current crossFlow touchpionts already inherit these attributes in the payload.
        ...(0, $jY52b.getExtraAttributes)(event, (0, $c5gj6.NAVIGATION_CONTEXT)),
        ...event.payload.attributes,
        namespaces: sources.join('.')
    };
    // Ensure navigation tag is not duplicated by using Set
    const tags = new Set(event.payload.tags || []);
    tags.add($3a28b2236392603c$var$CROSS_FLOW_TAG);
    if (event.payload) switch(eventType){
        case 0, $ddd31af8f515fa50$export$a1562d08625f5d7e:
        case 0, $ddd31af8f515fa50$export$12346a674644c156:
        case 0, $ddd31af8f515fa50$export$947dac6c72b26f81:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $ddd31af8f515fa50$export$f1d537d508d2945a:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

});


parcelRegister("c5lmG", function(module, exports) {
$parcel$export(module.exports, "EDITOR_TAG", () => $227d01b4c42eb8de$export$a1d9dc589a29b3aa);
$parcel$export(module.exports, "default", () => $227d01b4c42eb8de$export$2e2bcd8739ae039);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $bjvoZ = parcelRequire("bjvoZ");

var $9fEYx = parcelRequire("9fEYx");

var $gzEvY = parcelRequire("gzEvY");
const $227d01b4c42eb8de$export$a1d9dc589a29b3aa = 'editor';
const $227d01b4c42eb8de$export$8aa0d788f94a809 = 'fabricEditor';
class $227d01b4c42eb8de$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).Component {
    render() {
        return /*#__PURE__*/ (0, $5chsV.jsx)((0, $bjvoZ.default), {
            onEvent: this.handleEventWrapper,
            channel: (0, $9fEYx.FabricChannel).editor,
            children: this.props.children
        });
    }
    constructor(...args){
        super(...args), this.handleEventWrapper = (event)=>{
            (0, $gzEvY.handleEvent)(event, [
                $227d01b4c42eb8de$export$a1d9dc589a29b3aa,
                $227d01b4c42eb8de$export$8aa0d788f94a809
            ], this.props.logger, this.props.client);
        };
    }
}
$227d01b4c42eb8de$export$2e2bcd8739ae039.displayName = "FabricEditorListener";

});
parcelRegister("gzEvY", function(module, exports) {
$parcel$export(module.exports, "handleEvent", () => $f1a1d937158cd431$export$d6e5ca10785815df);

var $kVyKT = parcelRequire("kVyKT");

var $hxTlL = parcelRequire("hxTlL");
const $f1a1d937158cd431$export$d6e5ca10785815df = (event, // If passing through multiple tags, the primary tag should be first in the array.
// The primary tag is used for matching context.
tags, logger, client)=>{
    if (!event.payload) return;
    const payload = (0, $hxTlL.processEventPayload)(event, tags);
    (0, $kVyKT.sendEvent)(logger, client)(payload);
};

});
parcelRegister("hxTlL", function(module, exports) {
$parcel$export(module.exports, "processEventPayload", () => $8e24801dad205c6f$export$c37d638b7f2ca192);

var $jo5KC = parcelRequire("jo5KC");


var $12sEq = parcelRequire("12sEq");

var $1RI93 = parcelRequire("1RI93");

var $c5lmG = parcelRequire("c5lmG");

var $bMl9b = parcelRequire("bMl9b");
const $8e24801dad205c6f$var$extractFieldsFromContext = (fieldsToPick)=>(contexts)=>contexts.map((ctx)=>fieldsToPick.reduce((result, key)=>ctx[key] ? (0, (/*@__PURE__*/$parcel$interopDefault($jo5KC)))(result, {
                    [key]: ctx[key]
                }) : result, {})).reduce((result, item)=>(0, (/*@__PURE__*/$parcel$interopDefault($jo5KC)))(result, item), {});
const $8e24801dad205c6f$var$fieldExtractor = (contextKey)=>$8e24801dad205c6f$var$extractFieldsFromContext([
        'source',
        'objectType',
        'objectId',
        'containerType',
        'containerId',
        contextKey
    ]);
const $8e24801dad205c6f$var$getContextKey = (tag)=>{
    switch(tag){
        case 0, $bMl9b.ELEMENTS_TAG:
            return 0, $1RI93.ELEMENTS_CONTEXT;
        case 0, $c5lmG.EDITOR_TAG:
            return 0, $12sEq.EDITOR_CONTEXT;
        default:
            return '';
    }
};
const $8e24801dad205c6f$var$updatePayloadWithContext = (primaryTag, event)=>{
    if (event.context.length === 0) return {
        source: (0, $ddd31af8f515fa50$export$b055de0e665cb20c),
        ...event.payload
    };
    const contextKey = $8e24801dad205c6f$var$getContextKey(primaryTag) || 'attributes';
    const { [contextKey]: attributes, ...fields } = $8e24801dad205c6f$var$fieldExtractor(contextKey)(event.context);
    if (attributes) event.payload.attributes = (0, (/*@__PURE__*/$parcel$interopDefault($jo5KC)))(attributes, event.payload.attributes || {});
    return {
        source: (0, $ddd31af8f515fa50$export$b055de0e665cb20c),
        ...fields,
        ...event.payload
    };
};
const $8e24801dad205c6f$var$addTags = (tags, originalTags = [])=>{
    const mergedTags = new Set([
        ...originalTags,
        ...tags
    ]);
    return Array.from(mergedTags);
};
/**
 * The primary tag is used for matching the analytics event payload
 * with its context.
 */ function $8e24801dad205c6f$var$getPrimaryTag(tags) {
    if (typeof tags === 'string') return tags;
    if (!tags.length) throw new Error('Empty tags string array. Unable to match analytics event payload with context');
    return tags[0];
}
const $8e24801dad205c6f$export$c37d638b7f2ca192 = (event, tags)=>{
    const primaryTag = $8e24801dad205c6f$var$getPrimaryTag(tags);
    const tagsArray = typeof tags === 'string' ? [
        tags
    ] : tags;
    return {
        ...$8e24801dad205c6f$var$updatePayloadWithContext(primaryTag, event),
        tags: $8e24801dad205c6f$var$addTags(tagsArray, event.payload.tags)
    };
};

});
parcelRegister("bMl9b", function(module, exports) {
$parcel$export(module.exports, "ELEMENTS_TAG", () => $9fe0cfaa0685fcf3$export$ed71ae78997933a);
$parcel$export(module.exports, "default", () => $9fe0cfaa0685fcf3$export$2e2bcd8739ae039);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $bjvoZ = parcelRequire("bjvoZ");

var $9fEYx = parcelRequire("9fEYx");

var $gzEvY = parcelRequire("gzEvY");
const $9fe0cfaa0685fcf3$export$ed71ae78997933a = 'fabricElements';
class $9fe0cfaa0685fcf3$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).Component {
    render() {
        return /*#__PURE__*/ (0, $5chsV.jsx)((0, $bjvoZ.default), {
            onEvent: this.handleEventWrapper,
            channel: (0, $9fEYx.FabricChannel).elements,
            children: this.props.children
        });
    }
    constructor(...args){
        super(...args), this.handleEventWrapper = (event)=>{
            (0, $gzEvY.handleEvent)(event, $9fe0cfaa0685fcf3$export$ed71ae78997933a, this.props.logger, this.props.client);
        };
    }
}
$9fe0cfaa0685fcf3$export$2e2bcd8739ae039.displayName = "FabricElementsListener";

});




parcelRegister("jqPlK", function(module, exports) {
$parcel$export(module.exports, "default", () => $2b9dcbb3b886f441$export$2e2bcd8739ae039);

var $5chsV = parcelRequire("5chsV");
parcelRequire("fsvuC");

var $242fy = parcelRequire("242fy");

var $9fEYx = parcelRequire("9fEYx");

var $jl9VE = parcelRequire("jl9VE");
function $2b9dcbb3b886f441$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $242fy.default), {
        ...props,
        channel: (0, $9fEYx.FabricChannel).growth,
        processEvent: (0, $jl9VE.default)
    });
}
$2b9dcbb3b886f441$export$2e2bcd8739ae039.displayName = "GrowthAnalyticsListener";

});
parcelRegister("jl9VE", function(module, exports) {
$parcel$export(module.exports, "default", () => $c53dd776c7a04e7f$export$2e2bcd8739ae039);
/**
 * Inspired by analytics-web-react
 */ 
var $52ohX = parcelRequire("52ohX");

var $jo5KC = parcelRequire("jo5KC");


var $5lcoU = parcelRequire("5lcoU");

var $2cDzW = parcelRequire("2cDzW");

var $jY52b = parcelRequire("jY52b");

var $lyDmE = parcelRequire("lyDmE");

var $k5Yej = parcelRequire("k5Yej");
const $c53dd776c7a04e7f$var$GROWTH_TAG = 'growth';
const $c53dd776c7a04e7f$var$listenerVersion = "0.0.0-use.local";
var /**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * Analytics-next event format:
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Analytics platform event format:
 *  event {
 *      type: @atlaskit/analytics-gas-types.EventType
 *      payload {
 *          ...mandatoryAttributesBasedOnEventType
 *          attributes: {
 *              ...arbitraryAttributes
 *          }
 *      }
 *  }
 */ $c53dd776c7a04e7f$export$2e2bcd8739ae039 = (event, logger)=>{
    const sources = (0, $k5Yej.getSources)(event, (0, $5lcoU.GROWTH_CONTEXT));
    const source = (0, (/*@__PURE__*/$parcel$interopDefault($52ohX)))(sources) || (0, $ddd31af8f515fa50$export$b055de0e665cb20c);
    const extraAttributes = (0, $jY52b.getExtraAttributes)(event, (0, $5lcoU.GROWTH_CONTEXT));
    const components = (0, $2cDzW.getComponents)(event, (0, $5lcoU.GROWTH_CONTEXT));
    const packages = (0, $lyDmE.getPackageInfo)(event, (0, $5lcoU.GROWTH_CONTEXT));
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($52ohX)))((0, $lyDmE.getPackageInfo)(event, (0, $5lcoU.GROWTH_CONTEXT))) || {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const { eventType: eventType = (0, $ddd31af8f515fa50$export$a1562d08625f5d7e), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: payloadAttributes, name: name } = event.payload;
    const attributes = {
        listenerVersion: $c53dd776c7a04e7f$var$listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined,
        packageName: packageName,
        packageVersion: packageVersion,
        ...(0, (/*@__PURE__*/$parcel$interopDefault($jo5KC)))(extraAttributes, payloadAttributes)
    };
    // Ensure navigation tag is not duplicated by using Set
    const tags = new Set(event.payload.tags || []);
    tags.add($c53dd776c7a04e7f$var$GROWTH_TAG);
    if (event.payload) switch(eventType){
        case 0, $ddd31af8f515fa50$export$a1562d08625f5d7e:
        case 0, $ddd31af8f515fa50$export$12346a674644c156:
        case 0, $ddd31af8f515fa50$export$947dac6c72b26f81:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $ddd31af8f515fa50$export$f1d537d508d2945a:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

});


parcelRegister("gek4D", function(module, exports) {
$parcel$export(module.exports, "LOG_LEVEL", () => $cf06f03cb490b183$export$ffe0c436e29512cf);
$parcel$export(module.exports, "default", () => $cf06f03cb490b183$export$2e2bcd8739ae039);
/* eslint-disable no-console */ const $cf06f03cb490b183$export$ffe0c436e29512cf = {
    DEBUG: 0,
    INFO: 1,
    WARN: 2,
    ERROR: 3,
    OFF: 4
};
class $cf06f03cb490b183$export$2e2bcd8739ae039 {
    constructor({ logLevel: logLevel } = {}){
        this.logLevel = $cf06f03cb490b183$export$ffe0c436e29512cf.OFF;
        if (typeof logLevel === 'number') this.setLogLevel(logLevel);
    }
    setLogLevel(logLevel) {
        if (logLevel >= $cf06f03cb490b183$export$ffe0c436e29512cf.DEBUG && logLevel <= $cf06f03cb490b183$export$ffe0c436e29512cf.OFF) this.logLevel = +logLevel;
        else this.logLevel = $cf06f03cb490b183$export$ffe0c436e29512cf.OFF;
    }
    logMessage(level, type, ...args) {
        if (level >= this.logLevel) console[type](...args);
    }
    debug(...args) {
        this.logMessage($cf06f03cb490b183$export$ffe0c436e29512cf.DEBUG, 'log', ...args);
    }
    info(...args) {
        this.logMessage($cf06f03cb490b183$export$ffe0c436e29512cf.INFO, 'info', ...args);
    }
    warn(...args) {
        this.logMessage($cf06f03cb490b183$export$ffe0c436e29512cf.WARN, 'warn', ...args);
    }
    error(...args) {
        this.logMessage($cf06f03cb490b183$export$ffe0c436e29512cf.ERROR, 'error', ...args);
    }
}

});

parcelRegister("iVFTh", function(module, exports) {
$parcel$export(module.exports, "default", () => $2f3c9c6a007a1186$export$2e2bcd8739ae039);

var $5chsV = parcelRequire("5chsV");
parcelRequire("fsvuC");

var $242fy = parcelRequire("242fy");

var $9fEYx = parcelRequire("9fEYx");

var $2fVrC = parcelRequire("2fVrC");
function $2f3c9c6a007a1186$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $242fy.default), {
        ...props,
        channel: (0, $9fEYx.FabricChannel).linkingPlatform,
        processEvent: (0, $2fVrC.default)
    });
}
$2f3c9c6a007a1186$export$2e2bcd8739ae039.displayName = "LinkingPlatformAnalyticsListener";

});
parcelRegister("2fVrC", function(module, exports) {
$parcel$export(module.exports, "default", () => $767c79c60bc38d89$export$2e2bcd8739ae039);

var $52ohX = parcelRequire("52ohX");

var $jo5KC = parcelRequire("jo5KC");


var $fWdGl = parcelRequire("fWdGl");

var $2cDzW = parcelRequire("2cDzW");

var $jY52b = parcelRequire("jY52b");

var $lyDmE = parcelRequire("lyDmE");

var $k5Yej = parcelRequire("k5Yej");

var $9fEYx = parcelRequire("9fEYx");
const $767c79c60bc38d89$var$listenerVersion = "0.0.0-use.local";
var $767c79c60bc38d89$export$2e2bcd8739ae039 = (event)=>{
    const sources = (0, $k5Yej.getSources)(event, (0, $fWdGl.LINKING_PLATFORM_CONTEXT));
    const packages = (0, $lyDmE.getPackageInfo)(event, (0, $fWdGl.LINKING_PLATFORM_CONTEXT));
    const components = (0, $2cDzW.getComponents)(event, (0, $fWdGl.LINKING_PLATFORM_CONTEXT));
    const extraAttributes = (0, $jY52b.getExtraAttributes)(event, (0, $fWdGl.LINKING_PLATFORM_CONTEXT));
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($52ohX)))(packages) || {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const tags = new Set(event.payload.tags || []);
    tags.add((0, $9fEYx.FabricChannel).linkingPlatform);
    const payload = {
        name: event.payload.name,
        action: event.payload.action,
        actionSubject: event.payload.actionSubject,
        actionSubjectId: event.payload.actionSubjectId,
        eventType: event.payload.eventType,
        attributes: {
            packageName: packageName,
            packageVersion: packageVersion,
            listenerVersion: $767c79c60bc38d89$var$listenerVersion,
            sourceHierarchy: sources.join('.') || undefined,
            componentHierarchy: components.join('.') || undefined,
            packageHierarchy: packageHierarchy.join(',') || undefined,
            ...(0, (/*@__PURE__*/$parcel$interopDefault($jo5KC)))(extraAttributes, event.payload.attributes)
        },
        tags: Array.from(tags),
        source: (0, (/*@__PURE__*/$parcel$interopDefault($52ohX)))(sources) || (0, $ddd31af8f515fa50$export$b055de0e665cb20c),
        nonPrivacySafeAttributes: event.payload.nonPrivacySafeAttributes
    };
    return payload;
};

});


parcelRegister("66gpK", function(module, exports) {
$parcel$export(module.exports, "default", () => $b70807e78c4e0a76$export$2e2bcd8739ae039);

var $5chsV = parcelRequire("5chsV");
parcelRequire("fsvuC");

var $242fy = parcelRequire("242fy");

var $9fEYx = parcelRequire("9fEYx");

var $dKm98 = parcelRequire("dKm98");
function $b70807e78c4e0a76$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $242fy.default), {
        ...props,
        channel: (0, $9fEYx.FabricChannel).media,
        processEvent: (0, $dKm98.processEvent)
    });
}
$b70807e78c4e0a76$export$2e2bcd8739ae039.displayName = "MediaAnalyticsListener";

});
parcelRegister("dKm98", function(module, exports) {
$parcel$export(module.exports, "processEvent", () => $dbd9b8b79e4701fa$export$22af68e3614bf024);

var $52ohX = parcelRequire("52ohX");

var $jo5KC = parcelRequire("jo5KC");



var $ftzJJ = parcelRequire("ftzJJ");

var $hgDAZ = parcelRequire("hgDAZ");

var $gxGlQ = parcelRequire("gxGlQ");

var $gfTAg = parcelRequire("gfTAg");

var $4Qoom = parcelRequire("4Qoom");

var $FYZNf = parcelRequire("FYZNf");
const $dbd9b8b79e4701fa$var$listenerVersion = "0.0.0-use.local";
function $dbd9b8b79e4701fa$var$getMediaContexts(event) {
    return (0, $ftzJJ.extractFromEventContext)((0, $3a071bccf8601cb8$export$70df29c238ba7306), event);
}
function $dbd9b8b79e4701fa$var$getMediaRegion() {
    try {
        // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
        return window && window.sessionStorage && window.sessionStorage.getItem('media-api-region');
    } catch (e) {
        return;
    }
}
function $dbd9b8b79e4701fa$export$22af68e3614bf024(event) {
    const sources = (0, $FYZNf.getSources)(event);
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($52ohX)))((0, $4Qoom.getPackageInfo)(event)) || {};
    const extraAttributes = (0, $gxGlQ.getExtraAttributes)(event);
    const mediaContexts = $dbd9b8b79e4701fa$var$getMediaContexts(event) || [];
    const mediaAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($jo5KC)))({}, ...mediaContexts);
    const tags = new Set(event.payload.tags || []);
    tags.add('media');
    const components = (0, $hgDAZ.getComponents)(event);
    const mediaRegion = $dbd9b8b79e4701fa$var$getMediaRegion();
    const payload = {
        source: (0, (/*@__PURE__*/$parcel$interopDefault($52ohX)))(sources) || (0, $ddd31af8f515fa50$export$b055de0e665cb20c),
        actionSubject: event.payload.actionSubject,
        action: event.payload.action,
        eventType: event.payload.eventType,
        actionSubjectId: event.payload.actionSubjectId,
        // for backward compatibilty
        name: event.payload.name,
        tags: Array.from(tags),
        attributes: {
            packageName: packageName,
            packageVersion: packageVersion,
            ...(0, (/*@__PURE__*/$parcel$interopDefault($jo5KC)))({}, extraAttributes, mediaAttributes, event.payload.attributes),
            componentHierarchy: components.join('.') || undefined,
            packageHierarchy: (0, $gfTAg.getPackageHierarchy)(event),
            sourceHierarchy: sources.join('.') || undefined,
            listenerVersion: $dbd9b8b79e4701fa$var$listenerVersion,
            ...mediaRegion ? {
                mediaRegion: mediaRegion
            } : undefined
        },
        nonPrivacySafeAttributes: event.payload.nonPrivacySafeAttributes
    };
    return payload;
}

});


parcelRegister("fBMeC", function(module, exports) {
$parcel$export(module.exports, "default", () => $de0b5e8831d62c8c$export$2e2bcd8739ae039);

var $5chsV = parcelRequire("5chsV");
parcelRequire("fsvuC");

var $242fy = parcelRequire("242fy");

var $9fEYx = parcelRequire("9fEYx");

var $du66C = parcelRequire("du66C");
function $de0b5e8831d62c8c$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $242fy.default), {
        ...props,
        channel: (0, $9fEYx.FabricChannel).navigation,
        processEvent: (0, $du66C.default)
    });
}
$de0b5e8831d62c8c$export$2e2bcd8739ae039.displayName = "NavigationListener";

});
parcelRegister("du66C", function(module, exports) {
$parcel$export(module.exports, "default", () => $70a8c17511b79364$export$2e2bcd8739ae039);
/**
 * Inspired by analytics-web-react
 */ 
var $52ohX = parcelRequire("52ohX");

var $jo5KC = parcelRequire("jo5KC");


var $c5gj6 = parcelRequire("c5gj6");

var $2cDzW = parcelRequire("2cDzW");

var $jY52b = parcelRequire("jY52b");

var $lyDmE = parcelRequire("lyDmE");

var $k5Yej = parcelRequire("k5Yej");
const $70a8c17511b79364$var$NAVIGATION_TAG = 'navigation';
const $70a8c17511b79364$var$listenerVersion = "0.0.0-use.local";
var /**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * Analytics-next event format:
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Analytics platform event format:
 *  event {
 *      type: @atlaskit/analytics-gas-types.EventType
 *      payload {
 *          ...mandatoryAttributesBasedOnEventType
 *          attributes: {
 *              ...arbitraryAttributes
 *          }
 *      }
 *  }
 */ $70a8c17511b79364$export$2e2bcd8739ae039 = (event, logger)=>{
    const sources = (0, $k5Yej.getSources)(event, (0, $c5gj6.NAVIGATION_CONTEXT));
    const source = (0, (/*@__PURE__*/$parcel$interopDefault($52ohX)))(sources) || (0, $ddd31af8f515fa50$export$b055de0e665cb20c);
    const extraAttributes = (0, $jY52b.getExtraAttributes)(event, (0, $c5gj6.NAVIGATION_CONTEXT));
    const components = (0, $2cDzW.getComponents)(event, (0, $c5gj6.NAVIGATION_CONTEXT));
    const packages = (0, $lyDmE.getPackageInfo)(event, (0, $c5gj6.NAVIGATION_CONTEXT));
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($52ohX)))((0, $lyDmE.getPackageInfo)(event, (0, $c5gj6.NAVIGATION_CONTEXT))) || {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const { eventType: eventType = (0, $ddd31af8f515fa50$export$a1562d08625f5d7e), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: payloadAttributes, name: name } = event.payload;
    const attributes = {
        listenerVersion: $70a8c17511b79364$var$listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined,
        packageName: packageName,
        packageVersion: packageVersion,
        ...(0, (/*@__PURE__*/$parcel$interopDefault($jo5KC)))(extraAttributes, payloadAttributes)
    };
    // Ensure navigation tag is not duplicated by using Set
    const tags = new Set(event.payload.tags || []);
    tags.add($70a8c17511b79364$var$NAVIGATION_TAG);
    if (event.payload) switch(eventType){
        case 0, $ddd31af8f515fa50$export$a1562d08625f5d7e:
        case 0, $ddd31af8f515fa50$export$12346a674644c156:
        case 0, $ddd31af8f515fa50$export$947dac6c72b26f81:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $ddd31af8f515fa50$export$f1d537d508d2945a:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

});


parcelRegister("9EV4Y", function(module, exports) {
$parcel$export(module.exports, "default", () => $88adb9cd5450e999$export$2e2bcd8739ae039);

var $5chsV = parcelRequire("5chsV");
parcelRequire("fsvuC");

var $242fy = parcelRequire("242fy");

var $9fEYx = parcelRequire("9fEYx");

var $bto5m = parcelRequire("bto5m");
function $88adb9cd5450e999$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $242fy.default), {
        ...props,
        channel: (0, $9fEYx.FabricChannel).notifications,
        processEvent: (0, $bto5m.default)
    });
}
$88adb9cd5450e999$export$2e2bcd8739ae039.displayName = "NotificationsAnalyticsListener";

});
parcelRegister("bto5m", function(module, exports) {
$parcel$export(module.exports, "default", () => $4d303c1eb48e167b$export$2e2bcd8739ae039);
/**
 * Inspired by analytics-web-react
 */ 
var $52ohX = parcelRequire("52ohX");

var $jo5KC = parcelRequire("jo5KC");


var $iwItQ = parcelRequire("iwItQ");

var $2cDzW = parcelRequire("2cDzW");

var $jY52b = parcelRequire("jY52b");

var $lyDmE = parcelRequire("lyDmE");

var $k5Yej = parcelRequire("k5Yej");

var $9fEYx = parcelRequire("9fEYx");
const $4d303c1eb48e167b$var$listenerVersion = "0.0.0-use.local";
var /**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * Analytics-next event format:
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Analytics platform event format:
 *  event {
 *      type: @atlaskit/analytics-gas-types.EventType
 *      payload {
 *          ...mandatoryAttributesBasedOnEventType
 *          attributes: {
 *              ...arbitraryAttributes
 *          }
 *      }
 *  }
 */ $4d303c1eb48e167b$export$2e2bcd8739ae039 = (event, logger)=>{
    const sources = (0, $k5Yej.getSources)(event, (0, $iwItQ.NOTIFICATIONS_CONTEXT));
    const source = (0, (/*@__PURE__*/$parcel$interopDefault($52ohX)))(sources) || (0, $ddd31af8f515fa50$export$b055de0e665cb20c);
    const extraAttributes = (0, $jY52b.getExtraAttributes)(event, (0, $iwItQ.NOTIFICATIONS_CONTEXT));
    const components = (0, $2cDzW.getComponents)(event, (0, $iwItQ.NOTIFICATIONS_CONTEXT));
    const packages = (0, $lyDmE.getPackageInfo)(event, (0, $iwItQ.NOTIFICATIONS_CONTEXT));
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($52ohX)))((0, $lyDmE.getPackageInfo)(event, (0, $iwItQ.NOTIFICATIONS_CONTEXT))) || {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const { eventType: eventType = (0, $ddd31af8f515fa50$export$a1562d08625f5d7e), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: payloadAttributes, name: name } = event.payload;
    const attributes = {
        listenerVersion: $4d303c1eb48e167b$var$listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined,
        packageName: packageName,
        packageVersion: packageVersion,
        ...(0, (/*@__PURE__*/$parcel$interopDefault($jo5KC)))(extraAttributes, payloadAttributes)
    };
    // Ensure navigation tag is not duplicated by using Set
    const tags = new Set(event.payload.tags || []);
    tags.add((0, $9fEYx.FabricChannel).notifications);
    if (event.payload) switch(eventType){
        case 0, $ddd31af8f515fa50$export$a1562d08625f5d7e:
        case 0, $ddd31af8f515fa50$export$12346a674644c156:
        case 0, $ddd31af8f515fa50$export$947dac6c72b26f81:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $ddd31af8f515fa50$export$f1d537d508d2945a:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

});


parcelRegister("gFJcK", function(module, exports) {
$parcel$export(module.exports, "default", () => $c4a01e805cd83afe$export$2e2bcd8739ae039);

var $5chsV = parcelRequire("5chsV");
parcelRequire("fsvuC");

var $242fy = parcelRequire("242fy");

var $9fEYx = parcelRequire("9fEYx");

var $byw2L = parcelRequire("byw2L");
const $c4a01e805cd83afe$var$OmniChannelAnalyticsListener = (props)=>{
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $242fy.default), {
        ...props,
        channel: (0, $9fEYx.FabricChannel).omniChannel,
        processEvent: (0, $byw2L.default)
    });
};
$c4a01e805cd83afe$var$OmniChannelAnalyticsListener.displayName = "OmniChannelAnalyticsListener";
var $c4a01e805cd83afe$export$2e2bcd8739ae039 = $c4a01e805cd83afe$var$OmniChannelAnalyticsListener;

});
parcelRegister("byw2L", function(module, exports) {
$parcel$export(module.exports, "default", () => $d246f26ba3b85c35$export$2e2bcd8739ae039);

var $52ohX = parcelRequire("52ohX");

var $jo5KC = parcelRequire("jo5KC");


var $7aLHw = parcelRequire("7aLHw");

var $2cDzW = parcelRequire("2cDzW");

var $jY52b = parcelRequire("jY52b");

var $lyDmE = parcelRequire("lyDmE");

var $k5Yej = parcelRequire("k5Yej");

var $9fEYx = parcelRequire("9fEYx");
const $d246f26ba3b85c35$var$listenerVersion = "0.0.0-use.local";
var $d246f26ba3b85c35$export$2e2bcd8739ae039 = (event, logger)=>{
    const sources = (0, $k5Yej.getSources)(event, (0, $7aLHw.OMNI_CHANNEL_CONTEXT));
    const source = (0, (/*@__PURE__*/$parcel$interopDefault($52ohX)))(sources) || (0, $ddd31af8f515fa50$export$b055de0e665cb20c);
    const extraAttributes = (0, $jY52b.getExtraAttributes)(event, (0, $7aLHw.OMNI_CHANNEL_CONTEXT));
    const components = (0, $2cDzW.getComponents)(event, (0, $7aLHw.OMNI_CHANNEL_CONTEXT));
    const packages = (0, $lyDmE.getPackageInfo)(event, (0, $7aLHw.OMNI_CHANNEL_CONTEXT));
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($52ohX)))((0, $lyDmE.getPackageInfo)(event, (0, $7aLHw.OMNI_CHANNEL_CONTEXT))) || {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const { eventType: eventType = (0, $ddd31af8f515fa50$export$a1562d08625f5d7e), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: payloadAttributes, name: name } = event.payload;
    const attributes = {
        listenerVersion: $d246f26ba3b85c35$var$listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined,
        packageName: packageName,
        packageVersion: packageVersion,
        ...(0, (/*@__PURE__*/$parcel$interopDefault($jo5KC)))(extraAttributes, payloadAttributes)
    };
    // Ensure navigation tag is not duplicated by using Set
    const tags = new Set(event.payload.tags || []);
    tags.add((0, $9fEYx.FabricChannel).omniChannel);
    if (event.payload) switch(eventType){
        case 0, $ddd31af8f515fa50$export$a1562d08625f5d7e:
        case 0, $ddd31af8f515fa50$export$12346a674644c156:
        case 0, $ddd31af8f515fa50$export$947dac6c72b26f81:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $ddd31af8f515fa50$export$f1d537d508d2945a:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

});


parcelRegister("NnN2v", function(module, exports) {
$parcel$export(module.exports, "default", () => $7dbbbb9035ad5f78$export$2e2bcd8739ae039);

var $5chsV = parcelRequire("5chsV");
parcelRequire("fsvuC");

var $242fy = parcelRequire("242fy");

var $9fEYx = parcelRequire("9fEYx");

var $6fBsN = parcelRequire("6fBsN");
function $7dbbbb9035ad5f78$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $242fy.default), {
        ...props,
        channel: (0, $9fEYx.FabricChannel).peopleTeams,
        processEvent: (0, $6fBsN.default)
    });
}
$7dbbbb9035ad5f78$export$2e2bcd8739ae039.displayName = "PeopleTeamsAnalyticsListener";

});
parcelRegister("6fBsN", function(module, exports) {
$parcel$export(module.exports, "default", () => $4357a59385743706$export$2e2bcd8739ae039);
/**
 * Inspired by analytics-web-react
 */ 
var $52ohX = parcelRequire("52ohX");

var $jo5KC = parcelRequire("jo5KC");


var $jHROS = parcelRequire("jHROS");

var $2cDzW = parcelRequire("2cDzW");

var $jY52b = parcelRequire("jY52b");

var $lyDmE = parcelRequire("lyDmE");

var $k5Yej = parcelRequire("k5Yej");
const $4357a59385743706$var$PEOPLE_TEAMS_TAG = 'peopleTeams';
const $4357a59385743706$var$listenerVersion = "0.0.0-use.local";
var /**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * Analytics-next event format:
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Analytics platform event format:
 *  event {
 *      type: @atlaskit/analytics-gas-types.EventType
 *      payload {
 *          ...mandatoryAttributesBasedOnEventType
 *          attributes: {
 *              ...arbitraryAttributes
 *          }
 *      }
 *  }
 */ $4357a59385743706$export$2e2bcd8739ae039 = (event, logger)=>{
    const sources = (0, $k5Yej.getSources)(event, (0, $jHROS.PEOPLE_TEAMS_CONTEXT));
    const source = (0, (/*@__PURE__*/$parcel$interopDefault($52ohX)))(sources) || (0, $ddd31af8f515fa50$export$b055de0e665cb20c);
    const extraAttributes = (0, $jY52b.getExtraAttributes)(event, (0, $jHROS.PEOPLE_TEAMS_CONTEXT));
    const components = (0, $2cDzW.getComponents)(event, (0, $jHROS.PEOPLE_TEAMS_CONTEXT));
    const packages = (0, $lyDmE.getPackageInfo)(event, (0, $jHROS.PEOPLE_TEAMS_CONTEXT));
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($52ohX)))((0, $lyDmE.getPackageInfo)(event, (0, $jHROS.PEOPLE_TEAMS_CONTEXT))) || {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const { eventType: eventType = (0, $ddd31af8f515fa50$export$a1562d08625f5d7e), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: payloadAttributes, name: name } = event.payload;
    const attributes = {
        listenerVersion: $4357a59385743706$var$listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined,
        packageName: packageName,
        packageVersion: packageVersion,
        ...(0, (/*@__PURE__*/$parcel$interopDefault($jo5KC)))(extraAttributes, payloadAttributes)
    };
    // Ensure navigation tag is not duplicated by using Set
    const tags = new Set(event.payload.tags || []);
    tags.add($4357a59385743706$var$PEOPLE_TEAMS_TAG);
    if (event.payload) switch(eventType){
        case 0, $ddd31af8f515fa50$export$a1562d08625f5d7e:
        case 0, $ddd31af8f515fa50$export$12346a674644c156:
        case 0, $ddd31af8f515fa50$export$947dac6c72b26f81:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $ddd31af8f515fa50$export$f1d537d508d2945a:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

});


parcelRegister("k8C09", function(module, exports) {
$parcel$export(module.exports, "default", () => $254bc4ebab0fcec1$export$2e2bcd8739ae039);

var $5chsV = parcelRequire("5chsV");
parcelRequire("fsvuC");

var $242fy = parcelRequire("242fy");

var $9fEYx = parcelRequire("9fEYx");

var $hHQTB = parcelRequire("hHQTB");
function $254bc4ebab0fcec1$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $242fy.default), {
        ...props,
        channel: (0, $9fEYx.FabricChannel).postOffice,
        processEvent: (0, $hHQTB.default)
    });
}
$254bc4ebab0fcec1$export$2e2bcd8739ae039.displayName = "PostOfficeAnalyticsListener";

});
parcelRegister("hHQTB", function(module, exports) {
$parcel$export(module.exports, "default", () => $27661230ab28cfef$export$2e2bcd8739ae039);
/**
 * Inspired by analytics-web-react
 */ 
var $52ohX = parcelRequire("52ohX");

var $jo5KC = parcelRequire("jo5KC");


var $5c1Bf = parcelRequire("5c1Bf");

var $2cDzW = parcelRequire("2cDzW");

var $jY52b = parcelRequire("jY52b");

var $lyDmE = parcelRequire("lyDmE");

var $k5Yej = parcelRequire("k5Yej");

var $9fEYx = parcelRequire("9fEYx");
const $27661230ab28cfef$var$POST_OFFICE_TAG = (0, $9fEYx.FabricChannel).postOffice;
const $27661230ab28cfef$var$listenerVersion = "0.0.0-use.local";
var /**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * Analytics-next event format:
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Analytics platform event format:
 *  event {
 *      type: @atlaskit/analytics-gas-types.EventType
 *      payload {
 *          ...mandatoryAttributesBasedOnEventType
 *          attributes: {
 *              ...arbitraryAttributes
 *          }
 *      }
 *  }
 */ $27661230ab28cfef$export$2e2bcd8739ae039 = (event, logger)=>{
    const sources = (0, $k5Yej.getSources)(event, (0, $5c1Bf.POST_OFFICE_CONTEXT));
    const source = (0, (/*@__PURE__*/$parcel$interopDefault($52ohX)))(sources) || (0, $ddd31af8f515fa50$export$b055de0e665cb20c);
    const extraAttributes = (0, $jY52b.getExtraAttributes)(event, (0, $5c1Bf.POST_OFFICE_CONTEXT));
    const components = (0, $2cDzW.getComponents)(event, (0, $5c1Bf.POST_OFFICE_CONTEXT));
    const packages = (0, $lyDmE.getPackageInfo)(event, (0, $5c1Bf.POST_OFFICE_CONTEXT));
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($52ohX)))((0, $lyDmE.getPackageInfo)(event, (0, $5c1Bf.POST_OFFICE_CONTEXT))) || {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const { eventType: eventType = (0, $ddd31af8f515fa50$export$a1562d08625f5d7e), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: payloadAttributes, name: name } = event.payload;
    const attributes = {
        listenerVersion: $27661230ab28cfef$var$listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined,
        packageName: packageName,
        packageVersion: packageVersion,
        ...(0, (/*@__PURE__*/$parcel$interopDefault($jo5KC)))(extraAttributes, payloadAttributes)
    };
    // Ensure navigation tag is not duplicated by using Set
    const tags = new Set(event.payload.tags || []);
    tags.add($27661230ab28cfef$var$POST_OFFICE_TAG);
    if (event.payload) switch(eventType){
        case 0, $ddd31af8f515fa50$export$a1562d08625f5d7e:
        case 0, $ddd31af8f515fa50$export$12346a674644c156:
        case 0, $ddd31af8f515fa50$export$947dac6c72b26f81:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $ddd31af8f515fa50$export$f1d537d508d2945a:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

});


parcelRegister("9eBeR", function(module, exports) {
$parcel$export(module.exports, "default", () => $bb472f4ea781ea3a$export$2e2bcd8739ae039);

var $5chsV = parcelRequire("5chsV");
parcelRequire("fsvuC");

var $242fy = parcelRequire("242fy");

var $9fEYx = parcelRequire("9fEYx");

var $jnqqE = parcelRequire("jnqqE");
function $bb472f4ea781ea3a$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $242fy.default), {
        ...props,
        channel: (0, $9fEYx.FabricChannel).recentWork,
        processEvent: (0, $jnqqE.default)
    });
}
$bb472f4ea781ea3a$export$2e2bcd8739ae039.displayName = "RecentWorkAnalyticsListener";

});
parcelRegister("jnqqE", function(module, exports) {
$parcel$export(module.exports, "default", () => $d00beecfe9c8bf6c$export$2e2bcd8739ae039);
/**
 * Inspired by analytics-web-react
 */ 
var $52ohX = parcelRequire("52ohX");

var $jo5KC = parcelRequire("jo5KC");


var $iP7DD = parcelRequire("iP7DD");

var $2cDzW = parcelRequire("2cDzW");

var $jY52b = parcelRequire("jY52b");

var $lyDmE = parcelRequire("lyDmE");

var $k5Yej = parcelRequire("k5Yej");

var $9fEYx = parcelRequire("9fEYx");
const $d00beecfe9c8bf6c$var$listenerVersion = "0.0.0-use.local";
var /**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * Analytics-next event format:
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Analytics platform event format:
 *  event {
 *      type: @atlaskit/analytics-gas-types.EventType
 *      payload {
 *          ...mandatoryAttributesBasedOnEventType
 *          attributes: {
 *              ...arbitraryAttributes
 *          }
 *      }
 *  }
 */ $d00beecfe9c8bf6c$export$2e2bcd8739ae039 = (event, logger)=>{
    const sources = (0, $k5Yej.getSources)(event, (0, $iP7DD.RECENT_WORK_CONTEXT));
    const source = (0, (/*@__PURE__*/$parcel$interopDefault($52ohX)))(sources) || (0, $ddd31af8f515fa50$export$b055de0e665cb20c);
    const extraAttributes = (0, $jY52b.getExtraAttributes)(event, (0, $iP7DD.RECENT_WORK_CONTEXT));
    const components = (0, $2cDzW.getComponents)(event, (0, $iP7DD.RECENT_WORK_CONTEXT));
    const packages = (0, $lyDmE.getPackageInfo)(event, (0, $iP7DD.RECENT_WORK_CONTEXT));
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($52ohX)))((0, $lyDmE.getPackageInfo)(event, (0, $iP7DD.RECENT_WORK_CONTEXT))) || {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const { eventType: eventType = (0, $ddd31af8f515fa50$export$a1562d08625f5d7e), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: payloadAttributes, name: name } = event.payload;
    const attributes = {
        listenerVersion: $d00beecfe9c8bf6c$var$listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined,
        packageName: packageName,
        packageVersion: packageVersion,
        ...(0, (/*@__PURE__*/$parcel$interopDefault($jo5KC)))(extraAttributes, payloadAttributes)
    };
    // Ensure navigation tag is not duplicated by using Set
    const tags = new Set(event.payload.tags || []);
    tags.add((0, $9fEYx.FabricChannel).recentWork);
    if (event.payload) switch(eventType){
        case 0, $ddd31af8f515fa50$export$a1562d08625f5d7e:
        case 0, $ddd31af8f515fa50$export$12346a674644c156:
        case 0, $ddd31af8f515fa50$export$947dac6c72b26f81:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $ddd31af8f515fa50$export$f1d537d508d2945a:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

});


parcelRegister("i4JDX", function(module, exports) {
$parcel$export(module.exports, "default", () => $9009df0b8a54d21c$export$2e2bcd8739ae039);

var $5chsV = parcelRequire("5chsV");
parcelRequire("fsvuC");

var $242fy = parcelRequire("242fy");

var $9fEYx = parcelRequire("9fEYx");

var $7OZRC = parcelRequire("7OZRC");
function $9009df0b8a54d21c$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $242fy.default), {
        ...props,
        channel: (0, $9fEYx.FabricChannel).rovoExtension,
        processEvent: (0, $7OZRC.default)
    });
}
$9009df0b8a54d21c$export$2e2bcd8739ae039.displayName = "RovoExtensionAnalyticsListener";

});
parcelRegister("7OZRC", function(module, exports) {
$parcel$export(module.exports, "default", () => $5eecd25f966b9057$export$2e2bcd8739ae039);

var $52ohX = parcelRequire("52ohX");

var $jo5KC = parcelRequire("jo5KC");


var $hL5td = parcelRequire("hL5td");

var $2cDzW = parcelRequire("2cDzW");

var $jY52b = parcelRequire("jY52b");

var $lyDmE = parcelRequire("lyDmE");

var $k5Yej = parcelRequire("k5Yej");
const $5eecd25f966b9057$var$ROVO_EXTENSION_TAG = 'rovoExtension';
const $5eecd25f966b9057$var$listenerVersion = "0.0.0-use.local";
var /**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * It's a copy paste from the other process-event mappers.
 */ $5eecd25f966b9057$export$2e2bcd8739ae039 = (event, logger)=>{
    const sources = (0, $k5Yej.getSources)(event, (0, $hL5td.ROVO_EXTENSION_CONTEXT));
    const source = (0, (/*@__PURE__*/$parcel$interopDefault($52ohX)))(sources) || (0, $ddd31af8f515fa50$export$b055de0e665cb20c);
    const extraAttributes = (0, $jY52b.getExtraAttributes)(event, (0, $hL5td.ROVO_EXTENSION_CONTEXT));
    const components = (0, $2cDzW.getComponents)(event, (0, $hL5td.ROVO_EXTENSION_CONTEXT));
    const packages = (0, $lyDmE.getPackageInfo)(event, (0, $hL5td.ROVO_EXTENSION_CONTEXT));
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($52ohX)))((0, $lyDmE.getPackageInfo)(event, (0, $hL5td.ROVO_EXTENSION_CONTEXT))) || {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const { eventType: eventType = (0, $ddd31af8f515fa50$export$a1562d08625f5d7e), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: payloadAttributes, name: name } = event.payload;
    const attributes = {
        listenerVersion: $5eecd25f966b9057$var$listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined,
        packageName: packageName,
        packageVersion: packageVersion,
        ...(0, (/*@__PURE__*/$parcel$interopDefault($jo5KC)))(extraAttributes, payloadAttributes)
    };
    const tags = new Set(event.payload.tags || []);
    // "rovoExtension" allows us to differentiate our events from rovo events.
    tags.add($5eecd25f966b9057$var$ROVO_EXTENSION_TAG);
    if (event.payload) switch(eventType){
        case 0, $ddd31af8f515fa50$export$a1562d08625f5d7e:
        case 0, $ddd31af8f515fa50$export$12346a674644c156:
        case 0, $ddd31af8f515fa50$export$947dac6c72b26f81:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $ddd31af8f515fa50$export$f1d537d508d2945a:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

});


parcelRegister("efWAr", function(module, exports) {
$parcel$export(module.exports, "default", () => $a2f952797dde29fa$export$2e2bcd8739ae039);

var $5chsV = parcelRequire("5chsV");
parcelRequire("fsvuC");

var $242fy = parcelRequire("242fy");

var $9fEYx = parcelRequire("9fEYx");

var $bDyPe = parcelRequire("bDyPe");
function $a2f952797dde29fa$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $242fy.default), {
        ...props,
        channel: (0, $9fEYx.FabricChannel).teamworkGraph,
        processEvent: (0, $bDyPe.processEvent)
    });
}
$a2f952797dde29fa$export$2e2bcd8739ae039.displayName = "TeamworkGraphAnalyticsListener";

});
parcelRegister("bDyPe", function(module, exports) {
$parcel$export(module.exports, "processEvent", () => $32c2321f92655687$export$22af68e3614bf024);

var $52ohX = parcelRequire("52ohX");

var $jo5KC = parcelRequire("jo5KC");


var $hgDAZ = parcelRequire("hgDAZ");

var $gxGlQ = parcelRequire("gxGlQ");

var $gfTAg = parcelRequire("gfTAg");

var $4Qoom = parcelRequire("4Qoom");

var $FYZNf = parcelRequire("FYZNf");
const $32c2321f92655687$var$listenerVersion = "0.0.0-use.local";
function $32c2321f92655687$export$22af68e3614bf024(event) {
    const sources = (0, $FYZNf.getSources)(event);
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($52ohX)))((0, $4Qoom.getPackageInfo)(event)) || {};
    const extraAttributes = (0, $gxGlQ.getExtraAttributes)(event);
    const tags = new Set(event.payload.tags || []);
    tags.add('teamworkGraph');
    const components = (0, $hgDAZ.getComponents)(event);
    const payload = {
        source: (0, (/*@__PURE__*/$parcel$interopDefault($52ohX)))(sources) || (0, $ddd31af8f515fa50$export$b055de0e665cb20c),
        actionSubject: event.payload.actionSubject,
        action: event.payload.action,
        eventType: event.payload.eventType,
        actionSubjectId: event.payload.actionSubjectId,
        name: event.payload.name,
        tags: Array.from(tags),
        attributes: {
            packageName: packageName,
            packageVersion: packageVersion,
            ...(0, (/*@__PURE__*/$parcel$interopDefault($jo5KC)))({}, extraAttributes, event.payload.attributes),
            componentHierarchy: components.join('.') || undefined,
            packageHierarchy: (0, $gfTAg.getPackageHierarchy)(event),
            sourceHierarchy: sources.join('.') || undefined,
            listenerVersion: $32c2321f92655687$var$listenerVersion
        },
        nonPrivacySafeAttributes: event.payload.nonPrivacySafeAttributes
    };
    return payload;
}

});


parcelRegister("iIEYe", function(module, exports) {
$parcel$export(module.exports, "default", () => $e7ff57177dacde43$export$2e2bcd8739ae039);

var $5chsV = parcelRequire("5chsV");
parcelRequire("fsvuC");

var $242fy = parcelRequire("242fy");

var $9fEYx = parcelRequire("9fEYx");

var $9nbif = parcelRequire("9nbif");
function $e7ff57177dacde43$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $242fy.default), {
        ...props,
        channel: (0, $9fEYx.FabricChannel).townsquareHome,
        processEvent: (0, $9nbif.default)
    });
}
$e7ff57177dacde43$export$2e2bcd8739ae039.displayName = "TownsquareHomeAnalyticsListener";

});
parcelRegister("9nbif", function(module, exports) {
$parcel$export(module.exports, "default", () => $0ba2ce93bb2fc40a$export$2e2bcd8739ae039);

var $52ohX = parcelRequire("52ohX");

var $jo5KC = parcelRequire("jo5KC");


var $aQ7Tk = parcelRequire("aQ7Tk");

var $2cDzW = parcelRequire("2cDzW");

var $jY52b = parcelRequire("jY52b");

var $lyDmE = parcelRequire("lyDmE");

var $k5Yej = parcelRequire("k5Yej");
const $0ba2ce93bb2fc40a$var$TOWNSQUARE_TAG = 'townsquare';
const $0ba2ce93bb2fc40a$var$TOWNSQUARE_HOME_TAG = 'townsquareHome';
const $0ba2ce93bb2fc40a$var$listenerVersion = "0.0.0-use.local";
var /**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * It's a copy paste from the other process-event mappers.
 */ $0ba2ce93bb2fc40a$export$2e2bcd8739ae039 = (event, logger)=>{
    const sources = (0, $k5Yej.getSources)(event, (0, $aQ7Tk.TOWNSQUARE_HOME_CONTEXT));
    const source = (0, (/*@__PURE__*/$parcel$interopDefault($52ohX)))(sources) || (0, $ddd31af8f515fa50$export$b055de0e665cb20c);
    const extraAttributes = (0, $jY52b.getExtraAttributes)(event, (0, $aQ7Tk.TOWNSQUARE_HOME_CONTEXT));
    const components = (0, $2cDzW.getComponents)(event, (0, $aQ7Tk.TOWNSQUARE_HOME_CONTEXT));
    const packages = (0, $lyDmE.getPackageInfo)(event, (0, $aQ7Tk.TOWNSQUARE_HOME_CONTEXT));
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($52ohX)))((0, $lyDmE.getPackageInfo)(event, (0, $aQ7Tk.TOWNSQUARE_HOME_CONTEXT))) || {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const { eventType: eventType = (0, $ddd31af8f515fa50$export$a1562d08625f5d7e), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: payloadAttributes, name: name } = event.payload;
    const attributes = {
        listenerVersion: $0ba2ce93bb2fc40a$var$listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined,
        packageName: packageName,
        packageVersion: packageVersion,
        ...(0, (/*@__PURE__*/$parcel$interopDefault($jo5KC)))(extraAttributes, payloadAttributes)
    };
    const tags = new Set(event.payload.tags || []);
    // "townsquare" is our platform analytic for data portal
    tags.add($0ba2ce93bb2fc40a$var$TOWNSQUARE_TAG);
    // "townsquareHome" allows us to differentiate our events from townsquare events.
    tags.add($0ba2ce93bb2fc40a$var$TOWNSQUARE_HOME_TAG);
    if (event.payload) switch(eventType){
        case 0, $ddd31af8f515fa50$export$a1562d08625f5d7e:
        case 0, $ddd31af8f515fa50$export$12346a674644c156:
        case 0, $ddd31af8f515fa50$export$947dac6c72b26f81:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $ddd31af8f515fa50$export$f1d537d508d2945a:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

});




parcelRegister("4Bv9E", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => (parcelRequire("intO7")).default);
$parcel$export(module.exports, "AutoDismissFlag", () => (parcelRequire("3muTT")).default);
$parcel$export(module.exports, "FlagGroup", () => (parcelRequire("bnLBB")).default);
$parcel$export(module.exports, "FlagsProvider", () => (parcelRequire("j1DKB")).FlagsProvider);
$parcel$export(module.exports, "useFlags", () => (parcelRequire("2orDX")).useFlags);
$parcel$export(module.exports, "withFlagsProvider", () => (parcelRequire("3iiGg")).withFlagsProvider);

var $intO7 = parcelRequire("intO7");

var $3muTT = parcelRequire("3muTT");

var $bnLBB = parcelRequire("bnLBB");

var $j1DKB = parcelRequire("j1DKB");

var $2orDX = parcelRequire("2orDX");

var $3iiGg = parcelRequire("3iiGg");

});
parcelRegister("intO7", function(module, exports) {
$parcel$export(module.exports, "default", () => $c4e1fa95b0cffe56$export$2e2bcd8739ae039);
/* flag.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $gJ6nT = parcelRequire("gJ6nT");

var $d5Gwv = parcelRequire("d5Gwv");

var $9Tkwf = parcelRequire("9Tkwf");

var $lgvAm = parcelRequire("lgvAm");

var $ixlCP = parcelRequire("ixlCP");

var $llCao = parcelRequire("llCao");

var $jRYjy = parcelRequire("jRYjy");

var $cogH0 = parcelRequire("cogH0");

var $d0SZF = parcelRequire("d0SZF");

var $8e1dR = parcelRequire("8e1dR");


var $3wkbz = parcelRequire("3wkbz");

var $dp94n = parcelRequire("dp94n");

var $7KtJz = parcelRequire("7KtJz");

var $lBT2M = parcelRequire("lBT2M");

var $9zSqF = parcelRequire("9zSqF");

var $6TVlj = parcelRequire("6TVlj");

var $8XXob = parcelRequire("8XXob");

var $a7Ljg = parcelRequire("a7Ljg");

var $32qtA = parcelRequire("32qtA");
const $c4e1fa95b0cffe56$var$styles = {
    overflowWrap: "_3zvHkHdC7N",
    flag: "_0bjKvD8fU6 _4bt5LAnQyn _2WAcuGnQyn _23rrnHgHsw _2OUyjtGk8v _42Yu6BbFo4 _39xV02N91d",
    contentStack: "_1kOSYtpwtV _3Z9K0wqvoi _2Iz54kUiLg"
};
const $c4e1fa95b0cffe56$var$CSS_VAR_ICON_COLOR = '--flag-icon-color';
const $c4e1fa95b0cffe56$var$descriptionStyles = null;
const $c4e1fa95b0cffe56$var$flagWrapperStyles = null;
const $c4e1fa95b0cffe56$var$iconWrapperStyles = null;
const $c4e1fa95b0cffe56$var$transitionStyles = null;
const $c4e1fa95b0cffe56$var$analyticsAttributes = {
    componentName: 'flag',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
}; /**
    * __Flag__
    *
    * A flag is used for confirmations, alerts, and acknowledgments that require minimal user interaction,
    * often displayed using a flag group.
    *
    * - [Examples](https://atlassian.design/components/flag/examples)
    * - [Code](https://atlassian.design/components/flag/code)
    * - [Usage](https://atlassian.design/components/flag/usage)
    */ 
const $c4e1fa95b0cffe56$var$Flag = (props)=>{
    const { actions: actions = [], appearance: appearance = (0, $f8a69c6d37cb4ab8$export$d6830277b06edd6), icon: icon, title: title, description: description, linkComponent: linkComponent, onMouseOver: onMouseOver, onFocus: onFocus = (0, $9Tkwf.default), onMouseOut: onMouseOut, onBlur: onBlur = (0, $9Tkwf.default), onDismissed: onDismissedProp = (0, $9Tkwf.default), testId: testId, id: id, analyticsContext: analyticsContext, delayAnnouncement: delayAnnouncement, headingLevel: headingLevel = 2 } = props;
    const [isDelayToAnnounce, setIsDelayToAnnounce] = (0, $fsvuC.useState)(false);
    const { onDismissed: onDismissedFromFlagGroup, isDismissAllowed: isDismissAllowed } = (0, $32qtA.useFlagGroup)();
    const onDismissed = (0, $fsvuC.useCallback)((id, analyticsEvent)=>{
        onDismissedProp(id, analyticsEvent);
        onDismissedFromFlagGroup(id, analyticsEvent);
    }, [
        onDismissedProp,
        onDismissedFromFlagGroup
    ]);
    const [isExpanded, setIsExpanded] = (0, $fsvuC.useState)(false);
    const onDismissedAnalytics = (0, $d5Gwv.usePlatformLeafEventHandler)({
        fn: onDismissed,
        action: 'dismissed',
        analyticsData: analyticsContext,
        ...$c4e1fa95b0cffe56$var$analyticsAttributes
    });
    const isBold = appearance !== (0, $f8a69c6d37cb4ab8$export$d6830277b06edd6);
    const toggleExpand = (0, $fsvuC.useCallback)(()=>{
        setIsExpanded((previous)=>!previous);
    }, []);
    const buttonActionCallback = (0, $fsvuC.useCallback)(()=>{
        if (isDismissAllowed) onDismissedAnalytics(id);
    }, [
        onDismissedAnalytics,
        id,
        isDismissAllowed
    ]);
    (0, $fsvuC.useEffect)(()=>{
        // If buttons are removed as a prop, update isExpanded to be false
        if (isBold && isExpanded && !description && !actions.length) setIsExpanded(false);
    }, [
        actions.length,
        description,
        isBold,
        isExpanded
    ]);
    (0, $fsvuC.useEffect)(()=>{
        if (!delayAnnouncement) return;
        setTimeout(()=>{
            setIsDelayToAnnounce(true);
        }, delayAnnouncement);
    }, [
        delayAnnouncement
    ]);
    const onFocusAnalytics = (0, $d5Gwv.usePlatformLeafEventHandler)({
        fn: onFocus,
        action: 'focused',
        analyticsData: analyticsContext,
        ...$c4e1fa95b0cffe56$var$analyticsAttributes
    });
    const onBlurAnalytics = (0, $d5Gwv.usePlatformLeafEventHandler)({
        fn: onBlur,
        action: 'blurred',
        analyticsData: analyticsContext,
        ...$c4e1fa95b0cffe56$var$analyticsAttributes
    });
    const autoDismissProps = {
        onMouseOver: onMouseOver,
        onFocus: onFocusAnalytics,
        onMouseOut: onMouseOut,
        onBlur: onBlurAnalytics
    };
    const textColor = (0, $9zSqF.flagTextColor)[appearance];
    const iconColor = (0, $7KtJz.flagIconColor)[appearance];
    const iconGlyph = (0, $lBT2M.flagIconGlyph)[appearance];
    const isDismissable = isBold || isDismissAllowed;
    const shouldRenderGap = !isBold && (description || actions.length) || isExpanded;
    const isCollapseAnimationEnabled = (0, $llCao.fg)('platform-dst-flag-collapse-animation-fix'); // when delayAnnouncement is available we will use a hidden content for announcement
    const delayedAnnouncement = delayAnnouncement ? /*#__PURE__*/ (0, $5chsV.jsx)((0, $8e1dR.default), {
        children: /*#__PURE__*/ (0, $5chsV.jsxs)((0, $ixlCP.default), {
            children: [
                title,
                description
            ]
        })
    }) : undefined; // A11y improvement opportunity: all flags currently use role="alert" (assertive),
    // but non-critical flags (e.g. info, success) should use role="status" (polite)
    // to avoid interrupting screen reader users. See WCAG 4.1.3.
    return /*#__PURE__*/ (0, $5chsV.jsx)("div", {
        role: "alert",
        "data-testid": testId,
        ...autoDismissProps,
        className: (0, $gJ6nT.default)([
            "_39xV02N91d"
        ]),
        children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $jRYjy.Box), {
            padding: "space.200",
            backgroundColor: (0, $dp94n.flagBackgroundColor)[appearance],
            xcss: $c4e1fa95b0cffe56$var$styles.flag,
            children: /*#__PURE__*/ (0, $5chsV.jsxs)((0, $cogH0.Inline), {
                alignBlock: "start",
                space: "space.200",
                children: [
                    /*#__PURE__*/ (0, $5chsV.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                    , {
                        style: {
                            [$c4e1fa95b0cffe56$var$CSS_VAR_ICON_COLOR]: iconColor
                        },
                        "data-testid": testId && `${testId}-icon-container`,
                        className: (0, $gJ6nT.default)([
                            "_3iDTPbQ4SZ _4ouGXIoWWg _4kiQYAoWWg _0hPCNLDIqT _37wbyuDIqT _3YEZNOdnbC _1UtDYzGdh0"
                        ]),
                        children: icon || iconGlyph
                    }),
                    /*#__PURE__*/ (0, $5chsV.jsx)("span", {
                        className: (0, $gJ6nT.default)([
                            "_23rrnHoCc6 _4ouGXIdnbC _2O5Vij7dHp"
                        ]),
                        children: /*#__PURE__*/ (0, $5chsV.jsxs)((0, $d0SZF.Stack), {
                            space: shouldRenderGap ? 'space.100' : 'space.0',
                            xcss: isCollapseAnimationEnabled ? $c4e1fa95b0cffe56$var$styles.contentStack : undefined,
                            testId: testId && `${testId}-content-stack`,
                            children: [
                                isDelayToAnnounce && delayedAnnouncement,
                                /*#__PURE__*/ (0, $5chsV.jsxs)((0, $cogH0.Inline), {
                                    alignBlock: "stretch",
                                    space: "space.100",
                                    spread: "space-between",
                                    children: [
                                        /*#__PURE__*/ (0, $5chsV.jsx)((0, $jRYjy.Box), {
                                            paddingBlockStart: "space.050",
                                            paddingBlockEnd: "space.025",
                                            xcss: $c4e1fa95b0cffe56$var$styles.overflowWrap,
                                            children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $lgvAm.default), {
                                                as: `h${headingLevel}`,
                                                size: "xsmall",
                                                color: textColor,
                                                children: /*#__PURE__*/ (0, $5chsV.jsx)("span" /* if isDelayToAnnounce is true, we will hide the content form screen reader to avoid duplicate announcement */ , {
                                                    "aria-hidden": isDelayToAnnounce,
                                                    children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $ixlCP.default), {
                                                        children: title
                                                    })
                                                })
                                            })
                                        }),
                                        isDismissable ? !(isBold && !description && !actions.length) && /*#__PURE__*/ (0, $5chsV.jsx)((0, $8XXob.default), {
                                            testId: testId,
                                            appearance: appearance,
                                            isBold: isBold,
                                            isExpanded: isExpanded,
                                            onClick: isBold ? toggleExpand : buttonActionCallback
                                        }) : null
                                    ]
                                }),
                                /*#__PURE__*/ (0, $5chsV.jsxs)((0, $a7Ljg.default), {
                                    isExpanded: !isBold || isExpanded,
                                    testId: testId,
                                    children: [
                                        description && /*#__PURE__*/ (0, $5chsV.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                                        , {
                                            style: {
                                                color: (0, $6TVlj.flagTextColorToken)[appearance]
                                            },
                                            "data-testid": testId && `${testId}-description`,
                                            "aria-hidden": isDelayToAnnounce,
                                            className: (0, $gJ6nT.default)([
                                                "_2sNsIgmnOE _4bt5LAIZbP _2WAcuGIZbP _0NUa3rQEt6 _3zvHkHdC7N"
                                            ]),
                                            children: description
                                        }),
                                        /*#__PURE__*/ (0, $5chsV.jsx)((0, $3wkbz.default), {
                                            actions: actions,
                                            appearance: appearance,
                                            linkComponent: linkComponent,
                                            testId: testId
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
};
$c4e1fa95b0cffe56$var$Flag.displayName = "Flag";
var $c4e1fa95b0cffe56$export$2e2bcd8739ae039 = $c4e1fa95b0cffe56$var$Flag;

});
parcelRegister("lgvAm", function(module, exports) {
$parcel$export(module.exports, "default", () => $615f2936dc82e84d$export$2e2bcd8739ae039);
/* heading.tsx generated by @compiled/babel-plugin v3.0.2 */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors */ 
var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $gJ6nT = parcelRequire("gJ6nT");

var $d9U0U = parcelRequire("d9U0U");

var $6Hvdm = parcelRequire("6Hvdm");

var $69r2e = parcelRequire("69r2e");

var $hoalA = parcelRequire("hoalA");
const $615f2936dc82e84d$var$sizeTagMap = {
    xxlarge: 'h1',
    xlarge: 'h1',
    large: 'h2',
    medium: 'h3',
    small: 'h4',
    xsmall: 'h5',
    xxsmall: 'h6'
};
/**
 * Using '&&' here to increase specificity of Heading styles such that app styles like ".wiki-content h4" cannot override this component.
 */ const $615f2936dc82e84d$var$styles = {
    reset: "_0V2sJxdnbC _3z6cE5zUZr _1yGjhvYbGa"
};
/**
 * Using '&&' here to increase specificity of Heading styles such that app styles like ".wiki-content h4" cannot override this component.
 */ const $615f2936dc82e84d$var$headingColorStyles = {
    'color.text': "_4vhRtvy7kJ",
    'color.text.inverse': "_4vhRtve5R3",
    'color.text.warning.inverse': "_4vhRtvVW6T"
};
/**
 * Using '&&' here to increase specificity of Heading styles such that app styles like ".wiki-content h4" cannot override this component.
 */ const $615f2936dc82e84d$var$headingSizeStyles = {
    xxlarge: "_12pLkPJ6H4",
    xlarge: "_12pLkPXwEm",
    large: "_12pLkPxzFw",
    medium: "_12pLkPWSk4",
    small: "_12pLkP1kXk",
    xsmall: "_12pLkPEqul",
    xxsmall: "_12pLkPd8bj"
};
/**
 * @codegenEnd
 */ const $615f2936dc82e84d$var$useColor = (colorProp)=>{
    const surface = (0, $d9U0U.useSurface)();
    if (colorProp) return colorProp;
    if ((0, $6Hvdm.inverseColorMap).hasOwnProperty(surface)) return (0, $6Hvdm.inverseColorMap)[surface];
    return 'color.text';
};
/**
 * __Heading__
 *
 * Heading is a typography component used to display text in defined sizes and styles.
 *
 * @example
 *
 * ```jsx
 * <Heading size="xxlarge">Page title</Heading>
 * ```
 */ const $615f2936dc82e84d$var$Heading = /*#__PURE__*/ (0, $fsvuC.forwardRef)((props, ref)=>{
    const { children: children, size: size, id: id, testId: testId, as: as, color: colorProp } = props;
    typeof $hoalA;
    const [hLevel, inferredElement] = (0, $69r2e.useHeading)($615f2936dc82e84d$var$sizeTagMap[size]);
    const Component = as || inferredElement;
    const needsAriaRole = Component === 'div' && hLevel;
    const color = $615f2936dc82e84d$var$useColor(colorProp);
    return /*#__PURE__*/ (0, $5chsV.jsx)(Component, {
        id: id,
        ref: ref,
        "data-testid": testId,
        role: needsAriaRole ? 'heading' : undefined,
        "aria-level": needsAriaRole ? hLevel : undefined,
        className: (0, $gJ6nT.default)([
            $615f2936dc82e84d$var$styles.reset,
            $615f2936dc82e84d$var$headingSizeStyles[size],
            $615f2936dc82e84d$var$headingColorStyles[color]
        ]),
        children: children
    });
});
var $615f2936dc82e84d$export$2e2bcd8739ae039 = $615f2936dc82e84d$var$Heading;

});
parcelRegister("d9U0U", function(module, exports) {
$parcel$export(module.exports, "useSurface", () => $4ce27af0b1d17f5d$export$1aeb4f6b93c4540d);

var $fsvuC = parcelRequire("fsvuC");

var $ewzCi = parcelRequire("ewzCi");
const $4ce27af0b1d17f5d$export$1aeb4f6b93c4540d = ()=>{
    return (0, $fsvuC.useContext)((0, $ewzCi.SurfaceContext));
};
(0, $ewzCi.SurfaceContext).displayName = 'SurfaceProvider';

});
parcelRegister("ewzCi", function(module, exports) {
$parcel$export(module.exports, "SurfaceContext", () => $c8541027e72dfefa$export$1ca2a26fecb070ae);

var $fsvuC = parcelRequire("fsvuC");
const $c8541027e72dfefa$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $fsvuC.createContext)('elevation.surface');

});


parcelRegister("6Hvdm", function(module, exports) {
$parcel$export(module.exports, "inverseColorMap", () => $7ba0687d75d10130$export$2185ce37f9bdd963);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::69f941eca1bf309f7088207fc024b707>>
 * @codegenCommand afm workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../../tokens/src/artifacts/tokens-raw/atlassian-light.tsx <<SignedSource::2d05e18dbb472322c67fd0bc8ec55082>>
 */ const $7ba0687d75d10130$export$2185ce37f9bdd963 = {
    'color.background.neutral.bold': 'color.text.inverse',
    'color.background.neutral.bold.hovered': 'color.text.inverse',
    'color.background.neutral.bold.pressed': 'color.text.inverse',
    'color.background.selected.bold': 'color.text.inverse',
    'color.background.selected.bold.hovered': 'color.text.inverse',
    'color.background.selected.bold.pressed': 'color.text.inverse',
    'color.background.brand.bold': 'color.text.inverse',
    'color.background.brand.bold.hovered': 'color.text.inverse',
    'color.background.brand.bold.pressed': 'color.text.inverse',
    'color.background.brand.boldest': 'color.text.inverse',
    'color.background.brand.boldest.hovered': 'color.text.inverse',
    'color.background.brand.boldest.pressed': 'color.text.inverse',
    'color.background.danger.bold': 'color.text.inverse',
    'color.background.danger.bold.hovered': 'color.text.inverse',
    'color.background.danger.bold.pressed': 'color.text.inverse',
    'color.background.warning.bold': 'color.text.warning.inverse',
    'color.background.warning.bold.hovered': 'color.text.warning.inverse',
    'color.background.warning.bold.pressed': 'color.text.warning.inverse',
    'color.background.success.bold': 'color.text.inverse',
    'color.background.success.bold.hovered': 'color.text.inverse',
    'color.background.success.bold.pressed': 'color.text.inverse',
    'color.background.discovery.bold': 'color.text.inverse',
    'color.background.discovery.bold.hovered': 'color.text.inverse',
    'color.background.discovery.bold.pressed': 'color.text.inverse',
    'color.background.information.bold': 'color.text.inverse',
    'color.background.information.bold.hovered': 'color.text.inverse',
    'color.background.information.bold.pressed': 'color.text.inverse',
    'color.rovo.background.brand.bold': 'color.text.inverse',
    'color.rovo.background.brand.bold.hovered': 'color.text.inverse',
    'color.rovo.background.brand.bold.pressed': 'color.text.inverse'
};

});

parcelRegister("69r2e", function(module, exports) {
$parcel$export(module.exports, "useHeading", () => $c010199e9fc8feb2$export$97a37b1befbbf9b1);

var $7IxAU = parcelRequire("7IxAU");
const $c010199e9fc8feb2$export$97a37b1befbbf9b1 = (fallback)=>{
    const hLevel = (0, $7IxAU.useHeadingLevel)();
    /**
	 * Order here is important, we for now apply
	 * 1. inferred a11y level (this only applies if context is present)
	 * 2. default final fallback
	 */ return [
        hLevel,
        hLevel && (hLevel > 6 ? 'div' : `h${hLevel}`) || fallback
    ];
};

});
parcelRegister("7IxAU", function(module, exports) {
$parcel$export(module.exports, "useHeadingLevel", () => $6405ca8d919aa3c0$export$6a64a1e2d0bbbf75);

var $fsvuC = parcelRequire("fsvuC");

var $gub5M = parcelRequire("gub5M");
const $6405ca8d919aa3c0$export$6a64a1e2d0bbbf75 = ()=>{
    return (0, $fsvuC.useContext)((0, $gub5M.HeadingLevelContext));
};

});
parcelRegister("gub5M", function(module, exports) {
$parcel$export(module.exports, "HeadingLevelContext", () => $d9326964933468fc$export$d1fa8a19e192bc63);

var $fsvuC = parcelRequire("fsvuC");
const $d9326964933468fc$export$d1fa8a19e192bc63 = /*#__PURE__*/ (0, $fsvuC.createContext)(0);

});




parcelRegister("ixlCP", function(module, exports) {
$parcel$export(module.exports, "default", () => $77f53601805617ca$export$2e2bcd8739ae039);

var $5chsV = parcelRequire("5chsV");
parcelRequire("fsvuC");

var $llCao = parcelRequire("llCao");

var $lfw4f = parcelRequire("lfw4f");
function $77f53601805617ca$export$2e2bcd8739ae039({ children: children }) {
    return (0, $llCao.fg)('platform-dst-motion-isolate-presence') ? /*#__PURE__*/ (0, $5chsV.jsx)((0, $lfw4f.ExitingContext).Provider, {
        value: (0, $lfw4f.defaultExitingContext),
        children: children
    }) : /*#__PURE__*/ (0, $5chsV.jsx)((0, $5chsV.Fragment), {
        children: children
    });
}
$77f53601805617ca$export$2e2bcd8739ae039.displayName = "MotionPresenceBoundary";

});
parcelRegister("lfw4f", function(module, exports) {
$parcel$export(module.exports, "defaultExitingContext", () => $e7f97f19d6baad00$export$52502485782d6180);
$parcel$export(module.exports, "ExitingContext", () => $e7f97f19d6baad00$export$b9c4904d7a6929e6);
$parcel$export(module.exports, "default", () => $e7f97f19d6baad00$export$2e2bcd8739ae039);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $llCao = parcelRequire("llCao");
const $e7f97f19d6baad00$export$52502485782d6180 = {
    // Motions will always appear if not inside a exiting persistence component.
    appear: true,
    isInsideExitingPersistence: false,
    isExiting: false
};
const $e7f97f19d6baad00$export$b9c4904d7a6929e6 = /*#__PURE__*/ (0, $fsvuC.createContext)($e7f97f19d6baad00$export$52502485782d6180);
/**
 * This method will wrap any React element with a context provider. We're using context (instead of
 * cloneElement) so we can communicate between multiple elements without the need of prop drilling
 * (results in a better API for consumers).
 */ const $e7f97f19d6baad00$var$wrapChildWithContextProvider = (child, value = $e7f97f19d6baad00$export$52502485782d6180)=>{
    return /*#__PURE__*/ (0, $5chsV.jsx)($e7f97f19d6baad00$export$b9c4904d7a6929e6.Provider, {
        value: value,
        children: child
    }, `${child.key}-provider`);
};
/**
 * This function will convert all children types to an array while also filtering out non-valid React elements.
 */ const $e7f97f19d6baad00$var$childrenToArray = (children)=>{
    const childrenAsArray = [];
    // We convert children to an array using this helper method as it will add keys to children that do not
    // have them, such as when we have hardcoded children that are conditionally rendered.
    (0, $fsvuC.Children).toArray(children).forEach((child)=>{
        // We ignore any boolean children to make our code a little more simple later on,
        // and also filter out any falsies (empty strings, nulls, and undefined).
        if (typeof child !== 'boolean' && Boolean(child)) // Children WILL have a key after being forced into an array using the React.Children helper.
        childrenAsArray.push(child);
    });
    return childrenAsArray;
};
const $e7f97f19d6baad00$var$spliceNewElementsIntoPrevious = (current, previous)=>{
    const splicedChildren = previous.concat([]);
    const previousMap = $e7f97f19d6baad00$var$childrenToObj(previous);
    for(let i = 0; i < current.length; i++){
        const child = current[i];
        const childIsNew = !previousMap[child.key];
        if (childIsNew) // This will insert the new element after the previous element.
        splicedChildren.splice(i + 1, 0, child);
    }
    return splicedChildren;
};
const $e7f97f19d6baad00$var$childrenToObj = (children)=>{
    return children.reduce((acc, child)=>{
        acc[child.key] = child;
        return acc;
    }, {});
};
const $e7f97f19d6baad00$var$getMissingKeys = (current, previous)=>{
    const currentMapKeys = new Set(current.map((child)=>child.key));
    const missing = new Set();
    for(let i = 0; i < previous.length; i++){
        const element = previous[i];
        const key = element.key;
        if (!currentMapKeys.has(key)) missing.add(key);
    }
    return missing;
};
/**
 * How does this component work?
 *
 * It looks at changes in its children to see what is removed.
 *
 * If a child is removed it clones it and wraps it with context providing an `onFinish` callback.
 *
 * The cloned child will call the `onFinish` when it finishes its exit animation,
 * which lets `ExitingPersistence` know to stop rendering it.
 */ /**
 * __ExitingPersistence__
 *
 * Useful for enabling elements to persist and animate away when they are removed from the DOM.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motion)
 */ const $e7f97f19d6baad00$var$ExitingPersistence = /*#__PURE__*/ (0, $fsvuC.memo)(({ appear: appear = false, children: children, exitThenEnter: exitThenEnter })=>{
    const [stateChildren, setChildren] = (0, $fsvuC.useState)([
        null,
        children
    ]);
    const [exitingChildren, setExitingChildren] = (0, $fsvuC.useState)([]);
    const [defaultContext, setDefaultContext] = (0, $fsvuC.useState)(()=>({
            appear: appear,
            isExiting: false,
            isInsideExitingPersistence: true
        }));
    (0, $fsvuC.useEffect)(()=>{
        if (!defaultContext.appear) setDefaultContext({
            appear: true,
            isExiting: false,
            isInsideExitingPersistence: true
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    /**
	 * NOTE: This is a workaround for the test case written in Jira where the stateChildren is a boolean value because
	 * useState is mocked to return a boolean value.
	 */ if (typeof stateChildren === 'boolean') return children;
    const [previousChildren, currentChildren] = stateChildren;
    const previous = $e7f97f19d6baad00$var$childrenToArray(previousChildren);
    const current = $e7f97f19d6baad00$var$childrenToArray(currentChildren);
    if (currentChildren !== children) {
        // Parent updates can rerender this boundary before its children finish exiting. Keep
        // the previous children until their onFinish callbacks release them.
        const hasPendingExit = ((0, $llCao.fg)('platform-dst-motion-uplift-labels') || (0, $llCao.fg)('platform-dst-motion-uplift-input')) && $e7f97f19d6baad00$var$getMissingKeys(current, previous).size > 0;
        setChildren([
            hasPendingExit ? previousChildren : currentChildren,
            children
        ]);
    }
    const nextChildren = currentChildren !== children ? $e7f97f19d6baad00$var$childrenToArray(children) : current;
    const missingKeys = $e7f97f19d6baad00$var$getMissingKeys(nextChildren, previous);
    const isSomeChildRemoved = !!missingKeys.size;
    let visibleChildren = !isSomeChildRemoved && currentChildren !== children ? nextChildren : current;
    if (isSomeChildRemoved) visibleChildren = $e7f97f19d6baad00$var$spliceNewElementsIntoPrevious(current, previous);
    if (exitThenEnter) {
        if (exitingChildren.length) visibleChildren = (0, $llCao.fg)('platform-dst-motion-uplift') ? previous : exitingChildren;
        else {
            const nextExitingChildren = visibleChildren.filter((child)=>missingKeys.has(child.key));
            if (nextExitingChildren.length) setExitingChildren(nextExitingChildren);
        }
    }
    if (missingKeys.size) visibleChildren = visibleChildren.map((child)=>{
        const isExiting = missingKeys.has(child.key);
        // Retained exits can span several parent renders. Unchanged siblings should
        // keep their context identity instead of receiving redundant updates.
        if (((0, $llCao.fg)('platform-dst-motion-uplift-labels') || (0, $llCao.fg)('platform-dst-motion-uplift-input')) && !isExiting) return $e7f97f19d6baad00$var$wrapChildWithContextProvider(child, defaultContext);
        return $e7f97f19d6baad00$var$wrapChildWithContextProvider(child, {
            appear: true,
            isInsideExitingPersistence: true,
            isExiting: isExiting,
            onFinish: isExiting ? ()=>{
                missingKeys.delete(child.key);
                if (missingKeys.size === 0) {
                    setChildren([
                        null,
                        children
                    ]);
                    setExitingChildren([]);
                }
            } : undefined
        });
    });
    else visibleChildren = visibleChildren.map((child)=>$e7f97f19d6baad00$var$wrapChildWithContextProvider(child, defaultContext));
    return visibleChildren;
});
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$e7f97f19d6baad00$export$2e2bcd8739ae039 = $e7f97f19d6baad00$var$ExitingPersistence;
$e7f97f19d6baad00$var$ExitingPersistence.displayName = 'ExitingPersistence';

});


parcelRegister("jRYjy", function(module, exports) {
$parcel$export(module.exports, "Box", () => $2a121bfc4857039c$export$e71c4d32a2263218);
/* box.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $gJ6nT = parcelRequire("gJ6nT");

var $ewzCi = parcelRequire("ewzCi");
const $2a121bfc4857039c$var$baseStyles = null;
const $2a121bfc4857039c$var$backgroundColorMap = {
    'color.background.accent.lime.subtlest': "_0KLXruXL80",
    'color.background.accent.lime.subtlest.hovered': "_0KLXruL7r8",
    'color.background.accent.lime.subtlest.pressed': "_0KLXrulDnJ",
    'color.background.accent.lime.subtler': "_0KLXruuKDS",
    'color.background.accent.lime.subtler.hovered': "_0KLXruuIDk",
    'color.background.accent.lime.subtler.pressed': "_0KLXruyTNr",
    'color.background.accent.lime.subtle': "_0KLXruZcd0",
    'color.background.accent.lime.subtle.hovered': "_0KLXrude7x",
    'color.background.accent.lime.subtle.pressed': "_0KLXrum9Fz",
    'color.background.accent.lime.bolder': "_0KLXrubYhN",
    'color.background.accent.lime.bolder.hovered': "_0KLXruaWdC",
    'color.background.accent.lime.bolder.pressed': "_0KLXruCN3C",
    'color.background.accent.red.subtlest': "_0KLXrusDFP",
    'color.background.accent.red.subtlest.hovered': "_0KLXruIg5O",
    'color.background.accent.red.subtlest.pressed': "_0KLXruElzn",
    'color.background.accent.red.subtler': "_0KLXrubV9i",
    'color.background.accent.red.subtler.hovered': "_0KLXruFOVf",
    'color.background.accent.red.subtler.pressed': "_0KLXruFnU8",
    'color.background.accent.red.subtle': "_0KLXru0cUQ",
    'color.background.accent.red.subtle.hovered': "_0KLXruIt8U",
    'color.background.accent.red.subtle.pressed': "_0KLXrunRhf",
    'color.background.accent.red.bolder': "_0KLXruQrW1",
    'color.background.accent.red.bolder.hovered': "_0KLXrumCVf",
    'color.background.accent.red.bolder.pressed': "_0KLXruPm25",
    'color.background.accent.orange.subtlest': "_0KLXru2QQR",
    'color.background.accent.orange.subtlest.hovered': "_0KLXru629A",
    'color.background.accent.orange.subtlest.pressed': "_0KLXrupg0Z",
    'color.background.accent.orange.subtler': "_0KLXruwJ86",
    'color.background.accent.orange.subtler.hovered': "_0KLXruEo5I",
    'color.background.accent.orange.subtler.pressed': "_0KLXru78bI",
    'color.background.accent.orange.subtle': "_0KLXruuwVU",
    'color.background.accent.orange.subtle.hovered': "_0KLXrunwBH",
    'color.background.accent.orange.subtle.pressed': "_0KLXruKHmw",
    'color.background.accent.orange.bolder': "_0KLXrux4f7",
    'color.background.accent.orange.bolder.hovered': "_0KLXruwYNk",
    'color.background.accent.orange.bolder.pressed': "_0KLXruDYlO",
    'color.background.accent.yellow.subtlest': "_0KLXru56u3",
    'color.background.accent.yellow.subtlest.hovered': "_0KLXruBwZU",
    'color.background.accent.yellow.subtlest.pressed': "_0KLXruHN5H",
    'color.background.accent.yellow.subtler': "_0KLXruLv9B",
    'color.background.accent.yellow.subtler.hovered': "_0KLXruJMtC",
    'color.background.accent.yellow.subtler.pressed': "_0KLXruVvUp",
    'color.background.accent.yellow.subtle': "_0KLXruC29w",
    'color.background.accent.yellow.subtle.hovered': "_0KLXruSF9i",
    'color.background.accent.yellow.subtle.pressed': "_0KLXruOIUD",
    'color.background.accent.yellow.bolder': "_0KLXruYB6L",
    'color.background.accent.yellow.bolder.hovered': "_0KLXru5gSm",
    'color.background.accent.yellow.bolder.pressed': "_0KLXruTjon",
    'color.background.accent.green.subtlest': "_0KLXruV6wL",
    'color.background.accent.green.subtlest.hovered': "_0KLXruMqh8",
    'color.background.accent.green.subtlest.pressed': "_0KLXruUxn0",
    'color.background.accent.green.subtler': "_0KLXruNUep",
    'color.background.accent.green.subtler.hovered': "_0KLXruSZVv",
    'color.background.accent.green.subtler.pressed': "_0KLXruratX",
    'color.background.accent.green.subtle': "_0KLXru50ZN",
    'color.background.accent.green.subtle.hovered': "_0KLXru6mZS",
    'color.background.accent.green.subtle.pressed': "_0KLXruIBxe",
    'color.background.accent.green.bolder': "_0KLXrude1t",
    'color.background.accent.green.bolder.hovered': "_0KLXruB5SF",
    'color.background.accent.green.bolder.pressed': "_0KLXruLYGL",
    'color.background.accent.teal.subtlest': "_0KLXruuBpz",
    'color.background.accent.teal.subtlest.hovered': "_0KLXrugqYx",
    'color.background.accent.teal.subtlest.pressed': "_0KLXrufBlI",
    'color.background.accent.teal.subtler': "_0KLXrunfgW",
    'color.background.accent.teal.subtler.hovered': "_0KLXruA8mq",
    'color.background.accent.teal.subtler.pressed': "_0KLXrujHQE",
    'color.background.accent.teal.subtle': "_0KLXrufjGw",
    'color.background.accent.teal.subtle.hovered': "_0KLXrubjxt",
    'color.background.accent.teal.subtle.pressed': "_0KLXruUDSb",
    'color.background.accent.teal.bolder': "_0KLXruzHaB",
    'color.background.accent.teal.bolder.hovered': "_0KLXrunc80",
    'color.background.accent.teal.bolder.pressed': "_0KLXruu11s",
    'color.background.accent.blue.subtlest': "_0KLXruVva3",
    'color.background.accent.blue.subtlest.hovered': "_0KLXruotmK",
    'color.background.accent.blue.subtlest.pressed': "_0KLXruxyGe",
    'color.background.accent.blue.subtler': "_0KLXrup9dS",
    'color.background.accent.blue.subtler.hovered': "_0KLXruRRyT",
    'color.background.accent.blue.subtler.pressed': "_0KLXrueeqx",
    'color.background.accent.blue.subtle': "_0KLXru28sy",
    'color.background.accent.blue.subtle.hovered': "_0KLXruKSSk",
    'color.background.accent.blue.subtle.pressed': "_0KLXru40Rv",
    'color.background.accent.blue.bolder': "_0KLXrutfbE",
    'color.background.accent.blue.bolder.hovered': "_0KLXruupqB",
    'color.background.accent.blue.bolder.pressed': "_0KLXru36Hh",
    'color.background.accent.purple.subtlest': "_0KLXruB8KG",
    'color.background.accent.purple.subtlest.hovered': "_0KLXrueJK9",
    'color.background.accent.purple.subtlest.pressed': "_0KLXruhT4j",
    'color.background.accent.purple.subtler': "_0KLXruWOdT",
    'color.background.accent.purple.subtler.hovered': "_0KLXrujgGS",
    'color.background.accent.purple.subtler.pressed': "_0KLXruWgRz",
    'color.background.accent.purple.subtle': "_0KLXruf89Q",
    'color.background.accent.purple.subtle.hovered': "_0KLXru46BV",
    'color.background.accent.purple.subtle.pressed': "_0KLXruU9Hm",
    'color.background.accent.purple.bolder': "_0KLXruhdss",
    'color.background.accent.purple.bolder.hovered': "_0KLXruXxp4",
    'color.background.accent.purple.bolder.pressed': "_0KLXru1L16",
    'color.background.accent.magenta.subtlest': "_0KLXru8frT",
    'color.background.accent.magenta.subtlest.hovered': "_0KLXruWeuD",
    'color.background.accent.magenta.subtlest.pressed': "_0KLXruK9iC",
    'color.background.accent.magenta.subtler': "_0KLXruXM4x",
    'color.background.accent.magenta.subtler.hovered': "_0KLXrukPhQ",
    'color.background.accent.magenta.subtler.pressed': "_0KLXruGjVz",
    'color.background.accent.magenta.subtle': "_0KLXrupmfs",
    'color.background.accent.magenta.subtle.hovered': "_0KLXruexkg",
    'color.background.accent.magenta.subtle.pressed': "_0KLXruV3kb",
    'color.background.accent.magenta.bolder': "_0KLXruxE6Y",
    'color.background.accent.magenta.bolder.hovered': "_0KLXruPb8Y",
    'color.background.accent.magenta.bolder.pressed': "_0KLXruwQL0",
    'color.background.accent.gray.subtlest': "_0KLXrumhAQ",
    'color.background.accent.gray.subtlest.hovered': "_0KLXruBee8",
    'color.background.accent.gray.subtlest.pressed': "_0KLXruysrI",
    'color.background.accent.gray.subtler': "_0KLXruG6qS",
    'color.background.accent.gray.subtler.hovered': "_0KLXruXljP",
    'color.background.accent.gray.subtler.pressed': "_0KLXru6vdf",
    'color.background.accent.gray.subtle': "_0KLXrueZ10",
    'color.background.accent.gray.subtle.hovered': "_0KLXruY62e",
    'color.background.accent.gray.subtle.pressed': "_0KLXruvFnq",
    'color.background.accent.gray.bolder': "_0KLXrurxgm",
    'color.background.accent.gray.bolder.hovered': "_0KLXruW5tB",
    'color.background.accent.gray.bolder.pressed': "_0KLXrunA18",
    'color.background.disabled': "_0KLXruVrZW",
    'color.background.input': "_0KLXru7Cj1",
    'color.background.input.hovered': "_0KLXruqWX3",
    'color.background.input.pressed': "_0KLXruutHW",
    'color.background.inverse.subtle': "_0KLXruB4sa",
    'color.background.inverse.subtle.hovered': "_0KLXruVzWZ",
    'color.background.inverse.subtle.pressed': "_0KLXruTmu4",
    'color.background.neutral': "_0KLXruDMqu",
    'color.background.neutral.hovered': "_0KLXruKcZT",
    'color.background.neutral.pressed': "_0KLXrunpTK",
    'color.background.neutral.subtle': "_0KLXru5FNy",
    'color.background.neutral.subtle.hovered': "_0KLXruo126",
    'color.background.neutral.subtle.pressed': "_0KLXruN4oS",
    'color.background.neutral.bold': "_0KLXrugozt",
    'color.background.neutral.bold.hovered': "_0KLXrukTlo",
    'color.background.neutral.bold.pressed': "_0KLXruVbka",
    'color.background.selected': "_0KLXruY9q9",
    'color.background.selected.hovered': "_0KLXrusumd",
    'color.background.selected.pressed': "_0KLXruXsxn",
    'color.background.selected.bold': "_0KLXrukLmD",
    'color.background.selected.bold.hovered': "_0KLXruXLOx",
    'color.background.selected.bold.pressed': "_0KLXruPSfI",
    'color.background.brand.subtlest': "_0KLXrunl7T",
    'color.background.brand.subtlest.hovered': "_0KLXruNPoG",
    'color.background.brand.subtlest.pressed': "_0KLXruLKV0",
    'color.background.brand.bold': "_0KLXruDM2k",
    'color.background.brand.bold.hovered': "_0KLXruhmrj",
    'color.background.brand.bold.pressed': "_0KLXruczkD",
    'color.background.brand.boldest': "_0KLXru2o0p",
    'color.background.brand.boldest.hovered': "_0KLXruzGNP",
    'color.background.brand.boldest.pressed': "_0KLXru9Y3T",
    'color.background.danger': "_0KLXruhH7k",
    'color.background.danger.hovered': "_0KLXru1IMt",
    'color.background.danger.pressed': "_0KLXruig7D",
    'color.background.danger.bold': "_0KLXruqsXs",
    'color.background.danger.bold.hovered': "_0KLXruEISo",
    'color.background.danger.bold.pressed': "_0KLXruL5fL",
    'color.background.warning': "_0KLXruhxIM",
    'color.background.warning.hovered': "_0KLXrudEDW",
    'color.background.warning.pressed': "_0KLXruiJjO",
    'color.background.warning.bold': "_0KLXruKLKE",
    'color.background.warning.bold.hovered': "_0KLXruOCpk",
    'color.background.warning.bold.pressed': "_0KLXruSN2W",
    'color.background.success': "_0KLXruzaZe",
    'color.background.success.hovered': "_0KLXruYQVR",
    'color.background.success.pressed': "_0KLXruFj7I",
    'color.background.success.bold': "_0KLXruhbjP",
    'color.background.success.bold.hovered': "_0KLXru1YDn",
    'color.background.success.bold.pressed': "_0KLXrulx7w",
    'color.background.discovery': "_0KLXru94rk",
    'color.background.discovery.hovered': "_0KLXruaV2P",
    'color.background.discovery.pressed': "_0KLXruET5a",
    'color.background.discovery.bold': "_0KLXruqjHC",
    'color.background.discovery.bold.hovered': "_0KLXrunIkF",
    'color.background.discovery.bold.pressed': "_0KLXruSHT5",
    'color.background.information': "_0KLXrugNg3",
    'color.background.information.hovered': "_0KLXruwQql",
    'color.background.information.pressed': "_0KLXruB0Fx",
    'color.background.information.bold': "_0KLXruASYT",
    'color.background.information.bold.hovered': "_0KLXruGaQW",
    'color.background.information.bold.pressed': "_0KLXrujXMX",
    'color.blanket': "_0KLXruA5lS",
    'color.blanket.selected': "_0KLXrumA7q",
    'color.blanket.danger': "_0KLXrupOKR",
    'color.skeleton': "_0KLXruGsB2",
    'color.skeleton.subtle': "_0KLXruaVjy",
    'elevation.surface': "_0KLXrulfZc",
    'elevation.surface.hovered': "_0KLXrud1Zr",
    'elevation.surface.pressed': "_0KLXruJNoT",
    'elevation.surface.overlay': "_0KLXruoI2d",
    'elevation.surface.overlay.hovered': "_0KLXruhWTW",
    'elevation.surface.overlay.pressed': "_0KLXru0GoB",
    'elevation.surface.raised': "_0KLXruqi9L",
    'elevation.surface.raised.hovered': "_0KLXrubvxc",
    'elevation.surface.raised.pressed': "_0KLXruSEy3",
    'elevation.surface.sunken': "_0KLXrunmFW",
    'utility.elevation.surface.current': "_0KLXru4TrO"
};
const $2a121bfc4857039c$var$CURRENT_SURFACE_CSS_VAR = `--ds-elevation-surface-current`;
const $2a121bfc4857039c$var$setSurfaceTokenMap = {
    'elevation.surface': "_45TjwHlfZc",
    'elevation.surface.hovered': "_45TjwHd1Zr",
    'elevation.surface.pressed': "_45TjwHJNoT",
    'elevation.surface.overlay': "_45TjwHoI2d",
    'elevation.surface.overlay.hovered': "_45TjwHhWTW",
    'elevation.surface.overlay.pressed': "_45TjwH0GoB",
    'elevation.surface.raised': "_45TjwHqi9L",
    'elevation.surface.raised.hovered': "_45TjwHbvxc",
    'elevation.surface.raised.pressed': "_45TjwHSEy3",
    'elevation.surface.sunken': "_45TjwHnmFW"
};
const $2a121bfc4857039c$var$paddingBlockStartMap = {
    'space.0': "_46hvQmPgdg",
    'space.025': "_46hvQmFQfX",
    'space.050': "_46hvQm1Y8M",
    'space.075': "_46hvQmgVvo",
    'space.100': "_46hvQm2ADO",
    'space.150': "_46hvQm8HPE",
    'space.200': "_46hvQm5zaO",
    'space.250': "_46hvQmkG2W",
    'space.300': "_46hvQmNHnM",
    'space.400': "_46hvQmVa5s",
    'space.500': "_46hvQmS40j",
    'space.600': "_46hvQmp0Oa",
    'space.800': "_46hvQmGXk2",
    'space.1000': "_46hvQmyFLW"
};
const $2a121bfc4857039c$var$paddingBlockEndMap = {
    'space.0': "_0xmtkoPgdg",
    'space.025': "_0xmtkoFQfX",
    'space.050': "_0xmtko1Y8M",
    'space.075': "_0xmtkogVvo",
    'space.100': "_0xmtko2ADO",
    'space.150': "_0xmtko8HPE",
    'space.200': "_0xmtko5zaO",
    'space.250': "_0xmtkokG2W",
    'space.300': "_0xmtkoNHnM",
    'space.400': "_0xmtkoVa5s",
    'space.500': "_0xmtkoS40j",
    'space.600': "_0xmtkop0Oa",
    'space.800': "_0xmtkoGXk2",
    'space.1000': "_0xmtkoyFLW"
};
const $2a121bfc4857039c$var$paddingInlineStartMap = {
    'space.0': "_0LQT5EPgdg",
    'space.025': "_0LQT5EFQfX",
    'space.050': "_0LQT5E1Y8M",
    'space.075': "_0LQT5EgVvo",
    'space.100': "_0LQT5E2ADO",
    'space.150': "_0LQT5E8HPE",
    'space.200': "_0LQT5E5zaO",
    'space.250': "_0LQT5EkG2W",
    'space.300': "_0LQT5ENHnM",
    'space.400': "_0LQT5EVa5s",
    'space.500': "_0LQT5ES40j",
    'space.600': "_0LQT5Ep0Oa",
    'space.800': "_0LQT5EGXk2",
    'space.1000': "_0LQT5EyFLW"
};
const $2a121bfc4857039c$var$paddingInlineEndMap = {
    'space.0': "_03SyCPPgdg",
    'space.025': "_03SyCPFQfX",
    'space.050': "_03SyCP1Y8M",
    'space.075': "_03SyCPgVvo",
    'space.100': "_03SyCP2ADO",
    'space.150': "_03SyCP8HPE",
    'space.200': "_03SyCP5zaO",
    'space.250': "_03SyCPkG2W",
    'space.300': "_03SyCPNHnM",
    'space.400': "_03SyCPVa5s",
    'space.500': "_03SyCPS40j",
    'space.600': "_03SyCPp0Oa",
    'space.800': "_03SyCPGXk2",
    'space.1000': "_03SyCPyFLW"
};
const $2a121bfc4857039c$export$e71c4d32a2263218 = /*#__PURE__*/ (0, $fsvuC.forwardRef)(({ as: Component = 'div', children: children, backgroundColor: backgroundColor, padding: padding, paddingBlock: paddingBlock = padding, paddingBlockStart: paddingBlockStart = paddingBlock, paddingBlockEnd: paddingBlockEnd = paddingBlock, paddingInline: paddingInline = padding, paddingInlineStart: paddingInlineStart = paddingInline, paddingInlineEnd: paddingInlineEnd = paddingInline, style: style, testId: testId, xcss: xcss, ...htmlAttributes }, ref)=>{
    // This is to remove className from safeHtmlAttributes
    // @ts-ignore -- not using expect since it causes issues with help-center local consumption - className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    const { className: _spreadClass, ...safeHtmlAttributes } = htmlAttributes;
    const node = /*#__PURE__*/ (0, $5chsV.jsx)(Component, {
        style: style,
        // @ts-ignore -- Expression produces a union type that is too complex to represent. We may be able to narrow the type here but unsure.
        ref: ref,
        className: (0, $gJ6nT.default)([
            "_30huDKYbGa _24h04i2Njc _034jHtYbGa",
            backgroundColor && $2a121bfc4857039c$var$backgroundColorMap[backgroundColor],
            backgroundColor && $2a121bfc4857039c$var$isSurfaceToken(backgroundColor) && $2a121bfc4857039c$var$setSurfaceTokenMap[backgroundColor],
            paddingBlockStart && $2a121bfc4857039c$var$paddingBlockStartMap[paddingBlockStart],
            paddingBlockEnd && $2a121bfc4857039c$var$paddingBlockEndMap[paddingBlockEnd],
            paddingInlineStart && $2a121bfc4857039c$var$paddingInlineStartMap[paddingInlineStart],
            paddingInlineEnd && $2a121bfc4857039c$var$paddingInlineEndMap[paddingInlineEnd],
            xcss
        ]),
        ...safeHtmlAttributes,
        "data-testid": testId,
        children: children
    });
    if (backgroundColor) return /*#__PURE__*/ (0, $5chsV.jsx)((0, $ewzCi.SurfaceContext).Provider, {
        value: backgroundColor,
        children: node
    });
    return node;
});
function $2a121bfc4857039c$var$isSurfaceToken(backgroundColor) {
    return backgroundColor in $2a121bfc4857039c$var$setSurfaceTokenMap;
}

});

parcelRegister("cogH0", function(module, exports) {
$parcel$export(module.exports, "Inline", () => $37e62470b81f7006$export$fbae5b5ffd8af05e);
/* inline.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $gJ6nT = parcelRequire("gJ6nT");

var $dwUnm = parcelRequire("dwUnm");

var $jR7Rq = parcelRequire("jR7Rq");
const $37e62470b81f7006$var$styles = {
    separator: "_3SamIHPgdg _2YLqiKLl21 _1UtDYz16L5 _1pp6NdYbGa _20VacPYbGa",
    hug: "_2O5VijdnbC",
    fill: "_39xV02N91d _2O5Vij7dHp"
};
const $37e62470b81f7006$var$Separator = ({ children: children })=>/*#__PURE__*/ (0, $5chsV.jsx)("span", {
        className: (0, $gJ6nT.default)([
            $37e62470b81f7006$var$styles.separator
        ]),
        children: children
    });
$37e62470b81f7006$var$Separator.displayName = "Separator";
const $37e62470b81f7006$export$fbae5b5ffd8af05e = /*#__PURE__*/ (0, $fsvuC.memo)(/*#__PURE__*/ (0, $fsvuC.forwardRef)(({ as: as, alignInline: alignInline, alignBlock: alignItems = 'start', shouldWrap: shouldWrap = false, spread: spread, grow: grow, space: space, rowSpace: rowSpace, separator: separator, xcss: xcss, testId: testId, role: role, children: rawChildren, ...ariaAttributes }, ref)=>{
    const separatorComponent = typeof separator === 'string' ? /*#__PURE__*/ (0, $5chsV.jsx)($37e62470b81f7006$var$Separator, {
        children: separator
    }) : separator;
    const children = separatorComponent ? (0, $fsvuC.Children).toArray(rawChildren).filter(Boolean).map((child, index)=>{
        return /*#__PURE__*/ (0, $5chsV.jsxs)((0, $fsvuC.Fragment), {
            children: [
                separator && index > 0 ? separatorComponent : null,
                child
            ]
        }, index);
    }) : rawChildren;
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $jR7Rq.Flex), {
        ...ariaAttributes,
        as: as,
        role: role,
        alignItems: alignItems,
        justifyContent: spread || alignInline,
        direction: "row",
        gap: space,
        rowGap: rowSpace,
        wrap: shouldWrap ? 'wrap' : undefined,
        xcss: (0, $dwUnm.cx)(grow === 'hug' && $37e62470b81f7006$var$styles.hug, grow === 'fill' && $37e62470b81f7006$var$styles.fill, xcss),
        testId: testId,
        ref: ref,
        children: children
    });
}));
$37e62470b81f7006$export$fbae5b5ffd8af05e.displayName = 'Inline';

});
parcelRegister("dwUnm", function(module, exports) {
$parcel$export(module.exports, "cx", () => $146096cd63556527$export$a274e22fb40f762e);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ parcelRequire("fsvuC");

var $kZFYZ = parcelRequire("kZFYZ");
const $146096cd63556527$var$strictApi = (0, $kZFYZ.createStrictAPI)();
const $146096cd63556527$export$dbf350e5966cf602 = $146096cd63556527$var$strictApi.css;
const $146096cd63556527$export$eb1ecd84a24ee424 = $146096cd63556527$var$strictApi.cssMap;
$146096cd63556527$var$strictApi.cssMap;
const $146096cd63556527$export$a274e22fb40f762e = $146096cd63556527$var$strictApi.cx;
const $146096cd63556527$var$XCSSProp = $146096cd63556527$var$strictApi.XCSSProp;

});

parcelRegister("jR7Rq", function(module, exports) {
$parcel$export(module.exports, "Flex", () => $3ebeccc50685f262$export$f51f4c4ede09e011);
/* flex.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $gJ6nT = parcelRequire("gJ6nT");
const $3ebeccc50685f262$var$rowGapMap = {
    'space.0': "_42d1HAPgdg",
    'space.025': "_42d1HAFQfX",
    'space.050': "_42d1HA1Y8M",
    'space.075': "_42d1HAgVvo",
    'space.100': "_42d1HA2ADO",
    'space.150': "_42d1HA8HPE",
    'space.200': "_42d1HA5zaO",
    'space.250': "_42d1HAkG2W",
    'space.300': "_42d1HANHnM",
    'space.400': "_42d1HAVa5s",
    'space.500': "_42d1HAS40j",
    'space.600': "_42d1HAp0Oa",
    'space.800': "_42d1HAGXk2",
    'space.1000': "_42d1HAyFLW",
    'space.gap.xxsmall': "_42d1HAjV64",
    'space.gap.xsmall': "_42d1HAUCGe",
    'space.gap.small': "_42d1HAA6HX",
    'space.gap.medium': "_42d1HA1Tnb",
    'space.gap.large': "_42d1HAhS5a",
    'space.gap.xlarge': "_42d1HAK6kw",
    'space.gap.xxlarge': "_42d1HA2H2T"
};
const $3ebeccc50685f262$var$columnGapMap = {
    'space.0': "_17lj8pPgdg",
    'space.025': "_17lj8pFQfX",
    'space.050': "_17lj8p1Y8M",
    'space.075': "_17lj8pgVvo",
    'space.100': "_17lj8p2ADO",
    'space.150': "_17lj8p8HPE",
    'space.200': "_17lj8p5zaO",
    'space.250': "_17lj8pkG2W",
    'space.300': "_17lj8pNHnM",
    'space.400': "_17lj8pVa5s",
    'space.500': "_17lj8pS40j",
    'space.600': "_17lj8pp0Oa",
    'space.800': "_17lj8pGXk2",
    'space.1000': "_17lj8pyFLW",
    'space.gap.xxsmall': "_17lj8pjV64",
    'space.gap.xsmall': "_17lj8pUCGe",
    'space.gap.small': "_17lj8pA6HX",
    'space.gap.medium': "_17lj8p1Tnb",
    'space.gap.large': "_17lj8phS5a",
    'space.gap.xlarge': "_17lj8pK6kw",
    'space.gap.xxlarge': "_17lj8p2H2T"
};
const $3ebeccc50685f262$var$justifyContentMap = {
    start: "_37wbyu7p2s",
    center: "_37wbyuDIqT",
    end: "_37wbyuF05b",
    'space-between': "_37wbyuI7V3",
    'space-around': "_37wbyuxEoi",
    'space-evenly': "_37wbyuZHm0",
    stretch: "_37wbyuFlnN"
};
const $3ebeccc50685f262$var$flexDirectionMap = {
    column: "_0aFT5vbt8w",
    row: "_0aFT5v1qpb"
};
const $3ebeccc50685f262$var$flexWrapMap = {
    wrap: "_3TGfC9HnLE",
    nowrap: "_3TGfC9LRg7"
};
const $3ebeccc50685f262$var$alignItemsMap = {
    start: "_0hPCNL7p2s",
    center: "_0hPCNLDIqT",
    baseline: "_0hPCNLQame",
    end: "_0hPCNLF05b",
    stretch: "_0hPCNLFlnN"
};
const $3ebeccc50685f262$var$styles = {
    root: "_3iDTPbQ4SZ _24h04i2Njc"
};
const $3ebeccc50685f262$export$f51f4c4ede09e011 = /*#__PURE__*/ (0, $fsvuC.memo)(/*#__PURE__*/ (0, $fsvuC.forwardRef)(({ as: Component = 'div', role: role, alignItems: alignItems, justifyContent: justifyContent, gap: gap, columnGap: columnGap, rowGap: rowGap, children: children, testId: testId, direction: direction, wrap: wrap, xcss: xcss, ...ariaAttributes }, ref)=>{
    return /*#__PURE__*/ (0, $5chsV.jsx)(Component, {
        ...ariaAttributes,
        role: role,
        className: (0, $gJ6nT.default)([
            $3ebeccc50685f262$var$styles.root,
            gap && $3ebeccc50685f262$var$columnGapMap[gap],
            columnGap && $3ebeccc50685f262$var$columnGapMap[columnGap],
            gap && $3ebeccc50685f262$var$rowGapMap[gap],
            rowGap && $3ebeccc50685f262$var$rowGapMap[rowGap],
            alignItems && $3ebeccc50685f262$var$alignItemsMap[alignItems],
            direction && $3ebeccc50685f262$var$flexDirectionMap[direction],
            justifyContent && $3ebeccc50685f262$var$justifyContentMap[justifyContent],
            wrap && $3ebeccc50685f262$var$flexWrapMap[wrap],
            xcss
        ]),
        "data-testid": testId,
        ref: ref,
        children: children
    });
}));
$3ebeccc50685f262$export$f51f4c4ede09e011.displayName = 'Flex';

});


parcelRegister("d0SZF", function(module, exports) {
$parcel$export(module.exports, "Stack", () => $109db8a0f70829e7$export$694e0d28c7ffc90c);
/* stack.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $dwUnm = parcelRequire("dwUnm");

var $jR7Rq = parcelRequire("jR7Rq");
const $109db8a0f70829e7$var$styles = {
    hug: "_2O5VijdnbC",
    fill: "_39xV02N91d _2O5Vij7dHp"
};
const $109db8a0f70829e7$export$694e0d28c7ffc90c = /*#__PURE__*/ (0, $fsvuC.memo)(/*#__PURE__*/ (0, $fsvuC.forwardRef)(({ as: as, alignInline: alignItems, alignBlock: alignBlock = 'stretch', spread: spread, grow: grow, space: space, children: children, testId: testId, xcss: xcss, role: role, ...ariaAttributes }, ref)=>{
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $jR7Rq.Flex), {
        ...ariaAttributes,
        as: as,
        role: role,
        gap: space,
        direction: "column",
        alignItems: alignItems,
        justifyContent: spread || alignBlock,
        xcss: (0, $dwUnm.cx)(grow === 'hug' && $109db8a0f70829e7$var$styles.hug, grow === 'fill' && $109db8a0f70829e7$var$styles.fill, xcss),
        testId: testId,
        ref: ref,
        children: children
    });
}));
$109db8a0f70829e7$export$694e0d28c7ffc90c.displayName = 'Stack';

});

const $f8a69c6d37cb4ab8$export$d6830277b06edd6 = 'normal';
const $f8a69c6d37cb4ab8$export$1eee5ddc4f6d41c5 = 400;

parcelRegister("3wkbz", function(module, exports) {
$parcel$export(module.exports, "default", () => $9c2fb5fae2b401d4$export$2e2bcd8739ae039);
/* flag-actions.tsx generated by @compiled/babel-plugin v3.0.2 */ /* eslint-disable @atlaskit/design-system/no-nested-styles */ 
var $5chsV = parcelRequire("5chsV");
parcelRequire("fsvuC");

var $gJ6nT = parcelRequire("gJ6nT");

var $3KROw = parcelRequire("3KROw");

var $llCao = parcelRequire("llCao");

var $cogH0 = parcelRequire("cogH0");

var $5VwMQ = parcelRequire("5VwMQ");


var $b1Erm = parcelRequire("b1Erm");
const $9c2fb5fae2b401d4$var$buttonStylesOld = null;
const $9c2fb5fae2b401d4$var$buttonStyles = null;
const $9c2fb5fae2b401d4$var$fontStyles = null;
const $9c2fb5fae2b401d4$var$appearanceNormalButtonStyles = null;
const $9c2fb5fae2b401d4$var$appearanceBoldButtonStyles = null;
const $9c2fb5fae2b401d4$var$appearanceNormalActionsContainerStyles = null;
const $9c2fb5fae2b401d4$var$FlagActions = (props)=>{
    const { appearance: appearance = (0, $f8a69c6d37cb4ab8$export$d6830277b06edd6), actions: actions = [], linkComponent: linkComponent, testId: testId } = props;
    if (!actions.length) return null;
    const isBold = appearance !== (0, $f8a69c6d37cb4ab8$export$d6830277b06edd6);
    return /*#__PURE__*/ (0, $5chsV.jsx)("span", {
        className: (0, $gJ6nT.default)([
            !isBold && "_3rjf849EAj _2g5bSc9EAj",
            "_2sNsIgmnOE"
        ]),
        children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $cogH0.Inline), {
            space: "space.100",
            shouldWrap: true,
            alignBlock: "center",
            separator: isBold ? undefined : "\xb7",
            testId: testId && `${testId}-actions`,
            children: actions.map((action, index)=>(0, $llCao.fg)('platform_dst_flag_action_padding_fix') ? /*#__PURE__*/ (0, $5chsV.jsx)((0, $3KROw.default), {
                    onClick: action.onClick,
                    href: action.href,
                    target: action.target,
                    appearance: isBold ? 'default' : 'link',
                    component: linkComponent,
                    spacing: "compact",
                    testId: action.testId,
                    style: {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                        '--color': (0, $5VwMQ.actionTextColor)[appearance],
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                        '--bg-color': (0, $b1Erm.actionBackgroundColor)[appearance].default,
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                        '--bg-color-hover': (0, $b1Erm.actionBackgroundColor)[appearance].pressed,
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                        '--bg-color-active': (0, $b1Erm.actionBackgroundColor)[appearance].active
                    },
                    className: (0, $gJ6nT.default)([
                        "_1zBHawbfve _1Zh9sPbfve _4vhRtvWhvE _1KLLevWhvE _2yzFFQf7mX _1e2Yfgf7mX _1DQB67yL8i _42kVG6yL8i _0yfzw2yL8i _0tvG6syL8i _2T5IMK0Rl6 _42n1kX0Rl6 _0mPUgm0Rl6 _437BtI0Rl6 _06dOVI6wH8 _3kRhep6wH8 _0JO6Ak6wH8 _4d2m5x6wH8 _1YWIj4XiNI _2p7eIBBVOI",
                        isBold ? "_3gZsD7AASz _17zPT6AASz _27WIHEWfES _3CVxu7WfES _11DXJJAASz _0QO5anAASz _4GiLnvWfES _2k3Be9WfES" : "_3gZsD7AASz _17zPT6AASz _27WIHEAASz _3CVxu7AASz _11DXJJAASz _0QO5anAASz _4GiLnvAASz _2k3Be9AASz"
                    ]),
                    children: action.content
                }, index) : /*#__PURE__*/ (0, $5chsV.jsx)((0, $3KROw.default), {
                    onClick: action.onClick,
                    href: action.href,
                    target: action.target,
                    appearance: isBold ? 'default' : 'link',
                    component: linkComponent,
                    spacing: "compact",
                    testId: action.testId,
                    style: {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                        '--color': (0, $5VwMQ.actionTextColor)[appearance],
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                        '--bg-color': (0, $b1Erm.actionBackgroundColor)[appearance].default,
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                        '--bg-color-hover': (0, $b1Erm.actionBackgroundColor)[appearance].pressed,
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                        '--bg-color-active': (0, $b1Erm.actionBackgroundColor)[appearance].active
                    },
                    className: (0, $gJ6nT.default)([
                        "_1zBHawbfve _1Zh9sPbfve _4vhRtvWhvE _1KLLevWhvE _2yzFFQf7mX _1e2Yfgf7mX _3KzIDNAASz _4r9gguAASz _14OR94AASz _3ifz2HAASz _38CysdWfES _4y9fntWfES _0Jp6tVWfES _0YkdVFWfES _1DQB67yL8i _42kVG6yL8i _0yfzw2yL8i _0tvG6syL8i _2T5IMK0Rl6 _42n1kX0Rl6 _0mPUgm0Rl6 _437BtI0Rl6 _06dOVI6wH8 _3kRhep6wH8 _0JO6Ak6wH8 _4d2m5x6wH8 _1YWIj4XiNI _2p7eIBBVOI",
                        !isBold && "_3gZsD7AASz _17zPT6AASz _27WIHEAASz _3CVxu7AASz _11DXJJAASz _0QO5anAASz _4GiLnvAASz _2k3Be9AASz"
                    ]),
                    children: action.content
                }, index))
        })
    });
};
$9c2fb5fae2b401d4$var$FlagActions.displayName = "FlagActions";
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$9c2fb5fae2b401d4$export$2e2bcd8739ae039 = $9c2fb5fae2b401d4$var$FlagActions;

});
parcelRegister("3KROw", function(module, exports) {
$parcel$export(module.exports, "default", () => $6c800b437014e6f3$export$2e2bcd8739ae039);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $6TvVN = parcelRequire("6TvVN");

var $b6cDn = parcelRequire("b6cDn");

var $9VW4N = parcelRequire("9VW4N");

var $f85qz = parcelRequire("f85qz");

var $cmbBo = parcelRequire("cmbBo");

var $78vZo = parcelRequire("78vZo");

var $cuUd3 = parcelRequire("cuUd3");
function $6c800b437014e6f3$var$getInteractionState({ isDisabled: isDisabled = false, isActive: isActive = false, isFocus: isFocus = false, isHover: isHover = false, isSelected: isSelected = false, isLoading: isLoading = false }) {
    if (isDisabled) return 'disabled';
    if (isSelected && isFocus) return 'focusSelected';
    if (isSelected) return 'selected';
    // not allowing active or focus style changes while loading
    if (!isLoading && isActive) return 'active';
    if (!isLoading && isHover) return 'hover';
    if (isFocus) return 'focus';
    return 'default';
}
const $6c800b437014e6f3$var$initial = {
    isHover: false,
    isActive: false,
    isFocus: false
};
/**
 * __Custom theme button__
 *
 * @deprecated Legacy buttons are deprecated and will be removed from `atlaskit/button` in an upcoming major release. Please use `Button` from `@atlaskit/button/default/button`.
 *
 * Please refer to the [migration guide](https://atlassian.design/components/button/button-legacy/migration-guide) for further details.
 *
 * A custom theme button. Avoid using this component. It exists for those already using custom theming, which is hard to use and has performance issues.
 *
 * - [Examples](https://atlassian.design/components/button/examples#custom-theme-button)
 */ const $6c800b437014e6f3$var$CustomThemeButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).forwardRef(function CustomThemeButton({ appearance: // Calculate default props for use in custom themes
appearance = 'default', autoFocus: autoFocus = false, isDisabled: isDisabled = false, isSelected: isSelected = false, shouldFitContainer: shouldFitContainer = false, spacing: spacing = 'default', isLoading: isLoading = false, onMouseEnter: providedOnMouseEnter, onMouseLeave: providedOnMouseLeave, onMouseDown: providedOnMouseDown, onMouseUp: providedOnMouseUp, onFocus: providedOnFocus, onBlur: providedOnBlur, theme: theme = (0, $cmbBo.defaultThemeFn), ...rest }, ref) {
    // TODO is there a nicer way to do this?
    // Add default props back into object for spreading
    const restProps = {
        appearance: appearance,
        autoFocus: autoFocus,
        isDisabled: isDisabled,
        isSelected: isSelected,
        shouldFitContainer: shouldFitContainer,
        spacing: spacing,
        ...rest
    };
    const [state, setState] = (0, $fsvuC.useState)($6c800b437014e6f3$var$initial);
    const onMouseEnter = (0, $fsvuC.useCallback)((event)=>{
        setState((current)=>({
                ...current,
                isHover: true
            }));
        if (providedOnMouseEnter) providedOnMouseEnter(event);
    }, [
        providedOnMouseEnter
    ]);
    const onMouseLeave = (0, $fsvuC.useCallback)((event)=>{
        setState((current)=>({
                ...current,
                isHover: false,
                isActive: false
            }));
        if (providedOnMouseLeave) providedOnMouseLeave(event);
    }, [
        providedOnMouseLeave
    ]);
    const onMouseDown = (0, $fsvuC.useCallback)((event)=>{
        setState((current)=>({
                ...current,
                isActive: true
            }));
        if (providedOnMouseDown) providedOnMouseDown(event);
    }, [
        providedOnMouseDown
    ]);
    const onMouseUp = (0, $fsvuC.useCallback)((event)=>{
        setState((current)=>({
                ...current,
                isActive: false
            }));
        if (providedOnMouseUp) providedOnMouseUp(event);
    }, [
        providedOnMouseUp
    ]);
    const onFocus = (0, $fsvuC.useCallback)((event)=>{
        setState((current)=>({
                ...current,
                isFocus: true
            }));
        if (providedOnFocus) providedOnFocus(event);
    }, [
        providedOnFocus
    ]);
    const onBlur = (0, $fsvuC.useCallback)((event)=>{
        setState((current)=>({
                ...current,
                isFocus: false
            }));
        if (providedOnBlur) providedOnBlur(event);
    }, [
        providedOnBlur
    ]);
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $cuUd3.default).Provider, {
        value: theme,
        children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $6TvVN.default).Consumer, {
            children: ({ mode: mode })=>/*#__PURE__*/ (0, $5chsV.jsx)((0, $cuUd3.default).Consumer, {
                    mode: mode,
                    state: $6c800b437014e6f3$var$getInteractionState({
                        ...state,
                        isLoading: isLoading,
                        isSelected: restProps.isSelected,
                        isDisabled: restProps.isDisabled
                    }),
                    iconIsOnlyChild: (0, $9VW4N.default)(restProps),
                    isLoading: isLoading,
                    ...restProps,
                    children: ({ buttonStyles: buttonStyles })=>/*#__PURE__*/ (0, $5chsV.jsx)((0, $b6cDn.default), {
                            ...restProps,
                            ref: ref,
                            overlay: isLoading ? /*#__PURE__*/ (0, $5chsV.jsx)((0, $f85qz.default), {
                                ...restProps
                            }) : null,
                            // No need to render aria-disabled when it is false
                            "aria-disabled": isLoading || restProps['aria-disabled'],
                            onMouseEnter: onMouseEnter,
                            onMouseLeave: onMouseLeave,
                            onMouseDown: onMouseDown,
                            onMouseUp: onMouseUp,
                            onFocus: onFocus,
                            onBlur: onBlur,
                            buttonCss: (0, $78vZo.getSpecifiers)(buttonStyles)
                        })
                })
        })
    });
}));
// Tools including enzyme rely on components having a display name
$6c800b437014e6f3$var$CustomThemeButton.displayName = 'CustomThemeButton';
var $6c800b437014e6f3$export$2e2bcd8739ae039 = $6c800b437014e6f3$var$CustomThemeButton;

});
parcelRegister("6TvVN", function(module, exports) {
$parcel$export(module.exports, "default", () => $eb701831aebd7088$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ 
var $3Ghou = parcelRequire("3Ghou");
// Create default global light theme
const $eb701831aebd7088$var$dest = (0, $3Ghou.createTheme)(()=>({
        mode: 'light'
    }));
const $eb701831aebd7088$var$Provider = $eb701831aebd7088$var$dest.Provider;
const $eb701831aebd7088$var$Consumer = $eb701831aebd7088$var$dest.Consumer;
const $eb701831aebd7088$export$7692396083754928 = $eb701831aebd7088$var$dest.useTheme;
const $eb701831aebd7088$var$Theme = {
    Provider: $eb701831aebd7088$var$Provider,
    Consumer: $eb701831aebd7088$var$Consumer
};
var /**
 * @deprecated {@link https://hello.atlassian.net/browse/ENGHEALTH-2652 Internal documentation for deprecation (no external access)}
 * Use design tokens and the supported customization APIs of Atlassian Design System components.
 */ $eb701831aebd7088$export$2e2bcd8739ae039 = $eb701831aebd7088$var$Theme;

});
parcelRegister("3Ghou", function(module, exports) {
$parcel$export(module.exports, "createTheme", () => $db20ec1616e98255$export$25d302a5b900a763);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");
function $db20ec1616e98255$export$25d302a5b900a763(defaultGetTokens) {
    const emptyThemeFn = (getTokens, props)=>getTokens(props);
    /**
	 * Internally, Theme uses React Context, with internal providers and consumers.
	 * The React Context passes only a function that gets props, and turns them into tokens. This
	 * function gets mixed as more Providers with their own themes are added. This mixed function
	 * is ultimately picked up by Consumers, which implement a context consumer internally to fetch
	 * the theme.
	 */ const ThemeContext = /*#__PURE__*/ (0, $fsvuC.createContext)(defaultGetTokens);
    function useTheme(themeProps) {
        const theme = (0, $fsvuC.useContext)(ThemeContext);
        const themeFn = theme || emptyThemeFn;
        const tokens = themeFn(themeProps);
        return tokens;
    }
    // The Theme Consumer takes a function as its child - this function takes tokens, and the
    // return value is generally a set of nodes with the tokens applied appropriately.
    function Consumer(props) {
        const { children: children, ...themeProps } = props;
        // @ts-ignore See issue for more info: https://github.com/Microsoft/TypeScript/issues/10727
        // Argument of type 'Pick<ThemeProps & { children: (tokens: ThemeTokens) => ReactNode; }, Exclude<keyof ThemeProps, "children">>' is not assignable to parameter of type 'ThemeProps'.ts(2345)
        const tokens = useTheme(themeProps);
        // We add a fragment to ensure we don't break people upgrading.
        // Previously they may have been able to pass in undefined without things blowing up.
        return /*#__PURE__*/ (0, $5chsV.jsx)((0, $5chsV.Fragment), {
            children: children(tokens)
        });
    }
    /**
	 * The Theme Provider takes regular nodes as its children, but also takes a *theme function*
	 * - The theme function takes a set of props, as well as a function (getTokens) that can turn props into tokens.
	 * - The getTokens function isn't called immediately - instead the props are passed
	 *    through a mix of parent theming functions
	 * Children of this provider will receive this mixed theme
	 */ function Provider(props) {
        const themeFn = (0, $fsvuC.useContext)(ThemeContext);
        const valueFn = props.value || emptyThemeFn;
        const mixedFn = (0, $fsvuC.useCallback)((themeProps)=>valueFn(themeFn, themeProps), [
            themeFn,
            valueFn
        ]);
        return /*#__PURE__*/ (0, $5chsV.jsx)(ThemeContext.Provider, {
            value: mixedFn,
            children: props.children
        });
    }
    return {
        Consumer: Consumer,
        Provider: Provider,
        useTheme: useTheme
    };
}

});


parcelRegister("cmbBo", function(module, exports) {
$parcel$export(module.exports, "defaultThemeFn", () => $2995995b57373eff$export$437a7f77d13d7916);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
function $2995995b57373eff$export$437a7f77d13d7916(current, values) {
    return current(values);
}

});

parcelRegister("78vZo", function(module, exports) {
$parcel$export(module.exports, "getSpecifiers", () => $27f6f41f5fc62bf5$export$643db0b8d8778e);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
function $27f6f41f5fc62bf5$export$643db0b8d8778e(styles) {
    return {
        '&, &:hover, &:active, &:focus, &:focus-visible, &:visited, &:disabled, &[disabled]': styles
    };
}

});

parcelRegister("cuUd3", function(module, exports) {
$parcel$export(module.exports, "default", () => $d7b094198d0bb963$export$2e2bcd8739ae039);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled, @atlaskit/ui-styling-standard/no-atlaskit-theme -- Ignored via go/DSP-18766

var $3Ghou = parcelRequire("3Ghou");

var $3XUpP = parcelRequire("3XUpP");
const $d7b094198d0bb963$var$Theme = (0, $3Ghou.createTheme)((themeProps)=>({
        buttonStyles: (0, $3XUpP.getCustomCss)(themeProps),
        // No styles being applied directly to spinner by default
        // Keeping this for legacy compat. We could remove it, but given
        // that we are changing theme soon there is no point
        spinnerStyles: {}
    }));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$d7b094198d0bb963$export$2e2bcd8739ae039 = $d7b094198d0bb963$var$Theme;

});
parcelRegister("3XUpP", function(module, exports) {
$parcel$export(module.exports, "getCustomCss", () => $be92a93afd5de10b$export$31512de7fa606fa4);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $8lKCF = parcelRequire("8lKCF");
const $be92a93afd5de10b$var$stateToSelectorMap = {
    focus: '&:focus',
    focusSelected: '&:focus',
    hover: '&:hover',
    active: '&:active',
    disabled: '&[disabled]'
};
function $be92a93afd5de10b$export$31512de7fa606fa4({ appearance: appearance = 'default', spacing: spacing = 'default', isSelected: isSelected = false, shouldFitContainer: shouldFitContainer = false, iconIsOnlyChild: iconIsOnlyChild = false, isLoading: isLoading = false, state: state }) {
    let result = (0, $8lKCF.getCss)({
        appearance: appearance,
        spacing: spacing,
        isSelected: isSelected,
        shouldFitContainer: shouldFitContainer,
        isOnlySingleIcon: iconIsOnlyChild
    });
    // we need to disable the default browser focus styles always
    // this is because we are not expressing that we can have two pseudo states at a time
    result.outline = 'none';
    // Pulling relevant styles up to the top level
    const selector = $be92a93afd5de10b$var$stateToSelectorMap[state];
    if (selector) result = {
        ...result,
        ...result[selector]
    };
    if (isLoading) result = {
        ...result,
        // Pull overlay styles up to the top
        ...result['&[data-has-overlay="true"]']
    };
    // Delete all selectors and just keep root styles
    Object.keys(result).forEach((key)=>{
        // want to keep this one
        if (key === '&::-moz-focus-inner') return;
        // Not using .startsWith for ie11
        if (key.indexOf('&') === 0) delete result[key];
    });
    return result;
}

});



parcelRegister("5VwMQ", function(module, exports) {
$parcel$export(module.exports, "actionTextColor", () => $93a7d22ce2a937d7$export$7bcfe3cca4dd78b6);
const $93a7d22ce2a937d7$export$7bcfe3cca4dd78b6 = {
    success: "var(--ds-text-inverse, #FFFFFF)",
    info: "var(--ds-text-inverse, #FFFFFF)",
    error: "var(--ds-text-inverse, #FFFFFF)",
    warning: "var(--ds-text-warning-inverse, #292A2E)",
    normal: "var(--ds-link, #1868DB)"
};

});

parcelRegister("b1Erm", function(module, exports) {
$parcel$export(module.exports, "actionBackgroundColor", () => $99aef02ac06c786d$export$81ba6b63eedb299f);
const $99aef02ac06c786d$export$81ba6b63eedb299f = {
    success: {
        default: "var(--ds-background-inverse-subtle, #00000029)",
        active: "var(--ds-background-inverse-subtle-pressed, #00000052)",
        pressed: "var(--ds-background-inverse-subtle-hovered, #0000003D)"
    },
    info: {
        default: "var(--ds-background-inverse-subtle, #00000029)",
        active: "var(--ds-background-inverse-subtle-pressed, #00000052)",
        pressed: "var(--ds-background-inverse-subtle-hovered, #0000003D)"
    },
    error: {
        default: "var(--ds-background-inverse-subtle, #00000029)",
        active: "var(--ds-background-inverse-subtle-pressed, #00000052)",
        pressed: "var(--ds-background-inverse-subtle-hovered, #0000003D)"
    },
    warning: {
        default: "var(--ds-background-inverse-subtle, #00000029)",
        active: "var(--ds-background-inverse-subtle-pressed, #00000052)",
        pressed: "var(--ds-background-inverse-subtle-hovered, #0000003D)"
    },
    normal: {
        default: 'none',
        active: 'none',
        pressed: 'none'
    }
};

});


parcelRegister("dp94n", function(module, exports) {
$parcel$export(module.exports, "flagBackgroundColor", () => $6b68fbc8daaa3c1b$export$59e42969c95d314);
const $6b68fbc8daaa3c1b$export$59e42969c95d314 = {
    error: 'color.background.danger.bold',
    info: 'color.background.neutral.bold',
    normal: 'elevation.surface.overlay',
    success: 'color.background.success.bold',
    warning: 'color.background.warning.bold'
};

});

parcelRegister("7KtJz", function(module, exports) {
$parcel$export(module.exports, "flagIconColor", () => $c36585edfcfc4ad5$export$7f70afe2167f8235);
const $c36585edfcfc4ad5$export$7f70afe2167f8235 = {
    error: "var(--ds-icon-inverse, #FFFFFF)",
    info: "var(--ds-icon-inverse, #FFFFFF)",
    normal: "var(--ds-icon-subtle, #505258)",
    success: "var(--ds-icon-inverse, #FFFFFF)",
    warning: "var(--ds-icon-warning-inverse, #292A2E)"
};

});

parcelRegister("lBT2M", function(module, exports) {
$parcel$export(module.exports, "flagIconGlyph", () => $0d4df0293ccf41fd$export$73f08aee70487cd4);

var $5chsV = parcelRequire("5chsV");
parcelRequire("fsvuC");

var $6Pb6R = parcelRequire("6Pb6R");

var $cBqdE = parcelRequire("cBqdE");

var $cBvQ0 = parcelRequire("cBvQ0");

var $gD3tC = parcelRequire("gD3tC");
const $0d4df0293ccf41fd$export$73f08aee70487cd4 = {
    error: /*#__PURE__*/ (0, $5chsV.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6Pb6R))), {
        label: ""
    }),
    info: /*#__PURE__*/ (0, $5chsV.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cBqdE))), {
        label: ""
    }),
    normal: /*#__PURE__*/ (0, $5chsV.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cBqdE))), {
        label: ""
    }),
    success: /*#__PURE__*/ (0, $5chsV.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cBvQ0))), {
        label: ""
    }),
    warning: /*#__PURE__*/ (0, $5chsV.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gD3tC))), {
        label: ""
    })
};

});

parcelRegister("9zSqF", function(module, exports) {
$parcel$export(module.exports, "flagTextColor", () => $00d02362084c1ae2$export$f50075b2584087f);
const $00d02362084c1ae2$export$f50075b2584087f = {
    error: 'color.text.inverse',
    info: 'color.text.inverse',
    normal: 'color.text',
    success: 'color.text.inverse',
    warning: 'color.text.warning.inverse'
};

});

parcelRegister("6TVlj", function(module, exports) {
$parcel$export(module.exports, "flagTextColorToken", () => $b7d6e2b30bc96e59$export$13b42cd9d596bfe0);
const $b7d6e2b30bc96e59$export$13b42cd9d596bfe0 = {
    error: "var(--ds-text-inverse, #FFFFFF)",
    info: "var(--ds-text-inverse, #FFFFFF)",
    normal: "var(--ds-text, #292A2E)",
    success: "var(--ds-text-inverse, #FFFFFF)",
    warning: "var(--ds-text-warning-inverse, #292A2E)"
};

});

parcelRegister("8XXob", function(module, exports) {
$parcel$export(module.exports, "default", () => $ad461d4980447f2c$export$2e2bcd8739ae039);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $kfsyS = parcelRequire("kfsyS");

var $9cVKi = parcelRequire("9cVKi");

var $dfYNc = parcelRequire("dfYNc");

var $irYrv = parcelRequire("irYrv");

var $6TVlj = parcelRequire("6TVlj");
const $ad461d4980447f2c$var$DismissButtonComponent = ({ appearance: appearance, onClick: onClick, isBold: isBold, isExpanded: isExpanded, testId: testId })=>{
    let ButtonIcon = (0, (/*@__PURE__*/$parcel$interopDefault($irYrv)));
    let buttonLabel = 'Dismiss';
    let buttonTestId = testId && `${testId}-dismiss`;
    if (isBold) {
        ButtonIcon = isExpanded ? (0, (/*@__PURE__*/$parcel$interopDefault($dfYNc))) : (0, (/*@__PURE__*/$parcel$interopDefault($9cVKi)));
        buttonLabel = isExpanded ? 'Collapse' : 'Expand';
        buttonTestId = testId && `${testId}-toggle`;
    }
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $kfsyS.default), {
        icon: (iconProps)=>/*#__PURE__*/ (0, $5chsV.jsx)(ButtonIcon, {
                ...iconProps,
                size: "small",
                label: "",
                color: (0, $6TVlj.flagTextColorToken)[appearance]
            }),
        appearance: "subtle",
        spacing: "compact",
        label: buttonLabel,
        onClick: onClick,
        "aria-expanded": isBold ? isExpanded : undefined,
        testId: buttonTestId
    });
};
$ad461d4980447f2c$var$DismissButtonComponent.displayName = "DismissButtonComponent";
const $ad461d4980447f2c$var$DismissButton = /*#__PURE__*/ (0, $fsvuC.memo)($ad461d4980447f2c$var$DismissButtonComponent);
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$ad461d4980447f2c$export$2e2bcd8739ae039 = $ad461d4980447f2c$var$DismissButton;

});
parcelRegister("kfsyS", function(module, exports) {
$parcel$export(module.exports, "default", () => $e4cd7363741b03d8$export$2e2bcd8739ae039);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $fz4Xf = parcelRequire("fz4Xf");

var $3Kmf8 = parcelRequire("3Kmf8");

var $8e1dR = parcelRequire("8e1dR");

var $k56Mb = parcelRequire("k56Mb");

var $5Qhtn = parcelRequire("5Qhtn");

var $eYXrv = parcelRequire("eYXrv");
/**
 * __Icon Button__
 *
 * Renders an icon-only button lets people take a common and recognizable action where space is limited.
 *
 * - [Examples](https://atlassian.design/components/button/icon-button/examples)
 * - [Code](https://atlassian.design/components/button/icon-button/code)
 * - [Usage](https://atlassian.design/components/button/icon-button/usage)
 */ const $e4cd7363741b03d8$var$IconButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).forwardRef(function Button({ // Prevent duplicate labels being added.
'aria-label': preventedAriaLabel, 'aria-labelledby': ariaLabelledBy, analyticsContext: analyticsContext, appearance: appearance, autoFocus: autoFocus, icon: icon, interactionName: interactionName, isDisabled: isDisabled, isLoading: isLoading = false, isSelected: isSelected, isTooltipDisabled: isTooltipDisabled = true, label: label, onClick: onClick, onClickCapture: onClickCapture, onKeyDownCapture: onKeyDownCapture, onKeyUpCapture: onKeyUpCapture, onMouseDownCapture: onMouseDownCapture, onMouseUpCapture: onMouseUpCapture, onPointerDownCapture: onPointerDownCapture, onPointerUpCapture: onPointerUpCapture, onTouchEndCapture: onTouchEndCapture, onTouchStartCapture: onTouchStartCapture, shape: shape, spacing: spacing, testId: testId, tooltip: tooltip, type: type = 'button', ...unsafeRest }, ref) {
    // @ts-expect-error
    const { className: _className, css: _css, as: _as, style: _style, ...saferRest } = unsafeRest;
    if (isTooltipDisabled) return /*#__PURE__*/ (0, $5chsV.jsx)((0, $k56Mb.default), {
        ...saferRest,
        ref: ref,
        appearance: appearance,
        autoFocus: autoFocus,
        isDisabled: isDisabled,
        isLoading: isLoading,
        isSelected: isSelected,
        isIconButton: true,
        isCircle: shape === 'circle',
        hasIconBefore: !!icon,
        spacing: spacing,
        ariaLabelledBy: ariaLabelledBy,
        onClick: onClick,
        onClickCapture: onClickCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        testId: testId,
        componentName: "IconButton",
        analyticsContext: analyticsContext,
        type: type,
        interactionName: interactionName,
        children: /*#__PURE__*/ (0, $5chsV.jsxs)((0, $5Qhtn.default), {
            type: "icon",
            isLoading: isLoading,
            children: [
                /*#__PURE__*/ (0, $5chsV.jsx)((0, $eYXrv.default), {
                    icon: icon
                }),
                /*#__PURE__*/ (0, $5chsV.jsx)((0, $8e1dR.default), {
                    children: label
                })
            ]
        })
    });
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $3Kmf8.default), {
        content: tooltip?.content ?? label,
        testId: tooltip?.testId,
        position: tooltip?.position,
        delay: tooltip?.delay,
        onShow: tooltip?.onShow,
        onHide: tooltip?.onHide,
        mousePosition: tooltip?.mousePosition,
        analyticsContext: tooltip?.analyticsContext,
        strategy: tooltip?.strategy,
        tag: tooltip?.tag,
        truncate: tooltip?.truncate,
        component: tooltip?.component,
        hideTooltipOnClick: tooltip?.hideTooltipOnClick,
        hideTooltipOnMouseDown: tooltip?.hideTooltipOnMouseDown,
        hasNewContentOnTriggerClick: tooltip?.hasNewContentOnTriggerClick,
        ignoreTooltipPointerEvents: tooltip?.ignoreTooltipPointerEvents,
        shortcut: tooltip?.shortcut,
        children: (triggerProps)=>/*#__PURE__*/ (0, $5chsV.jsx)((0, $k56Mb.default), {
                ...saferRest,
                appearance: appearance,
                autoFocus: autoFocus,
                isDisabled: isDisabled,
                isLoading: isLoading,
                isSelected: isSelected,
                isIconButton: true,
                isCircle: shape === 'circle',
                hasIconBefore: false,
                spacing: spacing,
                ariaLabelledBy: ariaLabelledBy,
                onClick: (e, analyticsEvent)=>{
                    onClick?.(e, analyticsEvent);
                    triggerProps.onClick?.(e);
                },
                onMouseOver: (e)=>{
                    triggerProps.onMouseOver?.(e);
                    saferRest.onMouseOver?.(e);
                },
                onMouseOut: (e)=>{
                    triggerProps.onMouseOut?.(e);
                    saferRest.onMouseOut?.(e);
                },
                onMouseMove: (e)=>{
                    triggerProps.onMouseMove?.(e);
                    saferRest.onMouseMove?.(e);
                },
                onMouseDown: (e)=>{
                    triggerProps.onMouseDown?.(e);
                    saferRest.onMouseDown?.(e);
                },
                onFocus: (e)=>{
                    triggerProps.onFocus?.(e);
                    saferRest.onFocus?.(e);
                },
                onBlur: (e)=>{
                    triggerProps.onBlur?.(e);
                    saferRest.onBlur?.(e);
                },
                ref: (0, $fz4Xf.default)([
                    ref,
                    triggerProps?.ref
                ].filter(Boolean)),
                onMouseDownCapture: onMouseDownCapture,
                onMouseUpCapture: onMouseUpCapture,
                onKeyDownCapture: onKeyDownCapture,
                onKeyUpCapture: onKeyUpCapture,
                onTouchStartCapture: onTouchStartCapture,
                onTouchEndCapture: onTouchEndCapture,
                onPointerDownCapture: onPointerDownCapture,
                onPointerUpCapture: onPointerUpCapture,
                onClickCapture: onClickCapture,
                type: type,
                testId: testId,
                analyticsContext: analyticsContext,
                interactionName: interactionName,
                componentName: "IconButton",
                children: /*#__PURE__*/ (0, $5chsV.jsxs)((0, $5Qhtn.default), {
                    type: "icon",
                    isLoading: isLoading,
                    children: [
                        /*#__PURE__*/ (0, $5chsV.jsx)((0, $eYXrv.default), {
                            icon: icon
                        }),
                        /*#__PURE__*/ (0, $5chsV.jsx)((0, $8e1dR.default), {
                            children: label
                        })
                    ]
                })
            })
    });
}));
$e4cd7363741b03d8$var$IconButton.displayName = 'IconButton';
var $e4cd7363741b03d8$export$2e2bcd8739ae039 = $e4cd7363741b03d8$var$IconButton;

});
parcelRegister("fz4Xf", function(module, exports) {
$parcel$export(module.exports, "default", () => $2237885f0d4e4c99$export$2e2bcd8739ae039);
function $2237885f0d4e4c99$export$2e2bcd8739ae039(refs) {
    return (value)=>{
        refs.forEach((ref)=>{
            if (typeof ref === 'function') ref(value);
            else if (ref !== null && typeof ref === 'object') ref.current = value;
        });
    };
}

});

parcelRegister("3Kmf8", function(module, exports) {
$parcel$export(module.exports, "default", () => $fb17f36cb94a4902$export$2e2bcd8739ae039);
/* tooltip.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $dqdTY = parcelRequire("dqdTY");

var $gJaHb = parcelRequire("gJaHb");

var $fz4Xf = parcelRequire("fz4Xf");

var $9Tkwf = parcelRequire("9Tkwf");

var $i4L0K = parcelRequire("i4L0K");

var $hDNNn = parcelRequire("hDNNn");

var $iqc8V = parcelRequire("iqc8V");

var $lfw4f = parcelRequire("lfw4f");

var $eEY7a = parcelRequire("eEY7a");

var $llCao = parcelRequire("llCao");

var $f3WQU = parcelRequire("f3WQU");

var $bDK6L = parcelRequire("bDK6L");

var $QrsDO = parcelRequire("QrsDO");

var $974dn = parcelRequire("974dn");

var $2jUY9 = parcelRequire("2jUY9");

var $gc525 = parcelRequire("gc525");

var $eyyYg = parcelRequire("eyyYg");

var $1Nrrt = parcelRequire("1Nrrt");

var $7OBha = parcelRequire("7OBha");

var $7FD99 = parcelRequire("7FD99");

var $aguiM = parcelRequire("aguiM");

var $eaO2T = parcelRequire("eaO2T");

var $6OWks = parcelRequire("6OWks");

var $7CbH7 = parcelRequire("7CbH7");
const $fb17f36cb94a4902$var$tooltipZIndex = (0, $QrsDO.layers).tooltip();
const $fb17f36cb94a4902$var$analyticsAttributes = {
    componentName: 'tooltip',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
}; // Inverts motion direction
const $fb17f36cb94a4902$var$invertedDirection = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left'
}; /**
              * Converts a Popper placement to it's general direction.
              *
              * @param placement - Popper Placement value, e.g. 'top-start'
              * @returns Popper Direction, e.g. 'top'
              */ 
const $fb17f36cb94a4902$var$getDirectionFromPlacement = (placement)=>placement.split('-')[0]; /**
                                                                                                                * For the `platform-dst-top-layer-tooltip` path only. Always `false` when that
                                                                                                                * gate is off, so this cannot affect the legacy path even if it gains a caller
                                                                                                                * there.
                                                                                                                *
                                                                                                                * `mouseover` also fires when the pointer crosses boundaries between elements
                                                                                                                * _inside_ the trigger. A `relatedTarget` the trigger does not contain is what
                                                                                                                * distinguishes a real re-entry from one of those.
                                                                                                                */ 
function $fb17f36cb94a4902$var$isTopLayerPointerReEntry({ trigger: trigger, relatedTarget: relatedTarget }) {
    if (!(0, $llCao.fg)('platform-dst-top-layer-tooltip')) return false;
     // Missing trigger, or pointer from outside the document. Treat both as an
    // entry so we cannot get stuck suppressed.
    if (!trigger || !(relatedTarget instanceof Node)) return true;
    return !trigger.contains(relatedTarget);
}
function $fb17f36cb94a4902$var$Tooltip({ children: children, position: position = 'bottom', mousePosition: mousePosition = 'bottom', content: content, truncate: truncate = false, component: Container = (0, $7CbH7.default), tag: TargetContainer = 'div', testId: testId, delay: delay = 300, onShow: onShow = (0, $9Tkwf.default), onHide: onHide = (0, $9Tkwf.default), canAppear: canAppear, hideTooltipOnClick: hideTooltipOnClick = false, hideTooltipOnMouseDown: hideTooltipOnMouseDown = false, hasNewContentOnTriggerClick: hasNewContentOnTriggerClick = false, analyticsContext: analyticsContext, strategy: strategy = 'fixed', ignoreTooltipPointerEvents: ignoreTooltipPointerEvents = false, isScreenReaderAnnouncementDisabled: isScreenReaderAnnouncementDisabled = false, shortcut: shortcut, shouldAlwaysFadeIn: shouldAlwaysFadeIn = false, shouldRenderToParent: shouldRenderToParent = false }) {
    // Not using a gate for this check. When the gate is disabled `mouse-y` and `mouse-x` are treated as `mouse`.
    const isMousePosition = position === 'mouse' || position === 'mouse-y' || position === 'mouse-x';
    const tooltipPosition = isMousePosition ? mousePosition : position; // The deprecated hide props win over `hasNewContentOnTriggerClick`, as the prop
    // docs say. Setting both is a mistake, so keep the older behaviour. Read only
    // together with `platform-dst-top-layer-tooltip`; without the gate a press
    // never closes.
    const isStayOpenOnTriggerClick = hasNewContentOnTriggerClick && !hideTooltipOnClick && !hideTooltipOnMouseDown;
    const onShowHandler = (0, $gJaHb.usePlatformLeafSyntheticEventHandler)({
        fn: onShow,
        action: 'displayed',
        analyticsData: analyticsContext,
        ...$fb17f36cb94a4902$var$analyticsAttributes
    });
    const onHideHandler = (0, $gJaHb.usePlatformLeafSyntheticEventHandler)({
        fn: onHide,
        action: 'hidden',
        analyticsData: analyticsContext,
        ...$fb17f36cb94a4902$var$analyticsAttributes
    });
    const apiRef = (0, $fsvuC.useRef)(null);
    const [state, setState] = (0, $fsvuC.useState)('hide');
    const targetRef = (0, $fsvuC.useRef)(null);
    const containerRef = (0, $fsvuC.useRef)(null); // This function is deliberately _not_ memoized as it needs to re-run every render
    // to pick up any child ref changes. If you use render props you don't have this issue.
    const setImplicitRefFromChildren = (node)=>{
        containerRef.current = node;
        targetRef.current = node ? node.firstElementChild : null;
    }; // This is memoized and passed into the render props callback.
    const setDirectRef = (0, $fsvuC.useCallback)((node)=>{
        targetRef.current = node;
    }, []); // Putting a few things into refs so that we don't have to break memoization
    const stableState = (0, $hDNNn.default)(state); // These props are placed in separate refs instead of a single object to reduce memory usage.
    // Placing them in the same object previously caused an increase in the number of JavaScript event listeners
    // before garbage collection.
    const onShowHandlerStable = (0, $hDNNn.default)(onShowHandler);
    const onHideHandlerStable = (0, $hDNNn.default)(onHideHandler);
    const delayStable = (0, $hDNNn.default)(delay);
    const canAppearStable = (0, $hDNNn.default)(canAppear);
    const hasCalledShowHandler = (0, $fsvuC.useRef)(false);
    const shouldAlwaysFadeInStable = (0, $hDNNn.default)(shouldAlwaysFadeIn);
    const start = (0, $fsvuC.useCallback)((api)=>{
        apiRef.current = api;
        hasCalledShowHandler.current = false;
    }, []);
    const done = (0, $fsvuC.useCallback)(()=>{
        if (!apiRef.current) return;
         // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) onHideHandlerStable.current();
        apiRef.current = null;
        hasCalledShowHandler.current = false; // just in case
        setState('hide');
    }, [
        onHideHandlerStable
    ]);
    const abort = (0, $fsvuC.useCallback)(()=>{
        if (!apiRef.current) return;
        apiRef.current.abort(); // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) onHideHandlerStable.current();
        apiRef.current = null;
    }, [
        onHideHandlerStable
    ]);
    (0, $fsvuC.useEffect)(function mount() {
        return function unmount() {
            if (apiRef.current) abort();
        };
    }, [
        abort
    ]);
    const isDraggingRef = (0, $fsvuC.useRef)(false);
    (0, $fsvuC.useEffect)(()=>{
        return (0, $7OBha.register)({
            onRegister ({ isDragging: isDragging }) {
                isDraggingRef.current = isDragging;
            },
            onDragStart () {
                /**
         * Hiding any visible tooltips when a drag starts because otherwise it
         * looks janky (disappears and reappears), and is not required.
         */ apiRef.current?.requestHide({
                    isImmediate: true
                });
                isDraggingRef.current = true;
            },
            onDragEnd () {
                isDraggingRef.current = false;
            }
        });
    }, []); // Set while a pointer press has dismissed the tooltip. Every read and write is
    // behind `platform-dst-top-layer-tooltip`, where `popover="hint"` owns pointer
    // dismissal, so the legacy path never sees this.
    const isTopLayerPointerDismissedRef = (0, $fsvuC.useRef)(false);
    const tryShowTooltip = (0, $fsvuC.useCallback)((source)=>{
        /**
     * Prevent tooltips from being shown during a drag. This can occur with
     * the native drag and drop API, where some pointer events can fire
     * when they should not and lead to jank with tooltips.
     */ if (isDraggingRef.current) return;
         // Another tooltip is has been active but we still have the old `api`
        // around. We need to finish up the last usage.
        // Note: just being safe - this should not happen
        if (apiRef.current && !apiRef.current.isActive()) abort();
         // This tooltip is already active, we can exit
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        } /**
       * Stay dismissed until the trigger is re-entered or blurred. Otherwise
       * light dismiss hides on pointerup and the next `mouseover` from a
       * boundary crossing inside the trigger re-shows it. Deliberately after
       * the "already active" branch, so a held press stays visible.
       */ 
        if (isTopLayerPointerDismissedRef.current && (0, $llCao.fg)('platform-dst-top-layer-tooltip')) return;
         /**
       * Check if tooltip is allowed to show.
       *
       * Once a tooltip has started, or has scheduled to start
       * we won't be checking `canAppear` again.
       *
       * - We don't want tooltips to disappear once they are shown
       * - For consistency, we start after a single positive `canAppear`.
       *   Otherwise the amount of times we ask consumers would depend on
       *   how many times we get a "mousemove", which _could_ lead to situations
       *   where moving the mouse could result in a different outcome to if
       *   the mouse was not moved.
       */ 
        if (canAppearStable.current && !canAppearStable.current?.()) return;
        const entry = {
            source: source,
            delay: delayStable.current,
            show: ({ isImmediate: isImmediate })=>{
                // Call the onShow handler if it hasn't been called yet
                if (!hasCalledShowHandler.current) {
                    hasCalledShowHandler.current = true;
                    onShowHandlerStable.current();
                }
                setState(!isImmediate ? 'fade-in' : 'show-immediate');
            },
            hide: ({ isImmediate: isImmediate })=>{
                if (isImmediate) setState('hide');
                else if ((0, $llCao.fg)('platform-dst-top-layer-tooltip')) // Top-layer path: set state to 'top-layer-exit'. The component
                // stays mounted and Popover's isOpen prop transitions to
                // false, triggering the CSS exit animation internally.
                // finishHideAnimation is called after a brief delay matching
                // the CSS exit animation duration.
                setState('top-layer-exit');
                else setState('before-fade-out');
            },
            done: done,
            shouldAlwaysFadeIn: shouldAlwaysFadeInStable.current
        };
        const api = (0, $eaO2T.show)(entry);
        start(api);
    }, [
        canAppearStable,
        delayStable,
        done,
        start,
        abort,
        onShowHandlerStable,
        shouldAlwaysFadeInStable
    ]);
    const hideTooltipOnEsc = (0, $fsvuC.useCallback)(()=>{
        apiRef.current?.requestHide({
            isImmediate: true
        });
    }, [
        apiRef
    ]); // When using top-layer, popover="hint" handles Escape natively
    (0, $i4L0K.default)({
        onClose: hideTooltipOnEsc,
        isDisabled: state === 'hide' || state === 'fade-out' || state === 'top-layer-exit' || (0, $llCao.fg)('platform-dst-top-layer-tooltip')
    }); // ── Top-layer exit animation lifecycle ──
    // When state is 'top-layer-exit', Popover's isOpen transitions to false and
    // the CSS exit animation plays. The Popover's built-in `transitionend`
    // detection (with timeout fallback) calls `onExitFinish` when the exit
    // animation completes, which triggers the tooltip-manager lifecycle
    // (finishHideAnimation → done → onHide, setState('hide'), cleanup).
    const handleExitFinish = (0, $fsvuC.useCallback)(()=>{
        apiRef.current?.finishHideAnimation();
    }, []); // Browser dismiss (light dismiss on pointerup, or Escape). Recorded so we stay
    // hidden until the trigger is re-entered. Only wired up on the top-layer path,
    // but gated anyway to keep every use of the ref flag-checked.
    const handlePopoverClose = (0, $fsvuC.useCallback)(()=>{
        if ((0, $llCao.fg)('platform-dst-top-layer-tooltip')) isTopLayerPointerDismissedRef.current = true;
        apiRef.current?.requestHide({
            isImmediate: true
        });
    }, []);
    (0, $fsvuC.useEffect)(()=>{
        if (state === 'hide') return 0, $9Tkwf.default;
        if (state === 'before-fade-out') setState('fade-out');
        const unbind = (0, $dqdTY.bind)(window, {
            type: 'scroll',
            listener: ()=>{
                if (apiRef.current) apiRef.current.requestHide({
                    isImmediate: true
                });
            },
            options: {
                capture: true,
                passive: true,
                once: true
            }
        });
        return unbind;
    }, [
        state
    ]);
    const onMouseDown = (0, $fsvuC.useCallback)(()=>{
        // `hasNewContentOnTriggerClick`: `TopLayerTooltipPopup` re-shows the popover
        // after the light dismiss, so there is nothing to record, and a pending
        // show goes ahead with the new content, as it does without the gate.
        if (isStayOpenOnTriggerClick && (0, $llCao.fg)('platform-dst-top-layer-tooltip')) return;
         // Native light dismiss hides on pointerup, not here. Recorded now so the
        // tooltip stays dismissed afterwards.
        if ((0, $llCao.fg)('platform-dst-top-layer-tooltip')) isTopLayerPointerDismissedRef.current = true;
         // A press inside the show delay never reaches light dismiss, because no
        // popover is open on pointerup. Cancel the pending show so a quick click
        // does not surface a tooltip over content the press just changed.
        const shouldCancelPendingShow = stableState.current === 'hide' && (0, $llCao.fg)('platform-dst-top-layer-tooltip');
        if ((hideTooltipOnMouseDown || shouldCancelPendingShow) && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnMouseDown,
        isStayOpenOnTriggerClick,
        stableState
    ]);
    const onClick = (0, $fsvuC.useCallback)(()=>{
        if (hideTooltipOnClick && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnClick
    ]); // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseover of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    const onMouseOver = (0, $fsvuC.useCallback)((event)=>{
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
         // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault(); // Re-arm on a real re-entry, not on a boundary crossing inside the trigger.
        if ($fb17f36cb94a4902$var$isTopLayerPointerReEntry({
            trigger: targetRef.current,
            relatedTarget: event.relatedTarget
        }) && (0, $llCao.fg)('platform-dst-top-layer-tooltip')) isTopLayerPointerDismissedRef.current = false;
        const source = isMousePosition ? {
            type: 'mouse',
            clientX: event.clientX,
            clientY: event.clientY
        } : {
            type: 'keyboard'
        };
        tryShowTooltip(source);
    }, [
        isMousePosition,
        tryShowTooltip
    ]); // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseout of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    const onMouseOut = (0, $fsvuC.useCallback)((event)=>{
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
         // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    const onMouseMove = isMousePosition ? (event)=>{
        if (apiRef.current?.isActive()) apiRef.current.mousePos = {
            clientX: event.clientX,
            clientY: event.clientY
        };
    } : undefined;
    const onMouseOverTooltip = (0, $fsvuC.useCallback)(()=>{
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
    }, []);
    const onFocus = (0, $fsvuC.useCallback)((e)=>{
        // Check if focus-visible
        // Prevents tooltips from showing when focus is not visible,
        // i.e., when focus is moved onto tooltip trigger inside a popup on open
        try {
            if (!e.target.matches(':focus-visible')) return;
        } catch  {} // TODO: this does not play well with `hideTooltipOnMouseDown`
        // as "focus" will occur after the "mousedown".
        tryShowTooltip({
            type: 'keyboard'
        });
    }, [
        tryShowTooltip
    ]);
    const onBlur = (0, $fsvuC.useCallback)(()=>{
        // Focus leaving ends the dismissal, so focus coming back can show the tooltip.
        if ((0, $llCao.fg)('platform-dst-top-layer-tooltip')) isTopLayerPointerDismissedRef.current = false;
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    const onAnimationFinished = (0, $fsvuC.useCallback)((transition)=>{
        // Using lastState here because motion is not picking up the latest value
        if (transition === 'exiting' && stableState.current === 'fade-out' && apiRef.current) apiRef.current.finishHideAnimation();
    }, [
        stableState
    ]); // Doing a cast because typescript is struggling to narrow the type
    const CastTargetContainer = TargetContainer;
    const shouldRenderTooltipPopup = state !== 'hide' && Boolean(content);
    const shouldRenderHiddenContent = !isScreenReaderAnnouncementDisabled && shouldRenderTooltipPopup;
    const shouldRenderTooltipChildren = state !== 'hide' && state !== 'fade-out' && state !== 'top-layer-exit';
    const handleOpenLayerObserverCloseSignal = (0, $fsvuC.useCallback)(()=>{
        apiRef.current?.requestHide({
            isImmediate: true
        });
    }, []); // Called unconditionally so the hook order never depends on the feature
    // flag value. On the top-layer path a tooltip is not a layer (open layer
    // checks skip tooltips), so it does not register with the observer.
    (0, $iqc8V.useNotifyOpenLayerObserver)({
        // Layer is only visually open if both the tooltip popup (container) and children are rendered.
        isOpen: shouldRenderTooltipPopup && shouldRenderTooltipChildren,
        isEnabled: !(0, $llCao.fg)('platform-dst-top-layer-tooltip'),
        /**
     * We don't strictly need to provide an onClose callback at this time, as there is
     * already code that handles hiding the tooltip when a drag is started (and the only
     * usage right now is closing all layers when the user resizes the side nav).
     *
     * However, for future-proofing and semantic reasons, it makes sense to close the tooltip
     * whenever the open layer observer requests a close.
     */ onClose: handleOpenLayerObserverCloseSignal
    });
    const getReferenceElement = ()=>{
        if (isMousePosition && apiRef.current?.mousePos && targetRef.current) return (0, $aguiM.getVirtualElementFromMousePos)(apiRef.current.mousePos, {
            targetElement: targetRef.current,
            tooltipPosition: position
        });
        return targetRef.current || undefined;
    };
    const tooltipIdForHiddenContent = (0, $6OWks.default)('tooltip', shouldRenderHiddenContent);
    const tooltipTriggerProps = {
        onMouseOver: onMouseOver,
        onMouseOut: onMouseOut,
        onMouseMove: onMouseMove,
        onMouseDown: onMouseDown,
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur
    }; // This useEffect is purely for managing the aria attribute when using the
    // wrapped children approach.
    const isChildrenAFunction = typeof children === 'function';
    (0, $fsvuC.useEffect)(()=>{
        if (isChildrenAFunction) return;
         // If `children` is _not_ a function, we are stepping outside of the public
        // API to add a `aria-describedby` attribute.
        const target = targetRef.current;
        if (!target || !tooltipIdForHiddenContent) return;
        target.setAttribute('aria-describedby', tooltipIdForHiddenContent);
        return ()=>target.removeAttribute('aria-describedby');
    }, [
        isChildrenAFunction,
        tooltipIdForHiddenContent
    ]);
    const hiddenContent = shouldRenderHiddenContent ? /*#__PURE__*/ (0, $5chsV.jsx)("span", {
        "data-testid": testId ? `${testId}-hidden` : undefined,
        hidden: true,
        id: tooltipIdForHiddenContent,
        children: typeof content === 'function' ? content({}) : content
    }) : null;
    const PopperWrapper = shouldRenderToParent ? (0, $fsvuC.Fragment) : $fb17f36cb94a4902$var$TooltipPortal;
    const trigger = typeof children === 'function' ? // once we deprecate the wrapped approach, we can put the aria
    // attribute back into the tooltipTriggerProps and make it required
    // instead of optional in `types`
    /*#__PURE__*/ (0, $5chsV.jsxs)((0, $fsvuC.Fragment), {
        children: [
            children({
                ...tooltipTriggerProps,
                // `testId` propagates to the trigger element so `data-testid` lands in the
                // rendered DOM. Required because `@atlaskit/button/new` (and other Pressable-
                // backed primitives) overwrite `data-testid` from spread; passing a typed
                // `testId` lets their own destructure pick it up directly.
                ...testId ? {
                    testId: `${testId}--container`
                } : {},
                'aria-describedby': tooltipIdForHiddenContent,
                ref: setDirectRef
            }),
            hiddenContent
        ]
    }) : /*#__PURE__*/ (0, $5chsV.jsxs)(CastTargetContainer, {
        ...tooltipTriggerProps,
        ...testId ? {
            'data-testid': `${testId}--container`
        } : undefined,
        ref: setImplicitRefFromChildren,
        role: "presentation",
        children: [
            children,
            hiddenContent
        ]
    });
    if ((0, $llCao.fg)('platform-dst-top-layer-tooltip')) return /*#__PURE__*/ (0, $5chsV.jsxs)((0, $fsvuC.Fragment), {
        children: [
            trigger,
            shouldRenderTooltipPopup ? /*#__PURE__*/ (0, $5chsV.jsx)($fb17f36cb94a4902$var$TopLayerTooltipPopup, {
                targetRef: targetRef,
                tooltipPosition: tooltipPosition,
                mousePos: apiRef.current?.mousePos ?? undefined,
                position: position,
                onMouseOut: onMouseOut,
                onMouseOverTooltip: onMouseOverTooltip,
                ignoreTooltipPointerEvents: ignoreTooltipPointerEvents,
                truncate: truncate,
                testId: testId,
                shortcut: shortcut,
                content: content,
                Container: Container,
                onClose: handlePopoverClose,
                shouldStayOpenOnTriggerClick: isStayOpenOnTriggerClick,
                onExitFinish: handleExitFinish,
                isOpen: state !== 'hide' && state !== 'top-layer-exit'
            }) : null
        ]
    });
    return /*#__PURE__*/ (0, $5chsV.jsxs)((0, $fsvuC.Fragment), {
        children: [
            trigger,
            shouldRenderTooltipPopup ? /*#__PURE__*/ (0, $5chsV.jsx)(PopperWrapper, {
                children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $f3WQU.Popper), {
                    placement: tooltipPosition,
                    referenceElement: getReferenceElement(),
                    strategy: strategy,
                    children: ({ ref: ref, style: style, update: update, placement: placement })=>{
                        const direction = isMousePosition ? undefined : $fb17f36cb94a4902$var$invertedDirection[$fb17f36cb94a4902$var$getDirectionFromPlacement(placement)];
                        return /*#__PURE__*/ (0, $5chsV.jsx)((0, $lfw4f.default), {
                            appear: true,
                            children: shouldRenderTooltipChildren && /*#__PURE__*/ (0, $5chsV.jsx)((0, $eEY7a.default), {
                                distance: "constant",
                                entranceDirection: direction,
                                exitDirection: direction,
                                onFinish: onAnimationFinished,
                                duration: state !== 'show-immediate' ? 'medium' : 'none',
                                children: ({ className: className })=>/*#__PURE__*/ (0, $5chsV.jsx)(Container, {
                                        ref: ref,
                                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                        className: `Tooltip ${className}`,
                                        style: {
                                            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                                            ...style,
                                            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                                            ...ignoreTooltipPointerEvents && {
                                                pointerEvents: 'none'
                                            }
                                        },
                                        truncate: truncate,
                                        placement: tooltipPosition,
                                        testId: getReferenceElement() ? testId : testId && `${testId}--unresolved`,
                                        onMouseOut: onMouseOut,
                                        onMouseOver: onMouseOverTooltip,
                                        shortcut: shortcut,
                                        children: typeof content === 'function' ? content({
                                            update: update
                                        }) : content
                                    })
                            })
                        });
                    }
                })
            }) : null
        ]
    });
}
$fb17f36cb94a4902$var$Tooltip.displayName = "Tooltip";
var $fb17f36cb94a4902$export$2e2bcd8739ae039 = $fb17f36cb94a4902$var$Tooltip;
const $fb17f36cb94a4902$var$TooltipPortal = ({ children: children })=>{
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $bDK6L.default), {
        zIndex: $fb17f36cb94a4902$var$tooltipZIndex,
        children: children
    });
};
$fb17f36cb94a4902$var$TooltipPortal.displayName = "TooltipPortal";
const $fb17f36cb94a4902$var$tooltipMouseAnimationStyles = {
    enter: "_1gBibygnQY",
    exit: "_1gBibyTnGs"
}; /**
    * Top-layer tooltip popup component.
    *
    * Composes `Popover` (top-layer visibility + animation) with two positioning
    * hooks, of which EXACTLY ONE is enabled - two writing to the same popover would
    * fight for ownership, so `isEnabled` is derived from one boolean and negated:
    *
    *   - `useAnchoredPopoverAtPoint` for cursor-tracking positions (`mouse`,
    *     `mouse-x`, `mouse-y`) activated by a pointer.
    *   - `useAnchoredPopover` for everything else, including a cursor position
    *     activated via keyboard focus, where there is no cursor to track and
    *     anchoring to the trigger is what keeps the tooltip beside the target.
    *
    * Exit animation is handled by `Popover`'s `isOpen` prop. When `isOpen`
    * transitions to `false`, the primitive calls `hidePopover()` internally and
    * the CSS exit animation plays via `allow-discrete`. No glue code needed.
    */ 
function $fb17f36cb94a4902$var$TopLayerTooltipPopup({ targetRef: targetRef, tooltipPosition: tooltipPosition, mousePos: mousePos, position: position, onMouseOut: onMouseOut, onMouseOverTooltip: onMouseOverTooltip, ignoreTooltipPointerEvents: ignoreTooltipPointerEvents, truncate: truncate, testId: testId, shortcut: shortcut, content: content, Container: Container, onClose: onClose, onExitFinish: onExitFinish, isOpen: isOpen, shouldStayOpenOnTriggerClick: shouldStayOpenOnTriggerClick }) {
    const popoverRef = (0, $fsvuC.useRef)(null); // Never read. Some custom `component` wrappers render nothing without a ref.
    const containerRef = (0, $fsvuC.useRef)(null); // The host unmounts on close and remounts on open, so set `data-placement`
    // whenever a node attaches, as well as when the placement changes.
    const setPopoverNode = (0, $fsvuC.useCallback)((node)=>{
        node?.setAttribute('data-placement', tooltipPosition);
    }, [
        tooltipPosition
    ]);
    const hostRef = (0, $fz4Xf.default)([
        popoverRef,
        setPopoverNode
    ]); // `shouldStayOpenOnTriggerClick`: a press on the trigger light-dismisses the hint
    // popover, and the browser gives no way to cancel that. The dismiss runs
    // before the `pointerup` is dispatched, so show the popover again from the
    // trigger's `pointerup`. It is the same task, so no closed frame is painted,
    // the entry transition does not restart, and the `toggle` events coalesce
    // to open -> open, so `onClose` is not called. `mouseup` covers
    // environments that dismiss on `mouseup` too, such as the test polyfill.
    // `showPopover()` does nothing when the popover is already open. A layout
    // effect, so the listener is gone in the same commit that closes the
    // popover: a passive cleanup runs later, and a `pointerup` in that gap would
    // re-open a closing tooltip.
    (0, $fsvuC.useLayoutEffect)(()=>{
        const trigger = targetRef.current;
        if (!shouldStayOpenOnTriggerClick || !isOpen || !trigger) return;
        const reshow = ()=>{
            try {
                popoverRef.current?.showPopover();
            } catch  {}
        };
        return (0, $dqdTY.bindAll)(trigger, [
            {
                type: 'pointerup',
                listener: reshow
            },
            {
                type: 'mouseup',
                listener: reshow
            }
        ]);
    }, [
        shouldStayOpenOnTriggerClick,
        isOpen,
        targetRef
    ]); // Translate the legacy Popper-style placement string ("right",
    // "bottom-start", etc.) once and pass the same object to the hook and
    // to `Popover`.
    const placement = (0, $974dn.fromLegacyPlacement)({
        legacy: tooltipPosition
    });
    const isMousePosition = position === 'mouse' || position === 'mouse-x' || position === 'mouse-y';
    const isMouseStrategyActive = isMousePosition && Boolean(mousePos); // One object so the two calls cannot drift on `placement` or `isOpen`.
    const sharedPositioning = {
        popoverRef: popoverRef,
        placement: placement,
        isOpen: isOpen
    };
    (0, $gc525.useAnchoredPopover)({
        ...sharedPositioning,
        anchorRef: targetRef,
        isEnabled: !isMouseStrategyActive
    }); // `getPoint()` is latched once per activation, which is per-show here because
    // `TopLayerTooltipPopup` mounts fresh on every show. `null` before the trigger
    // has mounted applies no positioning at all.
    (0, $eyyYg.useAnchoredPopoverAtPoint)({
        ...sharedPositioning,
        isEnabled: isMouseStrategyActive,
        getPoint: ()=>{
            if (!mousePos || !targetRef.current || !isMousePosition) return null;
            return (0, $7FD99.getAnchorPoint)({
                cursor: mousePos,
                triggerRect: targetRef.current.getBoundingClientRect(),
                tooltipPosition: position,
                placement: placement
            });
        }
    });
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $2jUY9.Popover), {
        ref: hostRef,
        role: "tooltip",
        mode: "hint",
        isOpen: isOpen,
        onClose: onClose,
        onExitFinish: onExitFinish,
        testId: testId ? `${testId}--popover` : undefined,
        shouldAnimate: true,
        enteringAnimationXcss: isMouseStrategyActive && $fb17f36cb94a4902$var$tooltipMouseAnimationStyles.enter,
        exitingAnimationXcss: isMouseStrategyActive && $fb17f36cb94a4902$var$tooltipMouseAnimationStyles.exit,
        placement: placement,
        children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $1Nrrt.DefaultRoleContext).Provider, {
            value: "presentation",
            children: /*#__PURE__*/ (0, $5chsV.jsx)(Container, {
                ref: containerRef,
                className: "Tooltip",
                style: ignoreTooltipPointerEvents ? {
                    pointerEvents: 'none'
                } : undefined,
                truncate: truncate,
                placement: tooltipPosition,
                testId: testId,
                onMouseOut: onMouseOut,
                onMouseOver: onMouseOverTooltip,
                shortcut: shortcut,
                children: typeof content === 'function' ? content({
                    update: (0, $9Tkwf.default)
                }) : content
            })
        })
    });
}
$fb17f36cb94a4902$var$TopLayerTooltipPopup.displayName = "TopLayerTooltipPopup";

});
parcelRegister("gJaHb", function(module, exports) {
$parcel$export(module.exports, "usePlatformLeafSyntheticEventHandler", () => $feff8e0b71cccac5$export$1a04351537078b55);

var $fsvuC = parcelRequire("fsvuC");

var $mhEfz = parcelRequire("mhEfz");

var $g5SRF = parcelRequire("g5SRF");
function $feff8e0b71cccac5$export$1a04351537078b55({ fn: fn, action: action, componentName: componentName, packageName: packageName, packageVersion: packageVersion, analyticsData: analyticsData }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $mhEfz.useAnalyticsEvents)();
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    const dataRef = (0, $g5SRF.useTrackedRef)(analyticsData);
    const fnRef = (0, $g5SRF.useTrackedRef)(fn);
    const handler = (0, $fsvuC.useCallback)(()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        const context = {
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion,
            ...dataRef.current
        };
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        const clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        fnRef.current(analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}

});

parcelRegister("i4L0K", function(module, exports) {
$parcel$export(module.exports, "default", () => $327c8bc86475b888$export$2e2bcd8739ae039);

var $fsvuC = parcelRequire("fsvuC");

var $dqdTY = parcelRequire("dqdTY");

function $327c8bc86475b888$export$2e2bcd8739ae039({ onClose: onClose, isDisabled: isDisabled }) {
    const escapePressed = (0, $fsvuC.useRef)(false);
    const onKeyDown = (0, $fsvuC.useCallback)((e)=>{
        if (isDisabled || escapePressed.current || e.key !== (0, $4096afce6d06a916$export$2bb790b9008907b4)) // We're either already handling the key down event or it's not escape.
        // Bail early!
        return;
        escapePressed.current = true;
        onClose(e);
    }, [
        onClose,
        isDisabled
    ]);
    const onKeyUp = (0, $fsvuC.useCallback)(()=>{
        escapePressed.current = false;
    }, []);
    (0, $fsvuC.useEffect)(()=>{
        // Don't attach document event listeners if the hook is disabled
        if (isDisabled) return;
        return (0, $dqdTY.bindAll)(document, [
            {
                type: 'keydown',
                listener: onKeyDown
            },
            {
                type: 'keyup',
                listener: onKeyUp
            }
        ], {
            capture: false
        });
    }, [
        onKeyDown,
        onKeyUp,
        isDisabled
    ]);
}

});
/**
 * Character key codes which can be used in keyboard events.
 */ const $4096afce6d06a916$export$390330c10ff2b9a1 = 'ArrowUp';
const $4096afce6d06a916$export$a80636c6f41931fe = 'ArrowDown';
const $4096afce6d06a916$export$fc4577f2a2af0ae3 = 'ArrowLeft';
const $4096afce6d06a916$export$c40f9845adc73fb5 = 'ArrowRight';
const $4096afce6d06a916$export$4af703091671bc = 'Home';
const $4096afce6d06a916$export$e2bc30913faa5db7 = 'End';
const $4096afce6d06a916$export$10f6869ed0a7d75b = 'Tab';
const $4096afce6d06a916$export$8152f929a25a0ff4 = 'Enter';
const $4096afce6d06a916$export$e51a3576c045c8d5 = 'Space';
const $4096afce6d06a916$export$2bb790b9008907b4 = 'Escape';


parcelRegister("hDNNn", function(module, exports) {
$parcel$export(module.exports, "default", () => $f32adf1b02abb149$export$2e2bcd8739ae039);

var $fsvuC = parcelRequire("fsvuC");
function $f32adf1b02abb149$export$2e2bcd8739ae039(value) {
    const ref = (0, $fsvuC.useRef)(value);
    (0, $fsvuC.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref;
}

});

parcelRegister("iqc8V", function(module, exports) {
$parcel$export(module.exports, "useNotifyOpenLayerObserver", () => $190c549277758473$export$469bb693f11edc7f);

var $fsvuC = parcelRequire("fsvuC");

var $3zaUu = parcelRequire("3zaUu");

var $8JHGZ = parcelRequire("8JHGZ");
function $190c549277758473$export$469bb693f11edc7f({ isOpen: isOpen, type: type, onClose: onClose, isEnabled: isEnabled = true }) {
    const context = (0, $fsvuC.useContext)((0, $3zaUu.OpenLayerObserverContext));
    const namespace = (0, $8JHGZ.useOpenLayerObserverNamespace)();
    (0, $fsvuC.useEffect)(()=>{
        /**
		 * Registers the `onClose` callback with the OpenLayerObserver.
		 */ if (context === null || !isEnabled) return;
        if (!isOpen) /**
			 * If the layer is not open, we are not registering the `onClose` callback.
			 * This is important to prevent the `onClose` from being called for layers that
			 * are not open.
			 *
			 * Some consumers mistakenly pass "toggle" functions to `onClose` callbacks for
			 * layer components, as Popup, e.g. `onClose={() => setIsOpen(!isOpen)}`.
			 */ return;
        return context.onClose(onClose, {
            namespace: namespace,
            type: type
        });
    }, [
        context,
        isEnabled,
        isOpen,
        namespace,
        onClose,
        type
    ]);
}

});
parcelRegister("3zaUu", function(module, exports) {
$parcel$export(module.exports, "OpenLayerObserverContext", () => $8d9273a7c575ec9a$export$5fbf4d7fae6cdc00);

var $fsvuC = parcelRequire("fsvuC");
const $8d9273a7c575ec9a$export$5fbf4d7fae6cdc00 = /*#__PURE__*/ (0, $fsvuC.createContext)(null);

});

parcelRegister("8JHGZ", function(module, exports) {
$parcel$export(module.exports, "useOpenLayerObserverNamespace", () => $a04c9c8b8d5c999e$export$1d57e79091cc3046);

var $fsvuC = parcelRequire("fsvuC");

var $45zXM = parcelRequire("45zXM");
function $a04c9c8b8d5c999e$export$1d57e79091cc3046() {
    const namespace = (0, $fsvuC.useContext)((0, $45zXM.OpenLayerObserverNamespaceContext));
    return namespace;
}

});
parcelRegister("45zXM", function(module, exports) {
$parcel$export(module.exports, "OpenLayerObserverNamespaceContext", () => $a1341749333c9020$export$644a49f3b8c50fcd);

var $fsvuC = parcelRequire("fsvuC");
const $a1341749333c9020$export$644a49f3b8c50fcd = /*#__PURE__*/ (0, $fsvuC.createContext)(null);

});



parcelRegister("eEY7a", function(module, exports) {
$parcel$export(module.exports, "default", () => $e9f952bfabe5e6a0$export$2e2bcd8739ae039);

var $5chsV = parcelRequire("5chsV");
parcelRequire("fsvuC");

var $faV22 = parcelRequire("faV22");
const $e9f952bfabe5e6a0$var$invertedDirection = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left'
};
/**
 * __FadeIn__
 *
 * Useful for fading in one or more elements.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motion)
 */ const $e9f952bfabe5e6a0$var$FadeIn = ({ children: children, duration: duration = 'large', entranceDirection: entranceDirection, exitDirection: exitDirection, distance: distance = 'proportional', onFinish: onFinish, isPaused: isPaused })=>{
    const invertedEntranceDirection = entranceDirection !== undefined ? $e9f952bfabe5e6a0$var$invertedDirection[entranceDirection] : undefined;
    const isExitDirect = Boolean(exitDirection || invertedEntranceDirection) ? `fade-out-from-${exitDirection || invertedEntranceDirection}${distance === 'proportional' ? '' : '-constant'}` : 'fade-out';
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $faV22.default), {
        duration: duration,
        enteringAnimation: entranceDirection ? `fade-in-from-${entranceDirection}${distance === 'proportional' ? '' : '-constant'}` : 'fade-in',
        exitingAnimation: isExitDirect,
        animationTimingFunction: "ease-in-out",
        onFinish: onFinish,
        isPaused: isPaused,
        children: children
    });
};
$e9f952bfabe5e6a0$var$FadeIn.displayName = "FadeIn";
var $e9f952bfabe5e6a0$export$2e2bcd8739ae039 = $e9f952bfabe5e6a0$var$FadeIn;

});
parcelRegister("faV22", function(module, exports) {
$parcel$export(module.exports, "default", () => $e4d40dde2617d990$export$2e2bcd8739ae039);
/* keyframes-motion.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $fsvuC = parcelRequire("fsvuC");

var $gJ6nT = parcelRequire("gJ6nT");

var $ciGt1 = parcelRequire("ciGt1");

var $8Eh7r = parcelRequire("8Eh7r");

var $kZlXG = parcelRequire("kZlXG");

var $d1e01 = parcelRequire("d1e01");

var $hk7fM = parcelRequire("hk7fM");

var $alfDb = parcelRequire("alfDb");
const $e4d40dde2617d990$var$zoomIn = null;
const $e4d40dde2617d990$var$zoomOut = null;
const $e4d40dde2617d990$var$fadeIn = null;
const $e4d40dde2617d990$var$fadeOut = null;
const $e4d40dde2617d990$var$fadeInFromTop = null;
const $e4d40dde2617d990$var$fadeOutFromTop = null;
const $e4d40dde2617d990$var$fadeInFromLeft = null;
const $e4d40dde2617d990$var$fadeOutFromLeft = null;
const $e4d40dde2617d990$var$fadeInFromBottom = null;
const $e4d40dde2617d990$var$fadeOutFromBottom = null;
const $e4d40dde2617d990$var$fadeInFromRight = null;
const $e4d40dde2617d990$var$fadeOutFromRight = null;
const $e4d40dde2617d990$var$fadeInFromTopConstant = null;
const $e4d40dde2617d990$var$fadeOutFromTopConstant = null;
const $e4d40dde2617d990$var$fadeInFromLeftConstant = null;
const $e4d40dde2617d990$var$fadeOutFromLeftConstant = null;
const $e4d40dde2617d990$var$fadeInFromBottomConstant = null;
const $e4d40dde2617d990$var$fadeOutFromBottomConstant = null;
const $e4d40dde2617d990$var$fadeInFromRightConstant = null;
const $e4d40dde2617d990$var$fadeOutFromRightConstant = null;
const $e4d40dde2617d990$var$slideInFromTop = null;
const $e4d40dde2617d990$var$slideOutFromTop = null;
const $e4d40dde2617d990$var$slideInFromRight = null;
const $e4d40dde2617d990$var$slideOutFromRight = null;
const $e4d40dde2617d990$var$slideInFromBottom = null;
const $e4d40dde2617d990$var$slideOutFromBottom = null;
const $e4d40dde2617d990$var$slideInFromLeft = null;
const $e4d40dde2617d990$var$slideOutFromLeft = null;
/**
 * This is the base INTERNAL component used for all other entering motions.
 * This does not need Javascript to execute on the client so it will run immediately
 * for any SSR rendered React apps before the JS has executed.
 */ const $e4d40dde2617d990$var$EnteringMotion = ({ children: children, animationTimingFunction: animationTimingFunction, animationTimingFunctionExiting: animationTimingFunctionExiting = animationTimingFunction, enteringAnimation: enteringAnimation, exitingAnimation: exitingAnimation = enteringAnimation, isPaused: isPaused, onFinish: onFinishMotion, duration: duration = 'large' })=>{
    const staggered = (0, $alfDb.useStaggeredEntrance)();
    const { isExiting: isExiting, onFinish: onExitFinished, appear: appear } = (0, $hk7fM.useExitingPersistence)();
    const setTimeout = (0, $d1e01.useSetTimeout)();
    const paused = isPaused || !staggered.isReady;
    const delay = isExiting ? 0 : staggered.delay;
    const state = isExiting ? 'exiting' : 'entering';
    const [hasAnimationStyles, setHasAnimationStyles] = (0, $fsvuC.useState)(appear);
    (0, $fsvuC.useEffect)(()=>{
        // Tracking this to prevent changing state on an unmounted component
        let isCancelled = false;
        if (paused) return;
        // On initial mount if elements aren't set to animate on appear, we return early and callback
        if (!appear) {
            onFinishMotion && onFinishMotion(state);
            return;
        }
        /**
     * Updates relevant state.
     * Called when the animation is finished, or immediately with reduced motion.
     */ const onAnimationEnd = ()=>{
            if (state === 'exiting') // Updates the `ExitingPersistence` to remove this child
            onExitFinished?.();
            if (!isCancelled) setHasAnimationStyles(false);
            onFinishMotion?.(state);
        };
        if ((0, $kZlXG.isReducedMotion)()) {
            // If there is reduced motion there is no exit animation, so call this immediately
            onAnimationEnd();
            return;
        }
        // Elements may need animation styles back after initial mount (they could animate out)
        setHasAnimationStyles(true);
        // Queue `onAnimationEnd` for after the animation has finished
        setTimeout(onAnimationEnd, isExiting ? (0, $8Eh7r.exitingDurations)[duration] : (0, $ciGt1.durations)[duration] + delay);
        return ()=>{
            isCancelled = true;
        };
    // We ignore this for onFinishMotion as consumers could potentially inline the function
    // which would then trigger this effect every re-render.
    // We want to make it easier for consumers so we go down this path unfortunately.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        onExitFinished,
        state,
        isExiting,
        duration,
        delay,
        paused,
        setTimeout
    ]);
    return children({
        ref: staggered.ref,
        // @ts-expect-error: `ax` is not typed correctly
        className: hasAnimationStyles ? (0, $gJ6nT.default)([
            (0, $gJ6nT.default)([
                "_3Y6bKp38c8 _4Cu53BeMto _39Ohv4YbGa _1SdfoHYbGa"
            ]),
            paused && (0, $gJ6nT.default)([
                "_4Cu53BP4vI"
            ]),
            duration === 'small' && (0, $gJ6nT.default)([
                "_0nFVCGe6K4"
            ]),
            duration === 'medium' && (0, $gJ6nT.default)([
                "_0nFVCGngV3"
            ]),
            duration === 'large' && (0, $gJ6nT.default)([
                "_0nFVCG0G4o"
            ]),
            isExiting && duration === 'small' && (0, $gJ6nT.default)([
                "_0nFVCGjH1t"
            ]),
            isExiting && duration === 'medium' && (0, $gJ6nT.default)([
                "_0nFVCGnQ85"
            ]),
            isExiting && duration === 'large' && (0, $gJ6nT.default)([
                "_0nFVCGngV3"
            ]),
            isExiting && (0, $gJ6nT.default)([
                "_1jakNnUaiG _3Y6bKpgRhm"
            ]),
            !isExiting && animationTimingFunction === 'linear' && (0, $gJ6nT.default)([
                "_43vdfTHVQb"
            ]),
            !isExiting && animationTimingFunction === 'ease-out' && (0, $gJ6nT.default)([
                "_43vdfTzx0n"
            ]),
            !isExiting && animationTimingFunction === 'ease-in' && (0, $gJ6nT.default)([
                "_43vdfTsRAN"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-40-out' && (0, $gJ6nT.default)([
                "_43vdfTlmpr"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-60-out' && (0, $gJ6nT.default)([
                "_43vdfT6a7c"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-80-out' && (0, $gJ6nT.default)([
                "_43vdfTBOqL"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-out' && (0, $gJ6nT.default)([
                "_43vdfT8f3n"
            ]),
            isExiting && animationTimingFunction === 'linear' && (0, $gJ6nT.default)([
                "_43vdfTHVQb"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-out' && (0, $gJ6nT.default)([
                "_43vdfTzx0n"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in' && (0, $gJ6nT.default)([
                "_43vdfTsRAN"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-40-out' && (0, $gJ6nT.default)([
                "_43vdfTlmpr"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-60-out' && (0, $gJ6nT.default)([
                "_43vdfT6a7c"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-80-out' && (0, $gJ6nT.default)([
                "_43vdfTBOqL"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-out' && (0, $gJ6nT.default)([
                "_43vdfT8f3n"
            ]),
            (!isExiting && enteringAnimation === 'fade-in' || isExiting && exitingAnimation === 'fade-in') && (0, $gJ6nT.default)([
                "_1gBibykeLs"
            ]),
            (!isExiting && enteringAnimation === 'fade-out' || isExiting && exitingAnimation === 'fade-out') && (0, $gJ6nT.default)([
                "_1gBibyI0gR"
            ]),
            (!isExiting && enteringAnimation === 'zoom-in' || isExiting && exitingAnimation === 'zoom-in') && (0, $gJ6nT.default)([
                "_1gBibyhdkL"
            ]),
            (!isExiting && enteringAnimation === 'zoom-out' || isExiting && exitingAnimation === 'zoom-out') && (0, $gJ6nT.default)([
                "_1gBibyTD4f"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-top' || isExiting && exitingAnimation === 'slide-in-from-top') && (0, $gJ6nT.default)([
                "_1gBibyDhyF"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-top' || isExiting && exitingAnimation === 'slide-out-from-top') && (0, $gJ6nT.default)([
                "_1gBibyLNze"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-right' || isExiting && exitingAnimation === 'slide-in-from-right') && (0, $gJ6nT.default)([
                "_1gBibyXOlu"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-right' || isExiting && exitingAnimation === 'slide-out-from-right') && (0, $gJ6nT.default)([
                "_1gBibySaA1"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-bottom' || isExiting && exitingAnimation === 'slide-in-from-bottom') && (0, $gJ6nT.default)([
                "_1gBibynyVM"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-bottom' || isExiting && exitingAnimation === 'slide-out-from-bottom') && (0, $gJ6nT.default)([
                "_1gBibye6Fr"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-left' || isExiting && exitingAnimation === 'slide-in-from-left') && (0, $gJ6nT.default)([
                "_1gBibyoziG"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-left' || isExiting && exitingAnimation === 'slide-out-from-left') && (0, $gJ6nT.default)([
                "_1gBibyMeos"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-top' || isExiting && exitingAnimation === 'fade-in-from-top') && (0, $gJ6nT.default)([
                "_1gBibykcI4"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-top' || isExiting && exitingAnimation === 'fade-out-from-top') && (0, $gJ6nT.default)([
                "_1gBibyoGbB"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-left' || isExiting && exitingAnimation === 'fade-in-from-left') && (0, $gJ6nT.default)([
                "_1gBibyhAdH"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-left' || isExiting && exitingAnimation === 'fade-out-from-left') && (0, $gJ6nT.default)([
                "_1gBibyAEay"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-bottom' || isExiting && exitingAnimation === 'fade-in-from-bottom') && (0, $gJ6nT.default)([
                "_1gBibygoNB"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-bottom' || isExiting && exitingAnimation === 'fade-out-from-bottom') && (0, $gJ6nT.default)([
                "_1gBiby6f4m"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-right' || isExiting && exitingAnimation === 'fade-in-from-right') && (0, $gJ6nT.default)([
                "_1gBibyi3nN"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-right' || isExiting && exitingAnimation === 'fade-out-from-right') && (0, $gJ6nT.default)([
                "_1gBibyUa70"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-top-constant' || isExiting && exitingAnimation === 'fade-in-from-top-constant') && (0, $gJ6nT.default)([
                "_1gBibyisTU"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-top-constant' || isExiting && exitingAnimation === 'fade-out-from-top-constant') && (0, $gJ6nT.default)([
                "_1gBibyGz7o"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-left-constant' || isExiting && exitingAnimation === 'fade-in-from-left-constant') && (0, $gJ6nT.default)([
                "_1gBibyMMUA"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-left-constant' || isExiting && exitingAnimation === 'fade-out-from-left-constant') && (0, $gJ6nT.default)([
                "_1gBibykux3"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-bottom-constant' || isExiting && exitingAnimation === 'fade-in-from-bottom-constant') && (0, $gJ6nT.default)([
                "_1gBibyGPd4"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-bottom-constant' || isExiting && exitingAnimation === 'fade-out-from-bottom-constant') && (0, $gJ6nT.default)([
                "_1gBibyHnxz"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-right-constant' || isExiting && exitingAnimation === 'fade-in-from-right-constant') && (0, $gJ6nT.default)([
                "_1gBibyFRSA"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-right-constant' || isExiting && exitingAnimation === 'fade-out-from-right-constant') && (0, $gJ6nT.default)([
                "_1gBibyw0wK"
            ])
        ]) : '',
        style: {
            animationDelay: `${delay}ms`
        }
    }, state);
};
$e4d40dde2617d990$var$EnteringMotion.displayName = "EnteringMotion";
var $e4d40dde2617d990$export$2e2bcd8739ae039 = $e4d40dde2617d990$var$EnteringMotion;

});
parcelRegister("ciGt1", function(module, exports) {
$parcel$export(module.exports, "durations", () => $0b24271e54491ebe$export$38b928a7167ce124);
/**
 * Think of this as the motion equivalent of the @atlaskit/theme `grid()`.
 */ const $0b24271e54491ebe$export$368bacef0dacbe05 = 25;
const $0b24271e54491ebe$export$38b928a7167ce124 = {
    none: 0,
    small: 100,
    medium: 350,
    large: 700
};

});

parcelRegister("8Eh7r", function(module, exports) {
$parcel$export(module.exports, "exitingDurations", () => $d68273b68feba239$export$30fa1a2e62ae150c);

var $ciGt1 = parcelRequire("ciGt1");
/**
 * Used to multiply the initial duration for exiting motions.
 */ const $d68273b68feba239$var$EXITING_MOTION_MULTIPLIER = 0.5;
const $d68273b68feba239$export$30fa1a2e62ae150c = {
    none: (0, $ciGt1.durations).none,
    small: (0, $ciGt1.durations).small * $d68273b68feba239$var$EXITING_MOTION_MULTIPLIER,
    medium: (0, $ciGt1.durations).medium * $d68273b68feba239$var$EXITING_MOTION_MULTIPLIER,
    large: (0, $ciGt1.durations).large * $d68273b68feba239$var$EXITING_MOTION_MULTIPLIER
};

});

parcelRegister("kZlXG", function(module, exports) {
$parcel$export(module.exports, "isReducedMotion", () => $78809eab23b04f43$export$b7baf7667a68d87c);

var $k4whK = parcelRequire("k4whK");
const $78809eab23b04f43$export$b7baf7667a68d87c = ()=>{
    if (!(0, $k4whK.isMatchMediaAvailable)()) return false;
    const { matches: matches } = window.matchMedia('(prefers-reduced-motion: reduce)');
    return matches;
};

});
parcelRegister("k4whK", function(module, exports) {
$parcel$export(module.exports, "isMatchMediaAvailable", () => $ed13dff09a96752e$export$c5406bd59b374abd);
const $ed13dff09a96752e$export$c5406bd59b374abd = ()=>typeof window !== 'undefined' && 'matchMedia' in window;

});


parcelRegister("d1e01", function(module, exports) {
$parcel$export(module.exports, "useSetTimeout", () => $a12e31bf1f9da08a$export$4f34107a2b00f39c);

var $fsvuC = parcelRequire("fsvuC");
const $a12e31bf1f9da08a$var$getHookDeps = (opts)=>{
    switch(opts.cleanup){
        case 'next-effect':
            return undefined;
        case 'unmount':
        default:
            return [];
    }
};
const $a12e31bf1f9da08a$export$4f34107a2b00f39c = (opts = {
    cleanup: 'unmount'
})=>{
    const timeouts = (0, $fsvuC.useRef)([]);
    (0, $fsvuC.useEffect)(()=>{
        return ()=>{
            if (timeouts.current.length) {
                timeouts.current.forEach((id)=>clearTimeout(id));
                timeouts.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $a12e31bf1f9da08a$var$getHookDeps(opts));
    return (0, $fsvuC.useCallback)((handler, timeout, ...args)=>{
        const id = setTimeout(()=>{
            timeouts.current = timeouts.current.filter((timeoutId)=>timeoutId !== id);
            handler();
        }, timeout, ...args);
        timeouts.current.push(id);
    }, []);
};

});

parcelRegister("hk7fM", function(module, exports) {
$parcel$export(module.exports, "useExitingPersistence", () => $01ef350952c0ea5f$export$3b6f38abbdcbd000);

var $fsvuC = parcelRequire("fsvuC");

var $lfw4f = parcelRequire("lfw4f");
const $01ef350952c0ea5f$export$3b6f38abbdcbd000 = ()=>{
    return (0, $fsvuC.useContext)((0, $lfw4f.ExitingContext));
};

});

parcelRegister("alfDb", function(module, exports) {
$parcel$export(module.exports, "useStaggeredEntrance", () => $227ddc063bd995ce$export$25c7213fc07ec080);

var $fsvuC = parcelRequire("fsvuC");

var $kEvJm = parcelRequire("kEvJm");

var $eZnwX = parcelRequire("eZnwX");
const $227ddc063bd995ce$export$25c7213fc07ec080 = ()=>{
    const identifier = (0, $kEvJm.useUniqueId)();
    const context = (0, $fsvuC.useContext)((0, $eZnwX.StaggeredEntranceContext));
    return context(identifier);
};

});
parcelRegister("kEvJm", function(module, exports) {
$parcel$export(module.exports, "useUniqueId", () => $d9ab03676c106387$export$c485849f2e393253);
/* eslint-disable @repo/internal/react/disallow-unstable-values */ 
var $fsvuC = parcelRequire("fsvuC");
function $d9ab03676c106387$export$c485849f2e393253() {
    const identifier = (0, $fsvuC.useRef)('');
    if (!identifier.current) identifier.current = '_' + (Number(String(Math.random()).slice(2)) + Date.now() + Math.round(performance.now())).toString(36);
    return identifier.current;
}

});

parcelRegister("eZnwX", function(module, exports) {
$parcel$export(module.exports, "StaggeredEntranceContext", () => $237c213ec3ccad66$export$5e65d7d58ae96ad8);
$parcel$export(module.exports, "default", () => $237c213ec3ccad66$export$2e2bcd8739ae039);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $9Tkwf = parcelRequire("9Tkwf");

var $hxGHU = parcelRequire("hxGHU");
const $237c213ec3ccad66$export$5e65d7d58ae96ad8 = /*#__PURE__*/ (0, $fsvuC.createContext)(()=>({
        isReady: true,
        delay: 0,
        ref: (0, $9Tkwf.default)
    }));
/**
 * For a list of elements that need to animate in,
 * this should be used in conjunction with entering components.
 * This does not need Javascript to execute so it will run immediately for any SSR rendered React apps before the JS has executed.
 *
 * Will dynamically add delay to each child entering component.
 * Unfortunately all entering components _NEED_ to be a direct descendant.
 */ const $237c213ec3ccad66$var$StaggeredEntrance = ({ children: children, column: column, columns: columns = 'responsive', delayStep: delayStep = 50 })=>{
    const elementRefs = (0, $fsvuC.useRef)([]);
    const indexes = [];
    const [actualColumns, setActualColumns] = (0, $fsvuC.useState)(()=>{
        if (typeof columns === 'number') // A hardcoded columns is set so bail out and set it to that!
        return columns;
        if (typeof column === 'number') // A hardcoded column is set so we will set actualColumns to be 1.
        return 1;
        // We are in "responsive" mode.
        // So we will be calculating when the Javascript executes on the client how many columns there will be.
        return 0;
    });
    (0, $hxGHU.useLayoutEffect)(()=>{
        // We want to only run this code when we are in "responsive" mode.
        // It is assumed we are in responsive mode if `columns` is "responsive",
        // we have children element refs ready to be read (i.e. if there are no children this won't run as well)
        // and finally that `actualColumns` is `0` - this is because for the first render cycle `actualColumns` will be `0` (set above)
        // and then after this layout effect runs the value for `actualColumns` will then be calculated and set.
        if (columns === 'responsive' && elementRefs.current.length && actualColumns === 0) {
            let currentTop = 0;
            let numberColumns = 0;
            if (elementRefs.current.length <= 1) {
                setActualColumns(1);
                return;
            }
            // We set the current top to the first elements.
            // We will be comparing this and incrementing the column count
            // until we hit an element that has a different offset top (or we run out of elements).
            currentTop = elementRefs.current[0] ? elementRefs.current[0].offsetTop : 0;
            for(let i = 0; i < elementRefs.current.length; i++){
                const child = elementRefs.current[i];
                if (!child) break;
                if (currentTop === child.offsetTop) {
                    numberColumns += 1;
                    if (elementRefs.current.length - 1 === i) setActualColumns(numberColumns);
                    continue;
                }
                setActualColumns(numberColumns);
                break;
            }
        }
    // We only want this effect to run once - on initial mount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, $5chsV.jsx)($237c213ec3ccad66$export$5e65d7d58ae96ad8.Provider, {
        value: (id)=>{
            if (!indexes.includes(id)) indexes.push(id);
            const isReady = actualColumns > 0;
            const index = indexes.indexOf(id);
            const currentColumn = column || index % actualColumns;
            const currentRow = Math.floor(index / actualColumns);
            const distanceFromTopLeftElement = currentRow + currentColumn;
            // We don't want loads of elements to have the same staggered delay as it ends up looking slow for users.
            // To get around that we calculate the logarithm using `distanceFromTopLeftElement` which ends making
            // elements appear faster the further away from the top left element.
            const delay = Math.ceil(Math.log(distanceFromTopLeftElement + 1) * delayStep * 1.5) || 0;
            return {
                delay: delay,
                isReady: isReady,
                ref: (element)=>elementRefs.current[index] = element
            };
        },
        children: children
    });
};
$237c213ec3ccad66$var$StaggeredEntrance.displayName = "StaggeredEntrance";
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$237c213ec3ccad66$export$2e2bcd8739ae039 = $237c213ec3ccad66$var$StaggeredEntrance;

});
parcelRegister("hxGHU", function(module, exports) {
$parcel$export(module.exports, "useLayoutEffect", () => $a1f8ad34f939ea05$export$e5c5a5f917a5871c);

var $fsvuC = parcelRequire("fsvuC");
const $a1f8ad34f939ea05$export$e5c5a5f917a5871c = typeof window === 'undefined' ? (0, $fsvuC.useEffect) : (0, $fsvuC.useLayoutEffect);

});





parcelRegister("f3WQU", function(module, exports) {
$parcel$export(module.exports, "Popper", () => $76c275899e4acc1b$export$badac9ada3a0bdf9);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $hFU61 = parcelRequire("hFU61");

var $llCao = parcelRequire("llCao");

var $e7yyT = parcelRequire("e7yyT");

var $bwUgw = parcelRequire("bwUgw");

var $hjLVT = parcelRequire("hjLVT");
const $76c275899e4acc1b$var$viewportPadding = 5;
const $76c275899e4acc1b$var$constantModifiers = [
    {
        name: 'flip',
        options: {
            flipVariations: false,
            padding: $76c275899e4acc1b$var$viewportPadding,
            boundary: 'clippingParents',
            rootBoundary: 'viewport'
        }
    }
];
function $76c275899e4acc1b$var$defaultChildrenFn() {
    return null;
}
const $76c275899e4acc1b$var$defaultOffset = [
    0,
    8
];
function $76c275899e4acc1b$export$badac9ada3a0bdf9({ children: children, offset: offset, placement: placement, referenceElement: referenceElement, modifiers: modifiers, strategy: strategy, shouldFitViewport: shouldFitViewport }) {
    // The FF check sits at the very top of the public Popper so the
    // rest of the function (which has its own hooks) does not violate
    // the rules of hooks. Each branch is its own component with its
    // own complete hook order. Props are forwarded explicitly to
    // satisfy `no-unsafe-spread-props`.
    if ((0, $llCao.fg)('platform-dst-top-layer')) return /*#__PURE__*/ (0, $5chsV.jsx)((0, $bwUgw.PopperTopLayer), {
        children: children,
        offset: offset,
        placement: placement,
        referenceElement: referenceElement,
        modifiers: modifiers,
        strategy: strategy,
        shouldFitViewport: shouldFitViewport
    });
    return /*#__PURE__*/ (0, $5chsV.jsx)($76c275899e4acc1b$var$LegacyPopper, {
        children: children,
        offset: offset,
        placement: placement,
        referenceElement: referenceElement,
        modifiers: modifiers,
        strategy: strategy,
        shouldFitViewport: shouldFitViewport
    });
}
$76c275899e4acc1b$export$badac9ada3a0bdf9.displayName = "Popper";
function $76c275899e4acc1b$var$LegacyPopper({ children: children = $76c275899e4acc1b$var$defaultChildrenFn, offset: offset = $76c275899e4acc1b$var$defaultOffset, placement: placement = 'bottom-start', referenceElement: referenceElement, modifiers: modifiers, strategy: strategy = 'fixed', shouldFitViewport: shouldFitViewport = false }) {
    const [offsetX, offsetY] = offset;
    const internalModifiers = (0, $fsvuC.useMemo)(()=>{
        const preventOverflowModifier = {
            name: 'preventOverflow',
            options: {
                padding: $76c275899e4acc1b$var$viewportPadding,
                rootBoundary: shouldFitViewport ? 'viewport' : 'document'
            }
        };
        const offsetModifier = {
            name: 'offset',
            options: {
                offset: [
                    offsetX,
                    offsetY
                ]
            }
        };
        const maxSizeModifiers = shouldFitViewport ? (0, $e7yyT.getMaxSizeModifiers)({
            viewportPadding: $76c275899e4acc1b$var$viewportPadding
        }) : [];
        return [
            ...$76c275899e4acc1b$var$constantModifiers,
            preventOverflowModifier,
            offsetModifier,
            ...maxSizeModifiers
        ];
    }, [
        offsetX,
        offsetY,
        shouldFitViewport
    ]);
    // Merge custom props and memoize
    const mergedModifiers = (0, $fsvuC.useMemo)(()=>{
        if (modifiers == null) return internalModifiers;
        return [
            ...internalModifiers,
            ...modifiers
        ];
    }, [
        internalModifiers,
        modifiers
    ]);
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $hFU61.Popper), {
        // @ts-expect-error - No overload matches this call
        // This error was introduced after upgrading to TypeScript 5
        modifiers: mergedModifiers,
        placement: placement,
        strategy: strategy,
        referenceElement: referenceElement,
        children: children
    });
}
$76c275899e4acc1b$var$LegacyPopper.displayName = "LegacyPopper";

});
parcelRegister("e7yyT", function(module, exports) {
$parcel$export(module.exports, "getMaxSizeModifiers", () => $d7c64206c7871425$export$6d8c2b45c99d6e3f);
function $d7c64206c7871425$export$6d8c2b45c99d6e3f({ viewportPadding: viewportPadding }) {
    return [
        {
            /**
			 * Performing DOM measurements in the 'read' phase,
			 * which is the convention for popper modifiers
			 */ name: 'maxSizeData',
            enabled: true,
            phase: 'read',
            fn ({ state: state, name: name }) {
                if (!window.visualViewport) return;
                state.modifiersData[name] = {
                    viewport: {
                        width: window.visualViewport.width,
                        height: window.visualViewport.height
                    }
                };
            }
        },
        {
            /**
			 * Applying max size CSS
			 */ name: 'maxSize',
            enabled: true,
            phase: 'beforeWrite',
            requiresIfExists: [
                'offset',
                'preventOverflow',
                'flip'
            ],
            fn ({ state: state }) {
                const data = state.modifiersData.maxSizeData;
                if (typeof data?.viewport?.width !== 'number' || typeof data?.viewport?.height !== 'number') // This shouldn't occur in a real browser but might in non-browser test environments
                return;
                const { viewport: viewport } = data;
                const { popperOffsets: popperOffsets = {
                    x: 0,
                    y: 0
                } } = state.modifiersData;
                const [basePlacement] = state.placement.split('-');
                const placementOffset = state.modifiersData?.offset?.[state.placement] ?? {
                    x: 0,
                    y: 0
                };
                // By default we set these to the entire viewport (minus padding)
                // Each placement direction will overwrite one of these
                let maxWidth = viewport.width - 2 * viewportPadding;
                let maxHeight = viewport.height - 2 * viewportPadding;
                if (basePlacement === 'top') maxHeight = state.rects.reference.y + // Viewport-relative position of reference element
                placementOffset.y - // Space between popper and reference
                viewportPadding;
                if (basePlacement === 'bottom') maxHeight = viewport.height - popperOffsets.y - // Viewport-relative position of popper
                viewportPadding;
                if (basePlacement === 'left') maxWidth = state.rects.reference.x + // Viewport-relative position of reference element
                placementOffset.x - // Space between popper and reference
                viewportPadding;
                if (basePlacement === 'right') maxWidth = viewport.width - popperOffsets.x - // Viewport-relative position of popper
                viewportPadding;
                state.styles.popper.maxWidth = `${maxWidth}px`;
                state.styles.popper.maxHeight = `${maxHeight}px`;
            }
        }
    ];
}

});

parcelRegister("bwUgw", function(module, exports) {
$parcel$export(module.exports, "PopperTopLayer", () => $ed83e299a6c71f40$export$9802f50720ab826e);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $9Tkwf = parcelRequire("9Tkwf");

var $974dn = parcelRequire("974dn");

var $2jUY9 = parcelRequire("2jUY9");

var $gc525 = parcelRequire("gc525");

var $eyyYg = parcelRequire("eyyYg");

var $kOb0h = parcelRequire("kOb0h");

var $isTM6 = parcelRequire("isTM6");

var $ipV9d = parcelRequire("ipV9d");

var $5aOgs = parcelRequire("5aOgs");

var $jtt1n = parcelRequire("jtt1n");

var $koKda = parcelRequire("koKda");
/**
 * Inert render-prop values. The browser owns positioning under CSS Anchor
 * Positioning, so `style` / `ref` / `arrowProps` / `update` / `forceUpdate`
 * are no-ops that consumers can safely spread. Module scope keeps identities
 * stable for effect dep arrays.
 */ const $ed83e299a6c71f40$var$noopStyle = {};
const $ed83e299a6c71f40$var$noopSetRef = (0, $9Tkwf.default);
const $ed83e299a6c71f40$var$noopUpdate = ()=>Promise.resolve(null);
const $ed83e299a6c71f40$var$noopForceUpdate = ()=>({});
const $ed83e299a6c71f40$var$noopArrowProps = {
    ref: $ed83e299a6c71f40$var$noopSetRef,
    style: $ed83e299a6c71f40$var$noopStyle,
    'data-popper-arrow': true
};
/**
 * Normalises popper's `[along, away]` offset (which may include `null` or
 * `undefined` entries) into the `[along, away]` number tuple
 * `fromLegacyPlacement` expects.
 */ function $ed83e299a6c71f40$var$popperToTopLayerOffset(offset) {
    if (!offset) return undefined;
    const [along, away] = offset;
    if (along == null && away == null) return undefined;
    return [
        along ?? 0,
        away ?? 0
    ];
}
/**
 * SSR-safe `instanceof HTMLElement`. This runs during render, and the server
 * has no `HTMLElement` global. No hydration mismatch: refs are unset on the
 * server and on the first client render, so both sides get the same result.
 */ function $ed83e299a6c71f40$var$isHTMLElement(value) {
    return typeof HTMLElement !== 'undefined' && value instanceof HTMLElement;
}
function $ed83e299a6c71f40$export$9802f50720ab826e({ children: children, offset: offset, placement: placement = 'bottom-start', referenceElement: referenceElement, shouldFitViewport: shouldFitViewport = false }) {
    // `modifiers` and `strategy` are accepted for source compatibility but have
    // no runtime effect; CSS Anchor Positioning + top-layer rendering replaces
    // them. See `top-layer/notes/migrations/popper-migration.md`.
    // Anchor resolution: `referenceElement` prop, then `<Manager>` context.
    const managerAnchor = (0, $jtt1n.useManagerAnchor)();
    const effectiveReference = referenceElement ?? managerAnchor ?? undefined;
    // Real DOM nodes are anchored by `useAnchoredPopover`; popper
    // `VirtualElement`s go to `useAnchoredPopoverAtPoint`, which owns a synthetic
    // anchor element in `document.body`.
    const htmlAnchor = $ed83e299a6c71f40$var$isHTMLElement(effectiveReference) ? effectiveReference : null;
    const virtualReference = effectiveReference != null && !$ed83e299a6c71f40$var$isHTMLElement(effectiveReference) ? effectiveReference : null;
    const htmlAnchorRef = (0, $fsvuC.useRef)(htmlAnchor);
    htmlAnchorRef.current = htmlAnchor;
    const popoverRef = (0, $fsvuC.useRef)(null);
    const popoverId = (0, $kOb0h.usePopoverId)();
    // Track the resolved DOM anchor in state so the visibility hook re-runs when
    // its identity changes. Virtual anchors do not feed that hook, because their
    // probe is outside the consumer's DOM.
    //
    // Adjust state during render by comparing against the state itself: the
    // conditional guard means `setResolvedAnchor` is skipped once they match,
    // so it converges in one extra render. This is the React-documented pattern
    // and is side-effect-free — no ref mutation during render.
    const [resolvedAnchor, setResolvedAnchor] = (0, $fsvuC.useState)(htmlAnchor);
    if (resolvedAnchor !== htmlAnchor) setResolvedAnchor(htmlAnchor);
    const topLayerPlacement = (0, $fsvuC.useMemo)(()=>{
        return (0, $974dn.fromLegacyPlacement)({
            legacy: (0, $5aOgs.toLegacyPlacement)(placement),
            offset: $ed83e299a6c71f40$var$popperToTopLayerOffset(offset)
        });
    }, [
        placement,
        offset
    ]);
    const isOpen = effectiveReference != null;
    // Refs, because `getPoint` is LATCHED: called once per activation, so a
    // closed-over value would go stale if either prop changed while it stayed open.
    const virtualReferenceRef = (0, $fsvuC.useRef)(virtualReference);
    virtualReferenceRef.current = virtualReference;
    const topLayerPlacementRef = (0, $fsvuC.useRef)(topLayerPlacement);
    topLayerPlacementRef.current = topLayerPlacement;
    // Two positioning hooks, at most one enabled: `htmlAnchor` and
    // `virtualReference` both derive from `effectiveReference`, so they are never
    // both set, and when neither is the popover is closed.
    const isElementAnchored = htmlAnchor !== null;
    const isPointAnchored = virtualReference !== null;
    // Passed as one object so the element and point calls cannot drift.
    const sharedPositioning = {
        popoverRef: popoverRef,
        placement: topLayerPlacement,
        isOpen: isOpen,
        inlineSize: shouldFitViewport ? 'max-available' : 'content',
        blockSize: shouldFitViewport ? 'max-available' : 'content'
    };
    (0, $gc525.useAnchoredPopover)({
        ...sharedPositioning,
        anchorRef: htmlAnchorRef,
        isEnabled: isElementAnchored
    });
    (0, $eyyYg.useAnchoredPopoverAtPoint)({
        ...sharedPositioning,
        isEnabled: isPointAnchored,
        getPoint: ()=>{
            const current = virtualReferenceRef.current;
            if (!current) return null;
            return (0, $ipV9d.rectPointForPlacement)({
                rect: current.getBoundingClientRect(),
                placement: topLayerPlacementRef.current,
                isRtl: (0, $isTM6.isPageRtl)()
            });
        }
    });
    const { isReferenceHidden: isReferenceHidden, hasPopperEscaped: hasPopperEscaped } = (0, $koKda.useReferenceVisibility)({
        anchor: resolvedAnchor,
        popoverRef: popoverRef
    });
    const renderChildren = children;
    if (typeof renderChildren !== 'function') return null;
    const renderPropArg = {
        ref: $ed83e299a6c71f40$var$noopSetRef,
        style: $ed83e299a6c71f40$var$noopStyle,
        placement: placement,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped,
        update: $ed83e299a6c71f40$var$noopUpdate,
        forceUpdate: $ed83e299a6c71f40$var$noopForceUpdate,
        arrowProps: $ed83e299a6c71f40$var$noopArrowProps
    };
    const content = renderChildren(renderPropArg);
    // Rendered directly into the `<Popover>` host, which supplies the flex
    // formatting context the size caps need — so the render prop must return ONE
    // element. See `children` in `@atlaskit/top-layer`'s `popover/types.tsx`.
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $2jUY9.Popover), {
        ref: popoverRef,
        id: popoverId,
        isOpen: isOpen,
        mode: "manual",
        shouldAnimate: false,
        children: content
    });
}
$ed83e299a6c71f40$export$9802f50720ab826e.displayName = "PopperTopLayer";

});
parcelRegister("974dn", function(module, exports) {
$parcel$export(module.exports, "fromLegacyPlacement", () => $95ad8a38126b6128$export$69e99ed50b2534c9);

var $6oSvG = parcelRequire("6oSvG");
function $95ad8a38126b6128$export$69e99ed50b2534c9({ legacy: legacy, offset: offset }) {
    const basePlacement = (0, $6oSvG.placementMapping)[legacy];
    if (!offset) return basePlacement;
    const [along, away] = offset;
    return {
        ...basePlacement,
        offset: {
            gap: away,
            crossAxisShift: {
                // Sign is captured in `direction`; `value` is the magnitude.
                value: Math.abs(along),
                direction: along >= 0 ? 'forwards' : 'backwards'
            }
        }
    };
}

});
parcelRegister("6oSvG", function(module, exports) {
$parcel$export(module.exports, "placementMapping", () => $477bae71f118d8bf$export$27df359c528b7120);
const $477bae71f118d8bf$export$27df359c528b7120 = {
    top: {
        axis: 'block',
        edge: 'start',
        align: 'center'
    },
    'top-start': {
        axis: 'block',
        edge: 'start',
        align: 'start'
    },
    'top-center': {
        axis: 'block',
        edge: 'start',
        align: 'center'
    },
    'top-end': {
        axis: 'block',
        edge: 'start',
        align: 'end'
    },
    bottom: {
        axis: 'block',
        edge: 'end',
        align: 'center'
    },
    'bottom-start': {
        axis: 'block',
        edge: 'end',
        align: 'start'
    },
    'bottom-center': {
        axis: 'block',
        edge: 'end',
        align: 'center'
    },
    'bottom-end': {
        axis: 'block',
        edge: 'end',
        align: 'end'
    },
    right: {
        axis: 'inline',
        edge: 'end',
        align: 'center'
    },
    'right-start': {
        axis: 'inline',
        edge: 'end',
        align: 'start'
    },
    'right-end': {
        axis: 'inline',
        edge: 'end',
        align: 'end'
    },
    left: {
        axis: 'inline',
        edge: 'start',
        align: 'center'
    },
    'left-start': {
        axis: 'inline',
        edge: 'start',
        align: 'start'
    },
    'left-end': {
        axis: 'inline',
        edge: 'start',
        align: 'end'
    },
    auto: {
        axis: 'block',
        edge: 'end',
        align: 'center'
    },
    'auto-start': {
        axis: 'block',
        edge: 'end',
        align: 'start'
    },
    'auto-end': {
        axis: 'block',
        edge: 'end',
        align: 'end'
    }
};

});


parcelRegister("2jUY9", function(module, exports) {
$parcel$export(module.exports, "Popover", () => $117cefbd5a590736$export$5b6b19405a83ff9d);
/* popover.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $gJ6nT = parcelRequire("gJ6nT");

var $fsvuC = parcelRequire("fsvuC");

var $4twf9 = parcelRequire("4twf9");

var $dqdTY = parcelRequire("dqdTY");

var $fz4Xf = parcelRequire("fz4Xf");

var $kFwbq = parcelRequire("kFwbq");

var $7EsQa = parcelRequire("7EsQa");


var $gbYGm = parcelRequire("gbYGm");

var $99cJP = parcelRequire("99cJP");

var $8b7DD = parcelRequire("8b7DD");

var $9K6DR = parcelRequire("9K6DR");

var $5hREl = parcelRequire("5hREl");
/**
 * Native restoration only covers the first popover in an auto/hint stack, not each nested popover.
 * This fallback also supports manual popovers, which have no native restoration target.
 * See https://html.spec.whatwg.org/multipage/popover.html#show-popover (step 15.8).
 */ function $117cefbd5a590736$var$restoreFocus({ popover: popover, focusRestorationTarget: focusRestorationTarget }) {
    if (!focusRestorationTarget) return;
    const { ownerDocument: ownerDocument } = popover;
    // Native restoration has finished. Preserve focus moved outside the popover.
    const activeElementAfterClose = ownerDocument.activeElement;
    // Before close, we checked that focus was inside. Body can now mean focus was lost during close.
    if (activeElementAfterClose === ownerDocument.body || popover.contains(activeElementAfterClose)) // Match native popover restoration, which does not scroll the viewport.
    focusRestorationTarget.focus({
        preventScroll: true
    });
}
/**
 * Detects `popover="hint"` support via DOM reflection. SSR-safe, cached.
 */ const $117cefbd5a590736$var$supportsPopoverHint = (0, $kFwbq.default)(()=>{
    if (typeof document === 'undefined') return false;
    // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage -- feature detection
    const element = document.createElement('div');
    element.setAttribute('popover', 'hint');
    return element.popover === 'hint';
});
/**
 * **Surface reset**
 *
 * The host is still a DOM child of its trigger for inheritance, so it inherits
 * values like `pointer-events: none` or `white-space: nowrap`. Resets them to
 * what `<body>` gave the portal path. `font` and direction still inherit.
 * Not `all: initial`: that would also override the UA `[popover]` rules.
 *
 * `color` is a reset too: the UA `[popover]` rule sets `color: CanvasText`, so
 * the host never inherits a colour. `color.text` is what `<body>` gave the portal
 * path. Not `inherit`, which would take the trigger's colour (for example a link).
 * See `notes/decisions/surface-reset-color.md`.
 *
 * KEEP IN SYNC with `dialog/dialog-content.tsx` (ADS forbids shared styles).
 * The `satisfies` check below catches drift.
 */ const $117cefbd5a590736$var$surfaceResetStyles = {
    root: "_16fQCjIZbP _22xN0BzUZr _31O5bFzUZr _3npKLMzUZr _1W8Jgq7p2s _1sv16BdnbC _37eVqOYbGa _0D9ajdy7kJ"
};
const $117cefbd5a590736$var$styles = {
    root: "_1rY2tZYbGa _0IUicTdnbC _2CPmtLdnbC _3Ry02rdnbC _0MZiGidnbC _0JgUISdnbC _2jBLLmdnbC _35hjkkdnbC _354XgOdnbC _4rHKqQIZbP _29vmT7YvD1 _38PkgEYvD1 _4bqM9MyL8i _1mTOXy1qpb _3QA2gZLRg7 _2Shm1hzUZr _3Zo5bzzUZr _3hz6pUy1CL _1JQPw0E6Kk _4coeiLIZbP _4DVkoZIZbP _1pYRymYbGa _3sidotIZbP _0HFSp6YbGa _3NthtFzUZr _1hzzDPzUZr _3n2izOYbGa _2bmTl7YbGa _1Wet47YbGa _4eTLRPYbGa _2Q5CZ97dHp _42w5E7Q4SZ _0kCZAs7dHp _4FizMIdnbC _102crRdnbC",
    motion: "_1kOSYtHCFx _3Z9K0wPdtu _4f1LA5ThaV _3Y6bKpZSoF _0LqqFdYbGa _2Iz54kxlqh",
    enter: "_2fBhte3Dhq",
    exit: "_2fBhteV1L6"
};
// Intentionally using `Record<string, string>` instead of `React.CSSProperties`
// to avoid type errors about the CSS variables not being valid property names
const $117cefbd5a590736$var$popupMotionStyles = {
    block: {
        start: {
            '--ds-popover-motion-enter': "var(--ds-popup-enter-top, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInTop8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
            '--ds-popover-motion-exit': "var(--ds-popup-exit-top, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutTop4px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
        },
        end: {
            '--ds-popover-motion-enter': "var(--ds-popup-enter-bottom, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInBottom8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
            '--ds-popover-motion-exit': "var(--ds-popup-exit-bottom, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutBottom4px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
        }
    },
    inline: {
        start: {
            '--ds-popover-motion-enter': "var(--ds-popup-enter-left, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInLeft8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
            '--ds-popover-motion-exit': "var(--ds-popup-exit-left, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutLeft4px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
        },
        end: {
            '--ds-popover-motion-enter': "var(--ds-popup-enter-right, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInRight8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
            '--ds-popover-motion-exit': "var(--ds-popup-exit-right, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutRight4px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
        }
    }
};
const $117cefbd5a590736$export$5b6b19405a83ff9d = /*#__PURE__*/ (0, $fsvuC.forwardRef)(function Popover({ children: children, mode: modeProp = 'auto', onClose: onClose, onEnterFinish: onEnterFinish, onExitFinish: onExitFinish, shouldAnimate: shouldAnimate = false, placement: placement, testId: testId, isOpen: isOpen, enteringAnimationXcss: enteringAnimationXcss, exitingAnimationXcss: exitingAnimationXcss, initialFocusRef: initialFocusRef, role: // ARIA
role, label: label, labelledBy: labelledBy, id: idProp }, ref) {
    const autoId = (0, $fsvuC.useId)();
    const ownRef = (0, $fsvuC.useRef)(null);
    const combinedRef = (0, $fz4Xf.default)([
        ownRef,
        ref
    ].filter(Boolean));
    // `useId()` colons are invalid in CSS selectors and popover target attributes.
    const popoverId = idProp ?? `popover-${autoId.replace(/:/g, '')}`;
    // Keep the semantic callback current without rebinding native lifecycle
    // listeners during the same commit that calls showPopover()/hidePopover().
    const onCloseRef = (0, $fsvuC.useRef)(onClose);
    (0, $7EsQa.useLayoutEffect)(()=>{
        onCloseRef.current = onClose;
    }, [
        onClose
    ]);
    // A popover with `onClose` is closable (see `closable-popover-contract`).
    // `requestClosePopovers()` asks it to close; the consumer decides.
    const isClosable = Boolean(onClose);
    // `hint` falls back to `auto` when unsupported: closest behavior (light
    // dismiss works), but `auto` participates in the auto-dismiss stack so it
    // will close other `auto` popovers when opened. Acceptable trade-off given
    // shrinking browser set without `hint` support.
    const mode = modeProp === 'hint' && !$117cefbd5a590736$var$supportsPopoverHint() ? 'auto' : modeProp;
    const popupMotionStyle = (0, $fsvuC.useMemo)(()=>{
        if (!placement || !shouldAnimate) return undefined;
        const { axis: axis, edge: edge } = (0, $99cJP.resolvePlacement)({
            placement: placement
        });
        return $117cefbd5a590736$var$popupMotionStyles[axis][edge];
    }, [
        placement,
        shouldAnimate
    ]);
    // Tracks the close reason, including our own hidePopover() calls.
    const closeReasonRef = (0, $fsvuC.useRef)('light-dismiss');
    // Pre-open focus target, cleared before close when restoration is not eligible.
    const focusRestorationTargetRef = (0, $fsvuC.useRef)(null);
    const handleBeforeToggle = (0, $fsvuC.useCallback)((event)=>{
        const popover = event.currentTarget;
        if (!(popover instanceof HTMLElement)) return;
        const { ownerDocument: ownerDocument } = popover;
        const { activeElement: activeElement } = ownerDocument;
        if (event.newState === 'open') {
            focusRestorationTargetRef.current = activeElement instanceof HTMLElement ? activeElement : null;
            return;
        }
        /**
     * Like native restoration, leave external focus alone and skip light dismiss.
     * Check before closing so focus already on body is not mistaken for focus lost during close.
     * See https://html.spec.whatwg.org/multipage/popover.html#hide-popover-algorithm (step 20.2).
     */ if (closeReasonRef.current === 'light-dismiss' || !popover.contains(activeElement)) focusRestorationTargetRef.current = null;
    }, []);
    const handleToggleClosed = (0, $fsvuC.useCallback)((event)=>{
        const popover = event.currentTarget;
        if (!(popover instanceof HTMLElement)) return;
        const focusRestorationTarget = focusRestorationTargetRef.current;
        focusRestorationTargetRef.current = null;
        const reason = closeReasonRef.current;
        // Reset reason so a stale 'escape' from a race with Escape keydown
        // does not corrupt the next browser-dismiss cycle.
        closeReasonRef.current = 'light-dismiss';
        // Run after native restoration, before notifying the consumer, which may move focus itself.
        $117cefbd5a590736$var$restoreFocus({
            popover: popover,
            focusRestorationTarget: focusRestorationTarget
        });
        // Programmatic closes are already known to the consumer.
        if (reason !== 'programmatic') onCloseRef.current?.({
            reason: reason
        });
    }, []);
    const { phase: phase, isMounted: isMounted, onBeforeToggle: onBeforeToggle, onToggle: onToggle } = (0, $8b7DD.useAnimatedVisibility)({
        isOpen: isOpen,
        shouldAnimate: shouldAnimate,
        elementRef: ownRef,
        onEnterFinish: onEnterFinish,
        onExitFinish: onExitFinish
    });
    // Focus management: Tab cycling for dialog roles. Initial focus is below
    // the show/hide layout effect. Restoration is native for outermost
    // popovers; nested popovers are handled above via the `beforetoggle`
    // snapshot. Passing `phase` keeps `useFocusWrap` attached through the
    // animated-exit window (WCAG 2.4.3 guard). See notes/architecture/focus.md.
    (0, $9K6DR.useFocusWrap)({
        elementRef: ownRef,
        role: role,
        phase: phase
    });
    // Bind via `useLayoutEffect`, and BEFORE the show/hide layout effect
    // below, so listeners are attached when `showPopover()` synchronously
    // dispatches `beforetoggle`. A regular `useEffect` would miss that
    // first dispatch, dropping the `focusRestorationTargetRef` snapshot
    // and breaking nested-popover focus restoration on close. React runs
    // layout effects in source order on the same commit.
    (0, $7EsQa.useLayoutEffect)(()=>{
        const element = ownRef.current;
        if (!element) return;
        // Tag Escape before the browser processes light dismiss.
        const unbindEscape = (0, $dqdTY.bind)(element, {
            type: 'keydown',
            listener: (event)=>{
                // Ignore Escape events dispatched after native close.
                if (event.key === 'Escape' && (0, $gbYGm.isNativeElementOpen)({
                    element: element
                })) closeReasonRef.current = 'escape';
            },
            options: {
                capture: true
            }
        });
        const unbindToggle = (0, $dqdTY.bind)(element, {
            type: 'toggle',
            listener: (event)=>{
                if (event.newState === 'closed') handleToggleClosed(event);
                onToggle(event);
            }
        });
        // Snapshot the active element before `useInitialFocus` moves it,
        // then advance the shared visibility lifecycle.
        const unbindBeforeToggle = (0, $dqdTY.bind)(element, {
            type: 'beforetoggle',
            listener: (event)=>{
                handleBeforeToggle(event);
                onBeforeToggle(event);
            }
        });
        // `requestClosePopovers()` asks the consumer to close. Nothing is
        // hidden here, so a consumer that keeps `isOpen` stays in sync.
        const unbindRequestClose = (0, $dqdTY.bind)(element, {
            type: (0, $ba52e8a77c149a28$export$17ed9502ee8e92da),
            listener: ()=>{
                onCloseRef.current?.({
                    reason: 'programmatic'
                });
            }
        });
        return ()=>{
            unbindEscape();
            unbindToggle();
            unbindBeforeToggle();
            unbindRequestClose();
        };
    }, [
        handleBeforeToggle,
        handleToggleClosed,
        isMounted,
        onBeforeToggle,
        onToggle
    ]);
    // Show/hide based on isOpen. `showPopover`/`hidePopover` are no-ops when
    // already in the target state. Try/catch guards `InvalidStateError` on
    // disconnected elements (StrictMode/concurrent/unmount edge cases).
    (0, $7EsQa.useLayoutEffect)(()=>{
        const element = ownRef.current;
        if (!element) return;
        if (isOpen) {
            // Clear stale 'escape' from a prior cycle: the ref outlives
            // the host element, and interrupted close lifecycles may not reach
            // `handleToggleClosed` to reset it.
            closeReasonRef.current = 'light-dismiss';
            try {
                element.showPopover();
            } catch  {}
            return ()=>{
                closeReasonRef.current = 'programmatic';
                try {
                    element.hidePopover();
                } catch  {}
            };
        }
        closeReasonRef.current = 'programmatic';
        try {
            element.hidePopover();
        } catch  {}
    }, [
        isOpen
    ]);
    // Initial focus (role-dependent) is a layout effect, so it must come AFTER
    // the show/hide layout effect above: React runs layout effects in source
    // order, and focus only works once `showPopover()` has run. Focus then
    // lands in the same task as the open, before the browser paints.
    (0, $5hREl.useInitialFocus)({
        elementRef: ownRef,
        initialFocusRef: initialFocusRef,
        phase: phase,
        role: role
    });
    // Unmount the host once exit completes so it does not leave an empty
    // `role`/`popover` element in the accessibility tree. The element
    // remounts on the next open; the `popoverId` is stable across opens.
    if (!isMounted) return null;
    return /*#__PURE__*/ (0, $5chsV.jsx)("div", {
        ref: combinedRef,
        id: popoverId,
        // @ts-expect-error -- popover attribute not yet in React types
        // eslint-disable-next-line react/no-unknown-property -- popover attribute not yet in React types
        popover: mode,
        role: role,
        // Keep in sync with `closablePopoverAttribute` (internal/closable-popover-contract).
        "data-top-layer-closable": isClosable ? '' : undefined,
        "aria-label": label,
        "aria-labelledby": labelledBy,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Motion styles are selected at runtime from the placement.
        style: popupMotionStyle,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $gJ6nT.default)([
            $117cefbd5a590736$var$styles.root,
            $117cefbd5a590736$var$surfaceResetStyles.root,
            shouldAnimate && phase === 'entering' && $117cefbd5a590736$var$styles.enter,
            shouldAnimate && phase === 'exiting' && $117cefbd5a590736$var$styles.exit,
            shouldAnimate && $117cefbd5a590736$var$styles.motion,
            (0, $4twf9.cx)(shouldAnimate && phase === 'entering' && enteringAnimationXcss, shouldAnimate && phase === 'exiting' && exitingAnimationXcss)
        ]),
        children: children
    });
});

});
parcelRegister("kFwbq", function(module, exports) {
$parcel$export(module.exports, "default", () => $a8543d4a705cb638$export$2e2bcd8739ae039);
function $a8543d4a705cb638$export$2e2bcd8739ae039(fn) {
    let cache = null;
    return function result(...args) {
        if (!cache) cache = {
            value: fn.call(this, ...args)
        };
        /**
		 * Intentionally not adding `.clear()` function property
		 *
		 * - We currently have no need for it
		 * - We don't want to add a `.clear()` to functions that should never be called twice,
		 *   for example: `cleanup` functions.
		 * - We can add a `onceWithCleanup` variant as a separate export from ds-lib if the
		 *   need arises 🧘
		 */ return cache.value;
    };
}

});

parcelRegister("7EsQa", function(module, exports) {
$parcel$export(module.exports, "useLayoutEffect", () => $07f188ce48274501$export$e5c5a5f917a5871c);

var $fsvuC = parcelRequire("fsvuC");
const $07f188ce48274501$export$e5c5a5f917a5871c = typeof window === 'undefined' ? (0, $fsvuC.useEffect) : (0, $fsvuC.useLayoutEffect);

});

/**
 * Set by `Popover` on its host element when it has an `onClose`. Only those
 * popovers can be asked to close, so only those are counted by
 * `hasOpenDialogOrPopover` and asked to close by `requestClosePopovers`.
 * Popovers without `onClose` (for example the flag group or a spotlight) are
 * not dismissible by outside code and are skipped.
 */ const $ba52e8a77c149a28$export$c6890d80f1a52941 = 'data-top-layer-closable';
const $ba52e8a77c149a28$export$17ed9502ee8e92da = 'top-layer-request-close';

parcelRegister("gbYGm", function(module, exports) {
$parcel$export(module.exports, "isNativeElementOpen", () => $01ad46d5f3b21d13$export$89b923e18c14644d);
function $01ad46d5f3b21d13$export$89b923e18c14644d({ element: element }) {
    if (element instanceof HTMLDialogElement) return element.open;
    // Some DOM implementations throw for unsupported pseudo-classes.
    try {
        return element.matches(':popover-open');
    } catch  {
        return false;
    }
}

});

parcelRegister("99cJP", function(module, exports) {
$parcel$export(module.exports, "resolvePlacement", () => $8e9b25bfe6531baf$export$63044d21bc3d3fa2);

var $8u1wc = parcelRequire("8u1wc");
/**
 * Default gap between trigger and popover. Resolves to a design
 * token (`space.100`) so the value follows the design system's spacing
 * scale. Used when `placement.offset.gap` is not provided.
 */ const $8e9b25bfe6531baf$var$DEFAULT_GAP = "var(--ds-space-100, 8px)";
function $8e9b25bfe6531baf$export$63044d21bc3d3fa2({ placement: placement }) {
    return {
        axis: placement.axis ?? 'block',
        edge: placement.edge ?? 'end',
        align: placement.align ?? 'center',
        // Not `??`: `undefined` must survive, so "not specified" stays
        // distinguishable from an explicit `0`.
        minSize: placement.minSize === undefined ? undefined : (0, $8u1wc.toCssLengthString)({
            value: placement.minSize
        }),
        offset: {
            gap: (0, $8u1wc.toCssLengthString)({
                value: placement.offset?.gap ?? $8e9b25bfe6531baf$var$DEFAULT_GAP
            }),
            crossAxisShift: {
                value: (0, $8u1wc.toCssLengthString)({
                    value: placement.offset?.crossAxisShift?.value ?? 0
                }),
                direction: placement.offset?.crossAxisShift?.direction ?? 'forwards'
            }
        }
    };
}

});
parcelRegister("8u1wc", function(module, exports) {
$parcel$export(module.exports, "toCssLengthString", () => $be1b8b4e04c10674$export$63b6b0ff65d84d47);
/**
 * Normalizes an offset to a CSS length string. Numbers become `${n}px`;
 * strings pass through. Apply at the API boundary so internal code only
 * deals with strings.
 */ function $be1b8b4e04c10674$export$63b6b0ff65d84d47({ value: value }) {
    if (typeof value === 'number') return `${value}px`;
    return value;
}

});


parcelRegister("8b7DD", function(module, exports) {
$parcel$export(module.exports, "useAnimatedVisibility", () => $0ac7147025ffe9dd$export$1bccb45daf07907f);

var $fsvuC = parcelRequire("fsvuC");

var $7EsQa = parcelRequire("7EsQa");

var $gbYGm = parcelRequire("gbYGm");

var $3juIE = parcelRequire("3juIE");
function $0ac7147025ffe9dd$var$runCancellableSettlement({ schedule: schedule, onSettled: onSettled }) {
    let isCancelled = false;
    schedule(()=>{
        if (isCancelled) return;
        onSettled();
    });
    return ()=>{
        // Prevent an interrupted or unmounted lifecycle from firing a stale callback.
        isCancelled = true;
    };
}
/**
 * Fires `onSettled` once all animations currently applied to `element`
 * finish or are cancelled. Returns a cleanup that prevents stale settlement.
 */ function $0ac7147025ffe9dd$var$runOnAnimationsSettled({ element: element, onSettled: onSettled }) {
    return $0ac7147025ffe9dd$var$runCancellableSettlement({
        onSettled: onSettled,
        schedule: (settle)=>{
            const animations = element.getAnimations?.() ?? [];
            Promise.allSettled(animations.map((animation)=>animation.finished)).then(settle);
        }
    });
}
function $0ac7147025ffe9dd$var$getInitialVisibilityState({ isOpen: isOpen, willAnimate: willAnimate }) {
    if (!isOpen) return {
        phase: 'closed',
        controlledIntent: 'closed'
    };
    if (willAnimate) return {
        phase: 'entering',
        controlledIntent: 'open'
    };
    return {
        phase: 'open',
        controlledIntent: 'open'
    };
}
/**
 * Applies one lifecycle event to the current visibility phase.
 *
 * Events that are stale for the current phase are ignored. This allows
 * animation callbacks and native close events to settle safely after an
 * interrupted lifecycle.
 */ function $0ac7147025ffe9dd$var$getNextVisibilityState(state, action) {
    if (action.type === 'open-requested') {
        const shouldEnter = state.phase === 'closed' || state.phase === 'exiting' && state.controlledIntent === 'closed';
        if (shouldEnter && action.willAnimate) return {
            phase: 'entering',
            controlledIntent: 'open'
        };
        if (shouldEnter) return {
            phase: 'open',
            controlledIntent: 'open'
        };
        return {
            ...state,
            controlledIntent: 'open'
        };
    }
    if (action.type === 'close-requested') return {
        ...state,
        controlledIntent: 'closed'
    };
    if (action.type === 'exit-started') {
        if (state.phase !== 'open' && state.phase !== 'entering') return state;
        return {
            ...state,
            phase: 'exiting'
        };
    }
    // A browser dismiss started the exit, and something showed the element
    // again before the exit settled, while controlled intent stayed open. For
    // example, `@atlaskit/tooltip` re-shows after a light dismiss in the same
    // task. The element never painted closed, so go back to `open`.
    if (action.type === 'native-open-started') {
        if (state.phase !== 'exiting' || state.controlledIntent !== 'open') return state;
        return {
            ...state,
            phase: 'open'
        };
    }
    if (action.type === 'entry-settled') {
        if (state.phase !== 'entering') return state;
        return {
            ...state,
            phase: 'open'
        };
    }
    if (action.type === 'exit-settled') {
        if (state.phase !== 'exiting') return state;
        return {
            ...state,
            phase: 'closed'
        };
    }
    return state;
}
function $0ac7147025ffe9dd$export$1bccb45daf07907f({ isOpen: isOpen, shouldAnimate: shouldAnimate, elementRef: elementRef, onEnterFinish: onEnterFinish, onExitFinish: onExitFinish }) {
    const willAnimate = shouldAnimate && !(0, $3juIE.prefersReducedMotion)();
    const [visibilityState, dispatch] = (0, $fsvuC.useReducer)($0ac7147025ffe9dd$var$getNextVisibilityState, {
        isOpen: isOpen,
        willAnimate: willAnimate
    }, $0ac7147025ffe9dd$var$getInitialVisibilityState);
    const { phase: phase, controlledIntent: controlledIntent } = visibilityState;
    // Keep stable refs to the latest callbacks so effects and animation settlement closures
    // always call the current callback without needing them in dependency arrays.
    const onEnterFinishRef = (0, $fsvuC.useRef)(onEnterFinish);
    const onExitFinishRef = (0, $fsvuC.useRef)(onExitFinish);
    const willAnimateRef = (0, $fsvuC.useRef)(willAnimate);
    (0, $7EsQa.useLayoutEffect)(()=>{
        onEnterFinishRef.current = onEnterFinish;
        onExitFinishRef.current = onExitFinish;
        willAnimateRef.current = willAnimate;
    }, [
        onEnterFinish,
        onExitFinish,
        willAnimate
    ]);
    // Synchronize controlled intent during render so opening mounts the host in
    // the same commit. Keeping the processed intent in reducer state prevents a
    // browser-driven exit from being mistaken for a new controlled open request.
    if (isOpen && controlledIntent === 'closed') dispatch({
        type: 'open-requested',
        willAnimate: willAnimate
    });
    if (!isOpen && controlledIntent === 'open') dispatch({
        type: 'close-requested'
    });
    // Entry can commit `open` before its callback because the host stays mounted.
    // This ensures consumers observe the settled DOM rather than entering styles.
    // Treat the phase before the initial commit as closed so an initially open host
    // notifies consumers.
    const prevPhaseRef = (0, $fsvuC.useRef)('closed');
    (0, $fsvuC.useEffect)(()=>{
        const prevPhase = prevPhaseRef.current;
        prevPhaseRef.current = phase;
        if (prevPhase === phase) return;
        if (phase === 'open') onEnterFinishRef.current?.();
    }, [
        phase
    ]);
    const isMounted = phase !== 'closed';
    const cancelExitSettlementRef = (0, $fsvuC.useRef)(()=>{});
    // Exit must notify consumers before `closed` unmounts the host.
    const settleExit = (0, $fsvuC.useCallback)(()=>{
        onExitFinishRef.current?.();
        dispatch({
            type: 'exit-settled'
        });
    }, []);
    // Primitives bind these stable callbacks to their native lifecycle events.
    // This keeps event ownership at the primitive while the hook owns state transitions.
    const onBeforeToggle = (0, $fsvuC.useCallback)((event)=>{
        // Any native transition supersedes a previous exit snapshot. This prevents
        // a stale settlement from closing a host that is reopening or closing again.
        cancelExitSettlementRef.current();
        // Snapshot currentTarget because the DOM clears it after event dispatch.
        const element = event.currentTarget;
        if (event.newState === 'open') {
            if (element instanceof HTMLElement) {
                element.removeAttribute('inert');
                element.removeAttribute('aria-hidden');
            }
            // Dispatched on every native open. The reducer only acts when a browser
            // dismiss left the host `exiting` while `isOpen` stayed `true`.
            dispatch({
                type: 'native-open-started'
            });
        }
        if (event.newState === 'closed') {
            if (element instanceof HTMLElement) // We use a microtask to let native focus restoration happen before making the element inert.
            // The browser restores focus after beforetoggle returns, during its close steps.
            queueMicrotask(()=>{
                // A controlled close can be interrupted by isOpen changing back to true,
                // which reopens the element before this microtask runs.
                if ((0, $gbYGm.isNativeElementOpen)({
                    element: element
                })) return;
                // Exit animations keep closed content rendered, so make it non-interactive and hide it from assistive technology.
                element.setAttribute('inert', '');
                // Tooling does not consistently treat inert content as hidden, even though the browser does.
                element.setAttribute('aria-hidden', 'true');
            });
            dispatch({
                type: 'exit-started'
            });
        }
    }, []);
    const onToggle = (0, $fsvuC.useCallback)((event)=>{
        if (event.newState !== 'closed') return;
        if (!willAnimateRef.current) {
            cancelExitSettlementRef.current = $0ac7147025ffe9dd$var$runCancellableSettlement({
                schedule: queueMicrotask,
                onSettled: settleExit
            });
            return;
        }
        const element = elementRef.current;
        if (!element) return;
        // The closed `toggle` is task-queued after synchronous `beforetoggle`.
        // Snapshot here so the exiting phase styles have committed and the list
        // represents the animations that actually govern exit settlement.
        cancelExitSettlementRef.current = $0ac7147025ffe9dd$var$runOnAnimationsSettled({
            element: element,
            onSettled: settleExit
        });
    }, [
        elementRef,
        settleExit
    ]);
    (0, $7EsQa.useLayoutEffect)(()=>()=>{
            // Prevent a pending animation or microtask from notifying after unmount.
            cancelExitSettlementRef.current();
        }, []);
    // Entry settlement only removes entering styles. Its callback runs after the
    // resulting `open` commit in the effect above.
    (0, $fsvuC.useEffect)(function settleEntry() {
        if (phase !== 'entering') return;
        if (!willAnimate) {
            dispatch({
                type: 'entry-settled'
            });
            return;
        }
        const element = elementRef.current;
        if (!element) return;
        return $0ac7147025ffe9dd$var$runOnAnimationsSettled({
            element: element,
            onSettled () {
                dispatch({
                    type: 'entry-settled'
                });
            }
        });
    }, [
        phase,
        willAnimate,
        elementRef
    ]);
    return {
        phase: phase,
        isMounted: isMounted,
        onBeforeToggle: onBeforeToggle,
        onToggle: onToggle
    };
}

});
parcelRegister("3juIE", function(module, exports) {
$parcel$export(module.exports, "prefersReducedMotion", () => $54453e8b70f44603$export$ff7706047246b98b);

var $kFwbq = parcelRequire("kFwbq");
const $54453e8b70f44603$export$ff7706047246b98b = (0, $kFwbq.default)(()=>{
    if (typeof window === 'undefined' || !('matchMedia' in window)) return false;
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
});

});


parcelRegister("9K6DR", function(module, exports) {
$parcel$export(module.exports, "useFocusWrap", () => $e987d94d1cb2c59c$export$4f6462e86a70abe5);

var $fsvuC = parcelRequire("fsvuC");

var $dqdTY = parcelRequire("dqdTY");

var $8c95s = parcelRequire("8c95s");

var $aQFwo = parcelRequire("aQFwo");

var $jemDr = parcelRequire("jemDr");

var $4gSKC = parcelRequire("4gSKC");
/**
 * Roles that require focus wrapping per WAI-ARIA APG.
 *
 * - `dialog`: https://www.w3.org/WAI/ARIA/apg/patterns/dialog-modal/
 * - `alertdialog`: same keyboard pattern as dialog
 *
 * `menu` is intentionally excluded. Menus are composite widgets
 * (https://www.w3.org/WAI/ARIA/apg/practices/keyboard-interface/#kbd_general_within)
 * that manage their own internal keyboard navigation via arrow keys,
 * not Tab. Tab/Shift+Tab should move focus OUT of a menu entirely.
 *
 * Menu keyboard behavior (arrow keys, Home/End, type-ahead, Enter/Space)
 * is context-dependent. It varies by orientation, nesting depth, item
 * type, and control pattern (menu button vs menubar). This makes it
 * impossible to implement generically here. The consumer component
 * (e.g. `dropdown-menu`) owns all menu keyboard navigation.
 *
 * See: notes/decisions/menu-keyboard.md
 */ function $e987d94d1cb2c59c$var$roleRequiresFocusWrap(role) {
    return role === 'dialog' || role === 'alertdialog';
}
function $e987d94d1cb2c59c$export$4f6462e86a70abe5({ elementRef: elementRef, role: role, phase: phase }) {
    const isVisible = phase !== 'closed';
    (0, $fsvuC.useEffect)(()=>{
        const element = elementRef.current;
        if (!element || !$e987d94d1cb2c59c$var$roleRequiresFocusWrap(role) || !isVisible) return;
        const unbind = (0, $dqdTY.bind)(element, {
            type: 'keydown',
            listener: (event)=>{
                if (event.key !== 'Tab') return;
                // If focus is already in a nested layer, then
                // we continue to let that nested layer own focus
                if ((0, $4gSKC.isNestedLayerFocused)({
                    container: element
                })) return;
                // Prevent the browser giving focus to where it wants to
                // (we will be handling it, including with wrapping)
                event.preventDefault();
                const direction = event.shiftKey ? 'backwards' : 'forwards';
                // Try to move to the next/previous focusable element relative
                // to the currently focused element within the container.
                const next = (0, $jemDr.getNextFocusable)({
                    container: element,
                    direction: direction
                });
                if (next) {
                    next.focus();
                    return;
                }
                // Nothing is currently focused inside the container (or the
                // focused element is not in the focusable list). Fall back to
                // the first or last focusable element depending on direction.
                const fallback = direction === 'forwards' ? (0, $8c95s.getFirstFocusable)({
                    container: element
                }) : (0, $aQFwo.getLastFocusable)({
                    container: element
                });
                if (fallback) fallback.focus();
            },
            options: {
                capture: true
            }
        });
        return unbind;
    }, [
        elementRef,
        role,
        isVisible
    ]);
}

});
parcelRegister("8c95s", function(module, exports) {
$parcel$export(module.exports, "getFirstFocusable", () => $db9d14f4753eec4d$export$748138f04a69bf21);

var $6hNv6 = parcelRequire("6hNv6");
function $db9d14f4753eec4d$export$748138f04a69bf21({ container: container, filter: filter }) {
    const items = (0, $6hNv6.getFocusables)({
        container: container,
        filter: filter
    });
    return items.length > 0 ? items[0] : null;
}

});
parcelRegister("6hNv6", function(module, exports) {
$parcel$export(module.exports, "getFocusables", () => $96847f98fce94d5c$export$f6768025e418420e);

var $bVsxN = parcelRequire("bVsxN");
const $96847f98fce94d5c$var$focusableExclusions = [
    '[tabindex="-1"]',
    ':disabled',
    '[aria-disabled="true"]',
    '[aria-hidden="true"]'
];
const $96847f98fce94d5c$var$exclusionSelector = $96847f98fce94d5c$var$focusableExclusions.map((selector)=>`:not(${selector})`).join('');
const $96847f98fce94d5c$var$focusableSelector = [
    'a[href]',
    'area[href]',
    'input:not([type="hidden"])',
    'select',
    'textarea',
    'button',
    'iframe',
    'audio[controls]',
    'video[controls]',
    '[contenteditable]:not([contenteditable="false"])',
    '[tabindex]'
].map((selector)=>`${selector}${$96847f98fce94d5c$var$exclusionSelector}`).join(',');
function $96847f98fce94d5c$var$isVisible(element) {
    // Visibility filtering must not break focus navigation when the API is unsupported.
    if (typeof element.checkVisibility !== 'function') return true;
    try {
        // Exclude elements hidden by display, content-visibility or visibility because
        // they cannot receive focus. Offscreen, occluded and opacity-zero elements can
        // receive focus, so they intentionally remain included.
        return element.checkVisibility({
            checkVisibilityCSS: true
        });
    } catch  {
        return true;
    }
}
function $96847f98fce94d5c$export$f6768025e418420e({ container: container, filter: filter }) {
    const containerLayer = (0, $bVsxN.getClosestLayer)({
        element: container
    });
    return Array.from(container.querySelectorAll($96847f98fce94d5c$var$focusableSelector)).filter((element)=>{
        if (!(element instanceof HTMLElement)) return false;
        if ((0, $bVsxN.getClosestLayer)({
            element: element
        }) !== containerLayer) return false;
        if (element.closest('[inert]')) return false;
        if (!$96847f98fce94d5c$var$isVisible(element)) return false;
        return !filter || filter(element, container);
    });
}

});
parcelRegister("bVsxN", function(module, exports) {
$parcel$export(module.exports, "getClosestLayer", () => $7f672e5a39c1b466$export$3c9385904be131db);
function $7f672e5a39c1b466$export$3c9385904be131db({ element: element }) {
    return element.closest('[popover], dialog');
}

});



parcelRegister("aQFwo", function(module, exports) {
$parcel$export(module.exports, "getLastFocusable", () => $7d1bc77d1139fb67$export$73e81fa65335a75b);

var $6hNv6 = parcelRequire("6hNv6");
function $7d1bc77d1139fb67$export$73e81fa65335a75b({ container: container, filter: filter }) {
    const items = (0, $6hNv6.getFocusables)({
        container: container,
        filter: filter
    });
    return items.length > 0 ? items[items.length - 1] : null;
}

});

parcelRegister("jemDr", function(module, exports) {
$parcel$export(module.exports, "getNextFocusable", () => $82ec63e3f5000755$export$a7db88e6d491b450);
/**
 * Returns the next focusable element in the given direction relative to the
 * currently focused element within the container. Wraps around at both ends.
 *
 * The currently focused element does not need to be tabbable. This prevents
 * navigation from getting stuck on an element that was programmatically or
 * pointer focused with `tabindex="-1"`. Negative-tab-index elements remain
 * excluded as destinations.
 *
 * Returns `null` if there is no focused element within the container.
 */ 
var $6hNv6 = parcelRequire("6hNv6");
function $82ec63e3f5000755$export$a7db88e6d491b450({ container: container, direction: direction, filter: filter }) {
    const all = (0, $6hNv6.getFocusables)({
        container: container,
        filter: filter
    });
    const first = all[0];
    const last = all[all.length - 1];
    // Checking the elements directly narrows types from `HTMLElement | undefined`.
    if (!first || !last) return null;
    const current = container.ownerDocument.activeElement;
    if (!(current instanceof HTMLElement) || !container.contains(current)) return null;
    const index = all.indexOf(current);
    // The focused element can be absent from `all` when it is non-tabbable or
    // excluded by the filter. Find the first focusable element that follows it in
    // the DOM, which identifies the nearest focusable destination in either direction.
    if (index === -1) {
        const followingIndex = all.findIndex((element)=>Boolean(current.compareDocumentPosition(element) & current.DOCUMENT_POSITION_FOLLOWING));
        if (direction === 'forwards') // If nothing follows the current element, then wrap to the start.
        return all[followingIndex] ?? first;
        // The closest preceding element is immediately before the first following one.
        // A missing adjacent entry means the backward sequence wraps to the end.
        return all[followingIndex - 1] ?? last;
    }
    // The current element is tabbable, so use its adjacent list entry and wrap
    // when it is already at the boundary.
    if (direction === 'forwards') return all[index + 1] ?? first;
    return all[index - 1] ?? last;
}

});

parcelRegister("4gSKC", function(module, exports) {
$parcel$export(module.exports, "isNestedLayerFocused", () => $733a1422ccea62cf$export$b9590fdfeb5f722f);

var $bVsxN = parcelRequire("bVsxN");
function $733a1422ccea62cf$export$b9590fdfeb5f722f({ container: container }) {
    const focused = container.ownerDocument.activeElement;
    if (!(focused instanceof HTMLElement)) return false;
    // Cannot be in a nested layer if it is not in the container
    if (!container.contains(focused)) return false;
    // If not in the same layer, must be in a nested layer
    return (0, $bVsxN.getClosestLayer)({
        element: focused
    }) !== (0, $bVsxN.getClosestLayer)({
        element: container
    });
}

});


parcelRegister("5hREl", function(module, exports) {
$parcel$export(module.exports, "useInitialFocus", () => $f11f546f8779e22d$export$e992c40175757a22);

var $fsvuC = parcelRequire("fsvuC");

var $7EsQa = parcelRequire("7EsQa");

var $8c95s = parcelRequire("8c95s");
/**
 * Determines the correct element to receive initial focus within a popover,
 * based on its ARIA role.
 *
 * Focus rules by role (per WAI-ARIA APG):
 * - `dialog` / `alertdialog`: first element with `[autofocus]`, or first focusable element
 * - `menu`: first menu item (`[role="menuitem|menuitemcheckbox|menuitemradio"]`)
 * - `listbox`: first selected option (`[aria-selected="true"]`), or first option (`[role="option"]`)
 * - `tooltip`: no focus movement (tooltips are informational)
 * - no role / other roles: no focus movement
 *
 * Note: React 18's `autoFocus` JSX prop does NOT set the HTML `autofocus`
 * attribute - it only calls `.focus()` imperatively during commit, which
 * has no effect on hidden popover content. Consumers must set the native
 * attribute via a ref callback (e.g. `node.setAttribute('autofocus', '')`).
 * React 19+ reflects the JSX prop as the HTML attribute automatically.
 *
 * Combobox pattern exception: if the popup is controlled by a focused
 * combobox-like trigger (its `aria-controls` references this popup),
 * focus stays on the textbox. This applies to `menu`, `listbox`, and to
 * `dialog` / `alertdialog` when the combobox is outside the dialog. See
 * `isComboboxControllingPopup`.
 */ /**
 * WAI-ARIA APG Combobox Pattern: when a combobox controls a popup (listbox,
 * grid, tree, menu, or dialog), DOM focus must remain on the textbox. Subsequent
 * navigation through popup items uses `aria-activedescendant` (or proxied
 * keyboard events), never DOM focus movement.
 *
 * Detects both variants in a single pass:
 * - In-popup combobox: the textbox lives inside the popup `container`
 *   (the popup is rendered as a child of the combobox wrapper).
 * - External combobox: the textbox is rendered OUTSIDE the popup
 *   (`react-select` pattern, where the listbox is portalled separately
 *   from the textbox).
 *
 * Acceptance criteria for the active element:
 * - Role / element-type filter: `role="combobox"`, `role="textbox"`,
 *   `TEXTAREA`, `contentEditable`, or `INPUT` of text-like type
 *   (`text`, `search`, `email`, `url`, `tel`, `password`, or
 *   unspecified). Non-text input types (`button`, `checkbox`, etc.)
 *   are rejected.
 * - Reference filter: `aria-controls` (or legacy `aria-owns`) IDREFS
 *   must resolve to an element that IS or CONTAINS the popup container.
 *
 * See: https://www.w3.org/WAI/ARIA/apg/patterns/combobox/
 */ // `<input>` types treated as text-like for combobox detection.
// Non-text input types (`button`, `checkbox`, `submit`, etc.) are rejected.
// A missing `type` attribute defaults to `text` per the HTML spec, so we
// normalize that case before lookup rather than including an empty string here.
const $f11f546f8779e22d$var$TEXT_LIKE_INPUT_TYPES = new Set([
    'text',
    'search',
    'email',
    'url',
    'tel',
    'password'
]);
function $f11f546f8779e22d$var$isTextboxLikeElement(element) {
    const role = element.getAttribute('role');
    if (role === 'combobox' || role === 'textbox') return true;
    // `tagName` is uppercase for HTML elements but can be mixed-case for
    // XML/SVG. Normalize once so downstream comparisons stay lowercase.
    const tag = element.tagName.toLowerCase();
    if (tag === 'textarea') return true;
    if (element.isContentEditable) return true;
    if (tag === 'input') {
        const type = (element.getAttribute('type') ?? 'text').toLowerCase();
        return $f11f546f8779e22d$var$TEXT_LIKE_INPUT_TYPES.has(type);
    }
    return false;
}
function $f11f546f8779e22d$var$isComboboxControllingPopup({ container: container }) {
    const ownerDocument = container.ownerDocument;
    const active = ownerDocument.activeElement;
    if (!(active instanceof HTMLElement)) return false;
    if (!$f11f546f8779e22d$var$isTextboxLikeElement(active)) return false;
    // Accept legacy `aria-owns` in addition to `aria-controls`.
    // `aria-controls` / `aria-owns` are IDREFS (space-separated list of IDs)
    // per the WAI-ARIA spec, so we must split and check membership rather
    // than comparing with strict equality. A combobox that controls both
    // this popup and another element (e.g. a results status region) must
    // still be recognised as controlling this popup.
    const idRefs = active.getAttribute('aria-controls') ?? active.getAttribute('aria-owns');
    if (!idRefs) return false;
    // Match if any referenced element IS, CONTAINS, or IS CONTAINED BY the
    // popup container. The "contained by" case covers wrapper-style adopters
    // like react-select, where the combobox input's `aria-controls` points at
    // a listbox element that is a descendant of the Popover host (the
    // listbox role lives on a child the wrapped library owns, not on the
    // host we render).
    const referencedIds = idRefs.split(/\s+/).filter((id)=>id !== '');
    return referencedIds.some((id)=>{
        const referenced = ownerDocument.getElementById(id);
        if (!referenced) return false;
        return referenced === container || referenced.contains(container) || container.contains(referenced);
    });
}
/**
 * The `initialFocusRef` override target, when it is inside the popover. A
 * target outside the popover (or not in the DOM) is ignored, so the role
 * default applies.
 */ function $f11f546f8779e22d$var$getOverrideTarget({ container: container, initialFocusRef: initialFocusRef }) {
    const target = initialFocusRef?.current;
    if (target && container.contains(target)) return target;
    return null;
}
function $f11f546f8779e22d$var$getInitialFocusTarget({ container: container, initialFocusRef: initialFocusRef, role: role }) {
    // In each role branch, the combobox carve-out decides whether focus moves.
    // The override target, then the role default, decides where.
    if (role === 'dialog' || role === 'alertdialog') {
        // APG allows a combobox to control a dialog popup. Focus stays on the
        // combobox only when it is OUTSIDE the dialog. A dialog that contains
        // its own combobox still takes focus (see the comment below on why the
        // carve-out is per-role).
        if (!container.contains(container.ownerDocument.activeElement) && $f11f546f8779e22d$var$isComboboxControllingPopup({
            container: container
        })) return null;
        const overrideTarget = $f11f546f8779e22d$var$getOverrideTarget({
            container: container,
            initialFocusRef: initialFocusRef
        });
        if (overrideTarget) return overrideTarget;
        // Prefer element with the native HTML autofocus attribute.
        const autofocusEl = container.querySelector('[autofocus]');
        if (autofocusEl) return autofocusEl;
        // Fall back to first focusable element
        return (0, $8c95s.getFirstFocusable)({
            container: container
        });
    }
    // The combobox carve-out is kept role-specific rather than hoisted.
    // Hoisting it over-matched on dialog popups that contain a nested
    // combobox (e.g. datetime-picker's dialog hosts a react-select), where
    // the active combobox's `aria-controls` falsely matched the container
    // and suppressed the dialog's own focus contract. The dialog branch
    // above therefore skips only for a combobox outside the dialog.
    if (role === 'menu') {
        if ($f11f546f8779e22d$var$isComboboxControllingPopup({
            container: container
        })) return null;
        const overrideTarget = $f11f546f8779e22d$var$getOverrideTarget({
            container: container,
            initialFocusRef: initialFocusRef
        });
        if (overrideTarget) return overrideTarget;
        // Initial focus placement is the extent of what top-layer provides
        // for menus. All subsequent keyboard navigation (arrow keys, Home/End,
        // type-ahead, Enter/Space, submenu coordination) is the responsibility
        // of the consumer component (e.g. dropdown-menu), because menu keyboard
        // behavior varies by context (orientation, nesting, item type, control
        // pattern). See: notes/decisions/menu-keyboard.md
        return (0, $8c95s.getFirstFocusable)({
            container: container
        });
    }
    if (role === 'listbox') {
        // ARIA Combobox Pattern: if a combobox-like textbox owns the popup
        // (in-popup or external e.g. react-select), leave focus on the
        // textbox - navigation is proxied through it.
        if ($f11f546f8779e22d$var$isComboboxControllingPopup({
            container: container
        })) return null;
        const overrideTarget = $f11f546f8779e22d$var$getOverrideTarget({
            container: container,
            initialFocusRef: initialFocusRef
        });
        if (overrideTarget) return overrideTarget;
        // Prefer the selected option, then fall back to the first option.
        // We intentionally match by `[role="option"]` rather than by
        // `getFirstFocusable`. The standard WAI-ARIA APG listbox pattern
        // renders options with `tabindex="-1"` (managed via roving
        // tabindex); `getFirstFocusable` excludes `tabindex="-1"` elements
        // and would silently lose initial focus for spec-conformant
        // listboxes. Options remain programmatically focusable.
        const selectedOption = container.querySelector('[role="option"][aria-selected="true"]');
        if (selectedOption) return selectedOption;
        const firstOption = container.querySelector('[role="option"]');
        if (firstOption) return firstOption;
        // Last resort for non-standard listboxes that render no options
        // but do contain a focusable element (e.g. an empty-state action).
        return (0, $8c95s.getFirstFocusable)({
            container: container
        });
    }
    // tooltip, no role, or other roles: no focus movement
    return null;
}
function $f11f546f8779e22d$export$e992c40175757a22({ elementRef: elementRef, initialFocusRef: initialFocusRef, phase: phase, role: role }) {
    // Track the previous phase so we only focus on transitions into a
    // visible phase from either `'closed'` (fresh mount) or `'exiting'`
    // (mid-exit reopen where the browser has already restored focus to
    // the trigger). Pure `entering → exiting → entering` stutters where
    // the consumer toggles in the same frame are still collapsed.
    const prevPhaseRef = (0, $fsvuC.useRef)('closed');
    (0, $7EsQa.useLayoutEffect)(()=>{
        const prevPhase = prevPhaseRef.current;
        prevPhaseRef.current = phase;
        // Only focus on transitions into a visible phase from `'closed'`
        // (fresh open) or `'exiting'` (mid-exit reopen).
        if (phase === 'closed') return;
        if (prevPhase !== 'closed' && prevPhase !== 'exiting') return;
        const element = elementRef.current;
        if (!element) return;
        $f11f546f8779e22d$var$getInitialFocusTarget({
            container: element,
            initialFocusRef: initialFocusRef,
            role: role
        })?.focus();
    }, [
        elementRef,
        initialFocusRef,
        phase,
        role
    ]);
}

});


parcelRegister("gc525", function(module, exports) {
$parcel$export(module.exports, "useAnchoredPopover", () => $f0b193f8ff03cd85$export$147d8888d96bf7a3);
/**
 * Positioning AND anchor-relative sizing for top-layer popovers. Anchors an
 * ELEMENT; to anchor a viewport coordinate use `useAnchoredPopoverAtPoint`.
 *
 * Two runtime paths, each a function that applies its styles and returns the
 * cleanup: CSS Anchor Positioning in `./anchor-positioning`, and the JavaScript
 * fallback in `./javascript-fallback`. The path is resolved ONCE, at the top of
 * the hook, and threaded through positioning, sizing and margins.
 *
 * See `notes/architecture/positioning.md` and
 * `notes/decisions/fit-available-space.md`.
 */ 
var $fsvuC = parcelRequire("fsvuC");

var $cTXsj = parcelRequire("cTXsj");

var $7EsQa = parcelRequire("7EsQa");

var $3K2wK = parcelRequire("3K2wK");

var $bKey1 = parcelRequire("bKey1");

var $1BzD7 = parcelRequire("1BzD7");

var $99cJP = parcelRequire("99cJP");

var $bpyYQ = parcelRequire("bpyYQ");

var $dufKD = parcelRequire("dufKD");
/**
 * Which way the popover's inline axis runs. Maps every physical measurement below
 * onto a logical axis: the viewport unit of each cap and the anchor's measured
 * size. A style read, not a layout read, so it is cheap enough to take for every
 * popover.
 */ function $f0b193f8ff03cd85$var$getPopoverWritingMode({ popover: popover }) {
    // `String()` because not every test environment implements `writing-mode`.
    const writingMode = String(getComputedStyle(popover).writingMode);
    const isVertical = writingMode.startsWith('vertical') || writingMode.startsWith('sideways');
    return isVertical ? 'vertical' : 'horizontal';
}
/**
 * Measured stand-in for `anchor-size(self-*)`, used wherever `anchor-size()` is
 * not: the JavaScript fallback, and browsers with anchor positioning but no
 * `anchor-size()`.
 *
 * `offsetWidth` / `offsetHeight` are physical, so the axis is picked from the
 * POPOVER's `writing-mode`. Deliberately not memoized: a cached anchor size is a
 * stale one. Runs once per effect, not per frame.
 */ function $f0b193f8ff03cd85$var$measureAnchorSize({ anchor: anchor, writingMode: writingMode }) {
    if (writingMode === 'vertical') return {
        inline: `${anchor.offsetHeight}px`,
        block: `${anchor.offsetWidth}px`
    };
    return {
        inline: `${anchor.offsetWidth}px`,
        block: `${anchor.offsetHeight}px`
    };
}
const $f0b193f8ff03cd85$var$NO_ANCHOR_SIZE = {
    inline: null,
    block: null
};
const $f0b193f8ff03cd85$var$CSS_ANCHOR_SIZE = {
    inline: 'anchor-size(self-inline)',
    block: 'anchor-size(self-block)'
};
function $f0b193f8ff03cd85$var$isAnchorRelative(size) {
    return size === 'match-anchor' || size === 'min-anchor';
}
/**
 * The `anchor-name` written to an anchor that does not already carry one, as a CSS
 * `<dashed-ident>`. `useId()` is the same source as every other id in the design
 * system, including the popover's own `id` that `aria-controls` and `popovertarget`
 * point at, so it is unique exactly where those are and collides exactly where
 * they do. See `useAnchoredPopover` for the one case that needs the host's help.
 *
 * `@atlaskit/ds-lib`'s `useId` already swaps React's `:` and `«»` for `_`. The
 * replace covers a host `identifierPrefix`, which may carry characters a
 * `<dashed-ident>` cannot.
 */ function $f0b193f8ff03cd85$var$useNewAnchorName() {
    const id = (0, $cTXsj.useId)();
    return (0, $fsvuC.useMemo)(()=>`--anchor-${id.replace(/[^A-Za-z0-9_-]/g, '_')}`, [
        id
    ]);
}
/**
 * A referentially-stable, fully-resolved `TPlacement`, so a fresh inline
 * `placement` object does not re-run the effect.
 */ function $f0b193f8ff03cd85$var$useStablePlacement(placement) {
    const resolved = (0, $99cJP.resolvePlacement)({
        placement: placement
    });
    const axis = resolved.axis;
    const edge = resolved.edge;
    const align = resolved.align;
    const minSize = resolved.minSize;
    const gap = resolved.offset.gap;
    const shiftValue = resolved.offset.crossAxisShift.value;
    const shiftDirection = resolved.offset.crossAxisShift.direction;
    // Rebuilt from primitive deps, so the factory does not close over `resolved`
    // and exhaustive-deps can verify it.
    return (0, $fsvuC.useMemo)(()=>({
            axis: axis,
            edge: edge,
            align: align,
            minSize: minSize,
            offset: {
                gap: gap,
                crossAxisShift: {
                    value: shiftValue,
                    direction: shiftDirection
                }
            }
        }), [
        axis,
        edge,
        align,
        minSize,
        gap,
        shiftValue,
        shiftDirection
    ]);
}
function $f0b193f8ff03cd85$export$147d8888d96bf7a3({ anchorRef: anchorRef, popoverRef: popoverRef, placement: placement, isOpen: isOpen, isEnabled: isEnabled = true, inlineSize: inlineSize = 'content', blockSize: blockSize = 'content', shouldPreserveInlineSize: shouldPreserveInlineSize = false, forceFallbackPositioning: forceFallbackPositioning = false }) {
    // Stable for the life of the hook instance, so it follows a replacement anchor
    // element (the point hook remounts its `<div>`).
    const fallbackAnchorName = $f0b193f8ff03cd85$var$useNewAnchorName();
    const stablePlacement = $f0b193f8ff03cd85$var$useStablePlacement(placement);
    (0, $7EsQa.useLayoutEffect)(()=>{
        if (!isEnabled) return;
        // Resolved once, so positioning, sizing and margins cannot disagree about it.
        const isUsingCssAnchorPositioning = (0, $bpyYQ.supportsAnchorPositioning)() && !forceFallbackPositioning;
        // BOTH probes: a browser can have positioning without sizing, and
        // `anchor-size()` needs the `position-anchor` only the CSS path writes.
        const canUseAnchorSize = isUsingCssAnchorPositioning && (0, $dufKD.supportsAnchorSize)();
        const trigger = anchorRef.current;
        const popover = popoverRef.current;
        if (!trigger || !popover) return;
        // Fitting also reserves padding from the viewport edge as a margin.
        const isFitting = inlineSize === 'max-available' || blockSize === 'max-available';
        // Always read: the viewport caps are always written, and their unit follows
        // the popover's writing mode.
        const writingMode = $f0b193f8ff03cd85$var$getPopoverWritingMode({
            popover: popover
        });
        // Skipped where possible, so a position-only consumer pays no layout read.
        // Fitting on the CSS path needs it to clamp the default flip floor; see
        // `getDefaultPlacementAxisFloor`.
        const needsAnchorSize = $f0b193f8ff03cd85$var$isAnchorRelative(inlineSize) || $f0b193f8ff03cd85$var$isAnchorRelative(blockSize) || isFitting && isUsingCssAnchorPositioning;
        const anchorSize = needsAnchorSize ? canUseAnchorSize ? $f0b193f8ff03cd85$var$CSS_ANCHOR_SIZE : $f0b193f8ff03cd85$var$measureAnchorSize({
            anchor: trigger,
            writingMode: writingMode
        }) : $f0b193f8ff03cd85$var$NO_ANCHOR_SIZE;
        const sizeStyles = (0, $bKey1.getAnchoredPopoverSizeDeclarations)({
            placement: stablePlacement,
            inlineSize: inlineSize,
            blockSize: blockSize,
            isUsingCssAnchorPositioning: isUsingCssAnchorPositioning,
            anchorSize: anchorSize,
            writingMode: writingMode,
            shouldPreserveInlineSize: shouldPreserveInlineSize
        });
        if (isUsingCssAnchorPositioning) return (0, $3K2wK.applyAnchorPositioning)({
            anchor: trigger,
            popover: popover,
            placement: stablePlacement,
            sizeStyles: sizeStyles,
            isFitting: isFitting,
            fallbackAnchorName: fallbackAnchorName
        });
        return (0, $1BzD7.applyJavaScriptFallbackPositioning)({
            anchor: trigger,
            popover: popover,
            placement: stablePlacement,
            sizeStyles: sizeStyles
        });
    }, [
        isEnabled,
        anchorRef,
        popoverRef,
        stablePlacement,
        inlineSize,
        blockSize,
        shouldPreserveInlineSize,
        fallbackAnchorName,
        forceFallbackPositioning,
        isOpen
    ]);
}

});
parcelRegister("cTXsj", function(module, exports) {
$parcel$export(module.exports, "useId", () => $b07f2121c03fb04e$export$f680877a34711e37);

var $fsvuC = parcelRequire("fsvuC");
function $b07f2121c03fb04e$export$f680877a34711e37() {
    // React uses `:` or `«»` in selectors which breaks `document.querySelector(…)`.
    // Replace with `_` to match future React 19 functionality.
    return (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).useId().replace(/[:«»]/g, '_');
}

});

parcelRegister("3K2wK", function(module, exports) {
$parcel$export(module.exports, "applyAnchorPositioning", () => $60791b9d752a1564$export$50da8074e1408934);
/**
 * The CSS Anchor Positioning path: `position-anchor`, `position-area`,
 * `position-try-fallbacks` and the gap / shift margins, all declared on the
 * popover so the browser owns placement and flipping. The twin of
 * `../javascript-fallback/apply-javascript-fallback-positioning`.
 */ 
var $htvvG = parcelRequire("htvvG");

var $fwdgk = parcelRequire("fwdgk");

var $5q1sW = parcelRequire("5q1sW");

var $8aoIQ = parcelRequire("8aoIQ");

var $fI4Zu = parcelRequire("fI4Zu");

var $gUfNg = parcelRequire("gUfNg");

var $7QFax = parcelRequire("7QFax");
function $60791b9d752a1564$export$50da8074e1408934({ anchor: anchor, popover: popover, placement: placement, sizeStyles: sizeStyles, isFitting: isFitting, fallbackAnchorName: fallbackAnchorName }) {
    // Reuse rather than mint: another popover may already be anchored to it, or a
    // CONSUMER may have set it on their own element, as `post-office` does.
    const existingAnchorName = (0, $fI4Zu.getExistingAnchorName)(anchor);
    const anchorName = existingAnchorName ?? fallbackAnchorName;
    const gap = (0, $5q1sW.edgeMargin)({
        placement: placement,
        offset: placement.offset.gap
    });
    const crossAxisShift = (0, $fwdgk.crossAxisShiftMargins)({
        placement: placement,
        crossAxisShiftCssValue: placement.offset.crossAxisShift.value,
        direction: placement.offset.crossAxisShift.direction
    });
    const popoverStyles = [
        {
            property: 'position-anchor',
            value: anchorName
        },
        {
            property: 'position-area',
            value: (0, $gUfNg.placementToPositionArea)({
                placement: placement
            })
        },
        {
            property: 'position-try-fallbacks',
            value: (0, $7QFax.placementToTryFallbacks)({
                placement: placement
            })
        },
        /**
		 * **`position-visibility: always`**
		 *
		 * `position-visibility` is used to control the visibility of an anchored
		 * popover based on the visibility of the element being anchored to (the target).
		 *
		 * Default `position-visibility` value: `anchors-visible` → hide the anchored
		 * popover when the target is fully clipped by an ancestor (eg a scroll container)
		 * or is `visibility:hidden`.
		 * Sadly this "automatic hiding" does not actually "close" the popover,
		 * so things like `:popover-open` are still active, even though the popover
		 * is no longer painted and no longer receives pointer input. Chrome keeps it
		 * focusable and in the accessibility tree, so keyboard and screen reader users
		 * can still land inside a surface that is not painted.
		 * Per-engine behaviour: `notes/decisions/position-visibility-always.md`.
		 *
		 * Generally we have not run into issues with the default (`anchors-visible`)
		 *
		 * Exceptions:
		 *  - Target is intentionally not visible (eg `position:absolute` moving it outside of
		 *    its parent's "clipped boundary", or a `visibility:hidden` trigger)
		 *  - A trigger is scrolled out of its scroll container while the popover is open.
		 *
		 * We are switching from `anchors-visible` → `always` _for now_ to force no
		 * automatic hiding of the popover. There seems to be no compelling reason to use
		 * the default value. If one arises in the future, we could look towards making
		 *  this behaviour configurable.
		 */ {
            property: 'position-visibility',
            value: 'always'
        },
        // Reset browser default popover positioning that conflicts
        // with anchor positioning (UA: `inset: 0; margin: auto;`)
        {
            property: 'margin',
            value: '0'
        },
        {
            property: 'inset',
            value: 'auto'
        },
        gap,
        // When fitting, the shift margins come back COMPOSED with the reserved
        // viewport padding, rather than being written twice.
        ...isFitting ? (0, $8aoIQ.getFitMarginDeclarations)({
            placement: placement,
            crossAxisShiftMargins: crossAxisShift
        }) : crossAxisShift,
        ...sizeStyles
    ];
    // Anchor names are never cleaned up: multiple popovers can share an anchor,
    // and even with reference counting an async React update could remove the name
    // while something else still uses it. See
    // `notes/decisions/anchor-name-lifetime.md`. Only written when minted: a name
    // from a stylesheet may be a list, which an inline copy of its first entry
    // would collapse.
    if (existingAnchorName === null) anchor.style.setProperty('anchor-name', anchorName);
    return (0, $htvvG.setStyle)({
        element: popover,
        styles: popoverStyles
    });
}

});
parcelRegister("htvvG", function(module, exports) {
$parcel$export(module.exports, "setStyle", () => $80297bed685c43d3$export$37a5fde709c1db82);
/**
 * A single inline style declaration.
 *
 * `TProperty` narrows the property name for callers that write a known, closed
 * set of properties. Narrowing it lets a record keyed on those same names be
 * checked for exhaustiveness at compile time, rather than silently resolving to
 * `undefined` for a name that was never mapped.
 */ function $80297bed685c43d3$export$37a5fde709c1db82({ element: element, styles: styles }) {
    // Snapshot the prior inline value (NOT the computed style - we only want
    // to restore values that the consumer/our previous run inlined). An empty
    // string means "no inline value", in which case cleanup uses removeProperty.
    const priorValues = styles.map(({ property: property })=>({
            property: property,
            value: element.style.getPropertyValue(property)
        }));
    styles.forEach(({ property: property, value: value })=>{
        element.style.setProperty(property, value);
    });
    return function cleanup() {
        priorValues.forEach(({ property: property, value: value })=>{
            if (value === '') {
                element.style.removeProperty(property);
                return;
            }
            element.style.setProperty(property, value);
        });
    };
}

});

parcelRegister("fwdgk", function(module, exports) {
$parcel$export(module.exports, "crossAxisShiftMargins", () => $55b1c41d3a5e4a68$export$f7505ccec0897ae3);
function $55b1c41d3a5e4a68$export$f7505ccec0897ae3({ placement: placement, crossAxisShiftCssValue: crossAxisShiftCssValue, direction: direction }) {
    const crossAxis = placement.axis === 'block' ? 'inline' : 'block';
    // `calc()` rather than JavaScript math, so opaque values such as design tokens
    // negate correctly.
    const negated = `calc(-1 * ${crossAxisShiftCssValue})`;
    const isForwards = direction === 'forwards';
    return [
        {
            property: `margin-${crossAxis}-start`,
            value: isForwards ? crossAxisShiftCssValue : negated
        },
        {
            property: `margin-${crossAxis}-end`,
            value: isForwards ? negated : crossAxisShiftCssValue
        }
    ];
}

});

parcelRegister("5q1sW", function(module, exports) {
$parcel$export(module.exports, "edgeMargin", () => $d1553f9c13a35883$export$b94d052c6b40496);
function $d1553f9c13a35883$export$b94d052c6b40496({ placement: placement, offset: offset }) {
    const { axis: axis, edge: edge } = placement;
    // The side FACING the anchor is always opposite the placement edge.
    const anchorFacingEdge = edge === 'end' ? 'start' : 'end';
    return {
        property: `margin-${axis}-${anchorFacingEdge}`,
        value: offset
    };
}

});

parcelRegister("8aoIQ", function(module, exports) {
$parcel$export(module.exports, "getFitMarginDeclarations", () => $af4b364e2c8ea3c3$export$a7ffde4a856e8d8e);

var $bKey1 = parcelRequire("bKey1");
/**
 * The cross-axis sides that face the viewport rather than the anchor, and so take
 * the reserved padding.
 *
 * A `span-*` cell aligns the popover's MARGIN box to the anchor's edge, so padding
 * on the anchor-facing side does not reserve space at the viewport: it insets the
 * border box from the edge the consumer asked it to line up with. A centred
 * popover has no anchor-facing side, and padding both keeps the shift pair
 * antisymmetric so `anchor-center` still centres.
 *
 * Known cost: the slide fallbacks do not swap the inline margins the way
 * `flip-inline` does, so a slid popover keeps its padding on the anchor side (or,
 * re-centred, sits 2.5px off centre). Alignment in the requested position wins.
 */ function $af4b364e2c8ea3c3$var$viewportFacingCrossAxisSides({ align: align }) {
    if (align === 'center') return [
        'start',
        'end'
    ];
    // `align: 'start'` sits on the anchor's start edge and expands toward end.
    return [
        align === 'start' ? 'end' : 'start'
    ];
}
function $af4b364e2c8ea3c3$export$a7ffde4a856e8d8e({ placement: placement, crossAxisShiftMargins: crossAxisShiftMargins }) {
    const crossAxis = placement.axis === 'block' ? 'inline' : 'block';
    const paddedProperties = new Set($af4b364e2c8ea3c3$var$viewportFacingCrossAxisSides({
        align: placement.align
    }).map((side)=>`margin-${crossAxis}-${side}`));
    return [
        {
            property: `margin-${placement.axis}-${placement.edge}`,
            value: (0, $bKey1.VIEWPORT_PADDING)
        },
        ...crossAxisShiftMargins.map(({ property: property, value: value })=>paddedProperties.has(property) ? {
                property: property,
                value: `calc(${value} + ${0, $bKey1.VIEWPORT_PADDING})`
            } : {
                property: property,
                value: value
            })
    ];
}

});
parcelRegister("bKey1", function(module, exports) {
$parcel$export(module.exports, "VIEWPORT_PADDING", () => $80b64ba2cf889489$export$9f2fdbacbc62226e);
$parcel$export(module.exports, "getAnchoredPopoverSizeDeclarations", () => $80b64ba2cf889489$export$860b30329fa0b990);
const $80b64ba2cf889489$export$9f2fdbacbc62226e = '5px';
const $80b64ba2cf889489$export$32ab78b2bb853a01 = '150px';
/**
 * The dynamic viewport unit for one of the popover's axes. Not `dvi` / `dvb`:
 * css-values-4 defines those against the ROOT element's writing mode, while the
 * `max-{axis}-size` they are written to follows the popover's, so a popover in a
 * `vertical-rl` subtree of a horizontal document would be capped by the wrong
 * dimension.
 */ function $80b64ba2cf889489$var$viewportUnit({ axis: axis, writingMode: writingMode }) {
    const isHorizontalAxis = axis === 'inline' === (writingMode === 'horizontal');
    return isHorizontalAxis ? 'dvw' : 'dvh';
}
function $80b64ba2cf889489$var$getCrossAxis(axis) {
    return axis === 'block' ? 'inline' : 'block';
}
/**
 * The whole viewport, less the reserved padding on both sides. Rule 3's backstop.
 */ function $80b64ba2cf889489$var$viewportCap({ axis: axis, writingMode: writingMode }) {
    return `calc(100${$80b64ba2cf889489$var$viewportUnit({
        axis: axis,
        writingMode: writingMode
    })} - 2 * ${$80b64ba2cf889489$export$9f2fdbacbc62226e})`;
}
/**
 * The position-area cell cap, for the placement axis only. The host carries
 * `position-area`, so per css-anchor-position-1 the cell is its containing block:
 * `100%` is the anchor edge to the viewport edge, and it follows whichever side
 * `position-try-fallbacks` settles on. Percentages do not subtract margins, so
 * the gap is subtracted here.
 *
 * Meaningless on the JavaScript fallback, whose containing block is the viewport,
 * so that path gets `viewportCap` on both axes.
 */ function $80b64ba2cf889489$var$cellCap({ gap: gap }) {
    return `calc(100% - ${$80b64ba2cf889489$export$9f2fdbacbc62226e} - ${gap})`;
}
/**
 * The anchor term of the placement-axis floor, and the one place it is capped.
 *
 * `'match-anchor'` earns a floor only where it can flip: a definite size clamps to
 * the cap and shrinks below the anchor instead of flipping.
 *
 * The `canFlip` clamp is deliberate both ways. With no flip in play an unclamped
 * floor beats `max-{axis}-size` (CSS resolves `min` last), making the viewport
 * backstop inert. With a flip in play, clamping would stop the floor exceeding
 * the cell cap, which is what drives the flip.
 */ function $80b64ba2cf889489$var$getPlacementAxisAnchorFloor({ placementAxis: placementAxis, placementAxisSize: placementAxisSize, anchorValue: anchorValue, canFlip: canFlip, writingMode: writingMode }) {
    const hasAnchorFloor = placementAxisSize === 'min-anchor' || placementAxisSize === 'match-anchor' && canFlip;
    if (!hasAnchorFloor || anchorValue === null) return undefined;
    if (canFlip) return anchorValue;
    return `min(${anchorValue}, ${$80b64ba2cf889489$var$viewportCap({
        axis: placementAxis,
        writingMode: writingMode
    })})`;
}
/**
 * The default flip floor, clamped so that SOME cell can always hold it.
 *
 * The two cells either side of the anchor add up to the viewport less the anchor,
 * so the roomier one is at least half of that. A floor whose margin box fits
 * inside that half is guaranteed a cell somewhere in the fallback chain.
 * Unclamped, a short viewport with a centred anchor has NO cell that holds
 * 150px: every try-fallback overflows, the browser reverts to the base position,
 * and the floor pushes the popover past the viewport edge.
 *
 * This is NOT the `min(floor, cellCap)` that suppresses flipping: it is relative
 * to the VIEWPORT, so a small base cell still overflows it. `max(0px, …)` states
 * the lower bound for an anchor taller than the viewport.
 */ function $80b64ba2cf889489$var$getDefaultPlacementAxisFloor({ placementAxis: placementAxis, anchorValue: anchorValue, gap: gap, writingMode: writingMode }) {
    if (anchorValue === null) return $80b64ba2cf889489$export$32ab78b2bb853a01;
    // The viewport term and the anchor term must measure the SAME axis; see
    // `viewportUnit`.
    const viewport = `100${$80b64ba2cf889489$var$viewportUnit({
        axis: placementAxis,
        writingMode: writingMode
    })}`;
    const halfOfRemainingViewport = `calc((${viewport} - ${anchorValue}) / 2 - ${gap} - ${$80b64ba2cf889489$export$9f2fdbacbc62226e})`;
    return `min(${$80b64ba2cf889489$export$32ab78b2bb853a01}, max(0px, ${halfOfRemainingViewport}))`;
}
/**
 * The placement-axis floor: explicit minimums COMPOSE, the default does not.
 *
 * `placement.minSize` and the anchor term are both explicit requests, so they
 * compose as `max()`. `FALLBACK_MINIMUM_MAIN_AXIS_SIZE` never composes: it only
 * ever won by overriding a size the consumer asked for, and the anchor term drives
 * the flip on its own. Knock-on, intended: `minSize: 0` no longer removes an
 * anchor floor, because `max(0px, anchor)` IS the anchor.
 */ function $80b64ba2cf889489$var$getPlacementAxisFloor({ minSize: minSize, placementAxis: placementAxis, placementAxisSize: placementAxisSize, anchorValue: anchorValue, gap: gap, canFlip: canFlip, writingMode: writingMode }) {
    const anchorFloor = $80b64ba2cf889489$var$getPlacementAxisAnchorFloor({
        placementAxis: placementAxis,
        placementAxisSize: placementAxisSize,
        anchorValue: anchorValue,
        canFlip: canFlip,
        writingMode: writingMode
    });
    if (minSize !== undefined) return anchorFloor === undefined ? minSize : `max(${minSize}, ${anchorFloor})`;
    if (anchorFloor !== undefined) return anchorFloor;
    if (!canFlip) return undefined;
    return $80b64ba2cf889489$var$getDefaultPlacementAxisFloor({
        placementAxis: placementAxis,
        anchorValue: anchorValue,
        gap: gap,
        writingMode: writingMode
    });
}
function $80b64ba2cf889489$export$860b30329fa0b990({ placement: placement, inlineSize: inlineSize, blockSize: blockSize, isUsingCssAnchorPositioning: isUsingCssAnchorPositioning, anchorSize: anchorSize, writingMode: writingMode, shouldPreserveInlineSize: shouldPreserveInlineSize = false }) {
    const placementAxis = placement.axis;
    const crossAxis = $80b64ba2cf889489$var$getCrossAxis(placementAxis);
    // Rule 1. Feeds the per-axis CAPS only.
    const size = {
        inline: inlineSize === 'content' && blockSize === 'max-available' ? 'max-available' : inlineSize,
        block: blockSize === 'content' && inlineSize === 'max-available' ? 'max-available' : blockSize
    };
    // Rule 2 reads the requested values instead, un-mirrored: flipping is a
    // whole-popover outcome, so a fit request on either axis turns the floor on.
    const isFitting = inlineSize === 'max-available' || blockSize === 'max-available';
    // ...but only where the floor is what causes the flip. On the JavaScript
    // fallback a floor only inflates the measured size the side is picked from, so
    // it would flip a popover that fits.
    const canFlip = isFitting && isUsingCssAnchorPositioning;
    const declarations = [
        // Rule 3: both caps are always written. Only the placement axis can take the
        // cell cap.
        {
            property: `max-${placementAxis}-size`,
            value: size[placementAxis] === 'max-available' && isUsingCssAnchorPositioning ? $80b64ba2cf889489$var$cellCap({
                gap: placement.offset.gap
            }) : $80b64ba2cf889489$var$viewportCap({
                axis: placementAxis,
                writingMode: writingMode
            })
        },
        {
            property: `max-${crossAxis}-size`,
            value: $80b64ba2cf889489$var$viewportCap({
                axis: crossAxis,
                writingMode: writingMode
            })
        }
    ];
    // Rule 4. Only for a non-anchor-relative inline axis, so `'match-anchor'` below
    // stays the one writer of `inline-size` when it applies. CSS path only: the
    // fallback's containing block is the viewport, where shrink-to-fit already IS
    // the natural width for anything that fits on screen.
    if (isUsingCssAnchorPositioning && !shouldPreserveInlineSize && (size.inline === 'content' || size.inline === 'max-available')) declarations.push({
        property: 'inline-size',
        value: 'max-content'
    });
    // A max beats a definite size, so the caps above still win over this.
    for (const axis of [
        placementAxis,
        crossAxis
    ]){
        const anchorValue = anchorSize[axis];
        if (size[axis] === 'match-anchor' && anchorValue !== null) declarations.push({
            property: `${axis}-size`,
            value: anchorValue
        });
    }
    const placementAxisFloor = $80b64ba2cf889489$var$getPlacementAxisFloor({
        minSize: placement.minSize,
        placementAxis: placementAxis,
        placementAxisSize: size[placementAxis],
        anchorValue: anchorSize[placementAxis],
        gap: placement.offset.gap,
        canFlip: canFlip,
        writingMode: writingMode
    });
    if (placementAxisFloor !== undefined) declarations.push({
        property: `min-${placementAxis}-size`,
        value: placementAxisFloor
    });
    // A size contract, not a flip driver, so it is clamped to the cap.
    const crossAxisAnchorValue = anchorSize[crossAxis];
    if (size[crossAxis] === 'min-anchor' && crossAxisAnchorValue !== null) declarations.push({
        property: `min-${crossAxis}-size`,
        value: `min(${crossAxisAnchorValue}, ${$80b64ba2cf889489$var$viewportCap({
            axis: crossAxis,
            writingMode: writingMode
        })})`
    });
    return declarations;
}

});


parcelRegister("fI4Zu", function(module, exports) {
$parcel$export(module.exports, "getExistingAnchorName", () => $e2c5abd8be9a60b8$export$948d15b01d509455);
/**
 * The `anchor-name` an element already carries, or `null`. Computed as well as
 * inline, so a name set from a STYLESHEET is found: a minted inline name would
 * otherwise override it for every other rule anchored to that element.
 * `anchor-name` is a list and `position-anchor` takes one ident, so the first
 * name is the one to anchor to.
 */ function $e2c5abd8be9a60b8$export$948d15b01d509455(element) {
    const declared = element.style.getPropertyValue('anchor-name') || getComputedStyle(element).getPropertyValue('anchor-name');
    const first = declared.split(',')[0].trim();
    return first !== '' && first !== 'none' ? first : null;
}

});

parcelRegister("gUfNg", function(module, exports) {
$parcel$export(module.exports, "placementToPositionArea", () => $86167c4667950519$export$de49b61f233ddeb9);
function $86167c4667950519$export$de49b61f233ddeb9({ placement: placement }) {
    const { axis: axis, edge: edge, align: align } = placement;
    const edgeValue = `${axis}-${edge}`;
    if (align === 'center') return edgeValue;
    // Cross-axis name: block ↔ inline
    const crossAxis = axis === 'block' ? 'inline' : 'block';
    // Invert align → CSS span direction: visual 'start' → span toward 'end'
    const spanDir = align === 'start' ? 'end' : 'start';
    return `${edgeValue} span-${crossAxis}-${spanDir}`;
}

});

parcelRegister("7QFax", function(module, exports) {
$parcel$export(module.exports, "placementToTryFallbacks", () => $b9a56ee20bedbbe6$export$c4e16947a95d61f1);
/**
 * The cells to slide to along one edge, on the cross axis.
 *
 * A try option is only worth listing if its margin box can fit where an earlier
 * one did not, and two options over the SAME cell have the same margin box and
 * the same fit result. That rules out three cells for an aligned placement: the
 * near span on the requested edge IS the base position-area, and on the opposite
 * edge the near and far spans are where `flip-{A}` and the diagonal flip land.
 *
 * A centred placement has no near or far, so it slides to both spans on both
 * edges.
 */ function $b9a56ee20bedbbe6$var$slideOnEdge({ align: align, edgeKey: edgeKey, crossAxis: crossAxis, isOppositeEdge: isOppositeEdge }) {
    if (align === 'center') return [
        `${edgeKey} span-${crossAxis}-end`,
        `${edgeKey} span-${crossAxis}-start`
    ];
    if (isOppositeEdge) return [
        edgeKey
    ];
    // For `align: 'start'` the popover expands toward `end`, so the far span is
    // `start`; `align: 'end'` mirrors this.
    const far = align === 'start' ? 'start' : 'end';
    return [
        edgeKey,
        `${edgeKey} span-${crossAxis}-${far}`
    ];
}
function $b9a56ee20bedbbe6$var$flipDiagonally({ axis: axis }) {
    const flipOnMainAxis = axis === 'block' ? 'flip-block' : 'flip-inline';
    const flipToCrossAxis = axis === 'block' ? 'flip-inline' : 'flip-block';
    return `${flipOnMainAxis} ${flipToCrossAxis}`;
}
function $b9a56ee20bedbbe6$export$c4e16947a95d61f1({ placement: placement }) {
    const { axis: axis, edge: edge, align: align } = placement;
    const crossAxis = axis === 'block' ? 'inline' : 'block';
    const flippedEdge = edge === 'start' ? 'end' : 'start';
    const sameEdgeArea = `${axis}-${edge}`;
    const oppositeEdgeArea = `${axis}-${flippedEdge}`;
    const flipOnMainAxis = axis === 'block' ? 'flip-block' : 'flip-inline';
    return [
        $b9a56ee20bedbbe6$var$slideOnEdge({
            align: align,
            edgeKey: sameEdgeArea,
            crossAxis: crossAxis,
            isOppositeEdge: false
        }),
        flipOnMainAxis,
        align !== 'center' ? $b9a56ee20bedbbe6$var$flipDiagonally({
            axis: axis
        }) : null,
        $b9a56ee20bedbbe6$var$slideOnEdge({
            align: align,
            edgeKey: oppositeEdgeArea,
            crossAxis: crossAxis,
            isOppositeEdge: true
        })
    ].filter(Boolean).flat().join(', ');
}

});


parcelRegister("1BzD7", function(module, exports) {
$parcel$export(module.exports, "applyJavaScriptFallbackPositioning", () => $60ba1d05b0deae4f$export$89babc4c2047d2ba);
/**
 * The JavaScript positioning fallback: measured `position: fixed` coordinates for
 * browsers without CSS Anchor Positioning.
 *
 * Best effort, degrading in that order: measured anchored position, then anchored
 * with unresolvable offsets treated as `0`, then centred in the viewport, and
 * always visible. The two hazards differ in kind: `new ResizeObserver` runs
 * synchronously in the layout effect, where a throw unmounts the React tree,
 * while `update` runs asynchronously, where the danger is an uncleared
 * `opacity: 0`.
 */ 
var $dqdTY = parcelRequire("dqdTY");

var $hMOFt = parcelRequire("hMOFt");

var $ihyBX = parcelRequire("ihyBX");

var $htvvG = parcelRequire("htvvG");

var $dddn8 = parcelRequire("dddn8");

var $97pV2 = parcelRequire("97pV2");

var $gyvP6 = parcelRequire("gyvP6");
/**
 * Wrapped because jsdom throws on the unknown `:popover-open` selector.
 */ function $60ba1d05b0deae4f$var$isPopoverOpen(popover) {
    try {
        return popover.matches(':popover-open');
    } catch  {
        return false;
    }
}
/**
 * Observes the popover until its first non-zero layout, then self-disconnects;
 * ongoing movement is handled by the scroll and resize listeners. The popover is
 * `display: none` until `showPopover()`, and some browsers fire `toggle` before
 * layout, so RAF-after-toggle is unreliable.
 *
 * `null` where `ResizeObserver` is missing (non-DOM jest environments). There is
 * then no measurement to wait for, so the caller positions immediately and must
 * not hide the popover, because no reveal would follow.
 */ function $60ba1d05b0deae4f$var$createFirstLayoutObserver({ popover: popover, onFirstLayout: onFirstLayout }) {
    if (typeof ResizeObserver === 'undefined') return null;
    try {
        const observer = new ResizeObserver(()=>{
            if (popover.offsetWidth > 0 && popover.offsetHeight > 0) {
                onFirstLayout();
                observer.disconnect();
            }
        });
        return observer;
    } catch (error) {
        (0, $gyvP6.warnFallbackFailure)({
            error: error
        });
        return null;
    }
}
function $60ba1d05b0deae4f$export$89babc4c2047d2ba({ anchor: anchor, popover: popover, placement: placement, sizeStyles: sizeStyles }) {
    // Already in the top layer via the `popover` attribute, so this only resets the
    // UA defaults and writes measured `top` / `left`.
    const cleanupBaseStyles = (0, $htvvG.setStyle)({
        element: popover,
        styles: [
            {
                property: 'margin',
                value: '0'
            },
            {
                property: 'inset',
                value: 'auto'
            },
            ...sizeStyles
        ]
    });
    // The popover can be consumer-owned (`@atlaskit/popper`'s `createPopper`),
    // so restore prior inline values rather than removing ours.
    let undoPosition;
    let undoHide;
    // Resolved once per open and per resize, reused across scrolls: resolving is a
    // full style and layout flush, and a scroll cannot change what a CSS length
    // resolves to. A resize can (viewport units), and so can a re-open (a token
    // retargeted while closed).
    let resolvedOffsets = null;
    function invalidateResolvedOffsets() {
        resolvedOffsets = null;
    }
    function getResolvedOffsets() {
        if (resolvedOffsets) return resolvedOffsets;
        // Probed INSIDE the popover: it is in the top layer, not the anchor's DOM
        // tree, so anywhere else resolves a token against a different scope.
        resolvedOffsets = {
            gap: (0, $97pV2.resolveCssLengthToPixels)({
                value: placement.offset.gap,
                container: popover
            }),
            crossAxisShift: (0, $97pV2.resolveCssLengthToPixels)({
                value: placement.offset.crossAxisShift.value,
                container: popover
            })
        };
        return resolvedOffsets;
    }
    function reveal() {
        undoHide?.();
        undoHide = undefined;
    }
    function restorePosition() {
        undoPosition?.();
        undoPosition = undefined;
    }
    // `opacity: 0` not `visibility: hidden`: Firefox skips visibility-hidden
    // elements during `<dialog>` initial-focus traversal.
    function hideUntilPositioned() {
        // Keep the first snapshot, else we capture our own `opacity: 0`.
        if (undoHide) return;
        undoHide = (0, $htvvG.setStyle)({
            element: popover,
            styles: [
                {
                    property: 'opacity',
                    value: '0'
                }
            ]
        });
    }
    /**
	 * Last resort. The base styles above reset the UA
	 * `[popover] { inset: 0; margin: auto }`, so a popover with no `top` / `left`
	 * sits in the viewport corner rather than centred.
	 */ function centerInViewport() {
        restorePosition();
        undoPosition = (0, $htvvG.setStyle)({
            element: popover,
            styles: [
                {
                    property: 'inset',
                    value: '0'
                },
                {
                    property: 'margin',
                    value: 'auto'
                }
            ]
        });
    }
    function update() {
        try {
            const triggerRect = anchor.getBoundingClientRect();
            const viewport = {
                width: window.innerWidth,
                height: window.innerHeight
            };
            const { gap: gap, crossAxisShift: crossAxisShift } = getResolvedOffsets();
            const { top: top, left: left } = (0, $dddn8.computeFallbackPosition)({
                triggerRect: triggerRect,
                popoverEl: popover,
                placement: placement,
                viewport: viewport,
                gap: gap,
                crossAxisShift: {
                    value: crossAxisShift,
                    direction: placement.offset.crossAxisShift.direction
                }
            });
            // A non-finite coordinate serialises to a declaration the browser drops,
            // landing the popover in the corner just as silently as a throw would.
            if (!Number.isFinite(top) || !Number.isFinite(left)) {
                centerInViewport();
                return;
            }
            // Restore first so the snapshot stays the consumer's value.
            restorePosition();
            undoPosition = (0, $htvvG.setStyle)({
                element: popover,
                styles: [
                    {
                        property: 'top',
                        value: `${top}px`
                    },
                    {
                        property: 'left',
                        value: `${left}px`
                    }
                ]
            });
        } catch (error) {
            (0, $gyvP6.warnFallbackFailure)({
                error: error
            });
            // Anchoring needs the trigger geometry we just failed to get, so the
            // centred position is the only one left to degrade to.
            try {
                centerInViewport();
            } catch  {}
        } finally{
            // Unconditional. A popover in the wrong place is recoverable on the
            // next scroll or resize; one left at `opacity: 0` is invisible forever.
            reveal();
        }
    }
    function invalidateAndUpdate() {
        invalidateResolvedOffsets();
        update();
    }
    // One update per animation frame. Scroll reuses the resolved offsets; resize
    // re-resolves them.
    const scheduledScrollUpdate = (0, $hMOFt.default)(update);
    const scheduledResizeUpdate = (0, $hMOFt.default)(invalidateAndUpdate);
    const firstLayoutObserver = $60ba1d05b0deae4f$var$createFirstLayoutObserver({
        popover: popover,
        onFirstLayout: update
    });
    function positionOnNextLayout() {
        // A token can have been retargeted while the popover was closed, so each
        // open re-resolves the offsets.
        invalidateResolvedOffsets();
        // No observer means no measurement is coming: position now, and do not
        // hide, because the reveal would never arrive.
        if (!firstLayoutObserver) {
            update();
            return;
        }
        hideUntilPositioned();
        firstLayoutObserver.observe(popover);
    }
    // The popover can already be open when this runs, in which case the initial
    // `toggle` has fired and the listener below would miss it.
    if ($60ba1d05b0deae4f$var$isPopoverOpen(popover)) positionOnNextLayout();
    return (0, $ihyBX.combine)(cleanupBaseStyles, // Each open needs a fresh measurement, so hide and re-observe.
    (0, $dqdTY.bind)(popover, {
        type: 'toggle',
        listener: (event)=>{
            const toggleEvent = event;
            if (toggleEvent.newState === 'open') positionOnNextLayout();
        }
    }), ()=>firstLayoutObserver?.disconnect(), (0, $dqdTY.bind)(window, {
        type: 'scroll',
        listener: scheduledScrollUpdate,
        options: {
            capture: true,
            passive: true
        }
    }), (0, $dqdTY.bind)(window, {
        type: 'resize',
        listener: scheduledResizeUpdate,
        options: {
            passive: true
        }
    }), ()=>{
        scheduledScrollUpdate.cancel();
        scheduledResizeUpdate.cancel();
        restorePosition();
        reveal();
    });
}

});
parcelRegister("ihyBX", function(module, exports) {
$parcel$export(module.exports, "combine", () => $95f57d406fa48fe0$export$1be1fc439b849fdf);
/**
 * Combine multiple cleanup functions into a single cleanup function.
 *
 * @example
 * ```ts
 * useEffect(() => {
 *   return combine(
 *     bind(window, { type: 'resize', listener: onResize }),
 *     bind(window, { type: 'scroll', listener: onScroll, options: { capture: true } }),
 *   );
 * }, []);
 * ```
 */ function $95f57d406fa48fe0$export$1be1fc439b849fdf(...cleanupFns) {
    return function cleanup() {
        cleanupFns.forEach((callback)=>callback?.());
    };
}

});

parcelRegister("dddn8", function(module, exports) {
$parcel$export(module.exports, "computeFallbackPosition", () => $9a3867a1770c41d5$export$d5ef1dac02135664);
/**
 * Computes the base {top, left} position based on the primary edge,
 * flipping to the opposite side when there is not enough space.
 *
 * `gap` is applied along the main axis between trigger and popover.
 */ function $9a3867a1770c41d5$var$computeEdgePosition({ axis: axis, edge: edge, triggerRect: triggerRect, popoverWidth: popoverWidth, popoverHeight: popoverHeight, viewport: viewport, gap: gap }) {
    if (axis === 'block' && edge === 'end') {
        // Below trigger
        const spaceBelow = viewport.height - triggerRect.bottom;
        const spaceAbove = triggerRect.top;
        const fitsBelow = spaceBelow >= popoverHeight + gap;
        const useBelow = fitsBelow || spaceBelow >= spaceAbove;
        return {
            top: useBelow ? triggerRect.bottom + gap : triggerRect.top - popoverHeight - gap,
            left: triggerRect.left + triggerRect.width / 2 - popoverWidth / 2
        };
    }
    if (axis === 'block' && edge === 'start') {
        // Above trigger
        const spaceAbove = triggerRect.top;
        const spaceBelow = viewport.height - triggerRect.bottom;
        const fitsAbove = spaceAbove >= popoverHeight + gap;
        const useAbove = fitsAbove || spaceAbove >= spaceBelow;
        return {
            top: useAbove ? triggerRect.top - popoverHeight - gap : triggerRect.bottom + gap,
            left: triggerRect.left + triggerRect.width / 2 - popoverWidth / 2
        };
    }
    if (axis === 'inline' && edge === 'end') {
        // Right of trigger
        const spaceRight = viewport.width - triggerRect.right;
        const spaceLeft = triggerRect.left;
        const fitsRight = spaceRight >= popoverWidth + gap;
        const useRight = fitsRight || spaceRight >= spaceLeft;
        return {
            top: triggerRect.top + triggerRect.height / 2 - popoverHeight / 2,
            left: useRight ? triggerRect.right + gap : triggerRect.left - popoverWidth - gap
        };
    }
    if (axis === 'inline' && edge === 'start') {
        // Left of trigger
        const spaceLeft = triggerRect.left;
        const spaceRight = viewport.width - triggerRect.right;
        const fitsLeft = spaceLeft >= popoverWidth + gap;
        const useLeft = fitsLeft || spaceLeft >= spaceRight;
        return {
            top: triggerRect.top + triggerRect.height / 2 - popoverHeight / 2,
            left: useLeft ? triggerRect.left - popoverWidth - gap : triggerRect.right + gap
        };
    }
    // Unreachable for valid placements; defaults to below trigger
    return {
        top: triggerRect.bottom + gap,
        left: triggerRect.left + triggerRect.width / 2 - popoverWidth / 2
    };
}
/**
 * Adjusts the base (centered) position for non-center alignments.
 *
 * `align: 'start'` → popover start edge at trigger start edge
 * `align: 'end'`   → popover end edge at trigger end edge
 */ function $9a3867a1770c41d5$var$applyAlignment({ position: position, axis: axis, align: align, triggerRect: triggerRect, popoverWidth: popoverWidth, popoverHeight: popoverHeight }) {
    if (align === 'center') return position;
    if (axis === 'block') {
        // Block-axis placement → cross-axis is inline (left/right)
        if (align === 'start') return {
            ...position,
            left: triggerRect.left
        };
        // align === 'end'
        return {
            ...position,
            left: triggerRect.right - popoverWidth
        };
    }
    // Inline-axis placement → cross-axis is block (top/bottom)
    if (align === 'start') return {
        ...position,
        top: triggerRect.top
    };
    // align === 'end'
    return {
        ...position,
        top: triggerRect.bottom - popoverHeight
    };
}
/**
 * Applies the cross-axis shift offset. `forwards` always moves the popover
 * toward the cross-axis END, for every `align` value.
 *
 * Do not add a per-`align` sign inversion here. This is a coordinate, so the
 * direction is the sign and nothing else. The CSS path inverts only because an
 * END-side margin pushes a box the opposite way to a START-side one, which is a
 * property of margins.
 */ function $9a3867a1770c41d5$var$applyCrossAxisShift({ position: position, axis: axis, crossAxisShift: crossAxisShift }) {
    if (crossAxisShift.value === 0) return position;
    const directionSign = crossAxisShift.direction === 'forwards' ? 1 : -1;
    const delta = crossAxisShift.value * directionSign;
    // Cross-axis is the OPPOSITE of the placement axis.
    if (axis === 'block') return {
        ...position,
        left: position.left + delta
    };
    return {
        ...position,
        top: position.top + delta
    };
}
function $9a3867a1770c41d5$export$d5ef1dac02135664({ triggerRect: triggerRect, popoverEl: popoverEl, placement: placement, viewport: viewport, gap: gap, crossAxisShift: crossAxisShift }) {
    const { axis: axis, edge: edge, align: align } = placement;
    // Measure popover dimensions. Callers must ensure the popover has
    // laid out before calling this (it should not be `display: none`).
    const popoverWidth = popoverEl.offsetWidth;
    const popoverHeight = popoverEl.offsetHeight;
    const basePosition = $9a3867a1770c41d5$var$computeEdgePosition({
        axis: axis,
        edge: edge,
        triggerRect: triggerRect,
        popoverWidth: popoverWidth,
        popoverHeight: popoverHeight,
        viewport: viewport,
        gap: gap
    });
    const alignedPosition = $9a3867a1770c41d5$var$applyAlignment({
        position: basePosition,
        axis: axis,
        align: align,
        triggerRect: triggerRect,
        popoverWidth: popoverWidth,
        popoverHeight: popoverHeight
    });
    const shiftedPosition = $9a3867a1770c41d5$var$applyCrossAxisShift({
        position: alignedPosition,
        axis: axis,
        crossAxisShift: crossAxisShift
    });
    // Clamp to viewport so the popover is never offscreen
    return {
        top: Math.max(0, Math.min(shiftedPosition.top, viewport.height - popoverHeight)),
        left: Math.max(0, Math.min(shiftedPosition.left, viewport.width - popoverWidth))
    };
}

});

parcelRegister("97pV2", function(module, exports) {
$parcel$export(module.exports, "resolveCssLengthToPixels", () => $d9bad42cf4ffc658$export$98721546d2816d9e);

var $gyvP6 = parcelRequire("gyvP6");
/**
 * `null` when the environment cannot measure at all.
 */ function $d9bad42cf4ffc658$var$measureWithProbe({ value: value, container: container }) {
    // Reached through the container rather than the global, so a popover in
    // another document still measures and one with no view degrades gracefully.
    const view = container.ownerDocument.defaultView;
    if (!view) return null;
    const probe = container.ownerDocument.createElement('div');
    probe.style.position = 'absolute';
    probe.style.visibility = 'hidden';
    probe.style.pointerEvents = 'none';
    probe.style.height = '0';
    probe.style.padding = '0';
    probe.style.border = '0';
    // `width` clamps negatives to 0; use `margin-left` instead so signs are
    // preserved. `getComputedStyle` returns the resolved pixel value for
    // margin-* properties even when the source was a token / calc / var.
    probe.style.marginLeft = value;
    // Hidden from assistive tech and event targeting; defensive against
    // `getElementsByTagName('div')` walks in consumer code.
    probe.setAttribute('aria-hidden', 'true');
    probe.setAttribute('inert', '');
    try {
        container.appendChild(probe);
        const resolved = parseFloat(view.getComputedStyle(probe).marginLeft);
        return Number.isFinite(resolved) ? resolved : 0;
    } catch (error) {
        (0, $gyvP6.warnFallbackFailure)({
            error: error
        });
        return null;
    } finally{
        // `remove()` rather than `removeChild()`: consumer code may already have
        // detached the probe, which must not throw out of a layout effect.
        probe.remove();
    }
}
function $d9bad42cf4ffc658$export$98721546d2816d9e({ value: value, container: container }) {
    if (typeof value === 'number') return value;
    // Fast path: consumers occasionally pass `'0'` instead of the number `0`.
    if (value === '0' || value === '-0') return 0;
    // Fast path: bare `${n}px` strings come from `resolvePlacement`, so this avoids
    // a reflow for the common case.
    const pxMatch = value.match(/^(-?\d+(?:\.\d+)?)px$/);
    if (pxMatch) return Number(pxMatch[1]);
    return $d9bad42cf4ffc658$var$measureWithProbe({
        value: value,
        container: container
    }) ?? 0;
}

});
parcelRegister("gyvP6", function(module, exports) {
$parcel$export(module.exports, "warnFallbackFailure", () => $4662a2cb4a8f646b$export$e142245b95267f17);

function $4662a2cb4a8f646b$export$e142245b95267f17({ error: error }) {
    return;
}

});



parcelRegister("bpyYQ", function(module, exports) {
$parcel$export(module.exports, "supportsAnchorPositioning", () => $031f8f7f2f742176$export$7192e63dfa9e8124);

var $bFLkc = parcelRequire("bFLkc");
const $031f8f7f2f742176$export$7192e63dfa9e8124 = (0, $bFLkc.createCssDeclarationProbe)({
    property: 'anchor-name',
    value: '--a'
});

});
parcelRegister("bFLkc", function(module, exports) {
$parcel$export(module.exports, "createCssDeclarationProbe", () => $7d3a298ab870a608$export$69de71b4b7c76bad);

var $kFwbq = parcelRequire("kFwbq");
function $7d3a298ab870a608$export$69de71b4b7c76bad({ property: property, value: value }) {
    return (0, $kFwbq.default)(function supportsCssDeclaration() {
        if (typeof window === 'undefined' || typeof CSS === 'undefined' || typeof CSS.supports !== 'function') return false;
        return CSS.supports(property, value);
    });
}

});


parcelRegister("dufKD", function(module, exports) {
$parcel$export(module.exports, "supportsAnchorSize", () => $4194d4ea16c77edf$export$1c8dd0d1c9df9c6e);

var $bFLkc = parcelRequire("bFLkc");
const $4194d4ea16c77edf$export$1c8dd0d1c9df9c6e = (0, $bFLkc.createCssDeclarationProbe)({
    property: 'min-inline-size',
    value: 'anchor-size(self-inline)'
});

});


parcelRegister("eyyYg", function(module, exports) {
$parcel$export(module.exports, "useAnchoredPopoverAtPoint", () => $8ce228a6c0649509$export$3c5c8baff3ccd957);
/**
 * Positioning and sizing for a popover anchored to a viewport COORDINATE. No
 * positioning logic here: CSS Anchor Positioning needs a real element to carry
 * `anchor-name`, so this hook creates a hidden, zero-size one at the requested
 * point and delegates everything else to `useAnchoredPopover`.
 *
 * See `notes/decisions/anchored-popover-at-point.md` for why this is a sibling
 * hook instead of an anchor union inside `useAnchoredPopover`.
 */ 
var $fsvuC = parcelRequire("fsvuC");

var $7EsQa = parcelRequire("7EsQa");

var $gc525 = parcelRequire("gc525");
/**
 * Appended to `document.body` to escape any transformed ancestor, which would
 * break viewport-relative resolution of `position: fixed`. `Object.assign`
 * rather than `setStyle`: we own the element, so there is nothing to restore.
 */ function $8ce228a6c0649509$var$mountAnchorElementAtPoint({ point: point }) {
    const element = document.createElement('div');
    element.setAttribute('aria-hidden', 'true');
    Object.assign(element.style, {
        position: 'fixed',
        // Physical insets: `inset-inline-start` would need `viewportWidth - point.x`
        // in RTL.
        top: `${point.y}px`,
        left: `${point.x}px`,
        // Zero size, so placement alone decides which side the popover sits on.
        width: '0',
        height: '0',
        pointerEvents: 'none'
    });
    document.body.appendChild(element);
    return {
        element: element,
        cleanup: function cleanup() {
            element.remove();
        }
    };
}
function $8ce228a6c0649509$export$3c5c8baff3ccd957({ getPoint: getPoint, isEnabled: isEnabled = true, ...rest }) {
    const anchorRef = (0, $fsvuC.useRef)(null);
    // Latched, keyed on `isEnabled`: consumers read mutable refs inside `getPoint`,
    // so re-reading it would move an already-open popover, and keying on
    // `getPoint`'s identity would re-latch on every parent render.
    const getPointRef = (0, $fsvuC.useRef)(getPoint);
    getPointRef.current = getPoint;
    // Declared BEFORE `useAnchoredPopover` below, so the element exists when that
    // hook's effect reads the ref (React runs layout effects in source order). This
    // effect must not depend on anything the delegated effect does not: a dependency
    // here alone re-creates the element without that hook writing an `anchor-name`
    // onto it, and positioning silently dies.
    (0, $7EsQa.useLayoutEffect)(()=>{
        if (!isEnabled) return;
        const point = getPointRef.current();
        if (!point) return;
        const { element: element, cleanup: unmountAnchorElement } = $8ce228a6c0649509$var$mountAnchorElementAtPoint({
            point: point
        });
        anchorRef.current = element;
        return function cleanup() {
            unmountAnchorElement();
            anchorRef.current = null;
        };
    // The latch. See `getPointRef` above: `getPoint` is deliberately absent.
    }, [
        isEnabled
    ]);
    (0, $gc525.useAnchoredPopover)({
        ...rest,
        anchorRef: anchorRef,
        isEnabled: isEnabled
    });
}

});

parcelRegister("kOb0h", function(module, exports) {
$parcel$export(module.exports, "usePopoverId", () => $49fea46c5ad4ac5d$export$9198c6c168be2eeb);

var $cTXsj = parcelRequire("cTXsj");
function $49fea46c5ad4ac5d$export$9198c6c168be2eeb() {
    // `@atlaskit/ds-lib/use-id`, not React's `useId`: React's output contains
    // `:`, `«` and `»`, which are invalid in an HTML id token.
    return `popover-${(0, $cTXsj.useId)()}`;
}

});

parcelRegister("isTM6", function(module, exports) {
$parcel$export(module.exports, "isPageRtl", () => $26ed7adad72a5679$export$175375e9a2b5515d);

var $jF8Yw = parcelRequire("jF8Yw");
function $26ed7adad72a5679$export$175375e9a2b5515d() {
    const document = (0, $jF8Yw.getDocument)();
    if (!document) return false;
    return document.dir === 'rtl' || document.body.dir === 'rtl' || document.documentElement.dir === 'rtl';
}

});

parcelRegister("ipV9d", function(module, exports) {
$parcel$export(module.exports, "rectPointForPlacement", () => $17d55b2445454ad9$export$b065aeb850c3e87f);
function $17d55b2445454ad9$export$b065aeb850c3e87f({ rect: rect, placement: placement, isRtl: isRtl }) {
    const axis = placement.axis ?? 'block';
    const edge = placement.edge ?? 'end';
    const align = placement.align ?? 'center';
    if (axis === 'block') {
        // Popover sits above (`edge: 'start'`) or below (`edge: 'end'`)
        // the anchor. Hug the matching horizontal edge; align along x.
        const y = edge === 'start' ? rect.top : rect.bottom;
        const x = $17d55b2445454ad9$var$horizontalForAlign({
            rect: rect,
            align: align,
            isRtl: isRtl
        });
        return {
            x: x,
            y: y
        };
    }
    // `axis: 'inline'`: popover sits inline-start or inline-end of the
    // anchor. Hug the matching vertical edge; align along y.
    const x = $17d55b2445454ad9$var$inlineEdgeX({
        rect: rect,
        edge: edge,
        isRtl: isRtl
    });
    const y = $17d55b2445454ad9$var$verticalForAlign({
        rect: rect,
        align: align
    });
    return {
        x: x,
        y: y
    };
}
function $17d55b2445454ad9$var$horizontalForAlign({ rect: rect, align: align, isRtl: isRtl }) {
    if (align === 'center') return rect.left + rect.width / 2;
    // `start` / `end` are logical. In LTR, `start` is the left edge.
    // In RTL, `start` is the right edge.
    const isStartLeft = !isRtl;
    if (align === 'start') return isStartLeft ? rect.left : rect.right;
    return isStartLeft ? rect.right : rect.left;
}
function $17d55b2445454ad9$var$verticalForAlign({ rect: rect, align: align }) {
    if (align === 'center') return rect.top + rect.height / 2;
    if (align === 'start') return rect.top;
    return rect.bottom;
}
function $17d55b2445454ad9$var$inlineEdgeX({ rect: rect, edge: edge, isRtl: isRtl }) {
    const isStartLeft = !isRtl;
    if (edge === 'start') return isStartLeft ? rect.left : rect.right;
    return isStartLeft ? rect.right : rect.left;
}

});

parcelRegister("5aOgs", function(module, exports) {
$parcel$export(module.exports, "toLegacyPlacement", () => $906544b18e1eccff$export$e9a6fdb80170ffd);
function $906544b18e1eccff$export$e9a6fdb80170ffd(placement) {
    return placement;
}

});

parcelRegister("jtt1n", function(module, exports) {
$parcel$export(module.exports, "useManagerAnchor", () => $4fb1e4892a71b9ec$export$941a7e8bf0b9eafd);

var $fsvuC = parcelRequire("fsvuC");

var $cxtgF = parcelRequire("cxtgF");
function $4fb1e4892a71b9ec$export$941a7e8bf0b9eafd() {
    return (0, $fsvuC.useContext)((0, $cxtgF.AnchorContext));
}

});
parcelRegister("cxtgF", function(module, exports) {
$parcel$export(module.exports, "AnchorContext", () => $242fbdddb8162929$export$8f73317645bb7b8e);

var $fsvuC = parcelRequire("fsvuC");
const $242fbdddb8162929$export$8f73317645bb7b8e = /*#__PURE__*/ (0, $fsvuC.createContext)(null);

});


parcelRegister("koKda", function(module, exports) {
$parcel$export(module.exports, "useReferenceVisibility", () => $c495d294f7615a6b$export$61d36e2b682e92f7);

var $fsvuC = parcelRequire("fsvuC");

var $dqdTY = parcelRequire("dqdTY");

var $7EsQa = parcelRequire("7EsQa");

var $j3bLd = parcelRequire("j3bLd");
const $c495d294f7615a6b$var$INITIAL = {
    isReferenceHidden: false,
    hasPopperEscaped: false
};
function $c495d294f7615a6b$var$isFullyOutsideViewport(rect, viewport) {
    if (rect.width === 0 && rect.height === 0) return true;
    if (rect.bottom <= 0) return true;
    if (rect.right <= 0) return true;
    if (rect.top >= viewport.height) return true;
    if (rect.left >= viewport.width) return true;
    return false;
}
function $c495d294f7615a6b$var$isClippingOverflow(value) {
    return value === 'auto' || value === 'scroll' || value === 'hidden' || value === 'clip';
}
function $c495d294f7615a6b$var$isClippedByAncestors(element) {
    const rect = element.getBoundingClientRect();
    let parent = element.parentElement;
    while(parent){
        // Read the longhand axis properties directly. The `overflow` shorthand
        // is only populated when both axes share the same value, so reading it
        // alone misses ancestors that set only `overflow-x` or `overflow-y`.
        const style = window.getComputedStyle(parent);
        const clipsHorizontally = $c495d294f7615a6b$var$isClippingOverflow(style.overflowX);
        const clipsVertically = $c495d294f7615a6b$var$isClippingOverflow(style.overflowY);
        if (clipsHorizontally || clipsVertically) {
            const parentRect = parent.getBoundingClientRect();
            const horizontallyOutside = rect.right <= parentRect.left || rect.left >= parentRect.right;
            const verticallyOutside = rect.bottom <= parentRect.top || rect.top >= parentRect.bottom;
            if (clipsHorizontally && horizontallyOutside) return true;
            if (clipsVertically && verticallyOutside) return true;
        }
        parent = parent.parentElement;
    }
    return false;
}
function $c495d294f7615a6b$export$61d36e2b682e92f7({ anchor: anchor, popoverRef: popoverRef }) {
    const [visibility, setVisibility] = (0, $fsvuC.useState)($c495d294f7615a6b$var$INITIAL);
    const measure = (0, $fsvuC.useCallback)(()=>{
        if (!anchor) {
            setVisibility((previous)=>previous.isReferenceHidden === false && previous.hasPopperEscaped === false ? previous : $c495d294f7615a6b$var$INITIAL);
            return;
        }
        const viewport = (0, $j3bLd.readViewport)();
        const anchorRect = anchor.getBoundingClientRect();
        const isReferenceHidden = $c495d294f7615a6b$var$isFullyOutsideViewport(anchorRect, viewport) || $c495d294f7615a6b$var$isClippedByAncestors(anchor);
        const popoverElement = popoverRef.current;
        const hasPopperEscaped = popoverElement ? $c495d294f7615a6b$var$isFullyOutsideViewport(popoverElement.getBoundingClientRect(), viewport) : false;
        setVisibility((previous)=>{
            if (previous.isReferenceHidden === isReferenceHidden && previous.hasPopperEscaped === hasPopperEscaped) return previous;
            return {
                isReferenceHidden: isReferenceHidden,
                hasPopperEscaped: hasPopperEscaped
            };
        });
    }, [
        anchor,
        popoverRef
    ]);
    (0, $7EsQa.useLayoutEffect)(()=>{
        measure();
        if (typeof window === 'undefined') return undefined;
        const cleanups = [];
        // Resize observer on the anchor so layout changes update visibility.
        if (anchor && typeof ResizeObserver !== 'undefined') {
            const observer = new ResizeObserver(()=>measure());
            observer.observe(anchor);
            cleanups.push(()=>observer.disconnect());
        }
        // Scroll + resize: any scroll event in the document can move the
        // anchor in/out of any scrollable ancestor's viewport.
        cleanups.push((0, $dqdTY.bindAll)(window, [
            {
                type: 'scroll',
                listener: measure,
                options: {
                    capture: true,
                    passive: true
                }
            },
            {
                type: 'resize',
                listener: measure,
                options: {
                    passive: true
                }
            }
        ]));
        const visual = window.visualViewport;
        if (visual) cleanups.push((0, $dqdTY.bind)(visual, {
            type: 'resize',
            listener: measure,
            options: {
                passive: true
            }
        }));
        return ()=>{
            cleanups.forEach((cleanup)=>cleanup());
        };
    }, [
        anchor,
        measure
    ]);
    return visibility;
}

});
parcelRegister("j3bLd", function(module, exports) {
$parcel$export(module.exports, "readViewport", () => $50e0a25468442c82$export$64beed533e21f72d);
function $50e0a25468442c82$export$64beed533e21f72d() {
    if (typeof window === 'undefined') return {
        width: 0,
        height: 0
    };
    const visual = window.visualViewport;
    if (visual) return {
        width: visual.width,
        height: visual.height
    };
    return {
        width: window.innerWidth,
        height: window.innerHeight
    };
}

});




parcelRegister("bDK6L", function(module, exports) {
$parcel$export(module.exports, "default", () => $69ac44319534be5a$export$2e2bcd8739ae039);

var $5chsV = parcelRequire("5chsV");
parcelRequire("fsvuC");

var $llCao = parcelRequire("llCao");

var $bfvFP = parcelRequire("bfvFP");

var $bXNDv = parcelRequire("bXNDv");

var $mSqMb = parcelRequire("mSqMb");

var $8thOl = parcelRequire("8thOl");
function $69ac44319534be5a$export$2e2bcd8739ae039({ zIndex: zIndex = 0, children: children, mountStrategy: mountStrategy = 'effect' }) {
    const isSubsequentRender = (0, $mSqMb.default)(mountStrategy);
    (0, $8thOl.default)(zIndex);
    return !(0, $llCao.fg)('platform_design_system_team_portal_logic_r18_fix') ? isSubsequentRender ? /*#__PURE__*/ (0, $5chsV.jsx)((0, $bfvFP.default), {
        zIndex: zIndex,
        children: children
    }) : null : /*#__PURE__*/ (0, $5chsV.jsx)((0, $bXNDv.default), {
        zIndex: zIndex,
        children: children
    });
}
$69ac44319534be5a$export$2e2bcd8739ae039.displayName = "Portal";

});
parcelRegister("bfvFP", function(module, exports) {
$parcel$export(module.exports, "default", () => $870bbfcf581c76f9$export$2e2bcd8739ae039);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $80czl = parcelRequire("80czl");

var $jNtEw = parcelRequire("jNtEw");

var $fg2Kk = parcelRequire("fg2Kk");

var $dzW4K = parcelRequire("dzW4K");

var $i2UYV = parcelRequire("i2UYV");

var $EWReK = parcelRequire("EWReK");

var $lhiGg = parcelRequire("lhiGg");
function $870bbfcf581c76f9$export$2e2bcd8739ae039(props) {
    const { zIndex: zIndex, children: children } = props;
    const container = (0, $fsvuC.useMemo)(()=>(0, $EWReK.createContainer)(zIndex), [
        zIndex
    ]);
    const colorMode = (0, $fg2Kk.useColorMode)();
    const isInsideThemeProvider = (0, $dzW4K.useIsInsideThemeProvider)();
    // This is in the render method instead of useEffect so that
    // the portal will be added to the DOM before the children render.
    // For any further changes, ensure that the container does not have a
    // parent besides the portal parent.
    (0, $i2UYV.appendPortalContainerIfNotAppended)(container);
    (0, $fsvuC.useEffect)(()=>{
        return ()=>{
            (0, $lhiGg.removePortalContainer)(container);
        };
    }, [
        container
    ]);
    return /*#__PURE__*/ (0, $80czl.createPortal)(isInsideThemeProvider ? /*#__PURE__*/ (0, $5chsV.jsx)((0, $jNtEw.ThemeProvider), {
        defaultColorMode: colorMode,
        children: children
    }) : children, container);
}
$870bbfcf581c76f9$export$2e2bcd8739ae039.displayName = "InternalPortal";

});
parcelRegister("jNtEw", function(module, exports) {
$parcel$export(module.exports, "ThemeProvider", () => $75de191877df3172$export$d8964aec282183a3);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $gJ6nT = parcelRequire("gJ6nT");

var $fsvuC = parcelRequire("fsvuC");

var $dqdTY = parcelRequire("dqdTY");

var $llCao = parcelRequire("llCao");

var $gCKKR = parcelRequire("gCKKR");

var $c1W2k = parcelRequire("c1W2k");

var $fiu3C = parcelRequire("fiu3C");

var $j3auT = parcelRequire("j3auT");

var $2S58U = parcelRequire("2S58U");

var $5EoO0 = parcelRequire("5EoO0");

var $9xFXq = parcelRequire("9xFXq");

var $bvkoW = parcelRequire("bvkoW");

var $bhVVB = parcelRequire("bhVVB");

var $1YjM9 = parcelRequire("1YjM9");

var $dzW4K = parcelRequire("dzW4K");

var $juMDf = parcelRequire("juMDf");

var $cB4Mk = parcelRequire("cB4Mk");
const $75de191877df3172$var$defaultThemeSettings = {
    dark: 'dark',
    light: 'light',
    shape: 'shape',
    spacing: 'spacing',
    typography: 'typography'
};
const $75de191877df3172$var$isMatchMediaAvailable = typeof window !== 'undefined' && 'matchMedia' in window;
const $75de191877df3172$var$prefersDarkModeMql = $75de191877df3172$var$isMatchMediaAvailable ? window.matchMedia('(prefers-color-scheme: dark)') : undefined; // TODO: currently 'auto' color mode will always return 'light' in SSR.
// Additional work required: https://product-fabric.atlassian.net/browse/DSP-9781
function $75de191877df3172$var$getReconciledColorMode(colorMode) {
    if (colorMode === 'auto') return $75de191877df3172$var$prefersDarkModeMql?.matches ? 'dark' : 'light';
    return colorMode;
}
const $75de191877df3172$var$contentStyles = {
    body: "_3iDTPbcK7c"
};
function $75de191877df3172$export$d8964aec282183a3({ children: children, defaultColorMode: defaultColorMode = 'auto', defaultTheme: defaultTheme }) {
    const [chosenColorMode, setChosenColorMode] = (0, $fsvuC.useState)(defaultColorMode);
    const [reconciledColorMode, setReconciledColorMode] = (0, $fsvuC.useState)($75de191877df3172$var$getReconciledColorMode(defaultColorMode));
    const isInsideAppProvider = (0, $5EoO0.useIsInsideAppProvider)();
    const isAppProviderThemingEnabled = (0, $2S58U.useIsAppProviderThemingEnabled)();
    const isInsideThemeProvider = (0, $dzW4K.useIsInsideThemeProvider)(); /**
                                                             * A top-level ThemeProvider is detected by being the first ThemeProvider inside an AppProvider.
                                                             *
                                                             * This will not use sub-tree theming but instead set the global theme state using the
                                                             * `@atlaskit/tokens` APIs, as it's required for styling root `html` and `body` elements
                                                             * for compatibility with `@atlaskit/css-reset`.
                                                             *
                                                             * In the future we could consider moving away from DOM mutations and require AppProvider to wrap
                                                             * `html` in order to apply global theme state, which would allow a more consistent approach to
                                                             * theme loading.
                                                             */ 
    const isRootThemeProvider = isInsideAppProvider && !isInsideThemeProvider && isAppProviderThemingEnabled; /**
                                                                                                             * Each provider owns its own override stylesheet, so nested providers don't overwrite or remove
                                                                                                             * each other's overrides. `useId` is stable between the server render and hydration.
                                                                                                             *
                                                                                                             * Subtree providers also scope their override selector to their own element. Otherwise every
                                                                                                             * subtree using the same custom theme would match every provider's overrides, and the last
                                                                                                             * stylesheet in the document would win. The root provider targets `html`, which subtrees
                                                                                                             * inherit from.
                                                                                                             */ 
    const customThemeOverridesStyleId = (0, $fsvuC.useId)();
    const { theme: normalizedDefaultTheme, inlineStyles: inlineStyles } = (0, $c1W2k.getThemeAndOverrides)(defaultTheme, isRootThemeProvider ? undefined : customThemeOverridesStyleId);
    const [theme, setTheme] = (0, $fsvuC.useState)(()=>({
            ...$75de191877df3172$var$defaultThemeSettings,
            ...normalizedDefaultTheme
        }));
    const [hasHoistedInlineThemeStyles, setHasHoistedInlineThemeStyles] = (0, $fsvuC.useState)(false);
    const setColorMode = (0, $fsvuC.useCallback)((colorMode)=>{
        setChosenColorMode(colorMode);
        setReconciledColorMode($75de191877df3172$var$getReconciledColorMode(colorMode));
    }, []);
    const setPartialTheme = (0, $fsvuC.useCallback)((nextTheme)=>{
        setTheme((theme)=>({
                ...theme,
                ...nextTheme
            }));
    }, []);
    const lastSetGlobalThemePromiseRef = (0, $fsvuC.useRef)(null); /**
                                                                                                * Custom theme overrides apply regardless of `platform-static-theme-loading`: that gate only
                                                                                                * controls how the theme stylesheets themselves are loaded.
                                                                                                */ 
    const inlineThemeStylesOverrides = inlineStyles;
    (0, $fsvuC.useLayoutEffect)(()=>{
        return ()=>{
            document.head.querySelector(`style[data-theme-overrides="${customThemeOverridesStyleId}"]`)?.remove();
        };
    }, [
        customThemeOverridesStyleId
    ]);
    (0, $fsvuC.useLayoutEffect)(()=>{
        const isStaticThemeLoadingEnabled = (0, $llCao.fg)('platform-static-theme-loading');
        if (isStaticThemeLoadingEnabled && !hasHoistedInlineThemeStyles) (0, $juMDf.getInlineThemeStyles)(theme, chosenColorMode).forEach(({ id: id, css: css })=>{
            if (document.head.querySelector(`style[data-theme="${id}"]`)) return;
            const style = document.createElement('style');
            style.dataset.theme = id;
            style.textContent = css;
            document.head.appendChild(style);
        });
        const existingOverrideStyle = document.head.querySelector(`style[data-theme-overrides="${customThemeOverridesStyleId}"]`);
        if (inlineThemeStylesOverrides) {
            if (existingOverrideStyle) existingOverrideStyle.textContent = inlineThemeStylesOverrides;
            else {
                const style = document.createElement('style');
                style.dataset.themeOverrides = customThemeOverridesStyleId;
                style.textContent = inlineThemeStylesOverrides;
                document.head.appendChild(style);
            }
        } else existingOverrideStyle?.remove();
         // Only re-render to drop the inline styles when there are any to drop.
        if (!hasHoistedInlineThemeStyles && (isStaticThemeLoadingEnabled || inlineThemeStylesOverrides)) setHasHoistedInlineThemeStyles(true);
    }, [
        chosenColorMode,
        customThemeOverridesStyleId,
        hasHoistedInlineThemeStyles,
        inlineThemeStylesOverrides,
        theme
    ]);
    (0, $fsvuC.useEffect)(()=>{
        if (isRootThemeProvider) {
            /**
       * We need to wait for any previous `setGlobalTheme` calls to finish before calling it again.
       * This is to prevent race conditions as `setGlobalTheme` is async and mutates the DOM (e.g. sets the
       * `data-color-mode` attribute on the root element).
       *
       * Since we can't safely abort the `setGlobalTheme` execution, we need to wait for it to properly finish before
       * applying the new theme.
       *
       * Without this, we can end up in the following scenario:
       * 1. app loads with the default 'light' theme, kicking off `setGlobalTheme`
       * 2. app switches to 'dark' theme after retrieving value persisted in local storage, calling `setGlobalTheme` again
       * 3. `setGlobalTheme` function execution for `dark` finishes before the initial `light` execution
       * 4. `setGlobalTheme` function execution for `light` then finishes, resulting in the 'light' theme being applied.
       */ const cleanupLastFnCall = async ()=>{
                if (lastSetGlobalThemePromiseRef.current) {
                    const unbindFn = await lastSetGlobalThemePromiseRef.current;
                    unbindFn();
                    lastSetGlobalThemePromiseRef.current = null;
                }
            };
            const safelySetGlobalTheme = async ()=>{
                await cleanupLastFnCall();
                const promise = (0, $j3auT.setGlobalTheme)({
                    ...theme,
                    colorMode: reconciledColorMode
                });
                lastSetGlobalThemePromiseRef.current = promise;
            };
            safelySetGlobalTheme();
            return function cleanup() {
                cleanupLastFnCall();
            };
        } // For other theme providers (whether outside AppProvider or nested inside a ThemeProvider),
        // we treat them as sub-tree themes that do not load global theme state.
        (0, $cB4Mk.loadAndMountThemes)(theme);
    }, [
        isInsideAppProvider,
        isInsideThemeProvider,
        isRootThemeProvider,
        reconciledColorMode,
        theme
    ]);
    (0, $fsvuC.useEffect)(()=>{
        if (!$75de191877df3172$var$prefersDarkModeMql) return;
        const unbindListener = (0, $dqdTY.bind)($75de191877df3172$var$prefersDarkModeMql, {
            type: 'change',
            listener: (event)=>{
                if (chosenColorMode === 'auto') setReconciledColorMode(event.matches ? 'dark' : 'light');
            }
        });
        return unbindListener;
    }, [
        chosenColorMode
    ]);
    const attrs = {
        ...(0, $fiu3C.getThemeHtmlAttrs)({
            ...theme,
            colorMode: reconciledColorMode
        }),
        [(0, $gCKKR.SUBTREE_THEME_ATTRIBUTE)]: true,
        // Matches this provider's scoped override selector. Only set when there are overrides.
        ...inlineThemeStylesOverrides ? {
            [(0, $c1W2k.CUSTOM_THEME_SCOPE_ATTRIBUTE)]: customThemeOverridesStyleId
        } : {}
    };
    const inlineThemeStyles = (0, $llCao.fg)('platform-static-theme-loading') && !hasHoistedInlineThemeStyles ? (0, $juMDf.getInlineThemeStyles)(theme, chosenColorMode) : [];
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $bvkoW.InsideThemeProviderContext).Provider, {
        value: true,
        children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $9xFXq.ColorModeContext).Provider, {
            value: reconciledColorMode,
            children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $bhVVB.SetColorModeContext).Provider, {
                value: setColorMode,
                children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $1YjM9.ThemeContext).Provider, {
                    value: theme,
                    children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $1YjM9.SetThemeContext).Provider, {
                        value: setPartialTheme,
                        children: !isRootThemeProvider ? /*#__PURE__*/ (0, $5chsV.jsxs)("div", {
                            ...attrs,
                            className: (0, $gJ6nT.default)([
                                $75de191877df3172$var$contentStyles.body
                            ]),
                            children: [
                                !hasHoistedInlineThemeStyles && inlineThemeStylesOverrides && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles
                                /*#__PURE__*/ (0, $5chsV.jsx)("style", {
                                    "data-theme-overrides": customThemeOverridesStyleId,
                                    children: inlineThemeStylesOverrides
                                }),
                                inlineThemeStyles.map(({ id: id, css: css })=>// eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles
                                    /*#__PURE__*/ (0, $5chsV.jsx)("style", {
                                        "data-theme": id,
                                        children: css
                                    }, id)),
                                children
                            ]
                        }) : /*#__PURE__*/ (0, $5chsV.jsxs)((0, $5chsV.Fragment), {
                            children: [
                                !hasHoistedInlineThemeStyles && inlineThemeStylesOverrides && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles
                                /*#__PURE__*/ (0, $5chsV.jsx)("style", {
                                    "data-theme-overrides": customThemeOverridesStyleId,
                                    children: inlineThemeStylesOverrides
                                }),
                                inlineThemeStyles.map(({ id: id, css: css })=>// eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles
                                    /*#__PURE__*/ (0, $5chsV.jsx)("style", {
                                        "data-theme": id,
                                        children: css
                                    }, id)),
                                children
                            ]
                        })
                    })
                })
            })
        })
    });
}
$75de191877df3172$export$d8964aec282183a3.displayName = "ThemeProvider";

});
parcelRegister("gCKKR", function(module, exports) {
$parcel$export(module.exports, "THEME_DATA_ATTRIBUTE", () => $16f36540d1f15379$export$4ef52930e33717cd);
$parcel$export(module.exports, "SUBTREE_THEME_ATTRIBUTE", () => $16f36540d1f15379$export$cb374d25ded7f6ab);
$parcel$export(module.exports, "COLOR_MODE_ATTRIBUTE", () => $16f36540d1f15379$export$a00eac3f8684bcd0);
$parcel$export(module.exports, "CONTRAST_MODE_ATTRIBUTE", () => $16f36540d1f15379$export$2112803007239c61);
$parcel$export(module.exports, "CUSTOM_THEME_ATTRIBUTE", () => $16f36540d1f15379$export$352e418ed5b6193a);
$parcel$export(module.exports, "CSS_PREFIX", () => $16f36540d1f15379$export$6f0c6fb8c80fcc92);
$parcel$export(module.exports, "CSS_VAR_FULL", () => $16f36540d1f15379$export$4d0c7bbf80185957);
$parcel$export(module.exports, "TOKEN_NOT_FOUND_CSS_VAR", () => $16f36540d1f15379$export$dddac1532e822863);
$parcel$export(module.exports, "CURRENT_SURFACE_CSS_VAR", () => $16f36540d1f15379$export$9d7b58831ae93caa);
const $16f36540d1f15379$export$4ef52930e33717cd = 'data-theme';
const $16f36540d1f15379$export$cb374d25ded7f6ab = 'data-subtree-theme';
const $16f36540d1f15379$export$a00eac3f8684bcd0 = 'data-color-mode';
const $16f36540d1f15379$export$2112803007239c61 = 'data-contrast-mode';
const $16f36540d1f15379$export$352e418ed5b6193a = 'data-custom-theme';
const $16f36540d1f15379$export$6f0c6fb8c80fcc92 = 'ds';
const $16f36540d1f15379$export$4d0c7bbf80185957 = [
    'opacity',
    'font',
    'space',
    'border',
    'radius'
];
const $16f36540d1f15379$export$dddac1532e822863 = `--${$16f36540d1f15379$export$6f0c6fb8c80fcc92}-token-not-found`;
const $16f36540d1f15379$export$9d7b58831ae93caa = `--${$16f36540d1f15379$export$6f0c6fb8c80fcc92}-elevation-surface-current`;

});

parcelRegister("c1W2k", function(module, exports) {
$parcel$export(module.exports, "CUSTOM_THEME_SCOPE_ATTRIBUTE", () => $6c5afc4842617017$export$e5f6e0f338f81b9a);
$parcel$export(module.exports, "getThemeAndOverrides", () => $6c5afc4842617017$export$12087c26a9b2e83e);
function $6c5afc4842617017$var$isThemeWithOverrides(value) {
    return typeof value === 'object' && value !== null && 'id' in value && 'overrides' in value && typeof value.id === 'string' && typeof value.overrides === 'object' && value.overrides !== null;
}
const $6c5afc4842617017$export$e5f6e0f338f81b9a = 'data-theme-overrides-scope';
function $6c5afc4842617017$export$12087c26a9b2e83e(themeWithOverrides, scope) {
    const theme = {};
    const overrides = {};
    for (const [themeKind, value] of Object.entries(themeWithOverrides || {})){
        if ($6c5afc4842617017$var$isThemeWithOverrides(value)) {
            theme[themeKind] = value.id;
            overrides[themeKind] = {
                [value.id]: value.overrides
            };
            continue;
        }
        theme[themeKind] = value;
    }
    return {
        theme: theme,
        inlineStyles: $6c5afc4842617017$var$getCustomThemeOverrideStyles(overrides, scope)
    };
}
/**
 * Escapes a value for use inside a double-quoted CSS attribute selector.
 */ function $6c5afc4842617017$var$escapeAttributeValue(value) {
    return value.replace(/["\\]/g, '\\$&');
}
function $6c5afc4842617017$var$getThemeOverrideSelector(themeKind, themeName, scope) {
    // Colour themes only apply in their own colour mode.
    const colorMode = themeKind === 'light' || themeKind === 'dark' ? `[data-color-mode="${themeKind}"]` : '';
    const theme = `${colorMode}[data-theme~="${themeKind}:${themeName}"]`;
    if (scope) return `[data-subtree-theme][${$6c5afc4842617017$export$e5f6e0f338f81b9a}="${$6c5afc4842617017$var$escapeAttributeValue(scope)}"]${theme}`;
    return `html${theme}, [data-subtree-theme]${theme}`;
}
function $6c5afc4842617017$var$getCssVariableName(propertyName) {
    return `--ds-${propertyName.replace(/([A-Z])/g, '-$1').toLowerCase()}`;
}
/**
 * Generates CSS for custom theme overrides.
 *
 * Override property names are converted from camel case to `--ds-` CSS custom properties.
 */ function $6c5afc4842617017$var$getCustomThemeOverrideStyles(overrides, scope) {
    if (!overrides) return '';
    return Object.entries(overrides).flatMap(([themeKind, themes])=>Object.entries(themes || {}).flatMap(([themeName, values])=>{
            const styles = Object.entries(values || {})// Unset optional inputs are skipped so the theme's `var()` fallback applies. Writing
            // `undefined` would be a valid custom property value that breaks the formula.
            .filter(([, value])=>value !== undefined && value !== null).map(([propertyName, value])=>`${$6c5afc4842617017$var$getCssVariableName(propertyName)}: ${value};`).join('');
            return styles ? `
		${$6c5afc4842617017$var$getThemeOverrideSelector(themeKind, themeName, scope)} {
			${styles}
		}
	` : [];
        })).join('');
}

});

parcelRegister("fiu3C", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "getThemeHtmlAttrs", () => $4d3adfa285e347aa$export$e1f80cb7a749802f);
$parcel$export(module.exports, "default", () => $4d3adfa285e347aa$export$2e2bcd8739ae039);

var $llCao = parcelRequire("llCao");

var $gCKKR = parcelRequire("gCKKR");

var $5YW6K = parcelRequire("5YW6K");

var $UsQyW = parcelRequire("UsQyW");

var $lFod3 = parcelRequire("lFod3");

var $3T8mu = parcelRequire("3T8mu");
const $4d3adfa285e347aa$var$defaultColorMode = 'light';
const $4d3adfa285e347aa$var$defaultContrastMode = 'no-preference';
const $4d3adfa285e347aa$export$e1f80cb7a749802f = ({ colorMode: colorMode = (0, $UsQyW.themeStateDefaults)['colorMode'], dark: dark = (0, $UsQyW.themeStateDefaults)['dark'], light: light = (0, $UsQyW.themeStateDefaults)['light'], contrastMode: contrastMode = (0, $UsQyW.themeStateDefaults)['contrastMode'], motion: motion = (0, $UsQyW.themeStateDefaults)['motion'](), shape: shape = (0, $UsQyW.themeStateDefaults)['shape'], spacing: spacing = (0, $UsQyW.themeStateDefaults)['spacing'], typography: typography = (0, $UsQyW.themeStateDefaults)['typography'], UNSAFE_themeOptions: UNSAFE_themeOptions = (0, $UsQyW.themeStateDefaults)['UNSAFE_themeOptions'] } = {})=>{
    const themeAttribute = (0, $5YW6K.themeObjectToString)({
        dark: dark,
        light: light,
        motion: motion,
        shape: shape,
        spacing: spacing,
        typography: typography
    });
    let result = {
        [(0, $gCKKR.THEME_DATA_ATTRIBUTE)]: themeAttribute,
        [(0, $gCKKR.COLOR_MODE_ATTRIBUTE)]: colorMode === 'auto' ? $4d3adfa285e347aa$var$defaultColorMode : colorMode
    };
    if ((0, $llCao.fg)('platform_increased-contrast-themes')) result = {
        ...result,
        // CLEANUP: Move this to the initial `result` assignment above
        [(0, $gCKKR.CONTRAST_MODE_ATTRIBUTE)]: contrastMode === 'auto' ? $4d3adfa285e347aa$var$defaultContrastMode : contrastMode
    };
    if (UNSAFE_themeOptions && (0, $3T8mu.isValidBrandHex)(UNSAFE_themeOptions.brandColor)) {
        const optionString = JSON.stringify(UNSAFE_themeOptions);
        const uniqueId = (0, $lFod3.hash)(optionString);
        result[0, $gCKKR.CUSTOM_THEME_ATTRIBUTE] = uniqueId;
    }
    return result;
};
var $4d3adfa285e347aa$export$2e2bcd8739ae039 = $4d3adfa285e347aa$export$e1f80cb7a749802f;

});
parcelRegister("5YW6K", function(module, exports) {
$parcel$export(module.exports, "themeObjectToString", () => $2c7813bcb6c67c9f$export$62c37ab81302621a);

var $iTsiC = parcelRequire("iTsiC");

var $aNrGb = parcelRequire("aNrGb");

var $1wEbr = parcelRequire("1wEbr");
const $2c7813bcb6c67c9f$var$customThemeOptions = 'UNSAFE_themeOptions';
const $2c7813bcb6c67c9f$export$62c37ab81302621a = (themeState)=>Object.entries(themeState).reduce((themeString, [kind, id])=>{
        if (// colorMode theme state
        kind === 'colorMode' && typeof id === 'string' && (0, $iTsiC.isColorMode)(id) || // custom theme state
        kind === $2c7813bcb6c67c9f$var$customThemeOptions && typeof id === 'object' || // other theme states
        (0, $1wEbr.isThemeKind)(kind) && typeof id === 'string' && (0, $aNrGb.isThemeIds)(id)) return themeString + `${themeString ? ' ' : ''}` + `${kind}:${typeof id === 'object' ? JSON.stringify(id) : id}`;
        return themeString;
    }, '');

});
parcelRegister("iTsiC", function(module, exports) {
$parcel$export(module.exports, "isColorMode", () => $58aebfd8ab773a6a$export$4a14e169b1de4ee7);
const $58aebfd8ab773a6a$export$4a14e169b1de4ee7 = (modeId)=>{
    return [
        'light',
        'dark',
        'auto'
    ].includes(modeId);
};

});

parcelRegister("aNrGb", function(module, exports) {
$parcel$export(module.exports, "isThemeIds", () => $b10ce0b04cdceb95$export$ea35b8958c39dd07);

var $1KFZi = parcelRequire("1KFZi");
const $b10ce0b04cdceb95$export$ea35b8958c39dd07 = (themeId)=>{
    return (0, $1KFZi.themeIds).find((id)=>id === themeId) !== undefined;
};

});
parcelRegister("1KFZi", function(module, exports) {
$parcel$export(module.exports, "themeIds", () => $f70798f082fdb8f7$export$7d43e72a58e3283f);
const $f70798f082fdb8f7$export$7d43e72a58e3283f = [
    'light-increased-contrast',
    'light',
    'light-future',
    'UNSAFE-dynamic',
    'UNSAFE-dynamic-dark',
    'UNSAFE-test-light',
    'dark',
    'UNSAFE-test-dark',
    'dark-future',
    'dark-increased-contrast',
    'spacing',
    'shape',
    'typography',
    'UNSAFE-typography',
    'motion'
];

});


parcelRegister("1wEbr", function(module, exports) {
$parcel$export(module.exports, "isThemeKind", () => $51eb0855c66066b0$export$958fa026be3a263e);
const $51eb0855c66066b0$var$themeKinds = [
    'light',
    'dark',
    'spacing',
    'typography',
    'shape',
    'motion'
];
const $51eb0855c66066b0$export$958fa026be3a263e = (themeKind)=>{
    return $51eb0855c66066b0$var$themeKinds.find((kind)=>kind === themeKind) !== undefined;
};

});


parcelRegister("UsQyW", function(module, exports) {
$parcel$export(module.exports, "themeStateDefaults", () => $0a51a323ff6b1b7e$export$9aedcfa7336a207);
function $0a51a323ff6b1b7e$var$getMotionDefault() {
    return 'motion';
}
const $0a51a323ff6b1b7e$export$9aedcfa7336a207 = {
    colorMode: 'auto',
    contrastMode: 'auto',
    dark: 'dark',
    light: 'light',
    shape: 'shape',
    spacing: 'spacing',
    typography: 'typography',
    motion: $0a51a323ff6b1b7e$var$getMotionDefault,
    UNSAFE_themeOptions: undefined
};

});

parcelRegister("lFod3", function(module, exports) {
$parcel$export(module.exports, "hash", () => $378904dd2bc0d9e5$export$d6af199866bfb566);
const $378904dd2bc0d9e5$export$d6af199866bfb566 = (str)=>{
    let hash = 0;
    for(let i = 0; i < str.length; i++){
        const char = str.charCodeAt(i);
        hash = (hash << 5) - hash + char;
        hash &= hash; // Convert to 32bit integer
    }
    return new Uint32Array([
        hash
    ])[0].toString(36);
};

});

parcelRegister("3T8mu", function(module, exports) {
$parcel$export(module.exports, "isValidBrandHex", () => $3534582cced18ef5$export$53031ac1ecb71f44);
const $3534582cced18ef5$export$53031ac1ecb71f44 = (hex)=>/^#[0-9A-F]{6}$/i.test(hex);

});


parcelRegister("j3auT", function(module, exports) {
$parcel$export(module.exports, "setGlobalTheme", () => $6fcf2a68b2e8b21a$export$fd7e0dd2b74807f7);

var $llCao = parcelRequire("llCao");

var $dIKZc = parcelRequire("dIKZc");

var $UsQyW = parcelRequire("UsQyW");

var $gCRra = parcelRequire("gCRra");

var $dAthX = parcelRequire("dAthX");

var $fkm4H = parcelRequire("fkm4H");

var $hDcGm = parcelRequire("hDcGm");

var $3T8mu = parcelRequire("3T8mu");

var $lIu3X = parcelRequire("lIu3X");

var $9I4fj = parcelRequire("9I4fj");

/**
 * Sets the theme globally at runtime. This updates the `data-theme` and `data-color-mode` attributes on your page's <html> tag.
 *
 * @param {Object<string, string>} themeState The themes and color mode that should be applied.
 * @param {string} themeState.colorMode Determines which color theme is applied. If set to `auto`, the theme applied will be determined by the OS setting.
 * @param {string} themeState.contrastMode The contrast mode theme to be applied. If set to `auto`, the theme applied will be determined by the OS setting.set to `auto`, the theme applied will be determined by the OS setting.
 * @param {string} themeState.dark The color theme to be applied when the color mode resolves to 'dark'.
 * @param {string} themeState.light The color theme to be applied when the color mode resolves to 'light'.
 * @param {string} themeState.motion The motion theme to be applied.
 * @param {string} themeState.shape The shape theme to be applied.
 * @param {string} themeState.spacing The spacing theme to be applied.
 * @param {string} themeState.typography The typography theme to be applied.
 * @param {Object} themeState.UNSAFE_themeOptions The custom branding options to be used for custom theme generation
 * @param {function} themeLoader Callback function used to override the default theme loading functionality.
 *
 * @returns A Promise of an unbind function, that can be used to stop listening for changes to system theme.
 *
 * @example
 * ```
 * setGlobalTheme({colorMode: 'auto', light: 'light', dark: 'dark', spacing: 'spacing'});
 * ```
 */ const $6fcf2a68b2e8b21a$export$fd7e0dd2b74807f7 = async (nextThemeState = {}, themeLoader)=>{
    let { colorMode: colorMode = (0, $UsQyW.themeStateDefaults)['colorMode'], contrastMode: contrastMode = (0, $UsQyW.themeStateDefaults)['contrastMode'], dark: dark = (0, $UsQyW.themeStateDefaults)['dark'], light: light = (0, $UsQyW.themeStateDefaults)['light'], shape: shape = (0, $UsQyW.themeStateDefaults)['shape'], spacing: spacing = (0, $UsQyW.themeStateDefaults)['spacing'], typography: typography = (0, $UsQyW.themeStateDefaults)['typography'], motion: motion = (0, $UsQyW.themeStateDefaults)['motion'](), UNSAFE_themeOptions: UNSAFE_themeOptions = (0, $UsQyW.themeStateDefaults)['UNSAFE_themeOptions'] } = typeof nextThemeState === 'function' ? nextThemeState({
        ...(0, $UsQyW.themeStateDefaults),
        typography: (0, $UsQyW.themeStateDefaults)['typography'],
        shape: (0, $UsQyW.themeStateDefaults)['shape'],
        motion: (0, $UsQyW.themeStateDefaults)['motion'](),
        ...(0, $dIKZc.getGlobalTheme)()
    }) : nextThemeState;
    // CLEANUP: Remove. This blocks application of increased contrast themes
    // without the feature flag enabled.
    if (!(0, $llCao.fg)('platform_increased-contrast-themes')) {
        if (light === 'light-increased-contrast') light = 'light';
        if (dark === 'dark-increased-contrast') dark = 'dark';
    }
    const themeState = {
        colorMode: colorMode,
        contrastMode: contrastMode,
        dark: dark,
        light: light,
        shape: shape,
        spacing: spacing,
        typography: typography,
        motion: motion,
        UNSAFE_themeOptions: themeLoader ? undefined : UNSAFE_themeOptions
    };
    // Determine what to load and loading strategy
    const themePreferences = (0, $hDcGm.getThemePreferences)(themeState);
    const loadingStrategy = themeLoader ? themeLoader : (0, $9I4fj.loadAndAppendThemeCss);
    // Load standard themes
    const loadingTasks = themePreferences.map(async (themeId)=>await loadingStrategy(themeId));
    const themeOverridePreferences = (0, $fkm4H.getThemeOverridePreferences)(themeState);
    // Start loading override CSS before the first await. It is appended only after the standard
    // themes have loaded so that the override cascade order remains deterministic.
    const overrideThemeCssLoadingTasks = themeLoader ? [] : themeOverridePreferences.map((themeId)=>(0, $lIu3X.loadThemeCss)(themeId));
    // Load custom themes if needed
    if (!themeLoader && UNSAFE_themeOptions && (0, $3T8mu.isValidBrandHex)(UNSAFE_themeOptions?.brandColor)) {
        const mode = colorMode || (0, $UsQyW.themeStateDefaults)['colorMode'];
        const attrOfMissingCustomStyles = (0, $dAthX.findMissingCustomStyleElements)(UNSAFE_themeOptions, mode);
        if (attrOfMissingCustomStyles.length > 0) // Load custom theme styles
        loadingTasks.push((async ()=>{
            const { loadAndAppendCustomThemeCss: loadAndAppendCustomThemeCss } = await (parcelRequire("aoCnk"));
            loadAndAppendCustomThemeCss({
                colorMode: attrOfMissingCustomStyles.length === 2 ? 'auto' : attrOfMissingCustomStyles[0],
                UNSAFE_themeOptions: UNSAFE_themeOptions
            });
        })());
    }
    await Promise.all(loadingTasks);
    // Load override themes after standard themes
    if (themeLoader) for (const themeId of themeOverridePreferences)await loadingStrategy(themeId);
    else {
        const overrideThemeCss = await Promise.all(overrideThemeCssLoadingTasks);
        await Promise.all(themeOverridePreferences.map((themeId, index)=>(0, $9I4fj.loadAndAppendThemeCss)(themeId, overrideThemeCss[index])));
    }
    const autoUnbind = (0, $gCRra.default)(themeState);
    return autoUnbind;
};

});
parcelRegister("dIKZc", function(module, exports) {
$parcel$export(module.exports, "getGlobalTheme", () => $773ae257383f62e6$export$813ecdf77207a053);

var $gCKKR = parcelRequire("gCKKR");

var $6QO58 = parcelRequire("6QO58");

var $34ieU = parcelRequire("34ieU");
const $773ae257383f62e6$export$813ecdf77207a053 = ()=>{
    if (typeof document === 'undefined') return {};
    const element = document.documentElement;
    const colorMode = element.getAttribute((0, $gCKKR.COLOR_MODE_ATTRIBUTE)) || '';
    const theme = element.getAttribute((0, $gCKKR.THEME_DATA_ATTRIBUTE)) || '';
    return {
        ...(0, $34ieU.themeStringToObject)(theme),
        ...(0, $6QO58.isThemeColorMode)(colorMode) && {
            colorMode: colorMode
        }
    };
};

});
parcelRegister("6QO58", function(module, exports) {
$parcel$export(module.exports, "isThemeColorMode", () => $19352bf1ae599d73$export$fcfb1976c88f9f75);

var $2FSGD = parcelRequire("2FSGD");
const $19352bf1ae599d73$export$fcfb1976c88f9f75 = (colorMode)=>{
    return (0, $2FSGD.themeColorModes).find((mode)=>mode === colorMode) !== undefined;
};

});
parcelRegister("2FSGD", function(module, exports) {
$parcel$export(module.exports, "themeColorModes", () => $7bbca1fa6d72c863$export$83993de8eb66733);
/**
 * Theme modes: The general purpose of a theme.
 * This attr is used to apply the appropriate system-preference option
 * It may also be used as a selector for mode-specific overrides such as light/dark images.
 * The idea is there may exist many color themes, but every theme must either fit into light or dark.
 */ const $7bbca1fa6d72c863$export$83993de8eb66733 = [
    'light',
    'dark',
    'auto'
];

});


parcelRegister("34ieU", function(module, exports) {
$parcel$export(module.exports, "themeStringToObject", () => $5ffbe3a7b29990e6$export$f19b488f7c0547ee);

var $iTsiC = parcelRequire("iTsiC");

var $aNrGb = parcelRequire("aNrGb");

var $1wEbr = parcelRequire("1wEbr");
const $5ffbe3a7b29990e6$var$customThemeOptions = 'UNSAFE_themeOptions';
const $5ffbe3a7b29990e6$export$f19b488f7c0547ee = (themeState)=>{
    return themeState.split(' ').map((theme)=>theme.split(/:(.*)/s)).reduce((themeObject, [kind, id])=>{
        if (kind === 'colorMode' && (0, $iTsiC.isColorMode)(id)) themeObject[kind] = id;
        if ((0, $1wEbr.isThemeKind)(kind) && (0, $aNrGb.isThemeIds)(id)) // @ts-expect-error FIXME - this is a valid ts error
        themeObject[kind] = id;
        if (kind === $5ffbe3a7b29990e6$var$customThemeOptions) try {
            themeObject[$5ffbe3a7b29990e6$var$customThemeOptions] = JSON.parse(id);
        } catch  {
            new Error('Invalid custom theme string');
        }
        return themeObject;
    }, {});
};

});


parcelRegister("gCRra", function(module, exports) {
$parcel$export(module.exports, "default", () => $8fa15c80ad72f9ca$export$2e2bcd8739ae039);

var $llCao = parcelRequire("llCao");

var $fiu3C = parcelRequire("fiu3C");

var $cVOgP = parcelRequire("cVOgP");

var $2OgDV = parcelRequire("2OgDV");
function $8fa15c80ad72f9ca$export$2e2bcd8739ae039(themeState) {
    if (themeState.colorMode === 'auto') {
        // Set colorMode based on the user preference
        themeState.colorMode = (0, $cVOgP.default).getColorMode();
        // Bind a listener (if one doesn't already exist) to keep colorMode updated
        (0, $cVOgP.default).bind();
    } else (0, $cVOgP.default).unbind();
    if ((0, $llCao.fg)('platform_increased-contrast-themes')) {
        if (themeState.contrastMode === 'auto') {
            // Set contrastMode based on the user preference
            themeState.contrastMode = (0, $2OgDV.default).getContrastMode();
            // Bind a listener (if one doesn't already exist) to keep contrastMode updated
            (0, $2OgDV.default).bind();
        } else (0, $2OgDV.default).unbind();
    }
    const themeAttributes = (0, $fiu3C.default)(themeState);
    Object.entries(themeAttributes).forEach(([key, value])=>{
        document.documentElement.setAttribute(key, value);
    });
    return ()=>{
        (0, $cVOgP.default).unbind();
        if ((0, $llCao.fg)('platform_increased-contrast-themes')) (0, $2OgDV.default).unbind();
    };
}

});
parcelRegister("cVOgP", function(module, exports) {
$parcel$export(module.exports, "default", () => $a6901a0687581248$export$2e2bcd8739ae039);

var $dqdTY = parcelRequire("dqdTY");

var $gCKKR = parcelRequire("gCKKR");

var $9I4fj = parcelRequire("9I4fj");
const $a6901a0687581248$var$isMatchMediaAvailable = typeof window !== 'undefined' && 'matchMedia' in window;
/**
 * Updates the current theme when the system theme changes. Should be bound
 * to an event listener listening on the '(prefers-color-scheme: dark)' query
 * @param e The event representing a change in system theme.
 */ function $a6901a0687581248$var$checkNativeListener(e) {
    const element = document.documentElement;
    element.setAttribute((0, $gCKKR.COLOR_MODE_ATTRIBUTE), e.matches ? 'dark' : 'light');
}
const $a6901a0687581248$var$darkModeMql = $a6901a0687581248$var$isMatchMediaAvailable && window.matchMedia((0, $9I4fj.darkModeMediaQuery));
class $a6901a0687581248$var$ColorModeObserver {
    getColorMode() {
        if (!$a6901a0687581248$var$darkModeMql) return 'light';
        return $a6901a0687581248$var$darkModeMql?.matches ? 'dark' : 'light';
    }
    bind() {
        if ($a6901a0687581248$var$darkModeMql && this.unbindThemeChangeListener === null) this.unbindThemeChangeListener = (0, $dqdTY.bind)($a6901a0687581248$var$darkModeMql, {
            type: 'change',
            listener: $a6901a0687581248$var$checkNativeListener
        });
    }
    unbind() {
        if (this.unbindThemeChangeListener) {
            this.unbindThemeChangeListener();
            this.unbindThemeChangeListener = null;
        }
    }
    constructor(){
        this.unbindThemeChangeListener = null;
    }
}
$a6901a0687581248$var$ColorModeObserver.displayName = "ColorModeObserver";
/**
 * A singleton color mode observer - binds "auto" switching logic to a single `mediaQueryList` listener
 * that can be unbound by any consumer when no longer needed.
 */ const $a6901a0687581248$var$SingletonColorModeObserver = new $a6901a0687581248$var$ColorModeObserver();
var $a6901a0687581248$export$2e2bcd8739ae039 = $a6901a0687581248$var$SingletonColorModeObserver;

});
parcelRegister("9I4fj", function(module, exports) {
$parcel$export(module.exports, "loadAndAppendThemeCss", () => $63b6605cee12c150$export$26cd7ae85c7144e5);
$parcel$export(module.exports, "darkModeMediaQuery", () => $63b6605cee12c150$export$bb1e815119d30f8b);
$parcel$export(module.exports, "moreContrastMediaQuery", () => $63b6605cee12c150$export$8662df6937d86fcb);

var $gCKKR = parcelRequire("gCKKR");

var $lIu3X = parcelRequire("lIu3X");
const $63b6605cee12c150$export$26cd7ae85c7144e5 = async (themeId, preloadedThemeCss)=>{
    if (document.head.querySelector(`style[${(0, $gCKKR.THEME_DATA_ATTRIBUTE)}="${themeId}"]:not([${(0, $gCKKR.CUSTOM_THEME_ATTRIBUTE)}])`)) return;
    // Gracefully handles falsy values like `null` and `undefined` when maker ignore TS
    // to avoid loading default themes.
    if (!themeId) return;
    const themeCss = preloadedThemeCss ?? await (0, $lIu3X.loadThemeCss)(themeId);
    const style = document.createElement('style');
    style.textContent = themeCss;
    style.dataset.theme = themeId;
    document.head.appendChild(style);
};
const $63b6605cee12c150$export$bb1e815119d30f8b = '(prefers-color-scheme: dark)';
const $63b6605cee12c150$export$8662df6937d86fcb = '(prefers-contrast: more)';

});
parcelRegister("lIu3X", function(module, exports) {
$parcel$export(module.exports, "loadThemeCss", () => $e5f402aa6bec68c0$export$8a48286ed7df6720);

var $kjMka = parcelRequire("kjMka");
const $e5f402aa6bec68c0$export$8a48286ed7df6720 = async (themeId)=>{
    const { default: themeCss } = await (0, $kjMka.default)[themeId]();
    return themeCss;
};

});
parcelRegister("kjMka", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "themeImportMap", () => $ab142957292f8613$export$3a171c49f8c16356);
$parcel$export(module.exports, "default", () => $ab142957292f8613$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * This file contains a dynamic import for each theme this package exports.
 * Themes are loaded asynchronously at runtime to minimise the amount of CSS we send to the client.
 * This allows users to compose their themes and only use the tokens that are requested.
 * When a new theme is created, the import should automatically be added to the map
 *
 * @codegen <<SignedSource::b1d12c60fe57e05a2251249c2cea7224>>
 * @codegenCommand yarn build tokens
 */ 



















const $ab142957292f8613$export$3a171c49f8c16356 = {
    'light': ()=>(parcelRequire("8T1G2")),
    'light-future': ()=>(parcelRequire("adJ6X")),
    'light-finesse': ()=>(parcelRequire("5cK1k")),
    'light-increased-contrast-finesse': ()=>(parcelRequire("cnB0p")),
    'light-increased-contrast': ()=>(parcelRequire("dIL0o")),
    'UNSAFE-dynamic': ()=>(parcelRequire("alNPV")),
    'UNSAFE-dynamic-dark': ()=>(parcelRequire("c7cPg")),
    'UNSAFE-test-light': ()=>(parcelRequire("8iXau")),
    'UNSAFE-test-dark': ()=>(parcelRequire("j3CN4")),
    'dark': ()=>(parcelRequire("vnvvW")),
    'dark-future': ()=>(parcelRequire("77cBy")),
    'dark-finesse': ()=>(parcelRequire("12opD")),
    'dark-increased-contrast-finesse': ()=>(parcelRequire("4EZN5")),
    'dark-increased-contrast': ()=>(parcelRequire("1TGWa")),
    'spacing': ()=>(parcelRequire("j0ZKZ")),
    'typography': ()=>(parcelRequire("3yS8b")),
    'UNSAFE-typography': ()=>(parcelRequire("eUtoU")),
    'typography-finesse': ()=>(parcelRequire("4suD4")),
    'shape': ()=>(parcelRequire("lD6ys")),
    'motion': ()=>(parcelRequire("7X6DA"))
};
var $ab142957292f8613$export$2e2bcd8739ae039 = $ab142957292f8613$export$3a171c49f8c16356;

});
parcelRegister("8T1G2", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("lKBRc").then(()=>parcelRequire('dKi8g'));

});
parcelRegister("dk4lR", function(module, exports) {
"use strict";

function $9b3084c5dabc3940$var$load(id) {
    // eslint-disable-next-line no-undef
    return import((parcelRequire("8b7E8")).resolve(id));
}
module.exports = $9b3084c5dabc3940$var$load;

});
parcelRegister("8b7E8", function(module, exports) {
$parcel$export(module.exports, "register", () => $01896021d7502578$export$6503ec6e8aabbaf, (v) => $01896021d7502578$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $01896021d7502578$export$f7ad0328861e2f03, (v) => $01896021d7502578$export$f7ad0328861e2f03 = v);
var $01896021d7502578$export$6503ec6e8aabbaf;
var $01896021d7502578$export$f7ad0328861e2f03;
"use strict";
var $01896021d7502578$var$mapping = new Map();
function $01896021d7502578$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$01896021d7502578$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $01896021d7502578$var$resolve(id) {
    var resolved = $01896021d7502578$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$01896021d7502578$export$6503ec6e8aabbaf = $01896021d7502578$var$register;
$01896021d7502578$export$f7ad0328861e2f03 = $01896021d7502578$var$resolve;

});



parcelRegister("adJ6X", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("bGiw3").then(()=>parcelRequire('ev6zS'));

});

parcelRegister("5cK1k", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("3ggPj").then(()=>parcelRequire('1Q9kL'));

});

parcelRegister("cnB0p", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("6qVDh").then(()=>parcelRequire('9o36d'));

});

parcelRegister("dIL0o", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("bLgSj").then(()=>parcelRequire('fkigg'));

});

parcelRegister("alNPV", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("ft4s0").then(()=>parcelRequire('2GqGU'));

});

parcelRegister("c7cPg", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("eCZkZ").then(()=>parcelRequire('7qz1L'));

});

parcelRegister("8iXau", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("f5MoJ").then(()=>parcelRequire('3Ttnh'));

});

parcelRegister("j3CN4", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("lQucc").then(()=>parcelRequire('fG8yr'));

});

parcelRegister("vnvvW", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("jLCvY").then(()=>parcelRequire('1eCj4'));

});

parcelRegister("77cBy", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("69sgf").then(()=>parcelRequire('gVsla'));

});

parcelRegister("12opD", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("7skJU").then(()=>parcelRequire('51TZ5'));

});

parcelRegister("4EZN5", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("5Flq4").then(()=>parcelRequire('jtQdo'));

});

parcelRegister("1TGWa", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("gCbda").then(()=>parcelRequire('lFEt6'));

});

parcelRegister("j0ZKZ", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("7trZP").then(()=>parcelRequire('lADdd'));

});

parcelRegister("3yS8b", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("5WIWg").then(()=>parcelRequire('1PAvX'));

});

parcelRegister("eUtoU", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("dBPGo").then(()=>parcelRequire('5BrVu'));

});

parcelRegister("4suD4", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("bT6az").then(()=>parcelRequire('i0F4y'));

});

parcelRegister("lD6ys", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("kSqZ5").then(()=>parcelRequire('1W0BO'));

});

parcelRegister("7X6DA", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("cv4eD").then(()=>parcelRequire('hZeap'));

});





parcelRegister("2OgDV", function(module, exports) {
$parcel$export(module.exports, "default", () => $dfa54a22d20203b0$export$2e2bcd8739ae039);

var $dqdTY = parcelRequire("dqdTY");

var $gCKKR = parcelRequire("gCKKR");

var $9I4fj = parcelRequire("9I4fj");
const $dfa54a22d20203b0$var$isMatchMediaAvailable = typeof window !== 'undefined' && 'matchMedia' in window;
/**
 * Updates the current theme when the system contrast preference changes. Should be bound
 * to an event listener listening on the '(prefers-contrast: more)' query
 * @param e The event representing a change in system theme.
 */ function $dfa54a22d20203b0$var$checkNativeListener(e) {
    const element = document.documentElement;
    element.setAttribute((0, $gCKKR.CONTRAST_MODE_ATTRIBUTE), e.matches ? 'more' : 'no-preference');
}
const $dfa54a22d20203b0$var$contrastModeMql = $dfa54a22d20203b0$var$isMatchMediaAvailable && window.matchMedia((0, $9I4fj.moreContrastMediaQuery));
class $dfa54a22d20203b0$var$ContrastModeObserver {
    getContrastMode() {
        if (!$dfa54a22d20203b0$var$contrastModeMql) return 'no-preference';
        return $dfa54a22d20203b0$var$contrastModeMql?.matches ? 'more' : 'no-preference';
    }
    bind() {
        if ($dfa54a22d20203b0$var$contrastModeMql && this.unbindContrastChangeListener === null) this.unbindContrastChangeListener = (0, $dqdTY.bind)($dfa54a22d20203b0$var$contrastModeMql, {
            type: 'change',
            listener: $dfa54a22d20203b0$var$checkNativeListener
        });
    }
    unbind() {
        if (this.unbindContrastChangeListener) {
            this.unbindContrastChangeListener();
            this.unbindContrastChangeListener = null;
        }
    }
    constructor(){
        this.unbindContrastChangeListener = null;
    }
}
$dfa54a22d20203b0$var$ContrastModeObserver.displayName = "ContrastModeObserver";
/**
 * A singleton contrast mode observer - binds "auto" switching logic to a single `mediaQueryList` listener
 * that can be unbound by any consumer when no longer needed.
 */ const $dfa54a22d20203b0$var$SingletonContrastModeObserver = new $dfa54a22d20203b0$var$ContrastModeObserver();
var $dfa54a22d20203b0$export$2e2bcd8739ae039 = $dfa54a22d20203b0$var$SingletonContrastModeObserver;

});


parcelRegister("dAthX", function(module, exports) {
$parcel$export(module.exports, "findMissingCustomStyleElements", () => $a85d13c9baf94e71$export$bd1ac9300b0e885a);

var $gCKKR = parcelRequire("gCKKR");

var $lFod3 = parcelRequire("lFod3");
function $a85d13c9baf94e71$export$bd1ac9300b0e885a(UNSAFE_themeOptions, mode) {
    const optionString = JSON.stringify(UNSAFE_themeOptions);
    const uniqueId = (0, $lFod3.hash)(optionString);
    const attrOfMissingCustomStyles = [];
    (mode === 'auto' ? [
        'light',
        'dark'
    ] : [
        mode
    ]).forEach((themeId)=>{
        const element = document.head.querySelector(`style[${(0, $gCKKR.CUSTOM_THEME_ATTRIBUTE)}="${uniqueId}"][${(0, $gCKKR.THEME_DATA_ATTRIBUTE)}="${themeId}"]`);
        if (element) // Append the existing custom styles to take precedence over others
        document.head.appendChild(element);
        else attrOfMissingCustomStyles.push(themeId);
    });
    return attrOfMissingCustomStyles;
}

});

parcelRegister("fkm4H", function(module, exports) {
$parcel$export(module.exports, "getThemeOverridePreferences", () => $d2922f88cad0d7df$export$5d76d7014f4a5d08);

var $llCao = parcelRequire("llCao");

var $kFFkO = parcelRequire("kFFkO");
const $d2922f88cad0d7df$var$finesseOverrides = {
    light: 'light-finesse',
    'light-increased-contrast': 'light-increased-contrast-finesse',
    dark: 'dark-finesse',
    'dark-increased-contrast': 'dark-increased-contrast-finesse',
    typography: 'typography-finesse'
};
const $d2922f88cad0d7df$export$5d76d7014f4a5d08 = (themeState)=>{
    if (!(0, $llCao.fg)('platform-dst-tokens-finesse')) return [];
    const { colorMode: colorMode, contrastMode: contrastMode, dark: dark, light: light, typography: typography } = themeState;
    const selectedThemes = [
        ...colorMode === 'auto' ? [
            light,
            dark
        ] : [
            themeState[colorMode]
        ],
        typography
    ];
    if (contrastMode !== 'no-preference' && (0, $llCao.fg)('platform_increased-contrast-themes')) selectedThemes.forEach((themeId)=>{
        const increasedContrastTheme = (0, $kFFkO.default)(themeId);
        if (increasedContrastTheme) selectedThemes.push(increasedContrastTheme);
    });
    const themeOverridePreferences = selectedThemes.map((themeId)=>$d2922f88cad0d7df$var$finesseOverrides[themeId]).filter((themeId)=>themeId !== undefined);
    return [
        ...new Set(themeOverridePreferences)
    ];
};

});
parcelRegister("kFFkO", function(module, exports) {
$parcel$export(module.exports, "default", () => $f4a4d4ed8ffd856f$export$2e2bcd8739ae039);

var $2x5Up = parcelRequire("2x5Up");
function $f4a4d4ed8ffd856f$export$2e2bcd8739ae039(themeId) {
    return Object.entries((0, $2x5Up.default)).find(([, { increasesContrastFor: increasesContrastFor }])=>{
        return increasesContrastFor === themeId;
    })?.[1].id;
}

});
parcelRegister("2x5Up", function(module, exports) {
$parcel$export(module.exports, "themeOverrideIds", () => $95fdb65efe741b5d$export$ba8a43b83ecc69f8);
$parcel$export(module.exports, "themeIdsWithOverrides", () => $95fdb65efe741b5d$export$92ba366331403db2);
$parcel$export(module.exports, "default", () => $95fdb65efe741b5d$export$2e2bcd8739ae039);
/**
 * This file contains the source of truth for themes and all associated meta data.
 */ 
var $1KFZi = parcelRequire("1KFZi");


/**
 * Contrast preferences: The system contrast preference
 */ const $95fdb65efe741b5d$var$themeContrastModes = [
    'more',
    'no-preference',
    'auto'
];
const $95fdb65efe741b5d$export$ba8a43b83ecc69f8 = [
    'light-finesse',
    'light-increased-contrast-finesse',
    'dark-finesse',
    'dark-increased-contrast-finesse',
    'typography-finesse'
];
const $95fdb65efe741b5d$export$92ba366331403db2 = [
    ...(0, $1KFZi.themeIds),
    ...$95fdb65efe741b5d$export$ba8a43b83ecc69f8
];
const $95fdb65efe741b5d$export$9d64ff89b6869900 = {
    'atlassian-light': {
        id: 'light',
        displayName: 'Light Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        }
    },
    'atlassian-light-future': {
        id: 'light-future',
        displayName: 'Future Light Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        },
        override: 'light'
    },
    'atlassian-light-finesse': {
        id: 'light-finesse',
        displayName: 'FY27 Finesse Light Theme Override',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        },
        override: 'light'
    },
    'atlassian-light-increased-contrast-finesse': {
        id: 'light-increased-contrast-finesse',
        displayName: 'FY27 Finesse Light Theme (increased contrast) Override',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        },
        override: 'light-increased-contrast'
    },
    'atlassian-light-increased-contrast': {
        id: 'light-increased-contrast',
        displayName: 'Light Theme (increased contrast)',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        },
        extends: 'light',
        increasesContrastFor: 'light'
    },
    'UNSAFE-dynamic': {
        id: 'UNSAFE-dynamic',
        displayName: 'UNSAFE Dynamic Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        },
        extends: 'light'
    },
    'UNSAFE-dynamic-dark': {
        id: 'UNSAFE-dynamic-dark',
        displayName: 'UNSAFE Dynamic Dark Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        },
        extends: 'dark'
    },
    'UNSAFE-test-light': {
        id: 'UNSAFE-test-light',
        displayName: 'UNSAFE Test Light Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        },
        extends: 'light'
    },
    'UNSAFE-test-dark': {
        id: 'UNSAFE-test-dark',
        displayName: 'UNSAFE Test Dark Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        },
        extends: 'dark'
    },
    'atlassian-dark': {
        id: 'dark',
        displayName: 'Dark Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        }
    },
    'atlassian-dark-future': {
        id: 'dark-future',
        displayName: 'Future Dark Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        },
        override: 'light'
    },
    'atlassian-dark-finesse': {
        id: 'dark-finesse',
        displayName: 'FY27 Finesse Dark Theme Override',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        },
        override: 'dark'
    },
    'atlassian-dark-increased-contrast-finesse': {
        id: 'dark-increased-contrast-finesse',
        displayName: 'FY27 Finesse Dark Theme (increased contrast) Override',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        },
        override: 'dark-increased-contrast'
    },
    'atlassian-dark-increased-contrast': {
        id: 'dark-increased-contrast',
        displayName: 'Dark Theme (increased contrast)',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        },
        extends: 'dark',
        increasesContrastFor: 'dark'
    },
    'atlassian-spacing': {
        id: 'spacing',
        displayName: 'Atlassian Spacing',
        palette: 'spacingScale',
        attributes: {
            type: 'spacing'
        }
    },
    'atlassian-typography': {
        id: 'typography',
        displayName: 'Atlassian Typography',
        palette: 'typographyPalette',
        attributes: {
            type: 'typography'
        }
    },
    'UNSAFE-typography': {
        id: 'UNSAFE-typography',
        displayName: 'UNSAFE Dynamic Typography',
        palette: 'typographyPalette',
        attributes: {
            type: 'typography'
        },
        extends: 'typography'
    },
    'atlassian-typography-finesse': {
        id: 'typography-finesse',
        displayName: 'FY27 Finesse Typography Override',
        palette: 'typographyPalette',
        attributes: {
            type: 'typography'
        },
        override: 'typography'
    },
    'atlassian-shape': {
        id: 'shape',
        displayName: 'Shape',
        palette: 'shapePalette',
        attributes: {
            type: 'shape'
        }
    },
    'atlassian-motion': {
        id: 'motion',
        displayName: 'Motion',
        palette: 'motionPalette',
        attributes: {
            type: 'motion'
        }
    }
};
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$95fdb65efe741b5d$export$2e2bcd8739ae039 = $95fdb65efe741b5d$export$9d64ff89b6869900;

});



parcelRegister("hDcGm", function(module, exports) {
$parcel$export(module.exports, "getThemePreferences", () => $6aac770fdb48f771$export$dd6aeb7c823fc03d);

var $llCao = parcelRequire("llCao");

var $kFFkO = parcelRequire("kFFkO");
const $6aac770fdb48f771$export$dd6aeb7c823fc03d = (themeState)=>{
    const { colorMode: colorMode, contrastMode: contrastMode, dark: dark, light: light, shape: shape, spacing: spacing, typography: typography, motion: motion } = themeState;
    const autoColorModeThemes = [
        light,
        dark
    ];
    const themePreferences = [];
    if (colorMode === 'auto') {
        if (contrastMode !== 'no-preference' && (0, $llCao.fg)('platform_increased-contrast-themes')) autoColorModeThemes.forEach((normalTheme)=>{
            const increasedContrastTheme = (0, $kFFkO.default)(normalTheme);
            if (increasedContrastTheme) autoColorModeThemes.push(increasedContrastTheme);
        });
        themePreferences.push(...autoColorModeThemes);
    } else {
        themePreferences.push(themeState[colorMode]);
        if (contrastMode !== 'no-preference' && (0, $llCao.fg)('platform_increased-contrast-themes')) {
            const increasedContrastTheme = (0, $kFFkO.default)(themeState[colorMode]);
            if (increasedContrastTheme) themePreferences.push(increasedContrastTheme);
        }
    }
    [
        shape,
        spacing,
        typography,
        motion
    ].forEach((themeId)=>{
        if (themeId) themePreferences.push(themeId);
    });
    return [
        ...new Set(themePreferences)
    ];
};

});

parcelRegister("aoCnk", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = Promise.all([
    $dk4lR("a1CVM"),
    $dk4lR("5h6rP"),
    $dk4lR("9uyGr")
]).then(()=>parcelRequire('04ucY'));

});


parcelRegister("2S58U", function(module, exports) {
$parcel$export(module.exports, "useIsAppProviderThemingEnabled", () => $a9695b355c8505ec$export$a782702263f77544);

var $fsvuC = parcelRequire("fsvuC");

var $4dDEI = parcelRequire("4dDEI");
const $a9695b355c8505ec$export$a782702263f77544 = ()=>{
    return (0, $fsvuC.useContext)((0, $4dDEI.AppProviderThemingEnabledContext));
};

});
parcelRegister("4dDEI", function(module, exports) {
$parcel$export(module.exports, "AppProviderThemingEnabledContext", () => $cca21d368f730699$export$d2def9838ca456c0);

var $fsvuC = parcelRequire("fsvuC");
const $cca21d368f730699$export$d2def9838ca456c0 = /*#__PURE__*/ (0, $fsvuC.createContext)(false);

});


parcelRegister("5EoO0", function(module, exports) {
$parcel$export(module.exports, "useIsInsideAppProvider", () => $cc1ce8b5364ede6f$export$26aa23367bfbab0e);

var $fsvuC = parcelRequire("fsvuC");

var $94QG8 = parcelRequire("94QG8");
const $cc1ce8b5364ede6f$export$26aa23367bfbab0e = ()=>{
    return (0, $fsvuC.useContext)((0, $94QG8.InsideAppProviderContext));
};

});
parcelRegister("94QG8", function(module, exports) {
$parcel$export(module.exports, "InsideAppProviderContext", () => $7401531ec8c12b85$export$7981b2444296e410);

var $fsvuC = parcelRequire("fsvuC");
const $7401531ec8c12b85$export$7981b2444296e410 = /*#__PURE__*/ (0, $fsvuC.createContext)(false);

});


parcelRegister("9xFXq", function(module, exports) {
$parcel$export(module.exports, "ColorModeContext", () => $1f93e4d858f0f31e$export$49ddd74a6729fdb0);

var $fsvuC = parcelRequire("fsvuC");
const $1f93e4d858f0f31e$export$49ddd74a6729fdb0 = /*#__PURE__*/ (0, $fsvuC.createContext)(undefined);

});

parcelRegister("bvkoW", function(module, exports) {
$parcel$export(module.exports, "InsideThemeProviderContext", () => $d170e647fd40654b$export$332347eeb335453c);

var $fsvuC = parcelRequire("fsvuC");
const $d170e647fd40654b$export$332347eeb335453c = /*#__PURE__*/ (0, $fsvuC.createContext)(false);

});

parcelRegister("bhVVB", function(module, exports) {
$parcel$export(module.exports, "SetColorModeContext", () => $17488e52ab64ebde$export$b06130bad0bbc70f);

var $fsvuC = parcelRequire("fsvuC");
const $17488e52ab64ebde$export$b06130bad0bbc70f = /*#__PURE__*/ (0, $fsvuC.createContext)(undefined);

});

parcelRegister("1YjM9", function(module, exports) {
$parcel$export(module.exports, "ThemeContext", () => $9709640a183cb8d7$export$2c657da244d00bd6);
$parcel$export(module.exports, "SetThemeContext", () => $9709640a183cb8d7$export$f7a97b47760e2a13);

var $fsvuC = parcelRequire("fsvuC");
const $9709640a183cb8d7$export$2c657da244d00bd6 = /*#__PURE__*/ (0, $fsvuC.createContext)(undefined);
const $9709640a183cb8d7$export$f7a97b47760e2a13 = /*#__PURE__*/ (0, $fsvuC.createContext)(undefined);

});

parcelRegister("dzW4K", function(module, exports) {
$parcel$export(module.exports, "useIsInsideThemeProvider", () => $db262af52a86474b$export$7ca11437599d653d);

var $fsvuC = parcelRequire("fsvuC");

var $bvkoW = parcelRequire("bvkoW");
const $db262af52a86474b$export$7ca11437599d653d = ()=>{
    return (0, $fsvuC.useContext)((0, $bvkoW.InsideThemeProviderContext)) ?? false;
};

});

parcelRegister("juMDf", function(module, exports) {
$parcel$export(module.exports, "getInlineThemeStyles", () => $b1821a88d2118a17$export$ae40e6ba718781b9);

var $fsvuC = parcelRequire("fsvuC");

var $kjMka = parcelRequire("kjMka");

var $fkm4H = parcelRequire("fkm4H");

var $hDcGm = parcelRequire("hDcGm");
const $b1821a88d2118a17$var$themeCssPromises = new Map();
function $b1821a88d2118a17$var$getThemeCssPromise(themeId) {
    let themeCssPromise = $b1821a88d2118a17$var$themeCssPromises.get(themeId);
    if (!themeCssPromise) {
        themeCssPromise = (0, $kjMka.themeImportMap)[themeId]().then(({ default: css })=>css);
        $b1821a88d2118a17$var$themeCssPromises.set(themeId, themeCssPromise);
    }
    return themeCssPromise;
}
function $b1821a88d2118a17$var$getInlineThemeCss(themeId) {
    const reactUse = (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).use;
    const isServer = globalThis.false === true || typeof document === 'undefined';
    if (isServer) return reactUse?.($b1821a88d2118a17$var$getThemeCssPromise(themeId));
    return document.body.querySelector(`style[data-theme="${themeId}"]`)?.textContent ?? undefined;
}
function $b1821a88d2118a17$export$ae40e6ba718781b9(theme, colorMode) {
    const themeState = {
        ...theme,
        colorMode: colorMode,
        contrastMode: 'no-preference'
    };
    const themeIds = [
        ...(0, $hDcGm.getThemePreferences)(themeState),
        ...(0, $fkm4H.getThemeOverridePreferences)(themeState)
    ];
    return [
        ...new Set(themeIds)
    ].map((themeId)=>{
        const css = $b1821a88d2118a17$var$getInlineThemeCss(themeId);
        return css ? {
            id: themeId,
            css: css
        } : undefined;
    }).filter((style)=>style !== undefined);
}

});

parcelRegister("cB4Mk", function(module, exports) {
$parcel$export(module.exports, "loadAndMountThemes", () => $5b7114493ddfc091$export$7d4a7e812d176b24);

var $jF8Yw = parcelRequire("jF8Yw");

var $kjMka = parcelRequire("kjMka");

var $1Qjnk = parcelRequire("1Qjnk");
const $5b7114493ddfc091$var$loadThemeCss = async (themeId)=>{
    // Prevent duplicate loading of themes
    if ((0, $1Qjnk.isThemeMounted)(themeId)) return;
    // Gracefully handles falsy values like `null` and `undefined` when makers ignore
    // TS to avoid loading default themes.
    if (!themeId) return;
    const { default: themeCss } = await (0, $kjMka.themeImportMap)[themeId]();
    return themeCss;
};
const $5b7114493ddfc091$var$mountThemeCss = async (css, themeId)=>{
    // SSR-safe: Only mount on client side
    const doc = (0, $jF8Yw.getDocument)();
    if (!doc) return;
    const style = doc.createElement('style');
    style.textContent = css;
    style.dataset.theme = themeId;
    // Prevent duplicate mounting of themes.
    // It's possible the theme was already being loaded elsewhere.
    if ((0, $1Qjnk.isThemeMounted)(themeId)) return;
    doc.head.appendChild(style);
};
const $5b7114493ddfc091$var$loadAndMountThemeCss = async (themeId)=>{
    const themeCss = await $5b7114493ddfc091$var$loadThemeCss(themeId);
    if (!themeCss) return;
    $5b7114493ddfc091$var$mountThemeCss(themeCss, themeId);
};
const $5b7114493ddfc091$export$7d4a7e812d176b24 = async (theme)=>{
    const themesToLoad = Object.values(theme).filter((themeId)=>!!themeId);
    themesToLoad.forEach($5b7114493ddfc091$var$loadAndMountThemeCss);
};

});
parcelRegister("1Qjnk", function(module, exports) {
$parcel$export(module.exports, "isThemeMounted", () => $390b772dd0fa8200$export$835a0dc855d02822);

var $jF8Yw = parcelRequire("jF8Yw");

var $gCKKR = parcelRequire("gCKKR");
function $390b772dd0fa8200$export$835a0dc855d02822(themeId) {
    const doc = (0, $jF8Yw.getDocument)();
    if (!doc) return false;
    return doc.head.querySelector(`style[${(0, $gCKKR.THEME_DATA_ATTRIBUTE)}="${themeId}"]`);
}

});



parcelRegister("fg2Kk", function(module, exports) {
$parcel$export(module.exports, "useColorMode", () => $ea281a39769d6ea9$export$20f3076712c8dfa);

var $fsvuC = parcelRequire("fsvuC");

var $dIKZc = parcelRequire("dIKZc");

var $8HWVA = parcelRequire("8HWVA");

var $9xFXq = parcelRequire("9xFXq");
function $ea281a39769d6ea9$export$20f3076712c8dfa() {
    const value = (0, $fsvuC.useContext)((0, $9xFXq.ColorModeContext));
    // TODO: This will only return 'light' or 'dark' but never 'auto', which in some cases
    // may be desirable. We should consider returning both the reconciled color mode (e.g. 'light' or 'dark') and the selected color mode ("auto").
    const theme = (0, $dIKZc.getGlobalTheme)();
    const [resolvedColorMode, setResolvedColorMode] = (0, $fsvuC.useState)(theme?.colorMode || 'light');
    (0, $fsvuC.useEffect)(()=>{
        // We are using theme from context so no need to reference the DOM
        if (value) return;
        const observer = new (0, $8HWVA.ThemeMutationObserver)((theme)=>{
            setResolvedColorMode(theme?.colorMode || 'light');
        });
        observer.observe();
        return ()=>observer.disconnect();
    }, [
        value
    ]);
    return value ? value : resolvedColorMode;
}

});
parcelRegister("8HWVA", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "ThemeMutationObserver", () => $6b6a4e876badbb63$export$b741a7c3bcb1c635);
$parcel$export(module.exports, "default", () => $6b6a4e876badbb63$export$2e2bcd8739ae039);

var $gCKKR = parcelRequire("gCKKR");

var $dIKZc = parcelRequire("dIKZc");
class $6b6a4e876badbb63$export$b741a7c3bcb1c635 {
    static{
        this.observer = null;
    }
    static{
        this.callbacks = new Set();
    }
    constructor(callback){
        this.legacyObserver = null;
        this.callback = callback;
        $6b6a4e876badbb63$export$b741a7c3bcb1c635.callbacks.add(callback);
    }
    observe() {
        if (!$6b6a4e876badbb63$export$b741a7c3bcb1c635.observer) {
            $6b6a4e876badbb63$export$b741a7c3bcb1c635.observer = new MutationObserver(()=>{
                const theme = (0, $dIKZc.getGlobalTheme)();
                $6b6a4e876badbb63$export$b741a7c3bcb1c635.callbacks.forEach((callback)=>callback(theme));
            });
            // Observer only needs to be configured once
            $6b6a4e876badbb63$export$b741a7c3bcb1c635.observer.observe(document.documentElement, {
                attributeFilter: [
                    (0, $gCKKR.THEME_DATA_ATTRIBUTE),
                    (0, $gCKKR.COLOR_MODE_ATTRIBUTE)
                ]
            });
        }
    }
    disconnect() {
        if (this.callback) $6b6a4e876badbb63$export$b741a7c3bcb1c635.callbacks.delete(this.callback);
        if ($6b6a4e876badbb63$export$b741a7c3bcb1c635.callbacks.size === 0 && $6b6a4e876badbb63$export$b741a7c3bcb1c635.observer) {
            $6b6a4e876badbb63$export$b741a7c3bcb1c635.observer.disconnect();
            $6b6a4e876badbb63$export$b741a7c3bcb1c635.observer = null;
        }
    }
}
$6b6a4e876badbb63$export$b741a7c3bcb1c635.displayName = "ThemeMutationObserver";
var $6b6a4e876badbb63$export$2e2bcd8739ae039 = $6b6a4e876badbb63$export$b741a7c3bcb1c635;

});


parcelRegister("i2UYV", function(module, exports) {
$parcel$export(module.exports, "appendPortalContainerIfNotAppended", () => $bca8d14ac07cf336$export$c582005add11e141);


var $4UKeq = parcelRequire("4UKeq");
const $bca8d14ac07cf336$var$getPortalParent = ()=>{
    const parentElement = document.querySelector((0, $e9181d8bc9d96b1b$export$72f415121273627e));
    if (!parentElement) {
        const parent = document.createElement('div');
        parent.className = (0, $e9181d8bc9d96b1b$export$e4c79eb95c23a0da);
        // we are setting display to flex because we want each portal to create a new stacking context
        // See https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Positioning/Understanding_z_index/The_stacking_context
        parent.style.display = 'flex';
        (0, $4UKeq.getBody)()?.appendChild(parent);
        return parent;
    }
    return parentElement;
};
const $bca8d14ac07cf336$export$c582005add11e141 = (container)=>{
    if (!container.parentElement) $bca8d14ac07cf336$var$getPortalParent().appendChild(container);
};

});
const $e9181d8bc9d96b1b$export$e4c79eb95c23a0da = 'atlaskit-portal-container';
const $e9181d8bc9d96b1b$export$72f415121273627e = 'body > .atlaskit-portal-container';
const $e9181d8bc9d96b1b$export$13f57c02915787b3 = 'atlaskit-portal';

parcelRegister("4UKeq", function(module, exports) {
$parcel$export(module.exports, "getBody", () => $9b4f5ee7f5646482$export$135b49d4bc2964c6);
/**
 * Returns document body element
 * @return {number} - The document body element
 */ const $9b4f5ee7f5646482$export$135b49d4bc2964c6 = ()=>{
    return document.body;
};

});


parcelRegister("EWReK", function(module, exports) {
$parcel$export(module.exports, "createContainer", () => $e6c0e853adc7b8da$export$26ae5ca175b4ec5a);

const $e6c0e853adc7b8da$export$26ae5ca175b4ec5a = (zIndex)=>{
    const container = document.createElement('div');
    container.className = (0, $e9181d8bc9d96b1b$export$13f57c02915787b3);
    container.style.zIndex = `${zIndex}`;
    return container;
};

});

parcelRegister("lhiGg", function(module, exports) {
$parcel$export(module.exports, "removePortalContainer", () => $283e5c5020b37db0$export$da99f98bf3fe55b3);


var $4UKeq = parcelRequire("4UKeq");
const $283e5c5020b37db0$var$getPortalParent = ()=>{
    const parentElement = document.querySelector((0, $e9181d8bc9d96b1b$export$72f415121273627e));
    if (!parentElement) {
        const parent = document.createElement('div');
        parent.className = (0, $e9181d8bc9d96b1b$export$e4c79eb95c23a0da);
        // we are setting display to flex because we want each portal to create a new stacking context
        // See https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Positioning/Understanding_z_index/The_stacking_context
        parent.style.display = 'flex';
        (0, $4UKeq.getBody)()?.appendChild(parent);
        return parent;
    }
    return parentElement;
};
const $283e5c5020b37db0$export$da99f98bf3fe55b3 = (container)=>{
    const parent = $283e5c5020b37db0$var$getPortalParent();
    if (parent.contains(container)) parent.removeChild(container);
};

});


parcelRegister("bXNDv", function(module, exports) {
$parcel$export(module.exports, "default", () => $a863df50e4c9eafe$export$2e2bcd8739ae039);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $80czl = parcelRequire("80czl");

var $jNtEw = parcelRequire("jNtEw");

var $fg2Kk = parcelRequire("fg2Kk");

var $dzW4K = parcelRequire("dzW4K");

var $cg8k7 = parcelRequire("cg8k7");

var $ec4C7 = parcelRequire("ec4C7");

var $4fpez = parcelRequire("4fpez");
function $a863df50e4c9eafe$export$2e2bcd8739ae039(props) {
    const { zIndex: zIndex, children: children } = props;
    const [atlaskitPortal, setAtlaskitPortal] = (0, $fsvuC.useState)(null);
    const colorMode = (0, $fg2Kk.useColorMode)();
    const isInsideThemeProvider = (0, $dzW4K.useIsInsideThemeProvider)();
    (0, $cg8k7.useIsomorphicLayoutEffect)(()=>{
        const tempPortalContainer = (0, $ec4C7.createAtlaskitPortal)(zIndex);
        setAtlaskitPortal(tempPortalContainer);
        const portalParent = (0, $4fpez.createPortalParent)();
        if (!tempPortalContainer || !portalParent) return;
        portalParent.appendChild(tempPortalContainer);
        return ()=>{
            if (tempPortalContainer) portalParent.removeChild(tempPortalContainer);
            setAtlaskitPortal(null);
        };
    }, [
        zIndex
    ]);
    /**
	 * We wrap portal children with a Suspense boundary because in React 18 concurrent,
	 * if you suspend from _within_ a portal to a Suspense boundary _outside_ the portal,
	 * our portal gets in an infinite loop of rendering.
	 */ const suspendedChildren = /*#__PURE__*/ (0, $5chsV.jsx)((0, $fsvuC.Suspense), {
        fallback: null,
        children: isInsideThemeProvider ? /*#__PURE__*/ (0, $5chsV.jsx)((0, $jNtEw.ThemeProvider), {
            defaultColorMode: colorMode,
            children: children
        }) : children
    });
    return atlaskitPortal ? /*#__PURE__*/ (0, $80czl.createPortal)(suspendedChildren, atlaskitPortal) : null;
}
$a863df50e4c9eafe$export$2e2bcd8739ae039.displayName = "InternalPortalNew";

});
parcelRegister("cg8k7", function(module, exports) {
$parcel$export(module.exports, "useIsomorphicLayoutEffect", () => $a3739d9f9a4979d7$export$700979bc83e7db82);

var $fsvuC = parcelRequire("fsvuC");
const $a3739d9f9a4979d7$export$700979bc83e7db82 = typeof window !== 'undefined' ? (0, $fsvuC.useLayoutEffect) : (0, $fsvuC.useEffect);

});

parcelRegister("ec4C7", function(module, exports) {
$parcel$export(module.exports, "createAtlaskitPortal", () => $dd659a28c37bf01f$export$fef014d7cef9e543);

const $dd659a28c37bf01f$var$isDocumentDefined = ()=>{
    return document !== undefined;
};
const $dd659a28c37bf01f$export$fef014d7cef9e543 = (zIndex)=>{
    //atlaskit-portal div
    if ($dd659a28c37bf01f$var$isDocumentDefined()) {
        const atlaskitportal = document.createElement('div');
        atlaskitportal.className = (0, $e9181d8bc9d96b1b$export$13f57c02915787b3);
        atlaskitportal.style.zIndex = `${zIndex}`;
        return atlaskitportal;
    }
    return;
};

});

parcelRegister("4fpez", function(module, exports) {
$parcel$export(module.exports, "createPortalParent", () => $36f868d06278be44$export$95029ca7aca2989e);


var $4UKeq = parcelRequire("4UKeq");
const $36f868d06278be44$var$isDocumentDefined = ()=>{
    return document !== undefined;
};
const $36f868d06278be44$export$95029ca7aca2989e = ()=>{
    //atlaskit-portal-container div
    if ($36f868d06278be44$var$isDocumentDefined()) {
        const parentElement = document.querySelector((0, $e9181d8bc9d96b1b$export$72f415121273627e));
        if (!parentElement) {
            const parent = document.createElement('div');
            parent.className = (0, $e9181d8bc9d96b1b$export$e4c79eb95c23a0da);
            parent.style.display = 'flex';
            (0, $4UKeq.getBody)()?.appendChild(parent);
            return parent;
        }
        return parentElement;
    }
    return;
};

});


parcelRegister("mSqMb", function(module, exports) {
$parcel$export(module.exports, "default", () => $d548f623b922c20a$export$2e2bcd8739ae039);

var $fsvuC = parcelRequire("fsvuC");

var $cg8k7 = parcelRequire("cg8k7");
const $d548f623b922c20a$var$useIsSubsequentRender = (mountStrategy)=>{
    const [isSubsequentRender, setIsSubsequentRender] = (0, $fsvuC.useState)(false);
    const [useMountEffect] = (0, $fsvuC.useState)(()=>mountStrategy === 'layoutEffect' ? (0, $cg8k7.useIsomorphicLayoutEffect) : (0, $fsvuC.useEffect));
    useMountEffect(()=>{
        setIsSubsequentRender(true);
    }, []);
    return isSubsequentRender;
};
var $d548f623b922c20a$export$2e2bcd8739ae039 = $d548f623b922c20a$var$useIsSubsequentRender;

});

parcelRegister("8thOl", function(module, exports) {
$parcel$export(module.exports, "default", () => $063480e864a8cf9a$export$2e2bcd8739ae039);

var $fsvuC = parcelRequire("fsvuC");


var $5eWeK = parcelRequire("5eWeK");
const $063480e864a8cf9a$var$useFirePortalEvent = (zIndex)=>{
    const zIndexNumber = Number(zIndex);
    (0, $fsvuC.useEffect)(()=>{
        (0, $5eWeK.default)((0, $2842d286e8760d3e$export$ed5835cc67e87f72), zIndexNumber);
        return ()=>{
            (0, $5eWeK.default)((0, $2842d286e8760d3e$export$80816bd900e5bd00), zIndexNumber);
        };
    }, [
        zIndexNumber
    ]);
};
var $063480e864a8cf9a$export$2e2bcd8739ae039 = $063480e864a8cf9a$var$useFirePortalEvent;

});
const $2842d286e8760d3e$export$ed5835cc67e87f72 = 'akPortalMount';
const $2842d286e8760d3e$export$80816bd900e5bd00 = 'akPortalUnmount';

parcelRegister("5eWeK", function(module, exports) {
$parcel$export(module.exports, "default", () => $f36821803f93b834$export$2e2bcd8739ae039);
const $f36821803f93b834$var$zIndexToName = {
    100: 'card',
    200: 'navigation',
    300: 'dialog',
    400: 'layer',
    500: 'blanket',
    510: 'modal',
    600: 'flag',
    700: 'spotlight',
    9999: 'tooltip'
};
/**
 * return layer name in Atlassian design system corresponding to given z-index
 * @param {number} zIndex - z-index value for which layer name is needed
 * @returns {LayerName | null} - The layer name for given z-index. If layer name is not found then null is returned
 */ const $f36821803f93b834$var$getLayerName = (zIndex)=>{
    return $f36821803f93b834$var$zIndexToName.hasOwnProperty(zIndex) ? $f36821803f93b834$var$zIndexToName[zIndex] : null;
};
/**
 * Creates a PortalEvent object with given eventName, given zIndex and corresponding layer
 * @param {string} eventName - either of Mount or Unmount event name
 * @param {number} zIndex - z-index value which will be included in the event to be dispatched
 * @returns {PortalEvent} - The newly created PortalEvent object
 */ const $f36821803f93b834$var$getEvent = (eventName, zIndex)=>{
    const detail = {
        layer: $f36821803f93b834$var$getLayerName(Number(zIndex)),
        zIndex: zIndex
    };
    return new CustomEvent(eventName, {
        detail: detail
    });
};
function $f36821803f93b834$export$2e2bcd8739ae039(eventName, zIndex) {
    const event = $f36821803f93b834$var$getEvent(eventName, zIndex);
    window.dispatchEvent(event);
}

});



parcelRegister("1Nrrt", function(module, exports) {
$parcel$export(module.exports, "DefaultRoleContext", () => $4d2069ac316154ce$export$acf85578b9060d4d);
$parcel$export(module.exports, "useDefaultRole", () => $4d2069ac316154ce$export$940503e6d676c973);

var $fsvuC = parcelRequire("fsvuC");
const $4d2069ac316154ce$export$acf85578b9060d4d = /*#__PURE__*/ (0, $fsvuC.createContext)(undefined);
function $4d2069ac316154ce$export$940503e6d676c973() {
    return (0, $fsvuC.useContext)($4d2069ac316154ce$export$acf85578b9060d4d);
}

});

parcelRegister("7OBha", function(module, exports) {
$parcel$export(module.exports, "register", () => $1b0a89ad480978be$export$6503ec6e8aabbaf);
/* eslint-disable @atlaskit/design-system/no-direct-use-of-web-platform-drag-and-drop */ /**
 * We are listening directly to drag events instead of using a monitor from
 * `@atlaskit/pragmatic-drag-and-drop` to avoid the bundle size cost, as it
 * would affect almost every view in every app.
 *
 * We can reconsider this choice in the future.
 */ 
var $dqdTY = parcelRequire("dqdTY");
const $1b0a89ad480978be$var$registrations = new Set();
let $1b0a89ad480978be$var$cleanupEndEventListeners = null;
function $1b0a89ad480978be$var$onDragStart() {
    if ($1b0a89ad480978be$var$cleanupEndEventListeners) // If the cleanup function exists then we've already run this
    return;
    $1b0a89ad480978be$var$cleanupEndEventListeners = (0, $dqdTY.bindAll)(window, [
        {
            type: 'dragend',
            listener: $1b0a89ad480978be$var$onDragEnd
        },
        {
            type: 'pointerdown',
            listener: $1b0a89ad480978be$var$onDragEnd
        },
        {
            type: 'pointermove',
            listener: (()=>{
                let callCount = 0;
                return function listener() {
                    // Using 20 as it is far bigger than the most observed (3)
                    if (callCount < 20) {
                        callCount++;
                        return;
                    }
                    $1b0a89ad480978be$var$onDragEnd();
                };
            })()
        }
    ]);
    const clone = Array.from($1b0a89ad480978be$var$registrations);
    clone.forEach((subscriber)=>{
        subscriber.onDragStart();
    });
}
function $1b0a89ad480978be$var$onDragEnd() {
    $1b0a89ad480978be$var$cleanupEndEventListeners?.();
    $1b0a89ad480978be$var$cleanupEndEventListeners = null;
    const clone = Array.from($1b0a89ad480978be$var$registrations);
    clone.forEach((subscriber)=>{
        subscriber.onDragEnd();
    });
}
function $1b0a89ad480978be$var$bindStartEvents() {
    return (0, $dqdTY.bindAll)(window, [
        {
            type: 'dragstart',
            listener: $1b0a89ad480978be$var$onDragStart
        },
        {
            type: 'dragenter',
            listener: $1b0a89ad480978be$var$onDragStart
        }
    ]);
}
let $1b0a89ad480978be$var$cleanupStartEventListeners = null;
function $1b0a89ad480978be$export$6503ec6e8aabbaf(registration) {
    // if first registration, bind event listeners
    if (!$1b0a89ad480978be$var$cleanupStartEventListeners) // note: currently never unbinding these event listeners
    $1b0a89ad480978be$var$cleanupStartEventListeners = $1b0a89ad480978be$var$bindStartEvents();
    $1b0a89ad480978be$var$registrations.add(registration);
    /**
	 * The reasoning for this behavior is so that if a tooltip mounts during
	 * a drag it can still be suppressed.
	 *
	 * We use a separate callback instead of onDragStart to avoid infinite loops.
	 */ registration.onRegister({
        isDragging: $1b0a89ad480978be$var$cleanupEndEventListeners !== null
    });
    return function unregister() {
        $1b0a89ad480978be$var$registrations.delete(registration);
        if ($1b0a89ad480978be$var$registrations.size === 0) {
            $1b0a89ad480978be$var$cleanupStartEventListeners?.();
            $1b0a89ad480978be$var$cleanupStartEventListeners = null;
        }
    };
}

});

parcelRegister("7FD99", function(module, exports) {
$parcel$export(module.exports, "getAnchorPoint", () => $7310eeafcf7db2dd$export$d26fd3d066ede49);
/**
 * Returns the trigger's X edge for inline-axis placements, or the
 * trigger's horizontal center for block-axis placements.
 *
 * Note: does not account for RTL writing modes.
 */ function $7310eeafcf7db2dd$var$getTriggerEdgeX({ triggerRect: triggerRect, placement: placement }) {
    if (placement.axis === 'inline') return placement.edge === 'start' ? triggerRect.left : triggerRect.right;
    return triggerRect.left + triggerRect.width / 2;
}
/**
 * Returns the trigger's Y edge for block-axis placements, or the
 * trigger's vertical center for inline-axis placements.
 */ function $7310eeafcf7db2dd$var$getTriggerEdgeY({ triggerRect: triggerRect, placement: placement }) {
    if (placement.axis === 'block') return placement.edge === 'start' ? triggerRect.top : triggerRect.bottom;
    return triggerRect.top + triggerRect.height / 2;
}
function $7310eeafcf7db2dd$export$d26fd3d066ede49({ cursor: cursor, triggerRect: triggerRect, tooltipPosition: tooltipPosition, placement: placement }) {
    if (tooltipPosition === 'mouse-y') return {
        x: $7310eeafcf7db2dd$var$getTriggerEdgeX({
            triggerRect: triggerRect,
            placement: placement
        }),
        y: cursor.clientY
    };
    if (tooltipPosition === 'mouse-x') return {
        x: cursor.clientX,
        y: $7310eeafcf7db2dd$var$getTriggerEdgeY({
            triggerRect: triggerRect,
            placement: placement
        })
    };
    // tooltipPosition === 'mouse'
    return {
        x: cursor.clientX,
        y: cursor.clientY
    };
}

});

parcelRegister("aguiM", function(module, exports) {
$parcel$export(module.exports, "getVirtualElementFromMousePos", () => $966bfb8357a8dadd$export$2e68479e0a5d8746);
function $966bfb8357a8dadd$export$2e68479e0a5d8746(mousePos, { targetElement: targetElement, tooltipPosition: tooltipPosition }) {
    if (tooltipPosition === 'mouse') return {
        getBoundingClientRect: ()=>DOMRect.fromRect({
                x: mousePos.clientX,
                y: mousePos.clientY,
                width: 0,
                height: 0
            })
    };
    const targetRect = targetElement.getBoundingClientRect();
    if (tooltipPosition === 'mouse-x') return {
        getBoundingClientRect: ()=>DOMRect.fromRect({
                x: mousePos.clientX,
                y: targetRect.top,
                width: 0,
                height: targetRect.height
            })
    };
    if (tooltipPosition === 'mouse-y') return {
        getBoundingClientRect: ()=>DOMRect.fromRect({
                x: targetRect.left,
                y: mousePos.clientY,
                width: targetRect.width,
                height: 0
            })
    };
    throw new Error(`Invalid tooltip position for virtual element: ${tooltipPosition}`);
}

});

parcelRegister("eaO2T", function(module, exports) {
$parcel$export(module.exports, "show", () => $e121ccabe0cc21b4$export$57bf213be019eeb0);

var $llCao = parcelRequire("llCao");
let $e121ccabe0cc21b4$var$delayId = null;
function $e121ccabe0cc21b4$var$clearScheduled() {
    if ($e121ccabe0cc21b4$var$delayId != null) {
        window.clearTimeout($e121ccabe0cc21b4$var$delayId);
        $e121ccabe0cc21b4$var$delayId = null;
    }
}
function $e121ccabe0cc21b4$var$scheduleTimeout(fn, delay) {
    $e121ccabe0cc21b4$var$clearScheduled();
    $e121ccabe0cc21b4$var$delayId = window.setTimeout(()=>{
        $e121ccabe0cc21b4$var$delayId = null;
        fn();
    }, delay);
}
let $e121ccabe0cc21b4$var$active = null;
function $e121ccabe0cc21b4$export$57bf213be019eeb0(entry) {
    let phase = 'waiting-to-show';
    function isActive() {
        return Boolean($e121ccabe0cc21b4$var$active && $e121ccabe0cc21b4$var$active.entry === entry);
    }
    function cleanup() {
        if (isActive()) {
            $e121ccabe0cc21b4$var$clearScheduled();
            $e121ccabe0cc21b4$var$active = null;
        }
    }
    function done() {
        if (isActive()) entry.done();
        phase = 'done';
        cleanup();
    }
    function immediatelyHideAndDone() {
        if (isActive()) entry.hide({
            isImmediate: true
        });
        done();
    }
    function keep() {
        if (!isActive()) return;
        // aborting a wait to hide
        if (phase === 'waiting-to-hide') {
            phase = 'shown';
            $e121ccabe0cc21b4$var$clearScheduled();
            return;
        }
        // aborting hide animation
        if (phase === 'hide-animating') {
            phase = 'shown';
            $e121ccabe0cc21b4$var$clearScheduled();
            entry.show({
                isImmediate: false
            });
            return;
        }
    }
    function requestHide({ isImmediate: isImmediate }) {
        if (!isActive()) return;
        // If we were not showing yet anyway; finish straight away
        if (phase === 'waiting-to-show') {
            immediatelyHideAndDone();
            return;
        }
        // already waiting to hide
        // Bug in legacy path: isImmediate hide requests are ignored during waiting-to-hide,
        // meaning Escape/scroll won't instantly dismiss a tooltip that's already fading out.
        // Gated fix: only apply the immediate-hide behavior under the top-layer flag for now.
        if (phase === 'waiting-to-hide') {
            if (isImmediate && (0, $llCao.fg)('platform-dst-top-layer-tooltip')) immediatelyHideAndDone();
            return;
        }
        if (isImmediate) {
            immediatelyHideAndDone();
            return;
        }
        phase = 'waiting-to-hide';
        $e121ccabe0cc21b4$var$scheduleTimeout(()=>{
            phase = 'hide-animating';
            entry.hide({
                isImmediate: false
            });
        }, entry.delay);
    }
    function finishHideAnimation() {
        if (isActive() && phase === 'hide-animating') done();
    }
    function isVisible() {
        return phase === 'shown' || phase === 'waiting-to-hide' || phase === 'hide-animating';
    }
    function start() {
        const shouldAlwaysFadeIn = entry.shouldAlwaysFadeIn;
        const showImmediately = Boolean($e121ccabe0cc21b4$var$active && $e121ccabe0cc21b4$var$active.isVisible()) && !shouldAlwaysFadeIn;
        // If there was an active tooltip; we tell it to remove itself at once!
        if ($e121ccabe0cc21b4$var$active) {
            $e121ccabe0cc21b4$var$clearScheduled();
            $e121ccabe0cc21b4$var$active.entry.hide({
                isImmediate: true
            });
            $e121ccabe0cc21b4$var$active.entry.done();
            $e121ccabe0cc21b4$var$active = null;
        }
        // this tooltip is now the active tooltip
        $e121ccabe0cc21b4$var$active = {
            entry: entry,
            isVisible: isVisible
        };
        function show() {
            phase = 'shown';
            entry.show({
                isImmediate: showImmediately
            });
        }
        if (showImmediately) {
            show();
            return;
        }
        phase = 'waiting-to-show';
        $e121ccabe0cc21b4$var$scheduleTimeout(show, entry.delay);
    }
    // let's get started!
    start();
    const result = {
        keep: keep,
        abort: cleanup,
        isActive: isActive,
        requestHide: requestHide,
        finishHideAnimation: finishHideAnimation,
        mousePos: entry.source.type === 'mouse' ? {
            clientX: entry.source.clientX,
            clientY: entry.source.clientY
        } : null
    };
    return result;
}

});

parcelRegister("6OWks", function(module, exports) {
$parcel$export(module.exports, "default", () => $74a07a69d5848e1d$export$2e2bcd8739ae039);

var $KbPzQ = parcelRequire("KbPzQ");
function $74a07a69d5848e1d$export$2e2bcd8739ae039(prefix, shouldRenderId) {
    const seed = (0, $KbPzQ.useIdSeed)();
    return shouldRenderId ? `${seed(prefix)}` : undefined;
}

});
parcelRegister("KbPzQ", function(module, exports) {
$parcel$export(module.exports, "useIdSeed", () => $1c581ef0c58f9535$export$6ee17796e3d70de2);

var $cTXsj = parcelRequire("cTXsj");
function $1c581ef0c58f9535$export$6ee17796e3d70de2() {
    const uid = (0, $cTXsj.useId)();
    return (id)=>`${uid}-${id.toString()}`;
}

});


parcelRegister("7CbH7", function(module, exports) {
$parcel$export(module.exports, "default", () => $0ab1f2904234b81f$export$2e2bcd8739ae039);
/* tooltip-container.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $gJ6nT = parcelRequire("gJ6nT");

var $i92dJ = parcelRequire("i92dJ");
const $0ab1f2904234b81f$var$styles = {
    base: "_0bjKvDzXzM _2sNsIg7NXe _24h04i2Njc _1EqgXlGVdc _0KLXrugozt _1UtDYze5R3 _2I62gzPgdg _3iC0zdPgdg _3zvHkHwPeg _46hvQm1Y8M _0xmtko1Y8M _03SyCPgVvo _0LQT5EgVvo _1T2N03wPeg",
    truncate: "_4bt5LAnQyn _2WAcuGnQyn _1EqgXlgs9g _39HuIbz8Lp _1ANEUSLRg7"
};
/**
 * Used as the default tooltip container component for the exported `Tooltip` component.
 * Adds some styles to the tooltip primitive.
 */ const $0ab1f2904234b81f$var$TooltipContainer = /*#__PURE__*/ (0, $fsvuC.forwardRef)(function TooltipContainer({ style: style, className: className, children: children, truncate: truncate, placement: placement, testId: testId, onMouseOut: onMouseOut, onMouseOver: onMouseOver, id: id, shortcut: shortcut, role: role }, ref) {
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $i92dJ.default), {
        ref: ref,
        style: style,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $gJ6nT.default)([
            $0ab1f2904234b81f$var$styles.base,
            truncate && $0ab1f2904234b81f$var$styles.truncate,
            className
        ]),
        placement: placement,
        testId: testId,
        id: id,
        onMouseOut: onMouseOut,
        onMouseOver: onMouseOver,
        shortcut: shortcut,
        role: role,
        children: children
    });
});
$0ab1f2904234b81f$var$TooltipContainer.displayName = 'TooltipContainer';
var $0ab1f2904234b81f$export$2e2bcd8739ae039 = $0ab1f2904234b81f$var$TooltipContainer;

});
parcelRegister("i92dJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $b44ca244767c7a4a$export$2e2bcd8739ae039);
/* tooltip-primitive.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $gJ6nT = parcelRequire("gJ6nT");

var $1Nrrt = parcelRequire("1Nrrt");

var $eIAXd = parcelRequire("eIAXd");
const $b44ca244767c7a4a$var$primitiveStyles = null;
/**
 * The lower level component for rendering a tooltip.
 */ const $b44ca244767c7a4a$var$TooltipPrimitive = /*#__PURE__*/ (0, $fsvuC.forwardRef)(function TooltipPrimitive({ style: style, className: className, children: children, placement: placement, testId: testId, onMouseOut: onMouseOut, onMouseOver: onMouseOver, id: id, shortcut: shortcut, role: role }, ref) {
    const defaultRole = (0, $1Nrrt.useDefaultRole)();
    return /*#__PURE__*/ (0, $5chsV.jsx)("div", {
        ref: ref,
        style: style,
        "data-testid": testId ? `${testId}--wrapper` : undefined,
        children: /*#__PURE__*/ (0, $5chsV.jsxs)("div", {
            role: role ?? defaultRole ?? 'tooltip',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, $gJ6nT.default)([
                "_0wOv4Q18ZR",
                className
            ]),
            // Because the tooltip should not be focusable, there is no reason to have key events.
            /* eslint-disable-next-line @atlassian/a11y/mouse-events-have-key-events */ onMouseOut: onMouseOut,
            /* eslint-disable-next-line @atlassian/a11y/mouse-events-have-key-events */ onMouseOver: onMouseOver,
            "data-placement": placement,
            "data-testid": testId,
            id: id,
            children: [
                /*#__PURE__*/ (0, $5chsV.jsx)((0, $1Nrrt.DefaultRoleContext).Provider, {
                    value: undefined,
                    children: children
                }),
                shortcut && /*#__PURE__*/ (0, $5chsV.jsx)((0, $eIAXd.TooltipShortcut), {
                    shortcut: shortcut
                })
            ]
        })
    });
});
$b44ca244767c7a4a$var$TooltipPrimitive.displayName = 'TooltipPrimitive';
var $b44ca244767c7a4a$export$2e2bcd8739ae039 = $b44ca244767c7a4a$var$TooltipPrimitive;

});
parcelRegister("eIAXd", function(module, exports) {
$parcel$export(module.exports, "TooltipShortcut", () => $14ca73ee3e0b9ba7$export$5bcbc43c84236222);
/* tooltip-shortcut.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");
parcelRequire("fsvuC");

var $gJ6nT = parcelRequire("gJ6nT");
const $14ca73ee3e0b9ba7$var$styles = {
    shortcutSegmentsContainer: "_2mHwu8FQfX _3iDTPbQ4SZ _46hvQm1Y8M _0xmtkoFQfX",
    shortcutSegment: "_2sNsIg7NXe _0bjKvDcjp5 _3hxITi6wH8 _2V7sgONvrM _3vBAKHWkXl _3iDTPbQ4SZ _0hPCNLDIqT _0jFU0VbKFA _24h04i2Njc _46hvQmFQfX _0xmtkoFQfX _0LQT5EgVvo _03SyCPgVvo _2OUyjtZqHV _2w56ZUZqHV _0OZTBgZqHV _1UtDYzZqHV _0GTcwRZqHV _2xTnZxZqHV _43nrzTZqHV _0rIjykZqHV _4ouGXIZqHV _275DnzZqHV _0KLXruS2te"
};
const $14ca73ee3e0b9ba7$export$5bcbc43c84236222 = ({ shortcut: shortcut })=>{
    return /*#__PURE__*/ (0, $5chsV.jsx)("div", {
        className: (0, $gJ6nT.default)([
            $14ca73ee3e0b9ba7$var$styles.shortcutSegmentsContainer
        ]),
        children: shortcut.map((segment, index)=>/*#__PURE__*/ (0, $5chsV.jsx)("kbd", {
                className: (0, $gJ6nT.default)([
                    $14ca73ee3e0b9ba7$var$styles.shortcutSegment
                ]),
                children: segment
            }, `${segment}-${index}`))
    });
};
$14ca73ee3e0b9ba7$export$5bcbc43c84236222.displayName = "TooltipShortcut";

});




parcelRegister("k56Mb", function(module, exports) {
$parcel$export(module.exports, "default", () => $a2f0d00da6ed05a7$export$2e2bcd8739ae039);
/* button-base.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $gJ6nT = parcelRequire("gJ6nT");

var $fsvuC = parcelRequire("fsvuC");

var $dwUnm = parcelRequire("dwUnm");

var $fz4Xf = parcelRequire("fz4Xf");

var $cO4y2 = parcelRequire("cO4y2");

var $cTXsj = parcelRequire("cTXsj");

var $llCao = parcelRequire("llCao");

var $3OsKS = parcelRequire("3OsKS");

var $8e1dR = parcelRequire("8e1dR");

var $9djJE = parcelRequire("9djJE");

var $bwEOd = parcelRequire("bwEOd");

var $adYck = parcelRequire("adYck");

var $cVXgT = parcelRequire("cVXgT");
const $a2f0d00da6ed05a7$var$LOADING_LABEL = ', Loading';
const $a2f0d00da6ed05a7$var$styles = {
    base: "_0bjKvDKTcp _2sNsIgmnOE _23rrnHoacQ _2V7sgOdnbC _4c065UgVvo _3iDTPbccYA _24h04i2Njc _39xV02IZbP _1EqgXlN91d _1mT5xdRAKS _0hPCNLQame _37wbyuDIqT _17lj8p1Y8M _3YEZNOdnbC _0jFU0VZ49V _1kk5Tkf7mX _03SyCP8HPE _0LQT5E8HPE _2fwxA5DIqT _1RrJLit2nV _2Gfj6iOLYo _0EnhYgPgdg _4lwhQT6wH8 _0dpm39NvrM _2tbAUcYbGa _2WYcYGWVPG",
    interactiveMotion: "_23rrnHyKLB _3sFUREiSCN",
    linkDecorationUnset: "_00uqCYyL8i _3xtjKNYbGa _0H9qDF6wH8 _32C2rkyL8i _0i9AWAYbGa _0mm6KQ6wH8 _0DCa9DyL8i _3932vvYbGa _02cRtH6wH8 _3WzCGiyL8i _0NqVRtYbGa _3BKYwu6wH8",
    disabled: "_0wOv4Qsyl5 _1UtDYzot27 _0clgaMot27 _0CMRbkot27",
    sharedDisabled: "_0KLXruVrZW _1eOmH6VrZW _3gzVzLVrZW",
    spacingCompact: "_0bjKvDKxmn _4c065UFQfX _17lj8p1Y8M _0jFU0V9DVM _03SyCP8HPE _0LQT5E8HPE _1RrJLit2nV",
    circle: "_0bjKvDS5Zs",
    fullWidth: "_39xV02N91d",
    loading: "_0wOv4Q2mtD",
    iconButton: "_0jFU0VZ49V _39xV02Z49V _03SyCPPgdg _0LQT5EPgdg",
    iconButtonCompact: "_0jFU0V9DVM _39xV029DVM",
    buttonIconBefore: "_0LQT5E8HPE _17lj8pgVvo",
    buttonIconAfter: "_03SyCP8HPE _17lj8pgVvo",
    splitButton: "_13yjolgtVO",
    loadingOverlay: "_4bt5LAnQyn _2WAcuGnQyn _3iDTPbQ4SZ _1mT5xdWVPG _0hPCNLDIqT _37wbyuDIqT _1ZB6UyPgdg _2I62gzPgdg _1OKFqYPgdg _3iC0zdPgdg",
    navigationSplitButton: "_39xV02oWWg _0KLXru5FNy _03SyCPgVvo _0LQT5EgVvo"
};
const $a2f0d00da6ed05a7$var$defaultStyles = {
    root: "_0KLXru5FNy _1UtDYzZpcK _0z8nYC9r67 _0GBAIrogpp _2nTuUYZpcK _10n1R5ZpcK _0clgaMZpcK _0CMRbkZpcK",
    interactive: "_1eOmH6o126 _0clgaMZpcK _3gzVzLN4oS _0CMRbkZpcK",
    disabled: "_0KLXruyL8i _0z8nYChQC5 _1eOmH6yL8i _3gzVzLyL8i"
};
const $a2f0d00da6ed05a7$var$primaryStyles = {
    root: "_0KLXruDM2k _1UtDYze5R3 _2nTuUYe5R3 _10n1R5e5R3 _0clgaMe5R3 _0CMRbke5R3",
    interactive: "_0clgaMe5R3 _1eOmH6hmrj _0CMRbke5R3 _3gzVzLczkD"
};
const $a2f0d00da6ed05a7$var$rovoStyles = {
    root: "_0KLXruWwnm _1UtDYze5R3 _2nTuUYe5R3 _10n1R5e5R3 _0clgaMe5R3 _0CMRbke5R3",
    interactive: "_0clgaMe5R3 _1eOmH63nEM _0CMRbke5R3 _3gzVzLjYGY"
};
const $a2f0d00da6ed05a7$var$warningStyles = {
    root: "_0KLXruKLKE _1UtDYzVW6T _2nTuUYVW6T _10n1R5VW6T _0clgaMVW6T _0CMRbkVW6T",
    interactive: "_0clgaMVW6T _1eOmH6OCpk _0CMRbkVW6T _3gzVzLSN2W"
};
const $a2f0d00da6ed05a7$var$dangerStyles = {
    root: "_0KLXruqsXs _1UtDYze5R3 _2nTuUYe5R3 _10n1R5e5R3 _0clgaMe5R3 _0CMRbke5R3",
    interactive: "_0clgaMe5R3 _1eOmH6EISo _0CMRbke5R3 _3gzVzLL5fL"
};
const $a2f0d00da6ed05a7$var$discoveryStyles = {
    root: "_0KLXruqjHC _1UtDYze5R3 _2nTuUYe5R3 _10n1R5e5R3 _0clgaMe5R3 _0CMRbke5R3",
    interactive: "_0clgaMe5R3 _1eOmH6nIkF _0CMRbke5R3 _3gzVzLSHT5"
};
const $a2f0d00da6ed05a7$var$subtleStyles = {
    root: "_0KLXru5FNy _1UtDYzZpcK _2nTuUYZpcK _10n1R5ZpcK _0clgaMZpcK _0CMRbkZpcK",
    interactive: "_1eOmH6o126 _0clgaMZpcK _3gzVzLN4oS _0CMRbkZpcK",
    disabled: "_0KLXruyL8i _0z8nYChQC5 _1eOmH6yL8i _3gzVzLyL8i"
};
const $a2f0d00da6ed05a7$var$selectedStyles = {
    root: "_0KLXruY9q9 _1UtDYzjTy9 _0z8nYCrzt2 _0GBAIrogpp _2nTuUYjTy9 _10n1R5jTy9 _0clgaMjTy9 _0CMRbkjTy9",
    insideSplitButton: "_42Yu6BiZR3",
    interactive: "_1eOmH6sumd _0clgaMjTy9 _3gzVzLXsxn _0CMRbkjTy9",
    warning: "_0KLXruY9q9 _1UtDYzjTy9 _0clgaMjTy9 _1eOmH6Y9q9 _0CMRbkjTy9 _3gzVzLY9q9",
    danger: "_0KLXruY9q9 _1UtDYzjTy9 _0clgaMjTy9 _1eOmH6Y9q9 _0CMRbkjTy9 _3gzVzLY9q9",
    discovery: "_0KLXruY9q9 _1UtDYzjTy9 _0clgaMjTy9 _1eOmH6Y9q9 _0CMRbkjTy9 _3gzVzLY9q9"
};
const $a2f0d00da6ed05a7$var$brandSelectedSplitButtonStyles = {
    root: "_0KLXrunl7T _1UtDYzGaer _0z8nYCJrlu _0GBAIrogpp _2nTuUYGaer _10n1R5Gaer _0clgaMGaer _0CMRbkGaer",
    interactive: "_1eOmH6NPoG _0clgaMGaer _3gzVzLLKV0 _0CMRbkGaer"
};
/**
 * __button base__
 *
 * - Implements auto focus when enabled.
 * - Appends the `onClick` event with UFO analytics tracking.
 *
 * @private
 */ const $a2f0d00da6ed05a7$var$ButtonBase = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).forwardRef(// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore: to unblock React 18.2.0 -> 18.3.1 version bump in Jira
({ appearance: propAppearance, autoFocus: autoFocus = false, isDisabled: propIsDisabled = false, isLoading: isLoading = false, isSelected: propIsSelected = false, isIconButton: isIconButton = false, isCircle: isCircle = false, hasIconBefore: hasIconBefore = false, hasIconAfter: hasIconAfter = false, shouldFitContainer: shouldFitContainer = false, spacing: propSpacing = 'default', ariaLabel: ariaLabel, ariaLabelledBy: ariaLabelledBy, children: children, interactionName: interactionName, onClick: onClick, onMouseDown: onMouseDown, onMouseDownCapture: onMouseDownCapture, onMouseUp: onMouseUp, onMouseUpCapture: onMouseUpCapture, onKeyDown: onKeyDown, onKeyDownCapture: onKeyDownCapture, onKeyUp: onKeyUp, onKeyUpCapture: onKeyUpCapture, onTouchStart: onTouchStart, onTouchStartCapture: onTouchStartCapture, onTouchEnd: onTouchEnd, onTouchEndCapture: onTouchEndCapture, onPointerDown: onPointerDown, onPointerDownCapture: onPointerDownCapture, onPointerUp: onPointerUp, onPointerUpCapture: onPointerUpCapture, onClickCapture: onClickCapture, testId: testId, analyticsContext: analyticsContext, componentName: componentName, rootXcss: rootXcss, role: role, onMouseOver: onMouseOver, onMouseOut: onMouseOut, onFocus: onFocus, onBlur: onBlur, onMouseMove: onMouseMove, type: type, ...unsafeRest }, ref)=>{
    // React Compiler opt-out: RC-incompatible (memoization breaks runtime behaviour).
    'use no memo';
    const localRef = (0, $fsvuC.useRef)(null);
    const splitButtonContext = (0, $bwEOd.useSplitButtonContext)();
    const loadingLabelId = (0, $cTXsj.useId)();
    const isSplitButton = Boolean(splitButtonContext);
    const isNavigationSplitButton = splitButtonContext?.isNavigationSplitButton || false;
    const isDefaultAppearanceSplitButton = splitButtonContext?.appearance === 'default';
    const appearance = isDefaultAppearanceSplitButton ? 'subtle' : propAppearance || splitButtonContext?.appearance || 'default';
    const spacing = splitButtonContext?.spacing || propSpacing;
    const isDisabled = splitButtonContext?.isDisabled || propIsDisabled;
    const isInteractive = !isDisabled && !isLoading;
    // Also treat loading buttons as disabled
    const isEffectivelyDisabled = isDisabled || isLoading;
    const isSelected = propIsSelected && !isDisabled;
    // The open dropdown is part of a primary action, not a standalone selection.
    const isBrandSelectedSplitButton = isSelected && appearance === 'primary' && splitButtonContext?.appearance === 'primary' && (0, $llCao.fg)('platform-dst-tokens-finesse');
    (0, $cO4y2.default)(localRef, autoFocus);
    // @ts-expect-error
    const { className: _className, css: _css, as: _as, style: _style, ...saferRest } = unsafeRest;
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $3OsKS.Pressable), {
        ...saferRest,
        componentName: componentName || 'button',
        analyticsContext: analyticsContext,
        role: role,
        ref: (0, $fz4Xf.default)([
            localRef,
            ref
        ]),
        xcss: (0, $dwUnm.cx)($a2f0d00da6ed05a7$var$styles.base, isInteractive && $a2f0d00da6ed05a7$var$styles.interactiveMotion, appearance === 'default' && $a2f0d00da6ed05a7$var$defaultStyles.root, appearance === 'default' && isInteractive && $a2f0d00da6ed05a7$var$defaultStyles.interactive, appearance === 'primary' && $a2f0d00da6ed05a7$var$primaryStyles.root, appearance === 'primary' && isInteractive && $a2f0d00da6ed05a7$var$primaryStyles.interactive, appearance === 'rovo' && $a2f0d00da6ed05a7$var$rovoStyles.root, appearance === 'rovo' && isInteractive && $a2f0d00da6ed05a7$var$rovoStyles.interactive, appearance === 'warning' && $a2f0d00da6ed05a7$var$warningStyles.root, appearance === 'warning' && isInteractive && $a2f0d00da6ed05a7$var$warningStyles.interactive, appearance === 'danger' && $a2f0d00da6ed05a7$var$dangerStyles.root, appearance === 'danger' && isInteractive && $a2f0d00da6ed05a7$var$dangerStyles.interactive, appearance === 'discovery' && $a2f0d00da6ed05a7$var$discoveryStyles.root, appearance === 'discovery' && isInteractive && $a2f0d00da6ed05a7$var$discoveryStyles.interactive, appearance === 'subtle' && $a2f0d00da6ed05a7$var$subtleStyles.root, appearance === 'subtle' && isInteractive && $a2f0d00da6ed05a7$var$subtleStyles.interactive, $a2f0d00da6ed05a7$var$styles.linkDecorationUnset, isSelected && $a2f0d00da6ed05a7$var$selectedStyles.root, isSelected && isSplitButton && $a2f0d00da6ed05a7$var$selectedStyles.insideSplitButton, isSelected && isInteractive && $a2f0d00da6ed05a7$var$selectedStyles.interactive, isBrandSelectedSplitButton && $a2f0d00da6ed05a7$var$brandSelectedSplitButtonStyles.root, isBrandSelectedSplitButton && isInteractive && $a2f0d00da6ed05a7$var$brandSelectedSplitButtonStyles.interactive, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === 'danger' && $a2f0d00da6ed05a7$var$selectedStyles.danger, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === 'warning' && $a2f0d00da6ed05a7$var$selectedStyles.warning, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === 'discovery' && $a2f0d00da6ed05a7$var$selectedStyles.discovery, isDisabled && $a2f0d00da6ed05a7$var$styles.disabled, isDisabled && appearance !== 'default' && appearance !== 'subtle' && $a2f0d00da6ed05a7$var$styles.sharedDisabled, isDisabled && appearance === 'default' && $a2f0d00da6ed05a7$var$defaultStyles.disabled, spacing === 'compact' && $a2f0d00da6ed05a7$var$styles.spacingCompact, // This must come after spacing compact styling as it overrides the border radius
        isCircle && !isSplitButton && $a2f0d00da6ed05a7$var$styles.circle, shouldFitContainer && $a2f0d00da6ed05a7$var$styles.fullWidth, hasIconBefore && $a2f0d00da6ed05a7$var$styles.buttonIconBefore, hasIconAfter && $a2f0d00da6ed05a7$var$styles.buttonIconAfter, isIconButton && $a2f0d00da6ed05a7$var$styles.iconButton, isIconButton && spacing === 'compact' && $a2f0d00da6ed05a7$var$styles.iconButtonCompact, isLoading && $a2f0d00da6ed05a7$var$styles.loading, isSplitButton && $a2f0d00da6ed05a7$var$styles.splitButton, isNavigationSplitButton && $a2f0d00da6ed05a7$var$styles.navigationSplitButton, rootXcss),
        isDisabled: isDisabled,
        "aria-live": "polite",
        ...isLoading && {
            'aria-disabled': true
        },
        "aria-label": isLoading && ariaLabel && !ariaLabelledBy ? `${ariaLabel} ${$a2f0d00da6ed05a7$var$LOADING_LABEL}` : ariaLabel,
        "aria-labelledby": isLoading && ariaLabelledBy ? `${ariaLabelledBy} ${loadingLabelId}` : ariaLabelledBy,
        onClick: onClick,
        ...(0, $adYck.default)(isEffectivelyDisabled, {
            onMouseDownCapture: onMouseDownCapture,
            onMouseUpCapture: onMouseUpCapture,
            onKeyDownCapture: onKeyDownCapture,
            onKeyUpCapture: onKeyUpCapture,
            onTouchStartCapture: onTouchStartCapture,
            onTouchEndCapture: onTouchEndCapture,
            onPointerDownCapture: onPointerDownCapture,
            onPointerUpCapture: onPointerUpCapture,
            onClickCapture: onClickCapture
        }),
        testId: testId,
        onMouseOver: onMouseOver,
        onFocus: onFocus,
        onMouseMove: onMouseMove,
        onBlur: onBlur,
        type: type,
        interactionName: interactionName,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        onKeyDown: onKeyDown,
        onMouseOut: onMouseOut,
        onKeyUp: onKeyUp,
        onTouchStart: onTouchStart,
        onTouchEnd: onTouchEnd,
        onPointerDown: onPointerDown,
        onPointerUp: onPointerUp,
        children: /*#__PURE__*/ (0, $5chsV.jsxs)((0, $9djJE.SplitButtonContext).Provider, {
            value: undefined,
            children: [
                children,
                isLoading && /*#__PURE__*/ (0, $5chsV.jsx)("span", {
                    className: (0, $gJ6nT.default)([
                        $a2f0d00da6ed05a7$var$styles.loadingOverlay
                    ]),
                    children: (0, $cVXgT.default)({
                        spacing: spacing,
                        appearance: appearance,
                        isDisabled: isDisabled,
                        isSelected: isSelected,
                        testId: testId
                    })
                }),
                isLoading && (ariaLabelledBy || !ariaLabel) && /*#__PURE__*/ (0, $5chsV.jsx)((0, $8e1dR.default), {
                    id: loadingLabelId,
                    children: $a2f0d00da6ed05a7$var$LOADING_LABEL
                })
            ]
        })
    });
});
var $a2f0d00da6ed05a7$export$2e2bcd8739ae039 = $a2f0d00da6ed05a7$var$ButtonBase;

});
parcelRegister("3OsKS", function(module, exports) {
$parcel$export(module.exports, "Pressable", () => $a07e4e776f85c076$export$27c701ed9e449e99);
/* pressable.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $4twf9 = parcelRequire("4twf9");

var $d5Gwv = parcelRequire("d5Gwv");

var $i4a0W = parcelRequire("i4a0W");

var $9Tkwf = parcelRequire("9Tkwf");

var $lNjwN = parcelRequire("lNjwN");

var $iLp2b = parcelRequire("iLp2b");
const $a07e4e776f85c076$var$styles = {
    root: "_30huDKYbGa _24h04i2Njc _034jHtYbGa _0wOv4Q7zJH",
    disabled: "_0wOv4Qsyl5"
}; /**
    * __Pressable__
    *
    * A primitive for building custom buttons.
    *
    * - [Examples](https://atlassian.design/components/primitives/pressable/examples)
    * - [Code](https://atlassian.design/components/primitives/pressable/code)
    * - [Usage](https://atlassian.design/components/primitives/pressable/usage)
    */ 
const $a07e4e776f85c076$export$27c701ed9e449e99 = /*#__PURE__*/ (0, $fsvuC.forwardRef)(({ children: children, isDisabled: isDisabled, type: type = 'button', onClick: providedOnClick = (0, $9Tkwf.default), interactionName: interactionName, componentName: componentName, analyticsContext: analyticsContext, style: style, testId: testId, xcss: xcss, tabIndex: tabIndex, ...htmlAttributes }, ref)=>{
    const interactionContext = (0, $fsvuC.useContext)((0, $lNjwN.default));
    const handleClick = (0, $fsvuC.useCallback)((e, analyticsEvent)=>{
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    const onClick = (0, $d5Gwv.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: 'clicked',
        componentName: componentName || 'Pressable',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local",
        analyticsData: analyticsContext,
        actionSubject: 'button'
    }); // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    const { className: _spreadClass, ...safeHtmlAttributes } = htmlAttributes;
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $iLp2b.Focusable // @ts-ignore -- not using expect since it causes issues with help-center local consumption - we don't allow `button` on Focusable for makers as they should use Pressable instead
    ), {
        as: "button",
        // Adding a tabIndex of 0 to the button will allow it to be focused on click.
        // This is a known issue in Safari that is meant to be "intended", see https://bugs.webkit.org/show_bug.cgi?id=22261
        tabIndex: tabIndex ?? ((0, $i4a0W.isSafari)() && !isDisabled ? 0 : undefined),
        style: style,
        ...safeHtmlAttributes,
        type: type,
        onClick: onClick,
        disabled: isDisabled,
        xcss: (0, $4twf9.cx)($a07e4e776f85c076$var$styles.root, isDisabled && $a07e4e776f85c076$var$styles.disabled, xcss),
        testId: testId,
        ref: ref,
        children: children
    });
});

});
parcelRegister("i4a0W", function(module, exports) {
$parcel$export(module.exports, "isSafari", () => $6ac7c91a0a7097fc$export$95df08bae54cb4df);
function $6ac7c91a0a7097fc$export$95df08bae54cb4df() {
    if (typeof window !== 'undefined' && window.navigator != null) {
        const ua = window.navigator.userAgent?.toLowerCase();
        return ua ? ua.includes('safari') && !ua.includes('chrome') : false;
    }
    return false;
}

});

parcelRegister("iLp2b", function(module, exports) {
$parcel$export(module.exports, "Focusable", () => $782474c6cb1ff10e$export$35a3bebf7ef2d934);
/* focusable.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $gJ6nT = parcelRequire("gJ6nT");
const $782474c6cb1ff10e$var$focusRingStyles = null;
const $782474c6cb1ff10e$var$insetFocusRingStyles = null;
const $782474c6cb1ff10e$export$35a3bebf7ef2d934 = /*#__PURE__*/ (0, $fsvuC.forwardRef)(({ as: Component = 'button', children: children, isInset: isInset, testId: testId, style: style, xcss: xcss, ...htmlAttributes }, ref)=>{
    // This is to remove className from safeHtmlAttributes
    // @ts-ignore -- not using expect since it causes issues with help-center local consumption - className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    const { className: _spreadClass, ...safeHtmlAttributes } = htmlAttributes;
    return /*#__PURE__*/ (0, $5chsV.jsx)(Component, {
        ...safeHtmlAttributes,
        // @ts-ignore Expression produces a union type that is too complex to represent. We may be able to narrow the type here but unsure.
        ref: ref,
        className: (0, $gJ6nT.default)([
            "_2hGPVj98eZ _2i3C1kYbGa _2kH23qT6kp _1ubuxoD6gn _34b3D2vc3e _1NDpvb6wH8 _2wtOC9vc3e _3e11vU6wH8 _0hSAgbHZdu",
            isInset && "_34b3D2ZPSy _0aMSfYZPSy",
            xcss
        ]),
        style: style,
        "data-testid": testId,
        children: children
    });
});

});


parcelRegister("9djJE", function(module, exports) {
$parcel$export(module.exports, "SplitButtonContext", () => $c14cbc3ce5035532$export$4b86304b2c0d7e71);
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $fsvuC = parcelRequire("fsvuC");
const $c14cbc3ce5035532$export$4b86304b2c0d7e71 = /*#__PURE__*/ (0, $fsvuC.createContext)(undefined);

});

parcelRegister("bwEOd", function(module, exports) {
$parcel$export(module.exports, "useSplitButtonContext", () => $3712aba78b48c749$export$47e2c6fdb142d947);

var $fsvuC = parcelRequire("fsvuC");

var $9djJE = parcelRequire("9djJE");
const $3712aba78b48c749$export$47e2c6fdb142d947 = ()=>{
    const context = (0, $fsvuC.useContext)((0, $9djJE.SplitButtonContext));
    if (!context) return undefined;
    if (context.appearance === 'navigation') {
        const newContext = {
            spacing: 'default',
            appearance: 'subtle',
            isDisabled: false,
            isActiveOverSelected: false,
            isNavigationSplitButton: true,
            isHighlighted: context.isHighlighted
        };
        return newContext;
    }
    const splitButtonContext = {
        spacing: context.spacing,
        appearance: context.appearance,
        isDisabled: context.isDisabled,
        isActiveOverSelected: true,
        isNavigationSplitButton: false,
        isHighlighted: false
    };
    return splitButtonContext;
};

});

parcelRegister("adYck", function(module, exports) {
$parcel$export(module.exports, "default", () => $99ae8c3c5784a0ff$export$2e2bcd8739ae039);
function $99ae8c3c5784a0ff$var$abort(event) {
    event.preventDefault();
    event.stopPropagation();
}
const $99ae8c3c5784a0ff$var$tabKeyCode = 9;
function $99ae8c3c5784a0ff$var$onKey(event) {
    // Allowing tab so that a user can move focus away
    if (event.keyCode === $99ae8c3c5784a0ff$var$tabKeyCode) return;
    $99ae8c3c5784a0ff$var$abort(event);
}
function $99ae8c3c5784a0ff$export$2e2bcd8739ae039(shouldBlockEvents, events) {
    return shouldBlockEvents ? {
        onMouseDownCapture: $99ae8c3c5784a0ff$var$abort,
        onMouseUpCapture: $99ae8c3c5784a0ff$var$abort,
        onKeyDownCapture: $99ae8c3c5784a0ff$var$onKey,
        onKeyUpCapture: $99ae8c3c5784a0ff$var$onKey,
        onTouchStartCapture: $99ae8c3c5784a0ff$var$abort,
        onTouchEndCapture: $99ae8c3c5784a0ff$var$abort,
        onPointerDownCapture: $99ae8c3c5784a0ff$var$abort,
        onPointerUpCapture: $99ae8c3c5784a0ff$var$abort,
        onClickCapture: $99ae8c3c5784a0ff$var$abort,
        // Just smashing the existing onClick for good measure
        onClick: $99ae8c3c5784a0ff$var$abort
    } : events;
}

});

parcelRegister("cVXgT", function(module, exports) {
$parcel$export(module.exports, "default", () => $e8a26ea745404c34$export$2e2bcd8739ae039);

var $5chsV = parcelRequire("5chsV");
parcelRequire("fsvuC");

var $9cT91 = parcelRequire("9cT91");
function $e8a26ea745404c34$var$getIconSpacing(spacing) {
    switch(spacing){
        case 'compact':
            return 'small';
        default:
            return 'medium';
    }
}
function $e8a26ea745404c34$var$getSpinnerAppearance({ appearance: appearance, isDisabled: isDisabled, isSelected: isSelected }) {
    if (isDisabled || isSelected) return 'inherit';
    if (appearance === 'primary' || appearance === 'rovo' || appearance === 'danger' || appearance === 'discovery') return 'invert';
    return 'inherit';
}
function $e8a26ea745404c34$export$2e2bcd8739ae039({ appearance: appearance, spacing: spacing, isDisabled: isDisabled, isSelected: isSelected, testId: testId }) {
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $9cT91.default), {
        size: $e8a26ea745404c34$var$getIconSpacing(spacing),
        appearance: $e8a26ea745404c34$var$getSpinnerAppearance({
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected
        }),
        testId: testId ? `${testId}--loading-spinner` : undefined
    });
}

});


parcelRegister("5Qhtn", function(module, exports) {
$parcel$export(module.exports, "default", () => $af3a067d5753d583$export$2e2bcd8739ae039);
/* content.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $gJ6nT = parcelRequire("gJ6nT");
parcelRequire("fsvuC");
const $af3a067d5753d583$var$styles = {
    text: "_4bt5LAnQyn _2WAcuGnQyn _2O5Vij7dHp _3YEZNO7dHp _39HuIbz8Lp _1ANEUSLRg7",
    icon: "_3iDTPbQ4SZ _2O5VijdnbC _3YEZNOdnbC _4xdlr0DIqT _4ya3eEdnbC _26BoRwdnbC _20VacPYbGa",
    common: "_23rrnHBXJV",
    fade: "_1YKVNsdnbC"
};
/**
 * __Content__
 *
 * Used for slots within a Button, including icons and text content.
 */ const $af3a067d5753d583$var$Content = ({ children: children, type: type = 'text', isLoading: isLoading })=>{
    return /*#__PURE__*/ (0, $5chsV.jsx)("span", {
        className: (0, $gJ6nT.default)([
            $af3a067d5753d583$var$styles.common,
            type === 'text' && $af3a067d5753d583$var$styles.text,
            type === 'icon' && $af3a067d5753d583$var$styles.icon,
            isLoading && $af3a067d5753d583$var$styles.fade
        ]),
        children: children
    });
};
$af3a067d5753d583$var$Content.displayName = "Content";
var $af3a067d5753d583$export$2e2bcd8739ae039 = $af3a067d5753d583$var$Content;

});

parcelRegister("eYXrv", function(module, exports) {
$parcel$export(module.exports, "default", () => $fe1f8ac021cb2c5b$export$2e2bcd8739ae039);

var $5chsV = parcelRequire("5chsV");
parcelRequire("fsvuC");

var $llCao = parcelRequire("llCao");
function $fe1f8ac021cb2c5b$var$isIconRenderProp(func) {
    return !func.displayName && // most function components and class components have a displayName, negate them
    !func.render && // forwardRef doesn't require a display name, however it does include a render function, negate them
    typeof func === 'function' // at the very least we need to be a function
    ;
}
/**
 * __Icon renderer__
 *
 * Used to support render props with icons.
 *
 */ const $fe1f8ac021cb2c5b$var$IconRenderer = ({ icon: Icon })=>{
    // React Compiler opt-out: RC-incompatible (memoization breaks runtime behaviour).
    'use no memo';
    const isRenderProp = $fe1f8ac021cb2c5b$var$isIconRenderProp(Icon);
    let iconProps = {
        label: '',
        color: 'currentColor',
        size: (0, $llCao.fg)('platform_dst_button_chevron_sizing') ? (iconName)=>iconName.startsWith('Chevron') ? 'small' : 'medium' : undefined
    };
    // @ts-ignore - TS2322 TypeScript 5.9.2 upgrade
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $5chsV.Fragment), {
        children: isRenderProp ? Icon(iconProps) : /*#__PURE__*/ (0, $5chsV.jsx)(Icon, {
            ...iconProps
        })
    });
};
$fe1f8ac021cb2c5b$var$IconRenderer.displayName = "IconRenderer";
var $fe1f8ac021cb2c5b$export$2e2bcd8739ae039 = $fe1f8ac021cb2c5b$var$IconRenderer;

});



parcelRegister("a7Ljg", function(module, exports) {
$parcel$export(module.exports, "default", () => $4db6070f16447d54$export$2e2bcd8739ae039);
/* expander.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");
parcelRequire("fsvuC");

var $dwUnm = parcelRequire("dwUnm");

var $lfw4f = parcelRequire("lfw4f");

var $eEY7a = parcelRequire("eEY7a");

var $ixlCP = parcelRequire("ixlCP");

var $llCao = parcelRequire("llCao");

var $jRYjy = parcelRequire("jRYjy");

var $d0SZF = parcelRequire("d0SZF");
const $4db6070f16447d54$var$styles = {
    expander: "_39xV02N91d",
    expanderTransition: "_1kOSYtLaAG _3Z9K0wqvoi _2Iz54kUiLg",
    expanderCollapsed: "_4bt5LAnQyn _2WAcuGnQyn",
    container: "_23rrnHpA9h"
};
const $4db6070f16447d54$var$Expander = ({ children: children, isExpanded: isExpanded, testId: testId })=>{
    const isCollapseAnimationEnabled = (0, $llCao.fg)('platform-dst-flag-collapse-animation-fix');
    // Need to always render the ExpanderInternal otherwise the
    // reveal transition doesn't happen. We can't use CSS animation for
    // the the reveal because we don't know the height of the content.
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $jRYjy.Box), {
        xcss: (0, $dwUnm.cx)($4db6070f16447d54$var$styles.expander, isCollapseAnimationEnabled && $4db6070f16447d54$var$styles.expanderTransition, isCollapseAnimationEnabled && !isExpanded && $4db6070f16447d54$var$styles.expanderCollapsed),
        style: {
            maxHeight: isExpanded ? 150 : 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            flex: '1 1 100%',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            minWidth: 0
        },
        "aria-hidden": !isExpanded,
        testId: testId && `${testId}-expander`,
        children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $lfw4f.default), {
            appear: true,
            children: isExpanded && /*#__PURE__*/ (0, $5chsV.jsx)((0, $eEY7a.default), {
                children: (props)=>/*#__PURE__*/ (0, $5chsV.jsx)((0, $jRYjy.Box), {
                        xcss: (0, $dwUnm.cx)(!isCollapseAnimationEnabled && $4db6070f16447d54$var$styles.container),
                        ...props,
                        children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $d0SZF.Stack), {
                            space: "space.100",
                            children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $ixlCP.default), {
                                children: children
                            })
                        })
                    })
            })
        })
    });
};
$4db6070f16447d54$var$Expander.displayName = "Expander";
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$4db6070f16447d54$export$2e2bcd8739ae039 = $4db6070f16447d54$var$Expander;

});

parcelRegister("32qtA", function(module, exports) {
$parcel$export(module.exports, "useFlagGroup", () => $494ed551a99f8bc7$export$e91ea202abb66350);

var $fsvuC = parcelRequire("fsvuC");

var $9iIP7 = parcelRequire("9iIP7");
function $494ed551a99f8bc7$export$e91ea202abb66350() {
    return (0, $fsvuC.useContext)((0, $9iIP7.FlagGroupContext));
}

});
parcelRegister("9iIP7", function(module, exports) {
$parcel$export(module.exports, "FlagGroupContext", () => $cf8727ae1942e2a7$export$c57ba665aaa722be);

var $fsvuC = parcelRequire("fsvuC");

var $bg15J = parcelRequire("bg15J");
const $cf8727ae1942e2a7$export$c57ba665aaa722be = /*#__PURE__*/ (0, $fsvuC.createContext)((0, $bg15J.defaultFlagGroupContext));

});
parcelRegister("bg15J", function(module, exports) {
$parcel$export(module.exports, "defaultFlagGroupContext", () => $a0e2cca7e770fbae$export$643760c4938da30d);

var $9Tkwf = parcelRequire("9Tkwf");
const $a0e2cca7e770fbae$export$643760c4938da30d = {
    onDismissed: (0, $9Tkwf.default),
    isDismissAllowed: false
};

});




parcelRegister("3muTT", function(module, exports) {
$parcel$export(module.exports, "default", () => $797f6b61efa7e413$export$2e2bcd8739ae039);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $d5Gwv = parcelRequire("d5Gwv");

var $9Tkwf = parcelRequire("9Tkwf");

var $intO7 = parcelRequire("intO7");

var $32qtA = parcelRequire("32qtA");
const $797f6b61efa7e413$var$packageName = "platform-pkg";
const $797f6b61efa7e413$var$packageVersion = "0.0.0-use.local";
const $797f6b61efa7e413$export$66c3d409977b5615 = 8;
/**
 * __Auto dismiss flag__
 *
 * An auto dismiss flag is dismissed automatically after eight seconds.
 *
 * - [Examples](https://atlassian.design/components/flag/auto-dismiss-flag/examples)
 * - [Code](https://atlassian.design/components/flag/auto-dismiss-flag/code)
 */ const $797f6b61efa7e413$var$AutoDismissFlag = (props)=>{
    const { id: id, analyticsContext: analyticsContext, onDismissed: onDismissedProp = (0, $9Tkwf.default), autoDismissSeconds: autoDismissSeconds = $797f6b61efa7e413$export$66c3d409977b5615 } = props;
    const autoDismissTimer = (0, $fsvuC.useRef)(null);
    const { onDismissed: onDismissedFromFlagGroup, isDismissAllowed: isDismissAllowed } = (0, $32qtA.useFlagGroup)();
    const onDismissed = (0, $fsvuC.useCallback)((id, analyticsEvent)=>{
        onDismissedProp(id, analyticsEvent);
        onDismissedFromFlagGroup(id, analyticsEvent);
    }, [
        onDismissedProp,
        onDismissedFromFlagGroup
    ]);
    const onDismissedAnalytics = (0, $d5Gwv.usePlatformLeafEventHandler)({
        fn: onDismissed,
        action: 'dismissed',
        analyticsData: analyticsContext,
        componentName: 'flag',
        packageName: $797f6b61efa7e413$var$packageName,
        packageVersion: $797f6b61efa7e413$var$packageVersion
    });
    const isAutoDismissAllowed = isDismissAllowed && onDismissed;
    const dismissFlag = (0, $fsvuC.useCallback)(()=>{
        if (isAutoDismissAllowed) onDismissedAnalytics(id);
    }, [
        id,
        onDismissedAnalytics,
        isAutoDismissAllowed
    ]);
    const stopAutoDismissTimer = (0, $fsvuC.useCallback)(()=>{
        if (autoDismissTimer.current) {
            clearTimeout(autoDismissTimer.current);
            autoDismissTimer.current = null;
        }
    }, []);
    const startAutoDismissTimer = (0, $fsvuC.useCallback)(()=>{
        if (!isAutoDismissAllowed) return;
        stopAutoDismissTimer();
        autoDismissTimer.current = window.setTimeout(dismissFlag, autoDismissSeconds * 1000);
    }, [
        dismissFlag,
        stopAutoDismissTimer,
        isAutoDismissAllowed,
        autoDismissSeconds
    ]);
    (0, $fsvuC.useEffect)(()=>{
        startAutoDismissTimer();
        return stopAutoDismissTimer;
    }, [
        startAutoDismissTimer,
        stopAutoDismissTimer
    ]);
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $intO7.default), {
        ...props,
        onMouseOver: stopAutoDismissTimer,
        onFocus: stopAutoDismissTimer,
        onMouseOut: startAutoDismissTimer,
        onBlur: startAutoDismissTimer
    });
};
$797f6b61efa7e413$var$AutoDismissFlag.displayName = "AutoDismissFlag";
var $797f6b61efa7e413$export$2e2bcd8739ae039 = $797f6b61efa7e413$var$AutoDismissFlag;

});

parcelRegister("bnLBB", function(module, exports) {
$parcel$export(module.exports, "FlagGroup", () => $69044c7d13a760aa$export$a2c3479950310d7d);
$parcel$export(module.exports, "default", () => $69044c7d13a760aa$export$2e2bcd8739ae039);
/* flag-group.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $gJ6nT = parcelRequire("gJ6nT");

var $dqdTY = parcelRequire("dqdTY");

var $mhEfz = parcelRequire("mhEfz");

var $jF8Yw = parcelRequire("jF8Yw");

var $dwUnm = parcelRequire("dwUnm");

var $9Tkwf = parcelRequire("9Tkwf");

var $ceFHj = parcelRequire("ceFHj");

var $lfw4f = parcelRequire("lfw4f");

var $h1Xjd = parcelRequire("h1Xjd");

var $llCao = parcelRequire("llCao");

var $bDK6L = parcelRequire("bDK6L");

var $jRYjy = parcelRequire("jRYjy");

var $QrsDO = parcelRequire("QrsDO");

var $2jUY9 = parcelRequire("2jUY9");

var $8e1dR = parcelRequire("8e1dR");

var $bg15J = parcelRequire("bg15J");

var $9iIP7 = parcelRequire("9iIP7");
// transition: none is set on first-of-type to prevent a bug in Firefox
// that causes a broken transition
const $69044c7d13a760aa$var$groupStyles = {
    root: "_23rrnHhZcn _39xV02Hakr _1mT5xdWVPG _1ZB6UydnbC _3lCN7kqUim",
    first: "_23rrnHYbGa _1VJPcalCsS _42Yu6BcFV1",
    second: "_42Yu6B8OLE",
    nth: "_0nFVCGUaiG _1VJPcawyGK",
    hidden: "_0fKRyPnQyn"
};
// transition: none is set on first-of-type to prevent a bug in Firefox
// that causes a broken transition
const $69044c7d13a760aa$var$groupStylesNew = {
    root: "_23rrnHCdlx _1mT5xdWVPG _1ZB6UydnbC _39xV02Hakr _3lCN7kqUim",
    first: "_1VJPcalCsS _42Yu6BcFV1",
    second: "_1VJPcaG4bd _42Yu6B8OLE",
    nth: "_1VJPcaseKz",
    hidden: "_0fKRyPnQyn"
};
// Transform needed to push up while 1st flag is leaving
// Exiting time should match the exiting time of motion so is halved
const $69044c7d13a760aa$var$dismissAllowedStyles = null;
const $69044c7d13a760aa$var$flagGroupContainerStyles = null;
// When rendering in top layer, z-index is redundant (top layer stacks above everything).
// Override to avoid leaving an explicit z-index on the container.
const $69044c7d13a760aa$var$flagGroupContainerStylesTopLayer = null;
// cc_mohiti_flag_anchoring: update left inset from space.1000 (80px) to space.600 (48px)
// to match the bottom inset and produce a symmetric 48px × 48px anchor.
// The 80px left offset was a legacy artefact from the old left-rail nav sidebar.
// The mobile reset is mirrored from the base style so the override is self-contained
// and doesn't depend on @compiled's atomic CSS emit order at the ≤560px breakpoint.
const $69044c7d13a760aa$var$flagGroupContainerStylesSymmetric = null;
const $69044c7d13a760aa$export$a2c3479950310d7d = (props)=>{
    const { id: id, label: label = 'Flag notifications', labelTag: LabelTag = 'h2', shouldRenderToParent: shouldRenderToParent = false, children: children, onDismissed: onDismissed = (0, $9Tkwf.default) } = props;
    const hasFlags = Array.isArray(children) ? children.length > 0 : Boolean(children);
    const dismissFlagContext = (0, $fsvuC.useMemo)(()=>({
            onDismissed: onDismissed,
            isDismissAllowed: true
        }), [
        onDismissed
    ]);
    // Keep a stable reference to the latest children, dismiss handler, and
    // analytics creator so the keydown listener never reads stale closures.
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $mhEfz.useAnalyticsEvents)();
    const latestRef = (0, $fsvuC.useRef)({
        children: children,
        onDismissed: onDismissed,
        createAnalyticsEvent: createAnalyticsEvent
    });
    latestRef.current = {
        children: children,
        onDismissed: onDismissed,
        createAnalyticsEvent: createAnalyticsEvent
    };
    // Accessibility (JRACLOUD-97876): allow keyboard-only and assistive
    // technology users to dismiss the topmost (and only dismissable) flag with
    // the Escape key, without having to tab through the entire page to reach
    // the dismiss button. Behaviour is gated behind a feature flag so it can
    // be rolled out and validated incrementally.
    (0, $fsvuC.useEffect)(()=>{
        if (!(0, $llCao.fg)('platform_dst_flag_keyboard_dismiss')) return;
        if (!hasFlags) return;
        const doc = (0, $jF8Yw.getDocument)();
        if (!doc) return;
        const timeoutIds = new Set();
        const unbind = (0, $dqdTY.bind)(doc, {
            type: 'keydown',
            listener: (event)=>{
                if (event.key !== 'Escape' || event.defaultPrevented) return;
                const currentChildren = latestRef.current.children;
                const firstFlag = Array.isArray(currentChildren) ? currentChildren.find(Boolean) : currentChildren;
                if (!firstFlag || typeof firstFlag !== 'object') return;
                const id = firstFlag.props?.id;
                if (id === undefined || id === null || id === '') return;
                const analyticsEvent = latestRef.current.createAnalyticsEvent({
                    action: 'dismissed',
                    actionSubject: 'flag',
                    attributes: {
                        dismissedVia: 'keyboardShortcut',
                        key: 'Escape'
                    }
                });
                const timeoutId = setTimeout(()=>{
                    timeoutIds.delete(timeoutId);
                    if (event.defaultPrevented) return;
                    event.preventDefault();
                    latestRef.current.onDismissed?.(id, analyticsEvent);
                });
                timeoutIds.add(timeoutId);
            },
            options: {
                capture: true
            }
        });
        return ()=>{
            unbind();
            timeoutIds.forEach(clearTimeout);
            timeoutIds.clear();
        };
    }, [
        hasFlags
    ]);
    const renderChildren = ()=>{
        return children && typeof children === 'object' ? (0, $fsvuC.Children).map(children, (flag, index)=>{
            const isDismissAllowed = index === 0;
            return (0, $llCao.fg)('platform-dst-motion-uplift') ? /*#__PURE__*/ (0, $5chsV.jsx)((0, $jRYjy.Box), {
                xcss: (0, $dwUnm.cx)($69044c7d13a760aa$var$groupStylesNew.root, index === 0 && $69044c7d13a760aa$var$groupStylesNew.first, index === 1 && $69044c7d13a760aa$var$groupStylesNew.second, index >= 2 && $69044c7d13a760aa$var$groupStylesNew.nth, index >= 3 && $69044c7d13a760aa$var$groupStylesNew.hidden),
                "data-vc-oob": true,
                children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $ceFHj.default), {
                    enteringAnimation: "var(--ds-flag-enter, 250ms cubic-bezier(0, 0.4, 0, 1) SlideIn50PercentLeft, 250ms cubic-bezier(0, 0.4, 0, 1) FadeIn0to100)",
                    exitingAnimation: "var(--ds-flag-exit, 200ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOut15PercentLeft, 200ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)",
                    children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $9iIP7.FlagGroupContext).Provider, {
                        value: // Only the first flag should be able to be dismissed.
                        isDismissAllowed ? dismissFlagContext : (0, $bg15J.defaultFlagGroupContext),
                        children: flag
                    })
                })
            }) : /*#__PURE__*/ (0, $5chsV.jsx)((0, $h1Xjd.default), {
                enterFrom: "left",
                fade: "inout",
                duration: "medium",
                animationTimingFunction: "ease-in",
                children: ({ className: className, ref: ref })=>/*#__PURE__*/ (0, $5chsV.jsx)("div", {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                        className: (0, $gJ6nT.default)([
                            $69044c7d13a760aa$var$groupStyles.root,
                            index === 0 && $69044c7d13a760aa$var$groupStyles.first,
                            index === 1 && $69044c7d13a760aa$var$groupStyles.second,
                            index >= 1 && $69044c7d13a760aa$var$groupStyles.nth,
                            index >= 2 && $69044c7d13a760aa$var$groupStyles.hidden,
                            isDismissAllowed && "_2wEWqSnQ85",
                            className
                        ]),
                        ref: ref,
                        "data-vc-oob": true,
                        children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $9iIP7.FlagGroupContext).Provider, {
                            value: // Only the first flag should be able to be dismissed.
                            isDismissAllowed ? dismissFlagContext : (0, $bg15J.defaultFlagGroupContext),
                            children: flag
                        })
                    })
            });
        }) : false;
    };
    const useTopLayer = (0, $llCao.fg)('platform-dst-top-layer');
    const useSymmetricAnchor = (0, $llCao.fg)('cc_mohiti_flag_anchoring');
    const isKeyboardDismissEnabled = (0, $llCao.fg)('platform_dst_flag_keyboard_dismiss');
    // When the keyboard dismiss shortcut is available, surface it to assistive
    // technology users via the existing visually-hidden landmark heading so they
    // know they can press Escape to dismiss the topmost flag.
    const screenReaderLabel = isKeyboardDismissEnabled ? `${label}. Press Escape to dismiss.` : label;
    const flags = /*#__PURE__*/ (0, $5chsV.jsxs)("div", {
        id: id,
        "data-vc-oob": true,
        className: (0, $gJ6nT.default)([
            "_1mT5xdy1CL _42Yu6BGZ9s _1ZB6Uyp0Oa _3iC0zdyFLW _3A9RaWdnbC _1e2WYadnbC",
            useTopLayer && "_42Yu6BIZbP",
            useSymmetricAnchor && "_3iC0zdp0Oa _1e2WYadnbC"
        ]),
        children: [
            hasFlags ? /*#__PURE__*/ (0, $5chsV.jsx)((0, $8e1dR.default), {
                children: /*#__PURE__*/ (0, $5chsV.jsx)(LabelTag, {
                    children: screenReaderLabel
                })
            }) : null,
            /*#__PURE__*/ (0, $5chsV.jsx)((0, $lfw4f.default), {
                appear: false,
                children: renderChildren()
            })
        ]
    });
    if (useTopLayer) return /*#__PURE__*/ (0, $5chsV.jsx)((0, $2jUY9.Popover), {
        mode: "manual",
        isOpen: true,
        children: flags
    });
    return shouldRenderToParent ? flags : /*#__PURE__*/ (0, $5chsV.jsx)((0, $bDK6L.default), {
        zIndex: (0, $QrsDO.layers).flag(),
        children: flags
    });
};
$69044c7d13a760aa$export$a2c3479950310d7d.displayName = "FlagGroup";
var /* eslint-disable-next-line @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of this deprecated default export shim. */ /**
 * @deprecated Use `import { FlagGroup } from '@atlaskit/flag/flag-group'` instead.
 */ // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports -- VOLTC-139 tracks removal of this deprecated default export shim.
$69044c7d13a760aa$export$2e2bcd8739ae039 = $69044c7d13a760aa$export$a2c3479950310d7d;

});
parcelRegister("ceFHj", function(module, exports) {
$parcel$export(module.exports, "default", () => $62b35ed968f34130$export$2e2bcd8739ae039);
/* motion.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $gJ6nT = parcelRequire("gJ6nT");

var $fsvuC = parcelRequire("fsvuC");

var $dwUnm = parcelRequire("dwUnm");

var $fz4Xf = parcelRequire("fz4Xf");

var $llCao = parcelRequire("llCao");

var $iHAI5 = parcelRequire("iHAI5");

var $6lSeW = parcelRequire("6lSeW");

var $kZlXG = parcelRequire("kZlXG");

var $fAVYP = parcelRequire("fAVYP");

var $ckXfQ = parcelRequire("ckXfQ");

var $hk7fM = parcelRequire("hk7fM");

var $iJh5O = parcelRequire("iJh5O");

var $alfDb = parcelRequire("alfDb");
const $62b35ed968f34130$var$styles = {
    base: "_4Cu53BeMto _39Ohv4YbGa _1SdfoHYbGa",
    hidden: "_0fKRyPnQyn"
};
/**
 * Legacy implementation of `Motion` that inlines the animation lifecycle.
 * Used when the `platform-dst-use-motion` feature gate is off.
 */ const $62b35ed968f34130$var$MotionLegacy = /*#__PURE__*/ (0, $fsvuC.forwardRef)(({ children: children, enteringAnimation: enteringAnimation, enteringAnimationXcss: enteringAnimationXcss, exitingAnimation: exitingAnimation, exitingAnimationXcss: exitingAnimationXcss, onFinish: onFinishMotion, xcss: xcss, style: styleProp, testId: testId }, ref)=>{
    const staggered = (0, $alfDb.useStaggeredEntrance)();
    const { isExiting: isExiting, onFinish: onExitFinished, appear: appear } = (0, $hk7fM.useExitingPersistence)();
    const staggeredDelay = isExiting ? 0 : staggered.delay;
    const staggedIsReady = staggered.isReady;
    const [state, setState] = (0, $fsvuC.useState)(appear ? staggedIsReady && !staggeredDelay ? 'entering' : 'init' : 'idle');
    const elementRef = (0, $fsvuC.useRef)(null);
    const reanimateRef = (0, $fsvuC.useRef)();
    const animationRef = (0, $fsvuC.useRef)();
    const staggeredEntryRef = (0, $fsvuC.useRef)();
    (0, $fsvuC.useEffect)(()=>{
        if (isExiting) setState('exiting');
    }, [
        isExiting
    ]); // Handles staggered entry
    (0, $fsvuC.useEffect)(()=>{
        if (state !== 'init') return; // We delay the entry animation by the stagger delay
        staggeredEntryRef.current = setTimeout(()=>{
            setState('entering');
        }, staggeredDelay);
        return ()=>{
            if (staggeredEntryRef.current) clearTimeout(staggeredEntryRef.current);
        };
    }, [
        state,
        staggedIsReady,
        staggeredDelay
    ]); /**
                                                * Updates relevant state.
                                                * Called when the animation is finished, or immediately with reduced motion.
                                                */ 
    const onAnimationEnd = (0, $fsvuC.useCallback)((state, cancelled)=>{
        // We are done animating, so we set the state to idle
        let newState = 'idle';
        if (state === 'exiting') {
            if (!reanimateRef.current) // Updates the `ExitingPersistence` to remove this child
            onExitFinished?.();
            onFinishMotion?.('exiting');
        }
        if (state === 'entering') onFinishMotion?.('entering');
        if (reanimateRef.current === (0, $ckXfQ.Reanimate).exit_then_enter) {
            // We are done exiting, so we set the state to entering
            reanimateRef.current = (0, $ckXfQ.Reanimate).enter;
            newState = 'entering';
        } else if (reanimateRef.current) // We are done reanimating, so we clear the reanimate state
        reanimateRef.current = undefined;
        if (!cancelled) setState(newState);
         // We ignore this for onFinishMotion as consumers could potentially inline the function
    // which would then trigger this effect every re-render.
    // We want to make it easier for consumers so we go down this path unfortunately.
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        onExitFinished
    ]);
    (0, $fsvuC.useEffect)(()=>{
        // Tracking this to prevent changing state on an unmounted component
        let isCancelled = false;
        if (!staggedIsReady) return;
         // On initial mount if elements aren't set to animate on appear, we return early and callback
        // This only occurs on initial mount, as appear will be true once the component is mounted
        if (!appear) {
            onFinishMotion && onFinishMotion('entering');
            return;
        } // If the state is idle or init, we don't need to do anything
        if (state === 'idle' || state === 'init') return;
         // If there is reduced motion or no exit animation, we call the onAnimationEnd function immediately
        if ((0, $kZlXG.isReducedMotion)() || !exitingAnimation && !exitingAnimationXcss) {
            onAnimationEnd(state, isCancelled);
            return;
        }
        let animationDuration = 0;
        if (state === 'entering' || state === 'exiting') {
            if (elementRef.current) {
                if (elementRef.current.style.animation) {
                    // Motion token
                    const animationTimings = (0, $6lSeW.getDurationMs)((0, $fAVYP.resolveMotionToken)(elementRef.current.style.animation));
                    animationDuration = animationTimings.duration;
                    animationDuration += animationTimings.delay;
                } else {
                    // Custom motion
                    const styles = window.getComputedStyle(elementRef.current);
                    animationDuration = (0, $iHAI5.getComputedAnimationDurationMs)(styles.animationName, styles.animationDuration, styles.animationDelay);
                }
            }
        } // Queue `onAnimationEnd` for after the animation has finished
        if (state === 'exiting' && (exitingAnimation || exitingAnimationXcss)) animationRef.current = setTimeout(()=>onAnimationEnd(state, isCancelled), animationDuration);
        else if (state === 'entering' && (enteringAnimation || enteringAnimationXcss)) animationRef.current = setTimeout(()=>onAnimationEnd(state, isCancelled), animationDuration);
        return ()=>{
            isCancelled = true;
            if (animationRef.current) clearTimeout(animationRef.current);
        }; // We ignore this for onFinishMotion as consumers could potentially inline the function
    // which would then trigger this effect every re-render.
    // We want to make it easier for consumers so we go down this path unfortunately.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        onAnimationEnd,
        state,
        exitingAnimation,
        enteringAnimation,
        exitingAnimationXcss,
        enteringAnimationXcss,
        staggeredDelay,
        staggedIsReady
    ]);
    (0, $fsvuC.useImperativeHandle)(ref, ()=>({
            reanimate: (value)=>{
                animationRef.current && clearTimeout(animationRef.current);
                reanimateRef.current = value;
                if (value === (0, $ckXfQ.Reanimate).exit_then_enter) setState('exiting');
                else if (value === (0, $ckXfQ.Reanimate).enter) setState('entering');
            }
        }));
    let style = {};
    let customAnimation;
    if (state === 'entering') {
        if (enteringAnimation) style.animation = enteringAnimation;
        else if (enteringAnimationXcss) customAnimation = enteringAnimationXcss;
    } else if (state === 'exiting') {
        if (exitingAnimation) style.animation = exitingAnimation;
        else if (exitingAnimationXcss) customAnimation = exitingAnimationXcss;
    }
    const hasAnimationStyles = state !== 'idle' && state !== 'init';
    return /*#__PURE__*/ (0, $5chsV.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
    , {
        className: (0, $gJ6nT.default)([
            hasAnimationStyles && $62b35ed968f34130$var$styles.base,
            state === 'init' && $62b35ed968f34130$var$styles.hidden,
            (0, $dwUnm.cx)(xcss, customAnimation)
        ]),
        ref: (0, $fz4Xf.default)([
            staggered.ref,
            elementRef
        ]),
        style: styleProp || hasAnimationStyles ? {
            ...styleProp,
            ...style
        } : undefined,
        "data-testid": testId,
        children: children
    });
});
/**
 * Implementation of `Motion` built on top of the `useMotion` hook.
 * Used when the `platform-dst-use-motion` feature gate is on.
 */ const $62b35ed968f34130$var$MotionNext = /*#__PURE__*/ (0, $fsvuC.forwardRef)(({ children: children, enteringAnimation: enteringAnimation, enteringAnimationXcss: enteringAnimationXcss, exitingAnimation: exitingAnimation, exitingAnimationXcss: exitingAnimationXcss, onFinish: onFinishMotion, xcss: xcss, style: styleProp, testId: testId }, ref)=>{
    const { state: state, ref: motionRef, reanimate: reanimate } = (0, $iJh5O.useMotion)({
        onFinish: onFinishMotion
    });
    (0, $fsvuC.useImperativeHandle)(ref, ()=>({
            reanimate: reanimate
        }), [
        reanimate
    ]); // `xcss` and `style` apply to the wrapper `<div>` the `Motion` component renders,
    // so they are merged here (not in the hook) alongside the hook's animation output.
    return /*#__PURE__*/ (0, $5chsV.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
    , {
        className: (0, $gJ6nT.default)([
            state === 'init' && $62b35ed968f34130$var$styles.hidden,
            (0, $dwUnm.cx)(xcss, state === 'entering' && enteringAnimationXcss, state === 'exiting' && exitingAnimationXcss)
        ]),
        ref: motionRef,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...styleProp,
            animation: state === 'entering' ? enteringAnimation : state === 'exiting' ? exitingAnimation : undefined
        },
        "data-testid": testId,
        children: children
    });
}); /**
     * __Motion__
     *
     * A motion primitive that can be used to animate the entry and exit of components.
     */ 
const $62b35ed968f34130$var$Motion = /*#__PURE__*/ (0, $fsvuC.forwardRef)((props, ref)=>{
    if ((0, $llCao.fg)('platform-dst-use-motion')) return /*#__PURE__*/ (0, $5chsV.jsx)($62b35ed968f34130$var$MotionNext, {
        ...props,
        ref: ref
    });
    return /*#__PURE__*/ (0, $5chsV.jsx)($62b35ed968f34130$var$MotionLegacy, {
        ...props,
        ref: ref
    });
}); // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
var $62b35ed968f34130$export$2e2bcd8739ae039 = $62b35ed968f34130$var$Motion;

});
parcelRegister("iHAI5", function(module, exports) {
$parcel$export(module.exports, "getComputedAnimationDurationMs", () => $8912efedc574326d$export$dd9b73a7482d05b6);

var $c8d2V = parcelRequire("c8d2V");
const $8912efedc574326d$var$cssTimePattern = /^-?(?:\d+\.?\d*|\.\d+)(?:ms|s)$/;
const $8912efedc574326d$var$toCssList = (value)=>value.split(',').map((item)=>item.trim()).filter(Boolean);
const $8912efedc574326d$var$toTimeList = (value)=>$8912efedc574326d$var$toCssList(value).filter((time)=>$8912efedc574326d$var$cssTimePattern.test(time)).map((0, $c8d2V.convertToMs));
const $8912efedc574326d$export$dd9b73a7482d05b6 = (animationName, animationDuration, animationDelay)=>{
    const names = $8912efedc574326d$var$toCssList(animationName);
    const durations = $8912efedc574326d$var$toTimeList(animationDuration);
    const delays = $8912efedc574326d$var$toTimeList(animationDelay);
    if (names.length === 0 || durations.length === 0) return 0;
    let longestDuration = 0;
    for(let index = 0; index < names.length; index++){
        if (names[index] === 'none') continue;
        const duration = durations[index % durations.length];
        const delay = delays.length > 0 ? delays[index % delays.length] : 0;
        longestDuration = Math.max(longestDuration, duration + delay);
    }
    return longestDuration;
};

});
parcelRegister("c8d2V", function(module, exports) {
$parcel$export(module.exports, "convertToMs", () => $97dc872a038f4c7f$export$75eee42ff540d8ae);
const $97dc872a038f4c7f$export$75eee42ff540d8ae = (duration)=>{
    // Use regex to separate the number and the unit
    const matches = duration.match(/^(-?(?:\d+\.?\d*|\.\d+))(s|ms)$/);
    if (!matches) return 0; // Or return for invalid format
    const value = parseFloat(matches[1]);
    const unit = matches[2];
    if (unit === 's') return value * 1000; // Convert seconds to milliseconds
    else return value; // Already in milliseconds
};

});


parcelRegister("6lSeW", function(module, exports) {
$parcel$export(module.exports, "getDurationMs", () => $8b269bb580ff17ca$export$d0038b6e47881463);
/**
 * Gets the duration in milliseconds for an animation property.
 * @param animation - The animation property to get the duration for.
 * @returns The duration in milliseconds.
 */ const $8b269bb580ff17ca$export$d0038b6e47881463 = (animation)=>{
    const animations = animation.split(/,(?![^()]*\))/).map((value)=>[
            ...value.trim().matchAll(/(-?\d*\.?\d+)(ms|s)\b/g)
        ]).filter((matches)=>matches.length > 0);
    if (animations.length === 0) return {
        duration: 0,
        delay: 0
    };
    return animations.reduce((longest, matches)=>{
        const toMilliseconds = (match)=>{
            const value = parseFloat(match[1]);
            return match[2] === 's' ? value * 1000 : value;
        };
        const timing = {
            duration: toMilliseconds(matches[0]),
            delay: matches[1] ? toMilliseconds(matches[1]) : 0
        };
        return timing.duration + timing.delay > longest.duration + longest.delay ? timing : longest;
    }, {
        duration: 0,
        delay: 0
    });
};

});

parcelRegister("fAVYP", function(module, exports) {
$parcel$export(module.exports, "resolveMotionToken", () => $4ab810c97f0881b6$export$82b92541889a035d);

var $jF8Yw = parcelRequire("jF8Yw");
const $4ab810c97f0881b6$export$82b92541889a035d = (token)=>{
    const cssVarMatch = token.match(/var\(\s*(--[^,\s)]+)/);
    const cssVar = cssVarMatch ? cssVarMatch[1] : null;
    if (cssVar) {
        const documentElement = (0, $jF8Yw.getDocument)()?.documentElement;
        if (documentElement) return getComputedStyle(documentElement).getPropertyValue(cssVar);
    }
    return '';
};

});

parcelRegister("ckXfQ", function(module, exports) {
$parcel$export(module.exports, "Reanimate", () => $41e93cae8fd5f174$export$569340a66b14e0dc);
/**
 * Supported reanimate values.
 * 'enter' will re-enter the animation.
 * 'exit-then-enter' will exit the animation and then enter it again.
 */ var $41e93cae8fd5f174$export$569340a66b14e0dc = /*#__PURE__*/ function(Reanimate) {
    Reanimate["enter"] = "enter";
    Reanimate["exit_then_enter"] = "exit_then_enter";
    Reanimate["exit"] = "exit";
    return Reanimate;
}({});

});

parcelRegister("iJh5O", function(module, exports) {
$parcel$export(module.exports, "useMotion", () => $12d02986c41b27f1$export$2a51cfe9390d36ef);
/* use-motion.tsx generated by @compiled/babel-plugin v3.0.2 */ // Exposes start and finish callbacks while useMotion coordinates the animation lifecycle.

var $fsvuC = parcelRequire("fsvuC");

var $fz4Xf = parcelRequire("fz4Xf");

var $iHAI5 = parcelRequire("iHAI5");

var $6lSeW = parcelRequire("6lSeW");

var $kZlXG = parcelRequire("kZlXG");

var $fAVYP = parcelRequire("fAVYP");

var $hxGHU = parcelRequire("hxGHU");

var $ckXfQ = parcelRequire("ckXfQ");

var $hk7fM = parcelRequire("hk7fM");

var $alfDb = parcelRequire("alfDb");
function $12d02986c41b27f1$export$2a51cfe9390d36ef({ onFinish: onFinishMotion, onStart: onStartMotion, initialState: initialState } = {}) {
    const reducedMotion = (0, $kZlXG.isReducedMotion)();
    const staggered = (0, $alfDb.useStaggeredEntrance)();
    const { isExiting: isExiting, onFinish: onExitFinished, appear: appear } = (0, $hk7fM.useExitingPersistence)();
    const staggeredDelay = isExiting ? 0 : staggered.delay;
    const staggeredIsReady = staggered.isReady;
    const [state, setState] = (0, $fsvuC.useState)(initialState ?? (appear ? staggeredIsReady && !staggeredDelay ? 'entering' : 'init' : 'visible'));
    // ExitingPersistence must win during render so consumers apply exit styles before layout effects.
    // The lifecycle effect below uses the same value to measure and finish that exit.
    const motionState = isExiting ? 'exiting' : state;
    const elementRef = (0, $fsvuC.useRef)(null);
    const onFinishMotionRef = (0, $fsvuC.useRef)(onFinishMotion);
    onFinishMotionRef.current = onFinishMotion;
    const onStartMotionRef = (0, $fsvuC.useRef)(onStartMotion);
    onStartMotionRef.current = onStartMotion;
    const onExitFinishedRef = (0, $fsvuC.useRef)(onExitFinished);
    onExitFinishedRef.current = onExitFinished;
    const reanimateRef = (0, $fsvuC.useRef)();
    const animationRef = (0, $fsvuC.useRef)();
    const staggeredEntryRef = (0, $fsvuC.useRef)();
    (0, $hxGHU.useLayoutEffect)(()=>{
        if (motionState === 'exiting') onStartMotionRef.current?.('exiting');
        if (motionState === 'entering') onStartMotionRef.current?.('entering');
    }, [
        motionState
    ]);
    /**
   * Updates relevant state.
   * Called when the animation is finished, or immediately with reduced motion.
   */ const onAnimationEnd = (0, $fsvuC.useCallback)((currentState, cancelled)=>{
        // We are done animating, so we set the state to visible
        let newState = 'visible';
        if (currentState === 'exiting') {
            if (!reanimateRef.current) // Updates the `ExitingPersistence` to remove this child
            onExitFinishedRef.current?.();
            onFinishMotionRef.current?.('exiting');
        }
        if (currentState === 'entering') onFinishMotionRef.current?.('entering');
        if (reanimateRef.current === (0, $ckXfQ.Reanimate).exit_then_enter) {
            // We are done exiting, so we set the state to entering
            reanimateRef.current = (0, $ckXfQ.Reanimate).enter;
            newState = 'entering';
        } else if (reanimateRef.current === (0, $ckXfQ.Reanimate).enter) // We are done reanimating, so we clear the reanimate state
        reanimateRef.current = undefined;
        else if (reanimateRef.current === (0, $ckXfQ.Reanimate).exit) {
            // We are done reanimating, so we clear the reanimate state
            reanimateRef.current = undefined;
            newState = 'hidden';
        }
        if (!cancelled) setState(newState);
    // We ignore this for onFinishMotion as consumers could potentially inline the function
    // which would then trigger this effect every re-render.
    // We want to make it easier for consumers so we go down this path unfortunately.
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    // Handles staggered entry
    (0, $fsvuC.useEffect)(()=>{
        if (state !== 'init') return;
        if (reducedMotion) {
            onAnimationEnd('entering', false);
            return;
        }
        // We delay the entry animation by the stagger delay
        staggeredEntryRef.current = setTimeout(()=>{
            setState('entering');
        }, staggeredDelay);
        return ()=>{
            if (staggeredEntryRef.current) clearTimeout(staggeredEntryRef.current);
        };
    }, [
        onAnimationEnd,
        state,
        staggeredIsReady,
        staggeredDelay,
        reducedMotion
    ]);
    (0, $fsvuC.useEffect)(()=>{
        // Tracking this to prevent changing state on an unmounted component
        let isCancelled = false;
        if (!staggeredIsReady) return;
        // On initial mount if elements aren't set to animate on appear, we return early and callback
        // This only occurs on initial mount, as appear will be true once the component is mounted
        if (!appear) {
            onFinishMotion && onFinishMotion('entering');
            return;
        }
        // If the state is visible, hidden or init, we don't need to do anything
        if (motionState === 'visible' || motionState === 'init' || motionState === 'hidden') return;
        // If there is reduced motion or no exit animation, we call the onAnimationEnd function immediately
        if (reducedMotion) {
            onAnimationEnd(motionState, isCancelled);
            return;
        }
        let animationDuration = 0;
        if (motionState === 'entering' || motionState === 'exiting') {
            if (elementRef.current) {
                if (elementRef.current.style.animation) {
                    // Motion token
                    const animationTimings = (0, $6lSeW.getDurationMs)((0, $fAVYP.resolveMotionToken)(elementRef.current.style.animation));
                    animationDuration = animationTimings.duration;
                    animationDuration += animationTimings.delay;
                } else {
                    // Custom motion
                    const computedStyles = window.getComputedStyle(elementRef.current);
                    animationDuration = (0, $iHAI5.getComputedAnimationDurationMs)(computedStyles.animationName, computedStyles.animationDuration, computedStyles.animationDelay);
                }
            }
        }
        // Queue `onAnimationEnd` for after the animation has finished
        if (motionState === 'exiting') animationRef.current = setTimeout(()=>onAnimationEnd(motionState, isCancelled), animationDuration);
        else if (motionState === 'entering') animationRef.current = setTimeout(()=>onAnimationEnd(motionState, isCancelled), animationDuration);
        return ()=>{
            isCancelled = true;
            if (animationRef.current) clearTimeout(animationRef.current);
        };
    // We ignore this for onFinishMotion as consumers could potentially inline the function
    // which would then trigger this effect every re-render.
    // We want to make it easier for consumers so we go down this path unfortunately.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        onAnimationEnd,
        motionState,
        appear,
        staggeredDelay,
        staggeredIsReady,
        reducedMotion
    ]);
    const reanimate = (0, $fsvuC.useCallback)((value)=>{
        animationRef.current && clearTimeout(animationRef.current);
        reanimateRef.current = value;
        if (value === (0, $ckXfQ.Reanimate).exit_then_enter) setState('exiting');
        else if (value === (0, $ckXfQ.Reanimate).enter) setState('entering');
        else if (value === (0, $ckXfQ.Reanimate).exit) setState('exiting');
    }, []);
    const ref = (0, $fsvuC.useMemo)(()=>(0, $fz4Xf.default)([
            staggered.ref,
            elementRef
        ]), [
        staggered.ref
    ]);
    return {
        ref: ref,
        reanimate: reanimate,
        state: motionState
    };
}

});


parcelRegister("h1Xjd", function(module, exports) {
$parcel$export(module.exports, "default", () => $3cf788676c5a8c9f$export$2e2bcd8739ae039);

var $5chsV = parcelRequire("5chsV");
parcelRequire("fsvuC");

var $faV22 = parcelRequire("faV22");
/**
 * __SlideIn__
 *
 * Will slide an element into position, generally used for things that appear from outside of the viewport into view.
 *
 * See [examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motion).
 */ const $3cf788676c5a8c9f$var$SlideIn = ({ children: children, enterFrom: enterFrom, exitTo: exitTo, duration: duration = 'medium', isPaused: isPaused, onFinish: onFinish, animationTimingFunction: animationTimingFunction = 'ease-out', animationTimingFunctionExiting: animationTimingFunctionExiting = 'ease-in' })=>{
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $faV22.default), {
        duration: duration,
        enteringAnimation: `slide-in-from-${enterFrom}`,
        exitingAnimation: `slide-out-from-${exitTo || enterFrom}`,
        animationTimingFunction: animationTimingFunction,
        animationTimingFunctionExiting: animationTimingFunctionExiting,
        isPaused: isPaused,
        onFinish: onFinish,
        children: children
    });
};
$3cf788676c5a8c9f$var$SlideIn.displayName = "SlideIn";
var $3cf788676c5a8c9f$export$2e2bcd8739ae039 = $3cf788676c5a8c9f$var$SlideIn;

});


parcelRegister("j1DKB", function(module, exports) {
$parcel$export(module.exports, "FlagsProvider", () => $5d2b6edc7eb805e3$export$a4270ab432ac8a58);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $3muTT = parcelRequire("3muTT");

var $intO7 = parcelRequire("intO7");

var $68Iod = parcelRequire("68Iod");

var $bnLBB = parcelRequire("bnLBB");
const $5d2b6edc7eb805e3$var$getUniqueId = (()=>{
    let count = 0;
    return ()=>`flag-provider-unique-id:${count++}`;
})();
function $5d2b6edc7eb805e3$export$a4270ab432ac8a58({ children: children, shouldRenderToParent: shouldRenderToParent }) {
    const [flags, setFlags] = (0, $fsvuC.useState)([]);
    const removeFlag = (0, $fsvuC.useCallback)((id)=>{
        setFlags((current)=>{
            return current.slice(0).filter((flag)=>flag.id !== id);
        });
    }, []);
    const api = (0, $fsvuC.useMemo)(()=>({
            showFlag: function show(value) {
                const flag = {
                    ...value,
                    id: value.id || $5d2b6edc7eb805e3$var$getUniqueId()
                };
                setFlags((current)=>{
                    const index = current.findIndex((value)=>value.id === flag.id);
                    // If flag is not found add it
                    if (index === -1) return [
                        flag,
                        ...current
                    ];
                    // If flag already exists with the same id, then replace it
                    const shallow = [
                        ...current
                    ];
                    shallow[index] = flag;
                    return shallow;
                });
                return function dismiss() {
                    removeFlag(flag.id);
                };
            },
            hideFlag: removeFlag
        }), [
        removeFlag
    ]);
    return /*#__PURE__*/ (0, $5chsV.jsxs)((0, $5chsV.Fragment), {
        children: [
            /*#__PURE__*/ (0, $5chsV.jsx)((0, $68Iod.FlagContext).Provider, {
                value: api,
                children: children
            }),
            /*#__PURE__*/ (0, $5chsV.jsx)((0, $bnLBB.default), {
                onDismissed: removeFlag,
                shouldRenderToParent: shouldRenderToParent,
                children: flags.map((flag)=>{
                    const { isAutoDismiss: isAutoDismiss, ...restProps } = flag;
                    const FlagType = isAutoDismiss ? (0, $3muTT.default) : (0, $intO7.default);
                    return /*#__PURE__*/ (0, $fsvuC.createElement)(FlagType, {
                        ...restProps,
                        key: flag.id
                    });
                })
            })
        ]
    });
}
$5d2b6edc7eb805e3$export$a4270ab432ac8a58.displayName = "FlagsProvider";

});
parcelRegister("68Iod", function(module, exports) {
$parcel$export(module.exports, "FlagContext", () => $d2c9ec657b91ac42$export$2eb95677cf2465e1);

var $fsvuC = parcelRequire("fsvuC");
const $d2c9ec657b91ac42$export$2eb95677cf2465e1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).createContext(null);

});


parcelRegister("2orDX", function(module, exports) {
$parcel$export(module.exports, "useFlags", () => $f7c025835f22ffc1$export$2879604e6aec4ab);

var $fsvuC = parcelRequire("fsvuC");

var $68Iod = parcelRequire("68Iod");
function $f7c025835f22ffc1$export$2879604e6aec4ab() {
    const api = (0, $fsvuC.useContext)((0, $68Iod.FlagContext));
    if (api == null) throw new Error('Unable to find FlagProviderContext');
    return api;
}

});

parcelRegister("3iiGg", function(module, exports) {
$parcel$export(module.exports, "withFlagsProvider", () => $5572d757e57acafc$export$7b676815c264eaf3);

var $5chsV = parcelRequire("5chsV");
parcelRequire("fsvuC");

var $j1DKB = parcelRequire("j1DKB");
const $5572d757e57acafc$export$7b676815c264eaf3 = (fn)=>/*#__PURE__*/ (0, $5chsV.jsx)((0, $j1DKB.FlagsProvider), {
        children: fn()
    });

});


parcelRegister("l5c1p", function(module, exports) {
$parcel$export(module.exports, "CHANNEL", () => $74707f0cfb474d7b$export$44ffba16bd48dac6);
$parcel$export(module.exports, "DEFAULT_THEME_MODE", () => $74707f0cfb474d7b$export$c93026a968943f95);
$parcel$export(module.exports, "THEME_MODES", () => $74707f0cfb474d7b$export$6ba72c8346b4c57e);
$parcel$export(module.exports, "layers", () => $74707f0cfb474d7b$export$7be255094ccdc533);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ const $74707f0cfb474d7b$export$44ffba16bd48dac6 = '__ATLASKIT_THEME__';
const $74707f0cfb474d7b$export$c93026a968943f95 = 'light';
const $74707f0cfb474d7b$export$6ba72c8346b4c57e = [
    'light',
    'dark'
];
const $74707f0cfb474d7b$export$7be255094ccdc533 = {
    card: ()=>100,
    navigation: ()=>200,
    dialog: ()=>300,
    layer: ()=>400,
    blanket: ()=>500,
    modal: ()=>510,
    flag: ()=>600,
    spotlight: ()=>700,
    tooltip: ()=>9999
};

});

parcelRegister("aMHT4", function(module, exports) {
$parcel$export(module.exports, "Popper", () => (parcelRequire("f3WQU")).Popper);
$parcel$export(module.exports, "placements", () => (parcelRequire("hjLVT")).placements);
$parcel$export(module.exports, "Manager", () => (parcelRequire("1ihvq")).Manager);
$parcel$export(module.exports, "Reference", () => (parcelRequire("fD9oc")).Reference);

var $hjLVT = parcelRequire("hjLVT");
var $f3WQU = parcelRequire("f3WQU");

var $1ihvq = parcelRequire("1ihvq");

var $fD9oc = parcelRequire("fD9oc");

});
parcelRegister("1ihvq", function(module, exports) {
$parcel$export(module.exports, "Manager", () => $4dc5f3838691c37d$export$d0d38e7dec7a1a61);

var $5chsV = parcelRequire("5chsV");
parcelRequire("fsvuC");

var $god5t = parcelRequire("god5t");

var $cxtgF = parcelRequire("cxtgF");

var $2uF7x = parcelRequire("2uF7x");

var $lIkru = parcelRequire("lIkru");
function $4dc5f3838691c37d$export$d0d38e7dec7a1a61({ children: children }) {
    // `setAnchor` is the `useState` setter, which React guarantees is stable
    // across renders, so it can be passed straight to the context provider.
    const { anchor: anchor, setAnchor: setAnchor } = (0, $lIkru.useAnchorState)();
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $god5t.Manager), {
        children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $2uF7x.AnchorSetterContext).Provider, {
            value: setAnchor,
            children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $cxtgF.AnchorContext).Provider, {
                value: anchor,
                children: children
            })
        })
    });
}
$4dc5f3838691c37d$export$d0d38e7dec7a1a61.displayName = "Manager";

});
parcelRegister("2uF7x", function(module, exports) {
$parcel$export(module.exports, "AnchorSetterContext", () => $8a5f1cbd9aca4272$export$804169e6eecdff16);

var $fsvuC = parcelRequire("fsvuC");
const $8a5f1cbd9aca4272$export$804169e6eecdff16 = /*#__PURE__*/ (0, $fsvuC.createContext)(()=>undefined);

});

parcelRegister("lIkru", function(module, exports) {
$parcel$export(module.exports, "useAnchorState", () => $b1e3e82ab7cf506f$export$1b1b50fdcd7ac375);

var $fsvuC = parcelRequire("fsvuC");
function $b1e3e82ab7cf506f$export$1b1b50fdcd7ac375() {
    const [anchor, setAnchor] = (0, $fsvuC.useState)(null);
    return {
        anchor: anchor,
        setAnchor: setAnchor
    };
}

});


parcelRegister("fD9oc", function(module, exports) {
$parcel$export(module.exports, "Reference", () => $b804cf661f48d4eb$export$e0be378c32fb70a7);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $30yVU = parcelRequire("30yVU");

var $fz4Xf = parcelRequire("fz4Xf");

var $73Xj5 = parcelRequire("73Xj5");
function $b804cf661f48d4eb$export$e0be378c32fb70a7({ children: children, innerRef: innerRef }) {
    const publishAnchor = (0, $73Xj5.useManagerAnchorSetter)();
    const composedRef = (0, $fsvuC.useMemo)(()=>(0, $fz4Xf.default)([
            publishAnchor,
            innerRef
        ]), [
        publishAnchor,
        innerRef
    ]);
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $30yVU.Reference), {
        innerRef: composedRef,
        children: children
    });
}
$b804cf661f48d4eb$export$e0be378c32fb70a7.displayName = "Reference";

});
parcelRegister("73Xj5", function(module, exports) {
$parcel$export(module.exports, "useManagerAnchorSetter", () => $4013943fec26f6fb$export$fcdda419d7091b3);

var $fsvuC = parcelRequire("fsvuC");

var $2uF7x = parcelRequire("2uF7x");
function $4013943fec26f6fb$export$fcdda419d7091b3() {
    return (0, $fsvuC.useContext)((0, $2uF7x.AnchorSetterContext));
}

});



parcelRegister("7uMuM", function(module, exports) {
$parcel$export(module.exports, "default", () => $6679c5bee0cac044$export$2e2bcd8739ae039);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $mhEfz = parcelRequire("mhEfz");

var $kPPu5 = parcelRequire("kPPu5");
const $6679c5bee0cac044$var$withAnalyticsEvents = (createEventMap = {})=>(WrappedComponent)=>{
        const WithAnalyticsEvents = /*#__PURE__*/ (0, $fsvuC.forwardRef)((props, ref)=>{
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore: to unblock React 18.2.0 -> 18.3.1 version bump in Jira
            const { patchedEventProps: patchedEventProps } = (0, $kPPu5.usePatchedProps)(createEventMap, props);
            const { createAnalyticsEvent: createAnalyticsEvent } = (0, $mhEfz.useAnalyticsEvents)();
            return /*#__PURE__*/ (0, $5chsV.jsx)(WrappedComponent, {
                ...props,
                ...patchedEventProps,
                createAnalyticsEvent: createAnalyticsEvent,
                ref: ref
            });
        });
        WithAnalyticsEvents.displayName = `WithAnalyticsEvents(${WrappedComponent.displayName || WrappedComponent.name})`;
        return WithAnalyticsEvents;
    };
var $6679c5bee0cac044$export$2e2bcd8739ae039 = $6679c5bee0cac044$var$withAnalyticsEvents;

});
parcelRegister("kPPu5", function(module, exports) {
$parcel$export(module.exports, "usePatchedProps", () => $5f24ad1da51bfb1d$export$9ebb5a84d17e5d18);

var $fsvuC = parcelRequire("fsvuC");

var $mhEfz = parcelRequire("mhEfz");
function $5f24ad1da51bfb1d$export$9ebb5a84d17e5d18(createEventMap = {}, wrappedComponentProps) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $mhEfz.useAnalyticsEvents)();
    const handlerCache = (0, $fsvuC.useRef)({});
    const patchedProps = (0, $fsvuC.useMemo)(()=>{
        const cache = handlerCache.current;
        // Clean up no longer used handlers in cache
        Object.keys(cache).filter((key)=>!(key in createEventMap)).forEach((key)=>delete cache[key]);
        return Object.keys(createEventMap).reduce((p, k)=>{
            const eventCreator = createEventMap[k];
            if (![
                'object',
                'function'
            ].includes(typeof eventCreator)) return p;
            const propValue = wrappedComponentProps[k];
            if (k in cache && cache[k].eventCreator === eventCreator && cache[k].propValue === propValue) return {
                ...p,
                [k]: cache[k].wrappedCallback
            };
            const wrappedCallback = (...args)=>{
                const analyticsEvent = typeof eventCreator === 'function' ? eventCreator(createAnalyticsEvent, wrappedComponentProps) : createAnalyticsEvent(eventCreator);
                if (propValue && typeof propValue === 'function') propValue(...args, analyticsEvent);
            };
            cache[k] = {
                eventCreator: eventCreator,
                wrappedCallback: wrappedCallback,
                propValue: propValue
            };
            return {
                ...p,
                [k]: wrappedCallback
            };
        }, {});
    }, [
        createEventMap,
        wrappedComponentProps,
        createAnalyticsEvent,
        handlerCache
    ]);
    return {
        patchedEventProps: patchedProps
    };
}

});


parcelRegister("daZXj", function(module, exports) {
$parcel$export(module.exports, "Text", () => $214f546b6ab21c95$export$5f1af8db9871e1d6);
/* text.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $gJ6nT = parcelRequire("gJ6nT");

var $l9kus = parcelRequire("l9kus");

var $5Fop2 = parcelRequire("5Fop2");

var $d9U0U = parcelRequire("d9U0U");

var $gnRij = parcelRequire("gnRij");
const $214f546b6ab21c95$var$asAllowlist = [
    'span',
    'p',
    'strong',
    'em'
];
/**
 * Custom hook designed to abstract the parsing of the color props and make it clearer in the future how color is reconciled between themes and tokens.
 */ const $214f546b6ab21c95$var$useColor = (colorProp, hasTextAncestor)=>{
    const surface = (0, $d9U0U.useSurface)();
    if (colorProp === 'inherit') return undefined;
    if (colorProp) return colorProp;
    if (hasTextAncestor) return undefined;
    if ($214f546b6ab21c95$var$inverseColorMap.hasOwnProperty(surface)) return $214f546b6ab21c95$var$inverseColorMap[surface];
    return 'color.text';
};
const $214f546b6ab21c95$var$styles = {
    root: "_313842dnbC _0adFHsdnbC _1DCdHidnbC _2XsHFMdnbC _3zvHkHdC7N",
    'as.strong': "_1kk5Tkmb2E",
    'as.em': "_2l4i3rGpkd",
    'textAlign.center': "_2fwxA5DIqT",
    'textAlign.end': "_2fwxA5F05b",
    'textAlign.start': "_2fwxA57p2s",
    truncation: "_4bt5LAnQyn _2WAcuGnQyn _3iDTPbgJ9S _1U1ZhbbI28",
    breakAll: "_3W2Oc84hR5"
};
const $214f546b6ab21c95$var$fontSizeMap = {
    medium: "_2sNsIgmnOE",
    large: "_2sNsIg20Hp",
    small: "_2sNsIg7NXe"
};
const $214f546b6ab21c95$var$fontWeightMap = {
    bold: "_1kk5Tkmb2E",
    medium: "_1kk5Tkf7mX",
    regular: "_1kk5Tku7m9",
    semibold: "_1kk5Tk7GSX"
};
const $214f546b6ab21c95$var$textColorMap = {
    'color.text': "_1UtDYzy7kJ",
    'color.text.accent.lime': "_1UtDYzqsUt",
    'color.text.accent.lime.bolder': "_1UtDYzfXoY",
    'color.text.accent.red': "_1UtDYzjgGB",
    'color.text.accent.red.bolder': "_1UtDYziNu3",
    'color.text.accent.orange': "_1UtDYzu4OJ",
    'color.text.accent.orange.bolder': "_1UtDYzH9Ub",
    'color.text.accent.yellow': "_1UtDYzDIkS",
    'color.text.accent.yellow.bolder': "_1UtDYzD7aB",
    'color.text.accent.green': "_1UtDYz9qYF",
    'color.text.accent.green.bolder': "_1UtDYzgGm3",
    'color.text.accent.teal': "_1UtDYzY3Jz",
    'color.text.accent.teal.bolder': "_1UtDYz2SoF",
    'color.text.accent.blue': "_1UtDYz866Z",
    'color.text.accent.blue.bolder': "_1UtDYz802h",
    'color.text.accent.purple': "_1UtDYzYfD7",
    'color.text.accent.purple.bolder': "_1UtDYzXCFT",
    'color.text.accent.magenta': "_1UtDYzSbwp",
    'color.text.accent.magenta.bolder': "_1UtDYzcMOQ",
    'color.text.accent.gray': "_1UtDYzUktF",
    'color.text.accent.gray.bolder': "_1UtDYzyXux",
    'color.text.disabled': "_1UtDYzot27",
    'color.text.inverse': "_1UtDYze5R3",
    'color.text.selected': "_1UtDYzjTy9",
    'color.text.brand': "_1UtDYzGaer",
    'color.text.danger': "_1UtDYzAyGJ",
    'color.text.warning': "_1UtDYzZSA9",
    'color.text.warning.inverse': "_1UtDYzVW6T",
    'color.text.success': "_1UtDYzGL5O",
    'color.text.discovery': "_1UtDYzJejw",
    'color.text.information': "_1UtDYzccV4",
    'color.text.subtlest': "_1UtDYzKGUX",
    'color.text.subtle': "_1UtDYzZpcK",
    'color.link': "_1UtDYzM7Tp",
    'color.link.pressed': "_1UtDYzAwSC",
    'color.link.visited': "_1UtDYzWfPD",
    'color.link.visited.pressed': "_1UtDYzWyeI"
};
const $214f546b6ab21c95$var$inverseColorMap = {
    'color.background.neutral.bold': 'color.text.inverse',
    'color.background.neutral.bold.hovered': 'color.text.inverse',
    'color.background.neutral.bold.pressed': 'color.text.inverse',
    'color.background.selected.bold': 'color.text.inverse',
    'color.background.selected.bold.hovered': 'color.text.inverse',
    'color.background.selected.bold.pressed': 'color.text.inverse',
    'color.background.brand.bold': 'color.text.inverse',
    'color.background.brand.bold.hovered': 'color.text.inverse',
    'color.background.brand.bold.pressed': 'color.text.inverse',
    'color.background.brand.boldest': 'color.text.inverse',
    'color.background.brand.boldest.hovered': 'color.text.inverse',
    'color.background.brand.boldest.pressed': 'color.text.inverse',
    'color.background.danger.bold': 'color.text.inverse',
    'color.background.danger.bold.hovered': 'color.text.inverse',
    'color.background.danger.bold.pressed': 'color.text.inverse',
    'color.background.warning.bold': 'color.text.warning.inverse',
    'color.background.warning.bold.hovered': 'color.text.warning.inverse',
    'color.background.warning.bold.pressed': 'color.text.warning.inverse',
    'color.background.success.bold': 'color.text.inverse',
    'color.background.success.bold.hovered': 'color.text.inverse',
    'color.background.success.bold.pressed': 'color.text.inverse',
    'color.background.discovery.bold': 'color.text.inverse',
    'color.background.discovery.bold.hovered': 'color.text.inverse',
    'color.background.discovery.bold.pressed': 'color.text.inverse',
    'color.background.information.bold': 'color.text.inverse',
    'color.background.information.bold.hovered': 'color.text.inverse',
    'color.background.information.bold.pressed': 'color.text.inverse'
};
const $214f546b6ab21c95$export$5f1af8db9871e1d6 = /*#__PURE__*/ (0, $fsvuC.forwardRef)(({ as: Component = 'span', color: colorProp, align: align, testId: testId, id: id, size: size, weight: weight, maxLines: maxLines, xcss: xcss, children: children }, ref)=>{
    (0, $l9kus.default)($214f546b6ab21c95$var$asAllowlist.includes(Component), `@atlaskit/primitives: Text received an invalid "as" value of "${Component}"`);
    const hasTextAncestor = (0, $gnRij.useHasTextAncestor)();
    const color = $214f546b6ab21c95$var$useColor(colorProp, hasTextAncestor);
    if (!size && !hasTextAncestor) size = 'medium';
    const component = /*#__PURE__*/ (0, $5chsV.jsx)(Component, {
        id: id,
        className: (0, $gJ6nT.default)([
            $214f546b6ab21c95$var$styles.root,
            size && $214f546b6ab21c95$var$fontSizeMap[size],
            color && $214f546b6ab21c95$var$textColorMap[color],
            maxLines && $214f546b6ab21c95$var$styles.truncation,
            maxLines === 1 && $214f546b6ab21c95$var$styles.breakAll,
            align && $214f546b6ab21c95$var$styles[`textAlign.${align}`],
            weight && $214f546b6ab21c95$var$fontWeightMap[weight],
            Component === 'em' && $214f546b6ab21c95$var$styles['as.em'],
            Component === 'strong' && $214f546b6ab21c95$var$styles['as.strong'],
            xcss
        ]),
        style: {
            WebkitLineClamp: maxLines
        },
        "data-testid": testId,
        ref: ref,
        children: children
    });
    if (hasTextAncestor) // no need to re-apply context if the text is already wrapped
    return component;
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $5Fop2.HasTextAncestorProvider), {
        value: true,
        children: component
    });
});

});
parcelRegister("5Fop2", function(module, exports) {
$parcel$export(module.exports, "HasTextAncestorProvider", () => $a2eb1158358f6db0$export$ae933c6cbe5643ad);

var $j1QvU = parcelRequire("j1QvU");
const $a2eb1158358f6db0$export$ae933c6cbe5643ad = (0, $j1QvU.HasTextAncestorContext).Provider;

});
parcelRegister("j1QvU", function(module, exports) {
$parcel$export(module.exports, "HasTextAncestorContext", () => $9b0a949d6f7708e9$export$19538d0bfc69c6e0);

var $fsvuC = parcelRequire("fsvuC");
const $9b0a949d6f7708e9$export$19538d0bfc69c6e0 = /*#__PURE__*/ (0, $fsvuC.createContext)(false);

});


parcelRegister("gnRij", function(module, exports) {
$parcel$export(module.exports, "useHasTextAncestor", () => $ea1084f3ddd43def$export$9322276ec105d055);

var $fsvuC = parcelRequire("fsvuC");

var $j1QvU = parcelRequire("j1QvU");
const $ea1084f3ddd43def$export$9322276ec105d055 = ()=>(0, $fsvuC.useContext)((0, $j1QvU.HasTextAncestorContext));

});


parcelRegister("buO9q", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $e960b08c40f9f340$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $fsvuC = parcelRequire("fsvuC");

var $h2YWL = parcelRequire("h2YWL");
function $e960b08c40f9f340$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $e960b08c40f9f340$var$buttonGroupStyles = {
    name: "1oy5iav",
    styles: "display:inline-flex;gap:var(--ds-space-050, 4px);> *{flex:1 0 auto;}"
};
function $e960b08c40f9f340$export$2e2bcd8739ae039({ children: children, testId: testId, label: label, titleId: titleId }) {
    return /*#__PURE__*/ (0, $h2YWL.jsx)("div", {
        css: $e960b08c40f9f340$var$buttonGroupStyles,
        "data-testid": testId,
        role: "group",
        "aria-label": label,
        "aria-labelledby": titleId
    }, (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).Children.map((0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).Children.toArray(children), (child, idx)=>{
        if (!child) return null;
        return /*#__PURE__*/ (0, $h2YWL.jsx)((0, $fsvuC.Fragment), {
            key: idx
        }, child);
    }));
}
$e960b08c40f9f340$export$2e2bcd8739ae039.displayName = "ButtonGroup";

});

parcelRegister("h4B8Q", function(module, exports) {
$parcel$export(module.exports, "default", () => $ed1550b8cfb8ab8f$export$2e2bcd8739ae039);
var $ed1550b8cfb8ab8f$export$2e2bcd8739ae039 = (channel)=>(payload)=>(createAnalyticsEvent)=>{
            const consumerEvent = createAnalyticsEvent(payload);
            const clonedEvent = consumerEvent.clone();
            if (clonedEvent) clonedEvent.fire(channel);
            return consumerEvent;
        };

});

parcelRegister("f3cvj", function(module, exports) {
$parcel$export(module.exports, "default", () => $47349a67e9c116fb$export$2e2bcd8739ae039);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $9sl8X = parcelRequire("9sl8X");
const $47349a67e9c116fb$var$withAnalyticsContext = (defaultData)=>(WrappedComponent)=>{
        const WithAnalyticsContext = /*#__PURE__*/ (0, $fsvuC.forwardRef)(({ analyticsContext: analyticsContext, ...rest }, ref)=>{
            const analyticsData = (0, $fsvuC.useMemo)(()=>({
                    ...defaultData,
                    ...analyticsContext
                }), [
                analyticsContext
            ]);
            return /*#__PURE__*/ (0, $5chsV.jsx)((0, $9sl8X.default), {
                data: analyticsData,
                children: /*#__PURE__*/ (0, $5chsV.jsx)(WrappedComponent, {
                    ...rest,
                    ref: ref
                })
            });
        });
        WithAnalyticsContext.displayName = `WithAnalyticsContext(${WrappedComponent.displayName || WrappedComponent.name})`;
        return WithAnalyticsContext;
    };
var $47349a67e9c116fb$export$2e2bcd8739ae039 = $47349a67e9c116fb$var$withAnalyticsContext;

});

parcelRegister("i9EJT", function(module, exports) {
$parcel$export(module.exports, "useCallbackWithAnalytics", () => $aa9677afbc1e5837$export$53c2b9c37c40e0d8);

var $fsvuC = parcelRequire("fsvuC");

var $mhEfz = parcelRequire("mhEfz");

var $g5SRF = parcelRequire("g5SRF");
const $aa9677afbc1e5837$export$53c2b9c37c40e0d8 = (method, payload, channel)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $mhEfz.useAnalyticsEvents)();
    const methodRef = (0, $g5SRF.useTrackedRef)(method);
    const payloadRef = (0, $g5SRF.useTrackedRef)(payload);
    return (0, $fsvuC.useCallback)((...args)=>{
        const pload = typeof payloadRef.current === 'function' ? payloadRef.current(...args) : payloadRef.current;
        createAnalyticsEvent(pload).fire(channel);
        methodRef.current(...args);
    }, [
        createAnalyticsEvent,
        methodRef,
        payloadRef,
        channel
    ]);
};

});

parcelRegister("lXPyl", function(module, exports) {
$parcel$export(module.exports, "default", () => $1bdba27c6b823912$export$2e2bcd8739ae039);

var $5chsV = parcelRequire("5chsV");
parcelRequire("fsvuC");

var $buO9q = parcelRequire("buO9q");

var $lgvAm = parcelRequire("lgvAm");

var $jRYjy = parcelRequire("jRYjy");

var $daZXj = parcelRequire("daZXj");

var $9cT91 = parcelRequire("9cT91");

var $k0r3U = parcelRequire("k0r3U");

var $6AWig = parcelRequire("6AWig");

var $9wfCt = parcelRequire("9wfCt");

var $cG2xY = parcelRequire("cG2xY");
/**
 * __Empty state__
 *
 * A component used for presenting various empty states.
 * e.g. (no items, empty search, broken link, welcome screen etc.)
 *
 * @example
 * ```tsx
 * import EmptyState from '@atlaskit/empty-state';
 *
 * // An example of a 404 state
 * export default () => {
 *  <EmptyState
 *   header="Page not found"
 *   imageUrl="https://cdn.io/images/404"
 *   description="Looks like you've stumbled off track. Sorry about that! This page either doesn't exist or has been removed."
 *   primaryAction={<Button appearance="primary">Home Page</Button>}
 *   secondaryAction={<Button>Report a problem</Button>}
 *  />;
 * };
 * ```
 */ const $1bdba27c6b823912$var$EmptyState = ({ buttonGroupLabel: buttonGroupLabel, description: description, header: header, headingLevel: headingLevel = 4, headingSize: headingSize = 'medium', imageHeight: imageHeight, imageUrl: imageUrl, imageWidth: imageWidth, isLoading: isLoading, maxImageHeight: maxImageHeight = 160, maxImageWidth: maxImageWidth = 160, primaryAction: primaryAction, renderImage: renderImage, secondaryAction: secondaryAction, width: width, tertiaryAction: tertiaryAction, testId: testId })=>{
    const actionsContainer = primaryAction || secondaryAction || isLoading ? /*#__PURE__*/ (0, $5chsV.jsxs)((0, $k0r3U.default), {
        children: [
            primaryAction && secondaryAction ? /*#__PURE__*/ (0, $5chsV.jsxs)((0, $buO9q.default), {
                label: buttonGroupLabel || 'Button group',
                testId: testId && `${testId}-button-group`,
                children: [
                    secondaryAction,
                    primaryAction
                ]
            }) : primaryAction || secondaryAction,
            /*#__PURE__*/ (0, $5chsV.jsx)((0, $cG2xY.default), {
                children: isLoading && /*#__PURE__*/ (0, $5chsV.jsx)((0, $9cT91.default), {
                    testId: "empty-state-spinner"
                })
            })
        ]
    }) : null;
    const tag = `h${headingLevel > 0 && headingLevel < 7 ? headingLevel : headingLevel > 6 ? 6 : 4}`;
    return /*#__PURE__*/ (0, $5chsV.jsxs)((0, $6AWig.default), {
        testId: testId,
        width: width || 'wide',
        children: [
            imageUrl ? /*#__PURE__*/ (0, $5chsV.jsx)((0, $9wfCt.default), {
                src: imageUrl,
                maxWidth: maxImageWidth,
                maxHeight: maxImageHeight,
                width: imageWidth,
                height: imageHeight
            }) : renderImage && renderImage({
                maxImageWidth: maxImageWidth,
                maxImageHeight: maxImageHeight,
                imageWidth: imageWidth,
                imageHeight: imageHeight
            }),
            /*#__PURE__*/ (0, $5chsV.jsx)((0, $jRYjy.Box), {
                paddingBlockEnd: "space.200",
                children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $lgvAm.default), {
                    size: headingSize,
                    as: tag,
                    children: header
                })
            }),
            description && /*#__PURE__*/ (0, $5chsV.jsx)((0, $jRYjy.Box), {
                paddingBlockEnd: "space.300",
                children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $daZXj.Text), {
                    as: "p",
                    children: description
                })
            }),
            actionsContainer,
            tertiaryAction
        ]
    });
};
$1bdba27c6b823912$var$EmptyState.displayName = "EmptyState";
var $1bdba27c6b823912$export$2e2bcd8739ae039 = $1bdba27c6b823912$var$EmptyState;

});
parcelRegister("k0r3U", function(module, exports) {
$parcel$export(module.exports, "default", () => $c9ab2a404cedb9f5$export$2e2bcd8739ae039);
/* actions-container.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");
parcelRequire("fsvuC");

var $gJ6nT = parcelRequire("gJ6nT");
const $c9ab2a404cedb9f5$var$actionsStyles = null;
/**
 * __Actions container__
 *
 * A container for actions: primary action, secondary action, and tertiary action.
 *
 * @internal
 */ const $c9ab2a404cedb9f5$var$ActionsContainer = ({ children: children })=>/*#__PURE__*/ (0, $5chsV.jsx)("div", {
        className: (0, $gJ6nT.default)([
            "_3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _0rIjyk2ADO _0LQT5ES40j"
        ]),
        children: children
    });
$c9ab2a404cedb9f5$var$ActionsContainer.displayName = "ActionsContainer";
var $c9ab2a404cedb9f5$export$2e2bcd8739ae039 = $c9ab2a404cedb9f5$var$ActionsContainer;

});

parcelRegister("6AWig", function(module, exports) {
$parcel$export(module.exports, "default", () => $59733dec068836da$export$2e2bcd8739ae039);
/* container.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");
parcelRequire("fsvuC");

var $gJ6nT = parcelRequire("gJ6nT");
const $59733dec068836da$var$containerStyles = null;
/* Use max-width so the component can shrink on smaller viewports. */ const $59733dec068836da$var$wideContainerStyles = null;
const $59733dec068836da$var$narrowContainerStyles = null;
/**
 * __Container__
 *
 * Upper level container for Empty State.
 *
 * @internal
 */ const $59733dec068836da$var$Container = ({ children: children, width: width, testId: testId })=>/*#__PURE__*/ (0, $5chsV.jsx)("div", {
        "data-testid": testId,
        className: (0, $gJ6nT.default)([
            "_0rIjykp0Oa _43nrzTp0Oa _2xTnZxIZbP _0GTcwRIZbP _2fwxA5DIqT",
            width === 'narrow' ? "_1EqgXlAef5" : "_1EqgXl0xhY"
        ]),
        children: children
    });
$59733dec068836da$var$Container.displayName = "Container";
var $59733dec068836da$export$2e2bcd8739ae039 = $59733dec068836da$var$Container;

});

parcelRegister("9wfCt", function(module, exports) {
$parcel$export(module.exports, "default", () => $ed8e2ed406ab23cf$export$2e2bcd8739ae039);
/* image.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");
parcelRequire("fsvuC");

var $gJ6nT = parcelRequire("gJ6nT");
const $ed8e2ed406ab23cf$var$CSS_VAR_MAX_WIDTH = '--max-width';
const $ed8e2ed406ab23cf$var$CSS_VAR_MAX_HEIGHT = '--max-height';
const $ed8e2ed406ab23cf$var$imageStyles = null;
/**
 * __Image__
 *
 * Image in Empty State.
 *
 * @internal
 */ const $ed8e2ed406ab23cf$var$Image = ({ maxHeight: maxHeight, maxWidth: maxWidth, height: height = 'auto', width: width = 'auto', src: src })=>/*#__PURE__*/ (0, $5chsV.jsx)("img", {
        style: {
            [$ed8e2ed406ab23cf$var$CSS_VAR_MAX_WIDTH]: `${maxWidth}px`,
            [$ed8e2ed406ab23cf$var$CSS_VAR_MAX_HEIGHT]: `${maxHeight}px`
        },
        width: width,
        height: height,
        alt: "",
        role: "presentation",
        src: src,
        className: (0, $gJ6nT.default)([
            "_3iDTPbvLZJ _1EqgXlbdgD _0NUa3rsFBh _0rIjykNHnM _43nrzTdnbC _2xTnZxIZbP _0GTcwRIZbP"
        ])
    });
$ed8e2ed406ab23cf$var$Image.displayName = "Image";
var $ed8e2ed406ab23cf$export$2e2bcd8739ae039 = $ed8e2ed406ab23cf$var$Image;

});

parcelRegister("cG2xY", function(module, exports) {
$parcel$export(module.exports, "default", () => $f10ec3999c6b6ad5$export$2e2bcd8739ae039);
/* spinner-container.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");
parcelRequire("fsvuC");

var $gJ6nT = parcelRequire("gJ6nT");
const $f10ec3999c6b6ad5$var$spinnerContainerStyles = null;
/**
 * __Spinner container__
 *
 * A spinner container for loading state of Empty State.
 *
 * @internal
 */ const $f10ec3999c6b6ad5$var$SpinnerContainer = ({ children: children })=>/*#__PURE__*/ (0, $5chsV.jsx)("div", {
        className: (0, $gJ6nT.default)([
            "_39xV02NHnM _0GTcwR5zaO"
        ]),
        children: children
    });
$f10ec3999c6b6ad5$var$SpinnerContainer.displayName = "SpinnerContainer";
var $f10ec3999c6b6ad5$export$2e2bcd8739ae039 = $f10ec3999c6b6ad5$var$SpinnerContainer;

});


parcelRegister("4esqg", function(module, exports) {
$parcel$export(module.exports, "default", () => $9a2ede201da4e1e1$export$2e2bcd8739ae039);

var $d9mL9 = parcelRequire("d9mL9");
var $9a2ede201da4e1e1$export$2e2bcd8739ae039 = (0, $d9mL9.default);

});

parcelRegister("fg1VY", function(module, exports) {
$parcel$export(module.exports, "isUIAnalyticsEvent", () => $74048d2ede8c3f84$export$35f8383928ba8d7);
/// <reference types="node" />

var $5jOIJ = parcelRequire("5jOIJ");
const $74048d2ede8c3f84$export$35f8383928ba8d7 = (obj)=>obj instanceof (0, $5jOIJ.default) || !!obj?._isUIAnalyticsEvent || // Backwards compatibility with older analytics-next packages
    obj?.constructor?.name === 'UIAnalyticsEvent';

});

parcelRegister("kUhAN", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => (parcelRequire("4rs9h")).default);
$parcel$export(module.exports, "LoadingButton", () => (parcelRequire("cqpe5")).default);
$parcel$export(module.exports, "CustomThemeButton", () => (parcelRequire("3KROw")).default);
$parcel$export(module.exports, "Theme", () => (parcelRequire("cuUd3")).default);
$parcel$export(module.exports, "ButtonGroup", () => (parcelRequire("buO9q")).default);
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required, @atlaskit/volt-strict-mode/no-re-exports, @atlaskit/editor/no-re-export -- VOLTC-139 tracks removal of these deprecated re-export shims. */ // Ideally this file is not used directly. But rather, you go through the entry points
/**
 * @deprecated Use `import type { Appearance, Spacing, BaseOwnProps, BaseProps } from '@atlaskit/button/old-button/types'` instead.
 */ 
var $4rs9h = parcelRequire("4rs9h");

var $cqpe5 = parcelRequire("cqpe5");

var $3KROw = parcelRequire("3KROw");

var $cuUd3 = parcelRequire("cuUd3");

var $buO9q = parcelRequire("buO9q");

});

parcelRegister("bBGRQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $753235913b9c369b$export$2e2bcd8739ae039);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $llCao = parcelRequire("llCao");

var $kkKaC = parcelRequire("kkKaC");

var $ez83N = parcelRequire("ez83N");

var $5LVve = parcelRequire("5LVve");
class $753235913b9c369b$export$2e2bcd8739ae039 extends (0, $fsvuC.Component) {
    constructor(props){
        super(props), // Resolved once at construction, never re-read: Modern and Legacy are different component types,
        // so switching on a later render would unmount the whole subtree beneath this boundary.
        this.isModernContext = (0, $kkKaC.default) || (0, $llCao.fg)('analytics-next-use-legacy-context') === false || (0, $llCao.fg)('adminhub-analytics-next-use-modern-context') || (0, $llCao.fg)('bitbucket-analytics-next-use-modern-context');
        this.state = {
            hasError: false
        };
    }
    componentDidCatch(error, info) {
        const { onError: onError } = this.props;
        onError && onError(error, info);
        this.setState({
            hasError: true
        });
    }
    render() {
        const { data: data, children: children, ErrorComponent: ErrorComponent } = this.props;
        const { hasError: hasError } = this.state;
        const { isModernContext: isModernContext } = this;
        if (hasError) {
            if (ErrorComponent) {
                if (isModernContext) return /*#__PURE__*/ (0, $5chsV.jsx)((0, $5LVve.default), {
                    data: data,
                    children: /*#__PURE__*/ (0, $5chsV.jsx)(ErrorComponent, {})
                });
                return /*#__PURE__*/ (0, $5chsV.jsx)((0, $ez83N.default), {
                    data: data,
                    children: /*#__PURE__*/ (0, $5chsV.jsx)(ErrorComponent, {})
                });
            }
            return null;
        }
        if (isModernContext) return /*#__PURE__*/ (0, $5chsV.jsx)((0, $5LVve.default), {
            data: data,
            children: children
        });
        return /*#__PURE__*/ (0, $5chsV.jsx)((0, $ez83N.default), {
            data: data,
            children: children
        });
    }
}
$753235913b9c369b$export$2e2bcd8739ae039.displayName = "AnalyticsErrorBoundary";

});

parcelRegister("tQAit", function(module, exports) {
$parcel$export(module.exports, "AnalyticsEvent", () => (parcelRequire("c77jK")).default);
$parcel$export(module.exports, "isAnalyticsEvent", () => (parcelRequire("lTexC")).isAnalyticsEvent);
$parcel$export(module.exports, "UIAnalyticsEvent", () => (parcelRequire("5jOIJ")).default);
$parcel$export(module.exports, "isUIAnalyticsEvent", () => (parcelRequire("fg1VY")).isUIAnalyticsEvent);
$parcel$export(module.exports, "AnalyticsListener", () => (parcelRequire("bjvoZ")).default);
$parcel$export(module.exports, "AnalyticsContext", () => (parcelRequire("9sl8X")).default);
$parcel$export(module.exports, "withAnalyticsContext", () => (parcelRequire("f3cvj")).default);
$parcel$export(module.exports, "AnalyticsErrorBoundary", () => (parcelRequire("bBGRQ")).default);
$parcel$export(module.exports, "withAnalyticsEvents", () => (parcelRequire("7uMuM")).default);
$parcel$export(module.exports, "AnalyticsReactContext", () => (parcelRequire("4esqg")).default);
$parcel$export(module.exports, "useAnalyticsEvents", () => (parcelRequire("mhEfz")).useAnalyticsEvents);
$parcel$export(module.exports, "useCallbackWithAnalytics", () => (parcelRequire("i9EJT")).useCallbackWithAnalytics);
$parcel$export(module.exports, "usePlatformLeafEventHandler", () => (parcelRequire("d5Gwv")).usePlatformLeafEventHandler);
$parcel$export(module.exports, "usePlatformLeafSyntheticEventHandler", () => (parcelRequire("gJaHb")).usePlatformLeafSyntheticEventHandler);
$parcel$export(module.exports, "createAndFireEvent", () => (parcelRequire("h4B8Q")).default);
$parcel$export(module.exports, "cleanProps", () => (parcelRequire("70vN0")).default);
$parcel$export(module.exports, "AnalyticsDecorator", () => (parcelRequire("acQpH")).AnalyticsDecorator);
$parcel$export(module.exports, "AnalyticsDelegate", () => (parcelRequire("jVuYp")).default);
$parcel$export(module.exports, "withAnalytics", () => (parcelRequire("lnhnA")).default);

var $c77jK = parcelRequire("c77jK");

var $lTexC = parcelRequire("lTexC");

var $5jOIJ = parcelRequire("5jOIJ");

var $fg1VY = parcelRequire("fg1VY");

var $bjvoZ = parcelRequire("bjvoZ");

var $9sl8X = parcelRequire("9sl8X");

var $f3cvj = parcelRequire("f3cvj");

var $bBGRQ = parcelRequire("bBGRQ");

var $7uMuM = parcelRequire("7uMuM");

var $4esqg = parcelRequire("4esqg");

var $mhEfz = parcelRequire("mhEfz");

var $i9EJT = parcelRequire("i9EJT");

var $d5Gwv = parcelRequire("d5Gwv");

var $gJaHb = parcelRequire("gJaHb");

var $h4B8Q = parcelRequire("h4B8Q");

var $70vN0 = parcelRequire("70vN0");

var $acQpH = parcelRequire("acQpH");

var $jVuYp = parcelRequire("jVuYp");

var $lnhnA = parcelRequire("lnhnA");

});
parcelRegister("lTexC", function(module, exports) {
$parcel$export(module.exports, "isAnalyticsEvent", () => $ec7722d2343e3918$export$ad4be5c2ec28cecf);

var $c77jK = parcelRequire("c77jK");
const $ec7722d2343e3918$export$ad4be5c2ec28cecf = (obj)=>obj instanceof (0, $c77jK.default) || !!obj?._isAnalyticsEvent || // Backwards compatibility with older analytics-next packages
    obj?.constructor?.name === 'AnalyticsEvent';

});

parcelRegister("70vN0", function(module, exports) {
$parcel$export(module.exports, "default", () => $25067212c3adae31$export$2e2bcd8739ae039);
function $25067212c3adae31$export$2e2bcd8739ae039(props) {
    const { createAnalyticsEvent: createAnalyticsEvent, ...cleanedProps } = props;
    return cleanedProps;
}

});

parcelRegister("acQpH", function(module, exports) {
$parcel$export(module.exports, "AnalyticsDecorator", () => $57c1fce204259c2d$export$29afdd4b31a211bd);

var $fsvuC = parcelRequire("fsvuC");

var $eimiB = parcelRequire("eimiB");

var $a0y9F = parcelRequire("a0y9F");
class $57c1fce204259c2d$export$29afdd4b31a211bd extends (0, $fsvuC.Component) {
    static{
        this.defaultProps = {
            match: '*',
            matchPrivate: false
        };
    }
    static{
        this.contextTypes = (0, $a0y9F.ContextTypes);
    }
    static{
        this.childContextTypes = (0, $a0y9F.ContextTypes);
    }
    getChildContext() {
        return {
            onAnalyticsEvent: this.onAnalyticsEvent,
            getParentAnalyticsData: this.getParentAnalyticsData
        };
    }
    render() {
        const { children: children } = this.props;
        return (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).Children.only(children);
    }
    constructor(...args){
        super(...args), this.getDecoratedAnalyticsData = (name, srcData, isPrivate)=>{
            const { data: data, getData: getData, match: match, matchPrivate: matchPrivate } = this.props;
            const decoratedData = {
                ...srcData
            };
            if (matchPrivate === isPrivate && (0, $eimiB.default)(match, name)) {
                if (typeof data === 'object') Object.assign(decoratedData, data);
                if (typeof getData === 'function') Object.assign(decoratedData, getData(name, decoratedData));
            }
            return decoratedData;
        }, this.onAnalyticsEvent = (name, srcData, isPrivate)=>{
            const { onAnalyticsEvent: onAnalyticsEvent } = this.context;
            if (typeof onAnalyticsEvent !== 'function') return;
            const decoratedData = this.getDecoratedAnalyticsData(name, srcData, isPrivate);
            onAnalyticsEvent(name, decoratedData, isPrivate);
        }, this.getParentAnalyticsData = (name, isPrivate)=>{
            const parentData = this.getDecoratedAnalyticsData(name, {}, isPrivate);
            const { getParentAnalyticsData: getParentAnalyticsData } = this.context;
            if (typeof getParentAnalyticsData === 'function') Object.assign(parentData, getParentAnalyticsData(name, isPrivate));
            return parentData;
        };
    }
}

});
parcelRegister("eimiB", function(module, exports) {
$parcel$export(module.exports, "default", () => $2b601428c44ed7ae$export$2e2bcd8739ae039);
const $2b601428c44ed7ae$var$ENDS_WITH_DOT = /\.$/;
function $2b601428c44ed7ae$var$matchEvent(matcher, name) {
    if (matcher === '*' || name === undefined) return true;
    if (typeof matcher === 'string') {
        if ($2b601428c44ed7ae$var$ENDS_WITH_DOT.test(matcher)) return name.substr(0, matcher.length) === matcher;
        return name === matcher;
    }
    if (typeof matcher === 'function') return matcher(name);
    return matcher.test(name);
}
var $2b601428c44ed7ae$export$2e2bcd8739ae039 = $2b601428c44ed7ae$var$matchEvent;

});

parcelRegister("a0y9F", function(module, exports) {
$parcel$export(module.exports, "ContextTypes", () => $f7a522180841c4fb$export$bd0f7835a18a8866);

var $jf0Un = parcelRequire("jf0Un");
const $f7a522180841c4fb$export$bd0f7835a18a8866 = {
    onAnalyticsEvent: (0, (/*@__PURE__*/$parcel$interopDefault($jf0Un))).func,
    getParentAnalyticsData: (0, (/*@__PURE__*/$parcel$interopDefault($jf0Un))).func
};

});


parcelRegister("jVuYp", function(module, exports) {
$parcel$export(module.exports, "default", () => $5e6baa729514fd51$export$2e2bcd8739ae039);

var $fsvuC = parcelRequire("fsvuC");

var $jf0Un = parcelRequire("jf0Un");
const $5e6baa729514fd51$var$ContextTypes = {
    onAnalyticsEvent: (0, (/*@__PURE__*/$parcel$interopDefault($jf0Un))).func
};
/**
 * Listens to public and private events and delegates to an analytics
 * stack in a different React root.
 */ // eslint-disable-next-line @repo/internal/react/no-class-components
class $5e6baa729514fd51$var$AnalyticsDelegate extends (0, $fsvuC.Component) {
    static{
        this.contextTypes = $5e6baa729514fd51$var$ContextTypes;
    }
    static{
        this.childContextTypes = $5e6baa729514fd51$var$ContextTypes;
    }
    getChildContext() {
        return {
            onAnalyticsEvent: this.onAnalyticsEvent
        };
    }
    render() {
        const { children: children } = this.props;
        return (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).Children.only(children);
    }
    constructor(...args){
        super(...args), this.onAnalyticsEvent = (name, data, isPrivate)=>{
            const { delegateAnalyticsEvent: delegateAnalyticsEvent } = this.props;
            const eventData = {
                ...data
            };
            if (delegateAnalyticsEvent) delegateAnalyticsEvent(name, eventData, isPrivate);
            const { onAnalyticsEvent: onAnalyticsEvent } = this.context;
            if (typeof onAnalyticsEvent === 'function') onAnalyticsEvent(name, data, isPrivate);
        };
    }
}
var $5e6baa729514fd51$export$2e2bcd8739ae039 = $5e6baa729514fd51$var$AnalyticsDelegate;

});

parcelRegister("lnhnA", function(module, exports) {
$parcel$export(module.exports, "default", () => $b53658785a7baf75$export$2e2bcd8739ae039);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $jf0Un = parcelRequire("jf0Un");
/**
 * The withAnalytics HOC wraps a component and provides the `fireAnalyticsEvent`
 * and `firePrivateAnalyticsEvent` methods to it as props. It contains the logic
 * for how to fire events, including handling the analyticsId and analyticsData
 * props. The `map` argument may be an object or a function that returns an object.
 * The properties of the `map` object/result can be strings (the name of the event
 * that will be fired) or functions (which are responsible for firing the event).
 * You can specify a default `analyticsId` and `analyticsData` with the `defaultProps`
 * param. Please be aware that specifying a default `analyticsId` will cause public
 * events to always fire for your component unless it has been set to a falsy by
 * the component consumer.
 *
 * @param WrappedComponent
 * @param map
 * @param defaultProps
 * @param withDelegation
 */ const $b53658785a7baf75$var$withAnalytics = (WrappedComponent, map = {}, defaultProps = {}, withDelegation)=>{
    return class WithAnalytics extends (0, $fsvuC.Component) {
        static{
            this.displayName = `WithAnalytics(${WrappedComponent.displayName || WrappedComponent.name})`;
        }
        static{
            this.contextTypes = {
                onAnalyticsEvent: (0, (/*@__PURE__*/$parcel$interopDefault($jf0Un))).func,
                getParentAnalyticsData: (0, (/*@__PURE__*/$parcel$interopDefault($jf0Un))).func
            };
        }
        static{
            this.defaultProps = {
                analyticsId: defaultProps.analyticsId,
                analyticsData: defaultProps.analyticsData
            };
        }
        constructor(props){
            super(props), this.delegateAnalyticsEvent = (analyticsId, data, isPrivate)=>{
                const { onAnalyticsEvent: onAnalyticsEvent } = this.context;
                if (!onAnalyticsEvent) return;
                onAnalyticsEvent(analyticsId, data, isPrivate);
            }, this.fireAnalyticsEvent = (name, data)=>{
                const { analyticsData: analyticsData, analyticsId: analyticsId } = this.props;
                const { onAnalyticsEvent: onAnalyticsEvent } = this.context;
                if (!analyticsId || !onAnalyticsEvent) return;
                const eventData = {
                    ...analyticsData,
                    ...data
                };
                onAnalyticsEvent(`${analyticsId}.${name}`, eventData, false);
            }, this.privateAnalyticsEvent = (name, data)=>{
                const { onAnalyticsEvent: onAnalyticsEvent } = this.context;
                if (!onAnalyticsEvent) return;
                onAnalyticsEvent(`${name}`, data, true);
            }, this.getParentAnalyticsData = (name)=>{
                const { getParentAnalyticsData: getParentAnalyticsData } = this.context;
                let parentData = {};
                if (typeof getParentAnalyticsData === 'function' && this.props.analyticsId) {
                    const { analyticsId: analyticsId } = this.props;
                    parentData = getParentAnalyticsData(`${analyticsId}.${name}`, false);
                }
                return parentData;
            };
            this.state = {
                evaluatedMap: {}
            };
        }
        componentDidMount() {
            this.setState({
                evaluatedMap: typeof map === 'function' ? map(this.fireAnalyticsEvent) : map
            });
        }
        render() {
            const { analyticsId: analyticsId, analyticsData: analyticsData, ...componentProps } = this.props;
            Object.keys(this.state.evaluatedMap).forEach((prop)=>{
                const handler = this.state.evaluatedMap[prop];
                const originalProp = componentProps[prop];
                componentProps[prop] = (...args)=>{
                    if (typeof handler === 'function') handler(...args);
                    else this.fireAnalyticsEvent(handler);
                    if (typeof originalProp === 'function') originalProp(...args);
                };
            });
            return /*#__PURE__*/ (0, $5chsV.jsx)(WrappedComponent, {
                fireAnalyticsEvent: this.fireAnalyticsEvent,
                firePrivateAnalyticsEvent: this.privateAnalyticsEvent,
                getParentAnalyticsData: this.getParentAnalyticsData,
                delegateAnalyticsEvent: withDelegation ? this.delegateAnalyticsEvent : undefined,
                analyticsId: analyticsId,
                ref: this.props.innerRef,
                ...componentProps
            });
        }
    };
};
var $b53658785a7baf75$export$2e2bcd8739ae039 = $b53658785a7baf75$var$withAnalytics;

});


const $5b20f9eca5080b27$export$ce553301d55c2fd8 = 'fedramp-moderate';
const $5b20f9eca5080b27$export$f005e2e9f707cb5f = 'commercial';
const $5b20f9eca5080b27$export$bd6b5a7802d76127 = 'fedramp-fedex';
const $5b20f9eca5080b27$export$a739cd5aac835909 = 'stg';
const $5b20f9eca5080b27$export$42dd0cdd351a4a9 = 'prod';
const $5b20f9eca5080b27$export$404582bc18fe4d9e = 'dev';

const $8d44ad6280d93004$export$42f4885608027d0c = 'non_boolean';

/* eslint-disable jira/filename-case */ // SCREENS
const $46f069e6c968f461$export$f636b5b56f1d624a = 'Screen';
const $46f069e6c968f461$export$9d2de6eebf7462b5 = 'Drawer';
const $46f069e6c968f461$export$1171103ea9083ffa = 'Modal';
const $46f069e6c968f461$export$cae2783c9279926 = 'InlineDialog';
const $46f069e6c968f461$export$d1123261ca8831d2 = 'Dropdown';
const $46f069e6c968f461$export$238d30785c4bca84 = 'Banner';
const $46f069e6c968f461$export$a1562d08625f5d7e = 'UI';
const $46f069e6c968f461$export$947dac6c72b26f81 = 'TRACK';
const $46f069e6c968f461$export$f1d537d508d2945a = 'SCREEN';
const $46f069e6c968f461$export$12346a674644c156 = 'OPERATIONAL';

const $9924ccd0a7eb3f48$export$ce553301d55c2fd8 = 'fedramp-moderate';
const $9924ccd0a7eb3f48$export$f005e2e9f707cb5f = 'commercial';
const $9924ccd0a7eb3f48$export$17b81a3d6c98013c = 'isolated-cloud';
const $9924ccd0a7eb3f48$export$a739cd5aac835909 = 'staging';
const $9924ccd0a7eb3f48$export$42dd0cdd351a4a9 = 'prod';
const $9924ccd0a7eb3f48$export$404582bc18fe4d9e = 'dev';
const $9924ccd0a7eb3f48$export$87285944378c596 = 'Atl-Ctx-Perimeter';
const $9924ccd0a7eb3f48$export$715603e81922c3ec = 'Atl-Ctx-Isolation-Context-Domain';
const $9924ccd0a7eb3f48$export$a0ffa0598c95dfb7 = 'Atl-Ctx-Isolation-Context-Id';
const $9924ccd0a7eb3f48$export$74814ca8786924c3 = 'Bifrost-Atl-Ctx-Cloud-Service-Provider';
const $9924ccd0a7eb3f48$export$b61e047ddcc35726 = 'GCP';
const $9924ccd0a7eb3f48$export$1baf17f3e645a2b2 = 'AWS';

/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ // this is autogenerated file, see scripts/version-update.js
const $2604faf4ecb0fc27$export$a4ad2735b021c132 = '1.9.1';

const $d06951238cc95036$export$cf090d5281b5ae06 = 10000;
const $d06951238cc95036$export$8575e30be0feb909 = 30000;

/* eslint-disable jira/filename-case */ const $d0b0f317b4f60123$export$881d135f98d8d7d0 = 100;
const $d0b0f317b4f60123$export$9ab5bdcb8a1d6c34 = false;
const $d0b0f317b4f60123$export$f267d0e9ab3eb265 = false;
const $d0b0f317b4f60123$export$12c1dc38ea1692da = 0;
const $d0b0f317b4f60123$export$34932e325e1234b3 = false;


$parcel$global.rlb("l3i9Q")
//# sourceMappingURL=shared~vendor~atlaskit~ar.cc9bdb26.js.map
